import React from 'react';
import axios from 'axios';
import http from '../modules/api';
import {Route, Switch, NavLink, Link, Prompt} from "react-router-dom";
import $ from 'jquery';
import * as Menu from '../Menu_v2';

import bannerType1 from "../../resources/img/event_typeA.png";
import bannerType2 from "../../resources/img/event_typeB.png";
import bannerType3 from "../../resources/img/event_typeC.png";
import bannerType4 from "../../resources/img/event_typeD.png";

import icn_loading from "../../resources/img/icn_loading.gif";

import "react-datepicker/dist/react-datepicker.css";
import { CalendarContainer } from 'react-datepicker';

import Pagination from "react-js-pagination";

import RLDD from 'react-list-drag-and-drop/lib/RLDD';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

/** 셀렉트 박스 */
import Select from 'react-select';
import {reactSelectStyles} from '../modules/libraries/react-select';
import makeAnimated from 'react-select/animated';

import moment from 'moment';

import queryString from 'query-string';
import * as StringUtil from '../modules/utils/StringUtil';
import CheckBox from '../modules/common/CheckBox';
import RadioButton from '../modules/common/RadioButton';
import Alert from '../modules/common/Alert';

import ReactGA from 'react-ga';
import { isThisQuarter } from 'date-fns';
import EventSettingFileName from "./EventSettingFileName";
import * as CookieUtil from "../modules/utils/CookieUtil";
import WarningDialog from "../modules/dialogs/WarningDialog";
import TitleContentDialogV2 from '../modules/dialogs/TitleContentDialogV2';
import Button from '../modules/common/Button';

import curved_arrow_right from '../../resources/img/curved_arrow_right.svg';
import crown_icon from '../../resources/img/crown_icon.svg';
import Tooltip from '../modules/common/Tooltip';
import ConfirmDialogV2 from '../modules/dialogs/ConfirmDialogV2';
import icn_filter from "../../resources/img/icn_filter.svg";
import {ScrollMenu} from "react-horizontal-scrolling-menu";
import TagButton from "../modules/common/TagButton";
import icn_refresh_2 from "../../resources/img/icn_refresh_2.svg";
import PopupFrameV2 from "../modules/popup/PopupFrameV2";

/* step 아이콘 */
import btn_step_1_default from '../../resources/img/step/btn_step_1_default.svg';
import btn_step_2_default from '../../resources/img/step/btn_step_2_default.svg';
import btn_step_3_default from '../../resources/img/step/btn_step_3_default.svg';
import btn_step_4_default from '../../resources/img/step/btn_step_4_default.svg';

import btn_step_1_hover from '../../resources/img/step/btn_step_1_hover.svg';
import btn_step_2_hover from '../../resources/img/step/btn_step_2_hover.svg';
import btn_step_3_hover from '../../resources/img/step/btn_step_3_hover.svg';
import btn_step_4_hover from '../../resources/img/step/btn_step_4_hover.svg';

import btn_step_1_active from '../../resources/img/step/btn_step_1_active.svg';
import btn_step_2_active from '../../resources/img/step/btn_step_2_active.svg';
import btn_step_3_active from '../../resources/img/step/btn_step_3_active.svg';
import btn_step_4_active from '../../resources/img/step/btn_step_4_active.svg';

ReactGA.initialize('UA-78553461-8');

const animatedComponents = makeAnimated();

var ga_label = sessionStorage.getItem("userName") + "(" + sessionStorage.getItem("user_id") + ")";

let is_test_use = "";
if (document.domain.indexOf("127.0.0.1") >= 0 || document.domain.indexOf("otdeal.me") >= 0) {
    is_test_use = "&is_test_use=Y"
}

var is_step_change = false;
var is_step_1_complete = false;
var is_step_2_complete = false;
var is_step_3_complete = false;
var is_step_4_complete = false;
var is_category_add_all = false;
var is_category_remove_all = false;
var is_category_add_member = false;
var is_category_remove_member = false;
var is_category_add_non = false;
var is_category_remove_non = false;
var is_item_cnt_vaidate_all = false;
var is_item_cnt_vaidate_member = false;
var is_item_cnt_vaidate_non = false;

var is_free_finish = false
var is_order = false
var is_install = false

var isFormIncomplete = true;

var category_page_depth = -1;

let window_scrollTop;

export class EventSetting extends React.Component {
    state = {
        single_size : true,
        querystring: queryString.parse(this.props.location.search),

        solution_type_cd : "", // 비연동 서비스 구분자 : 09900
        roleType : "", // 사용자 권한

        step: "0",

        user_seq : "",
        event_period : "",
        event_cycle : "0",
        event_ampm : "",
        event_time : "12",
        event_type : "A",
        shop_intro_title : "",
        shop_intro_content : "",

        checked_pc_banner_list: [],
        checked_mobile_banner_list: [],
        // checked_pc_banner_type_list: [],
        // checked_mobile_banner_type_list: [],

        pc_banner_type_paging : {
            activePage: 1,
            totalCnt: 0,
            startIdx: 0,
            rowcnt:15,
        },
        
        mobile_banner_type_paging : {
            activePage: 1,
            totalCnt: 0,
            startIdx: 0,
            rowcnt:12,
        },

        all_user_item : {
            event_item_created_period: "0",
            event_item_analysis_period: "1",

            event_item_min_price: "",
            event_item_max_price: "",
            isAnyPrice:false,

            event_item_min_hit: "",
            event_item_max_hit: "",
            isAnyHit:false,

            event_item_min_review: "",
            event_item_max_review: "",
            isAnyReview:true,

            event_item_min_order: "",
            event_item_max_order: "",
            isAnyOrder:false,

            event_item_min_quantity: "",
            event_item_max_quantity: "",
            isAnyQuantity:false,

            product_duplicate_check_type: "",
        },
        member_user_item : {
            event_item_created_period: "0",
            event_item_analysis_period: "1",

            event_item_min_price: "",
            event_item_max_price: "",
            isAnyPrice:false,

            event_item_min_hit: "",
            event_item_max_hit: "",
            isAnyHit:false,

            event_item_min_review: "",
            event_item_max_review: "",
            isAnyReview:true,

            event_item_min_order: "",
            event_item_max_order: "",
            isAnyOrder:false,

            event_item_min_quantity: "",
            event_item_max_quantity: "",
            isAnyQuantity:false,

            product_duplicate_check_type: "",
        },
        none_user_item : {
            event_item_created_period: "0",
            event_item_analysis_period: "1",

            event_item_min_price: "",
            event_item_max_price: "",
            isAnyPrice:false,

            event_item_min_hit: "",
            event_item_max_hit: "",
            isAnyHit:false,

            event_item_min_review: "",
            event_item_max_review: "",
            isAnyReview:true,

            event_item_min_order: "",
            event_item_max_order: "",
            isAnyOrder:false,

            event_item_min_quantity: "",
            event_item_max_quantity: "",
            isAnyQuantity:false,

            product_duplicate_check_type: "",
        },

        event_item_user_type: "",

        event_banner_pc_option_value: "1.33",
        event_banner_mobile_option_value: "1.5",
        // event_banner_pc_width: "1.33",
        event_banner_pc_width: "",
        // event_banner_mobile_width: "1.5",
        event_banner_mobile_width: "",
        // event_banner_pc_height: "1",
        event_banner_pc_height: "",
        // event_banner_mobile_height: "1",
        event_banner_mobile_height: "",

        event_period_text : "",
        event_cycle_text : "반복안함",
        event_item_created_period_text:"날짜 무관",
        event_item_analysis_period_text:"1주",
        event_ampm_text : "",
        event_time_text : "12",
        event_type_text : "A",

        event_banner_pc_width_text : "1.33 : 1",
        event_banner_mobile_width_text : "1.5 : 1",

        bannerTypeList: [],
        mobileBannerTypeList: [],
        bannerImgWidth: 0 + "%",
        mobileBannerImgWidth: 0 + "%",
        categoryList:[],

        domain_list:[],
        input_domain_width:  "35px",

        event_type_arr: [],
        event_mobile_type_arr: [],
        non_use_event_type_list : [],
        non_use_event_mobile_type_list : [],
        pcBannerSizeList: [],
        mobileBannerSizeList:[],

        cafe24ShopsList:[],
        shop_no: "1",
        reg_date: "",

        isAnyPrice : false,
        iframe_page_id : sessionStorage.getItem("solution_type_cd") == "09900" ? "robomd_main_page" : "",
        iframe_html_id : "",
        iframe_html_name : "",
        is_iframe_page_id_loaded : false,

        iframe_html_id_list : [],

        hour_list: [],

        select_catefory_for_all_user_1: "",
        select_catefory_for_all_user_2: "",
        select_catefory_for_all_user_3: "",
        select_catefory_for_all_user_4: "",

        select_category_no_list_for_all_user : [],
        select_category_name_list_for_all_user : [],

        select_catefory_for_only_user_1: "",
        select_catefory_for_only_user_2: "",
        select_catefory_for_only_user_3: "",
        select_catefory_for_only_user_4: "",

        select_category_no_list_for_only_user : [],
        select_category_name_list_for_only_user : [],

        select_catefory_for_non_user_1: "",
        select_catefory_for_non_user_2: "",
        select_catefory_for_non_user_3: "",
        select_catefory_for_non_user_4: "",

        select_category_no_list_for_non_user : [],
        select_category_name_list_for_non_user : [],

        allUserItemCnt: "-",
        memberUserItemCnt:  "-",
        nonUserItemCnt:  "-",

        iframe_page_name_list: [],

        display_yn: "Y",

        is_custom_pc_banner_size: true,
        is_custom_mobile_banner_size: true,

        page_control_type: "",
        page_control_position_type: "",

        transition_mode: "",    //27000
        transition_speed: "",   //28000
        transition_pause: "",   //29000
        transition_speed_val: "",
        transition_pause_val: "",

        translated_yn: "N",     /*번역 여부*/
        language_code: "",

        gif_divide_yn: "N",     /*gif 분리 여부*/

        link_open_type_list: [],
        link_open_type: "48002",    /* 링크 열기 타입 */

        transition_mode_code_list:[],   /*슬라이드 전환 효과 코드 리스트*/
        transition_speed_code_list:[],  /*슬라이드 전환 효과 속도 코드 리스트*/
        transition_pause_code_list:[],  /*슬라이드 전환 시간 코드 리스트*/

        language_code_list:[],  /*번역 언어 코드 리스트*/

        category_page_1: "",
        category_page_2: "",
        category_page_3: "",
        category_page_4: "",
        category_page_step: 0,

        is_file_name_setting_open: false, // 파일명 규칙 설정 팝업 열림 여부
        file_name_setting_yn: "",         // 파일명 규칙 설정 여부

        is_use_target_view_service : "N", // 타겟뷰 서비스 사용 여부,
        slide_yn : "Y", // 배너 슬라이드 여부
        event_show_type : "70001", // 디자인 노출 유형
        // 팝업 관련 값
        popup_position : "71001", // 팝업 위치
        popup_block_cycle : "72001", // 팝업 차단 주기
        popup_block_cycle_title : "", // 팝업 차단 주기 제목
        popup_target_type : "73001", // 노출 대상
        popup_target_view_seq_list : [], // 타겟뷰 시퀀스 목록
        popup_seq : "", // 팝업 시퀀스
        popup_close_btn_title_cd : "74001",
        popup_close_btn_title : "",

        event_show_type_list : [],
        popup_position_list : [],
        popup_block_cycle_list : [],
        popup_close_btn_title_list : [],
        popup_target_type_list : [],
        popup_target_view_list : [],
        target_view_list : [],

        // 템플릿 필터 태그 가로 스크롤 동작
        selected: "",
        clicked: false,
        dragging: false,
        position: 0,

        template_ctg_list: [],        // 템플릿 카테고리 리스트
        template_tag_list: [],        // 템플릿 태그 리스트
        w_template_all_tag_list: {    // 가로 템플릿 카테고리별 태그 리스트
            bsn: [],
            usg: [],
            lyt: [],
            sty: [],
        },
        h_template_all_tag_list: {    // 세로 템플릿 카테고리별 태그 리스트
            bsn: [],
            usg: [],
            lyt: [],
            sty: [],
        },
        w_selected_tags: {             // 가로 템플릿 카테고리별 선택된 태그 리스트
            bsn: [],
            usg: [],
            lyt: [],
            sty: [],
        },
        h_selected_tags: {             // 세로 템플릿 카테고리별 선택된 태그 리스트
            bsn: [],
            usg: [],
            lyt: [],
            sty: [],
        },
        w_all_selected: {              // 가로 템플릿 카테고리별 전체 선택 여부
            bsn: false,
            usg: false,
            lyt: false,
            sty: false,
        },
        h_all_selected: {              // 세로 템플릿 카테고리별 전체 선택 여부
            bsn: false,
            usg: false,
            lyt: false,
            sty: false,
        },
        w_all_tag_selected: true,                     // 가로 템플릿 필터 전체 태그 버튼 선택 여부
        h_all_tag_selected: true,                     // 세로 템플릿 필터 전체 태그 버튼 선택 여부
        show_template_filter_popup: false,            // 템플릿 필터 팝업
        show_template_filter_popup_type: "03000",     // 템플릿 필터 팝업 가로/세로 타입 구분

        banner_arrow_position_list: [
            {value: "A3001", text: "이미지 양끝에서 매우 가깝게", img_url: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/banner_arrow/arrow_very_close.png", img_width: "200px"},
            {value: "A3002", text: "이미지 양끝에서 적당히", img_url: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/banner_arrow/arrow_reasonable_far.png", img_width: "200px"},
            {value: "A3003", text: "이미지 양끝에서 멀리", img_url: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/banner_arrow/arrow_far.png", img_width: "200px"},
            {value: "A3004", text: "이미지 양끝에서 매우 멀리", img_url: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/banner_arrow/arrow_very_far.png", img_width: "200px"},
        ],
        banner_arrow_box_list: [
            {value: "A4001", text: "화살표만", img_url: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/banner_arrow/arrow_nomal.png", img_height: "60px"},
            {value: "A4002", text: "흰색박스", img_url: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/banner_arrow/arrow_white_box.png", img_height: "60px"},
            {value: "A4003", text: "반투명 라운드박스", img_url: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/banner_arrow/arrow_round_translucent.png", img_height: "60px"},
            {value: "A4004", text: "동그란 박스", img_url: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/banner_arrow/arrow_round_box.png", img_height: "60px"},
            {value: "A4005", text: "반투명 박스", img_url: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/banner_arrow/arrow_translucent.png", img_height: "60px"},
            {value: "A4006", text: "검정 박스", img_url: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/banner_arrow/arrow_black_box.png", img_height: "60px"},
        ],

        banner_arrow_color_list: [
            {value: "A5001", text: "블랙"},
            {value: "A5002", text: "흰색"},
            {value: "A5003", text: "회색"},
        ],

        banner_arrow_size_border_width_list: [
            {value: "A6001", text: "작게", img_url: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/banner_arrow/arrow_small.png", img_height: "20px"},
            {value: "A6002", text: "적당히", img_url: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/banner_arrow/arrow_nomal.png", img_height: "40px"},
            {value: "A6003", text: "얇게", img_url: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/banner_arrow/arrow_thin.png", img_height: "45px"},
            {value: "A6004", text: "크게", img_url: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/banner_arrow/arrow_big.png", img_height: "80px"},
        ],
        
        banner_arrow_hover_yn_list: [
            {value: "Y", text: "예"},
            {value: "N", text: "아니요 (항상 표시)"},
        ],

        banner_arrow_use_yn: "N",
        banner_arrow_position: "A3001",
        banner_arrow_box: "A4001",
        banner_arrow_color: "A5001",
        banner_arrow_size_border_width: "A6001",
        banner_arrow_hover_yn: "N",

        popup_block_cycle_day: 1,
        popup_block_cycle_default_text: "오늘 하루 보지 않기",

        popup_position_left: 0,
        popup_position_right: 0,
        popup_position_top: 0,
        popup_position_bottom : 0,

        popup_delay_type_list: [],
        popup_delay_type_cd: "75001",
        popup_delay_time: 1, 
    };

    setBindingHandler() {
        this.setInnerWidth = this.setInnerWidth.bind(this);
    }

    componentDidMount(e) {
        this.setBindingHandler();
        
        this.setState({solution_type_cd: CookieUtil.getCookie("solution_type_cd"), roleType: sessionStorage.getItem("roleType")}, () => {
            if(this.state.solution_type_cd == '09900') {
                this.setState({step: "0"})
            }
        });

        console.log("#### solution_type_cd(sessionStorage) ####", sessionStorage.getItem('solution_type_cd'));
        console.log("#### solution_type_cd(cookie) ####", CookieUtil.getCookie('solution_type_cd'));

        // var checkUnload = true;
        // $(window).on("beforeunload", function(){
        //     if(checkUnload) {
        //         return "이 페이지를 벗어나면 저장하지 않은 내용은 모두 초기화 됩니다.";
        //     }
        // });

        for(var j=0; j<2; j++) {
            for(var i=0; i<=11; i++ ) {
                const {hour_list} = this.state;
                if (j==0) {
                    if (i == 0) {
                        hour_list.push({key:i , hour:"오전 "+12+"시"});
                    } else {
                        hour_list.push({key:i , hour:"오전 "+i+"시"});
                    }
                } else {
                    if (i == 0) {
                        hour_list.push({key:i+12 , hour:"오후 "+12+"시"});
                    } else {
                        hour_list.push({key:i+12 , hour:"오후 "+i+"시"});
                    }
                }
                this.setState({hour_list: hour_list});
            }
        }

        // this.loadCommonCode("16000", "iframe_page_name_list")
        // this.loadCommonCodeForAutoEvent("16000", "iframe_page_name_list")
        this.loadIframePageNameList()
        this.loadCommonCode("20000", "product_duplicate_check_type_list")
        this.loadCommonCode("48000", "link_open_type_list")

        this.loadCommonCode("70000", "event_show_type_list");
        this.loadCommonCode("71000", "popup_position_list");
        this.loadCommonCode("72000", "popup_block_cycle_list",
            (list) => {
                if(!(this.state.querystring.iframe_page_id && this.state.querystring.iframe_html_id)){
                    this.setState({popup_block_cycle_title: list.find(obj => obj.code_cd == "72001").val2})
                }
            }
        );
        this.loadCommonCode("73000", "popup_target_type_list");
        this.loadCommonCode("74000", "popup_close_btn_title_list", 
            (list) => {
                if(!(this.state.querystring.iframe_page_id && this.state.querystring.iframe_html_id)){
                    this.setState({popup_close_btn_title: list.find(obj => obj.code_cd == "74001").val1})
                }
            }
        );
        this.loadCommonCode("75000", "popup_delay_type_list");

        // this.getIframeHtmlIdList();
        if (this.state.querystring.iframe_page_id && this.state.querystring.iframe_html_id) {
            this.getSetting();
        } else {
            this.setState({step:"0"});

            // 페이징된 배너 디자인 목록 조회
            //this.getCafe24CodePaging("03000");
            //this.getCafe24CodePaging("07000");
            this.getBannerDesignTemplateFilter();
            this.getBannerDesignTemplateUserFavoritePaging("03000").then(r => {});
            this.getBannerDesignTemplateUserFavoritePaging("07000").then(r => {});

            // 슬라이드 전환 효과 코드 조회
            this.getCafe24Code("27000");
            // 슬라이드 전환 효과 속도 코드 조회
            this.getCafe24Code("28000");
            // 슬라이드 전환 시간 코드 조회
            this.getCafe24Code("29000");

            /** 일정, 상품탭 초기화 */
            // 일정탭 state
            let start_date = new Date().setDate(new Date().getDate() + 1);
            let {event_period, event_cycle, event_ampm, event_time, event_period_text, event_cycle_text} = this.state;
            event_period = "3";
            event_cycle = "3";
            event_ampm = "am";
            event_time = "9";
            event_period_text = "3일";
            event_cycle_text = "3일";
            // 상품탭 state
            let {all_user_item, member_user_item, none_user_item} = this.state;
            all_user_item["isAnyPrice"] = true;
            all_user_item["isAnyHit"] = true;
            all_user_item["isAnyOrder"] = true;
            all_user_item["isAnyQuantity"] = true;
            all_user_item["product_duplicate_check_type"] = "20001";
            
            member_user_item["isAnyPrice"] = true;
            member_user_item["isAnyHit"] = true;
            member_user_item["isAnyOrder"] = true;
            member_user_item["isAnyQuantity"] = true;
            member_user_item["product_duplicate_check_type"] = "20001";
            
            none_user_item["isAnyPrice"] = true;
            none_user_item["isAnyHit"] = true;
            none_user_item["isAnyOrder"] = true;
            none_user_item["isAnyQuantity"] = true;
            none_user_item["product_duplicate_check_type"] = "20001";
            
            this.setState({
                start_date : start_date,
                all_user_item : all_user_item,
                member_user_item : member_user_item,
                none_user_item : none_user_item,
                event_period : event_period,
                event_cycle : event_cycle,
                event_ampm : event_ampm,
                event_time : event_time,
                event_period_text : event_period_text,
                event_cycle_text : event_cycle_text,
            })
        }

        if(this.state.event_item_user_type == null || this.state.event_item_user_type == "") { // 최초 설정시 배너용 쌍품 유저 타입
            $("#all_user").attr("checked", true);
            this.setState({event_item_user_type: 15001})
        } 

        this.loadProductCategory("", 1); // 최상위 카테고리 조회
        // this.loadPageCategory("", 1); // 최상위 카테고리 조회
        this.stroeOrSettingCnt(); // 무료체험, 결제 상태 조회

        // 대제목 언어 선택 코드 조회
        this.getCafe24Code("23000");

        this.getTargetViewList(); // 타겟뷰 목록 조회

        $(document).ready(function () {
            if(sessionStorage.getItem('is_reduct_left_menu') == 'T'){
                $(".wrap_file_name_setting").css("margin-left", "96px");
            } else{
                $(".wrap_file_name_setting").css("margin-left", "260px");
            }

        });

        window.addEventListener("resize", this.setInnerWidth);
    }
    
    componentDidUpdate(e) {
        // 화면 스크롤 고정
        if( this.state.is_file_name_setting_open
            || this.state.warning_dialog_show_state
            || this.state.title_content_dialog_show_state) {
            document.body.style.overflow = 'hidden'; // 스크롤 고정
        } else {
            document.body.style.overflow = 'auto'; // 스크롤 고정 해제
        }

        if(is_step_change) {
            // 스크롤탑
            window.scrollTo(0, 0);
            
            if (Number(this.state.step) == 1) { // 스케줄 설정
                // $("#event_time").val(this.state.event_time).attr("selected", "selected");
                $("#event_period_"+this.state.event_period).addClass("active");
                $("#event_cycle_"+this.state.event_cycle).addClass("active");
            } else if (Number(this.state.step) == 2) { // 상품설정
    
            } else if (Number(this.state.step) == 3) { // 배너 스타일 설정
                $("#event_banner_pc_width").val(this.state.event_banner_pc_option_value).attr("selected", "selected");
                $("#event_banner_mobile_width").val(this.state.event_banner_mobile_option_value).attr("selected", "selected");
            }

            is_step_change = false;
        }

        if (is_category_add_all || is_category_remove_all) {
            // this.getItemCntCheckValidate("all");
            is_category_add_all = false;
            is_category_remove_all = false;
        }

        if (is_category_add_member || is_category_remove_member) {
            // this.getItemCntCheckValidate("member");
            is_category_add_member = false;
            is_category_remove_member = false;
        }

        if (is_category_add_non|| is_category_remove_non) {
            // this.getItemCntCheckValidate("non");
            is_category_add_non = false;
            is_category_remove_non = false;
        }


        if (this.state.all_user_item.isAnyPrice == true) {
            $("#event_item_min_price").attr("disabled", "true");           
            $("#event_item_max_price").attr("disabled", "true");
            $("#event_item_min_price").val("");
            $("#event_item_max_price").val("");
        }
        if (this.state.all_user_item.isAnyHit == true) {
            // console.log($("#event_item_min_hit"));
            $("#event_item_min_hit").attr("disabled", "true");           
            $("#event_item_max_hit").attr("disabled", "true");
            $("#event_item_min_hit").val("");
            $("#event_item_max_hit").val("");
        }
        if (this.state.all_user_item.isAnyReview == true) {
            $("#event_item_min_review").attr("disabled", "true");           
            $("#event_item_max_review").attr("disabled", "true");
            $("#event_item_min_review").val("");
            $("#event_item_max_review").val("");
        }
        if (this.state.all_user_item.isAnyOrder == true) {
            $("#event_item_min_order").attr("disabled", "true");           
            $("#event_item_max_order").attr("disabled", "true");
            $("#event_item_min_order").val("");
            $("#event_item_max_order").val("");
        }
        if (this.state.all_user_item.isAnyQuantity == true) {
            $("#event_item_min_quantity").attr("disabled", "true");           
            $("#event_item_max_quantity").attr("disabled", "true");
            $("#event_item_min_quantity").val("");
            $("#event_item_max_quantity").val("");
        }


        if (this.state.member_user_item.isAnyPrice == true) {
            $("#event_item_min_price_member_user").attr("disabled", "true");           
            $("#event_item_max_price_member_user").attr("disabled", "true");
            $("#event_item_min_price_member_user").val("");
            $("#event_item_max_price_member_user").val("");
        }
        if (this.state.member_user_item.isAnyHit == true) {
            $("#event_item_min_hit_member_user").attr("disabled", "true");           
            $("#event_item_max_hit_member_user").attr("disabled", "true");
            $("#event_item_min_hit_member_user").val("");
            $("#event_item_max_hit_member_user").val("");
        }
        if (this.state.member_user_item.isAnyReview == true) {
            $("#event_item_min_review_member_user").attr("disabled", "true");           
            $("#event_item_max_review_member_user").attr("disabled", "true");
            $("#event_item_min_review_member_user").val("");
            $("#event_item_max_review_member_user").val("");
        }
        if (this.state.member_user_item.isAnyOrder == true) {
            $("#event_item_min_order_member_user").attr("disabled", "true");           
            $("#event_item_max_order_member_user").attr("disabled", "true");
            $("#event_item_min_order_member_user").val("");
            $("#event_item_max_order_member_user").val("");
        }
        if (this.state.member_user_item.isAnyQuantity == true) {
            $("#event_item_min_quantity_member_user").attr("disabled", "true");           
            $("#event_item_max_quantity_member_user").attr("disabled", "true");
            $("#event_item_min_quantity_member_user").val("");
            $("#event_item_max_quantity_member_user").val("");
        }


        if (this.state.none_user_item.isAnyPrice == true) {
            $("#event_item_min_price_none_user").attr("disabled", "true");           
            $("#event_item_max_price_none_user").attr("disabled", "true");
            $("#event_item_min_price_none_user").val("");
            $("#event_item_max_price_none_user").val("");
        }
        if (this.state.none_user_item.isAnyHit == true) {
            $("#event_item_min_hit_none_user").attr("disabled", "true");           
            $("#event_item_max_hit_none_user").attr("disabled", "true");
            $("#event_item_min_hit_none_user").val("");
            $("#event_item_max_hit_none_user").val("");
        }
        if (this.state.none_user_item.isAnyReview == true) {
            $("#event_item_min_review_none_user").attr("disabled", "true");           
            $("#event_item_max_review_none_user").attr("disabled", "true");
            $("#event_item_min_review_none_user").val("");
            $("#event_item_max_review_none_user").val("");
        }
        if (this.state.none_user_item.isAnyOrder == true) {
            $("#event_item_min_order_none_user").attr("disabled", "true");           
            $("#event_item_max_order_none_user").attr("disabled", "true");
            $("#event_item_min_order_none_user").val("");
            $("#event_item_max_order_none_user").val("");
        }
        if (this.state.none_user_item.isAnyQuantity == true) {
            $("#event_item_min_quantity_none_user").attr("disabled", "true");           
            $("#event_item_max_quantity_none_user").attr("disabled", "true");
            $("#event_item_min_quantity_none_user").val("");
            $("#event_item_max_quantity_none_user").val("");
        }
    }

    componentWillUnmount = () => {
        window.removeEventListener("resize", this.setInnerWidth);
    }

    setInnerWidth = () => {
        this.setState({ innerWidth : window.innerWidth });
    }

    loadCommonCode(upper_code_cd, stateName, callback=()=>{}) {
        http.get("/rest/common/cafe24Code?upper_code_cd="+upper_code_cd+is_test_use)
        .then(res => {
            // console.log(res.data);
            this.setState({[stateName]: res.data}, () => {
                if (upper_code_cd == "72000") {
                    const popup_block_cycle_list = this.state.popup_block_cycle_list;
                    const popup_block_cycle = this.state.popup_block_cycle;

                    const result = popup_block_cycle_list
                    .find(item => item.code_cd === popup_block_cycle)
                    ?.val3;

                    this.setState({
                        popup_block_cycle_day: result,
                    });
                }
            });
            return res.data;
        })
        .then((list) => {
            callback(list);
        })
    }

    loadCommonCodeForAutoEvent(upper_code_cd, stateName) {
        http.get("/rest/common/cafe24AutoEventCode?upper_code_cd="+upper_code_cd)
        .then(res => {
            // console.log(res.data);
            this.setState({[stateName]: res.data});
        })
    }
    
    loadIframePageNameList() {
        http.get("/rest/common/cafe24AutoEventCode?upper_code_cd=16000")
        .then(res => {
            let iframe_page_name_list = res.data;
            let popup_iframe_page_name_list = [];
            let idx = 0;
            for (let index in iframe_page_name_list) {
                if (iframe_page_name_list[index]["is_popup_use"] == "Y") {
                    popup_iframe_page_name_list[idx] = iframe_page_name_list[index]
                    idx ++;
                }
            }
            this.setState({
                iframe_page_name_list,
                banner_iframe_page_name_list:iframe_page_name_list,
                popup_iframe_page_name_list,
            }, () => {
                if (window.location.href.includes('/popup')) {
                    this.onChangeEventShowType("70002");
                }
            });
        })
    }

    getSetting = () => {
        http.get("/rest/shop/event/setting?iframe_page_id="+this.state.querystring.iframe_page_id+"&iframe_html_id="+this.state.querystring.iframe_html_id)
            .then(
                resultData => { 
                    if (resultData.data.err_code == 401) {
                        window.location.href = "/logout";
                    } else if (resultData.data.err_code == 404) {
                        alert("접근할 수 없는 배너 설정입니다.")
                        window.location.href = "/shop/cafe24/event/setting/list";
                    }

                    // 팝업 설정인데
                    if (resultData.data.list[0].event_show_type == "70002") {
                        if (this.state.popup_iframe_page_name_list.length > 0) {
                            let popup_iframe_page_name_list = this.state.popup_iframe_page_name_list;
                            let is_not_popup_page = true;
                            for(let idx in popup_iframe_page_name_list) {
                                if (popup_iframe_page_name_list[idx]["code_name"] == resultData.data.list[0].iframe_page_id) {
                                    is_not_popup_page = false;
                                }
                            }
                            // 팝업 페이지 목록이 아닌 경우
                            if (is_not_popup_page) {
                                alert("접근할 수 없는 배너 설정입니다.")
                                window.location.href = "/shop/cafe24/event/setting/list";
                            }
                        }
                    }

                    var pcBannerSizeList = resultData.data.pcBannerSizeList;
                    var mobileBannerSizeList = resultData.data.mobileBannerSizeList;
                    pcBannerSizeList.push({
                        code_name: "0",
                        val1: "기타 (직접 입력)"
                    })
                    
                    mobileBannerSizeList.push({
                        code_name: "0",
                        val1: "기타 (직접 입력)"
                    })

                    this.setState({ pcBannerSizeList: pcBannerSizeList});
                    this.setState({ mobileBannerSizeList: mobileBannerSizeList});

                    if(resultData.data.bannerTypeList != null && resultData.data.bannerTypeList.length > 0) {
                        this.setState({bannerTypeList : resultData.data.bannerTypeList});
                        if (resultData.data.bannerTypeList.length >= 4) {
                            this.setState({bannerImgWidth : parseInt((100 / 4)-6) + "%"});
                        } else {
                            this.setState({bannerImgWidth : parseInt((100 / resultData.data.bannerTypeList.length)-6) + "%"});
                        }
                        var bannerImgWidth = this.state.bannerImgWidth;
                        $(".banner-inner").css("width", bannerImgWidth);
                    }
                    if(resultData.data.mobileBannerTypeList != null && resultData.data.mobileBannerTypeList.length > 0) {
                        this.setState({mobileBannerTypeList : resultData.data.mobileBannerTypeList});
                        if (resultData.data.mobileBannerTypeList.length >= 4) {
                            this.setState({mobileBannerImgWidth : parseInt((100 / 4)-6) + "%"});
                        } else {
                            this.setState({mobileBannerImgWidth : parseInt((100 / resultData.data.mobileBannerTypeList.length)-6) + "%"});
                        }
                        var mobileBannerImgWidth = this.state.mobileBannerImgWidth;
                        $(".mobile-banner-inner").css("width", mobileBannerImgWidth);
                    }
                    if(resultData.data.categoryList != null && resultData.data.categoryList.length > 0) {
                        this.setState({categoryList : resultData.data.categoryList});
                    }
                    if(resultData.data.cafe24ShopsList != null && resultData.data.cafe24ShopsList.length > 0) {
                        this.setState({cafe24ShopsList: resultData.data.cafe24ShopsList});
                        if(resultData.data.list!= null && resultData.data.list.length > 0) {
                            console.log("### shop_no: "+resultData.data.list[0].shop_no);
                            $("#cafe24Shops").val(resultData.data.list[0].shop_no).attr("selected", "selected");
                        }
                        this.setState({shop_no:$("#cafe24Shops").val()});
                    }
                    if(resultData.data.list!= null && resultData.data.list.length > 0) {
                        let popup_position_left = 0;
                        let popup_position_right = 0;
                        let popup_position_top = 0;
                        let popup_position_bottom = 0;
                        if (resultData.data.list[0].popup_position_x > 0) {
                            popup_position_right = resultData.data.list[0].popup_position_x;
                        } else if (resultData.data.list[0].popup_position_x < 0) {
                            popup_position_left = -1 * resultData.data.list[0].popup_position_x;
                        }
                        if (resultData.data.list[0].popup_position_y > 0) {
                            popup_position_top = resultData.data.list[0].popup_position_y;
                        } else if (resultData.data.list[0].popup_position_y < 0) {
                            popup_position_bottom = -1 * resultData.data.list[0].popup_position_y;
                        }

                        this.setState({user_seq : resultData.data.list[0].user_seq});
                        this.setState({event_period : resultData.data.list[0].event_period});
                        this.setState({event_cycle : resultData.data.list[0].event_cycle});
                        this.setState({reg_date: resultData.data.list[0].reg_date});
                        this.setState({display_yn: resultData.data.list[0].display_yn});
                        this.setState({install_yn: resultData.data.list[0].install_yn});

                        this.setState({file_name_setting_yn: resultData.data.list[0].file_name_setting_yn});
                        this.setState({
                            slide_yn : resultData.data.list[0].slide_yn,
                            event_show_type : resultData.data.list[0].event_show_type,
                            popup_position : resultData.data.list[0].popup_position,
                            popup_block_cycle : resultData.data.list[0].popup_block_cycle,
                            popup_block_cycle_title : resultData.data.list[0].popup_block_cycle_title,
                            
                            popup_block_cycle_day : resultData.data.list[0].popup_block_cycle_day,
                            popup_close_btn_title : resultData.data.list[0].popup_close_btn_title,
                            popup_close_btn_title_cd : resultData.data.list[0].popup_close_btn_title_cd,
                            
                            popup_target_type : resultData.data.list[0].popup_target_type,
                            popup_target_view_list : resultData.data.list[0].popup_target_view_list,
                            
                            popup_seq : resultData.data.list[0].popup_seq,
                            
                            popup_position_left,
                            popup_position_right,
                            popup_position_top,
                            popup_position_bottom,
                            
                            popup_delay_type_cd : resultData.data.list[0].popup_delay_type_cd ? resultData.data.list[0].popup_delay_type_cd : "75001",
                            popup_delay_time : resultData.data.list[0].popup_delay_time ? resultData.data.list[0].popup_delay_time : 1,
                        }, () => {
                            // 사용자 멀티샵 서비스 무료체험, 결제여부 확인
                            this.fn_shopServiceOperated("01009");   // 01009 : 타겟뷰 서비스
                        });

                        if(this.state.solution_type_cd == '09900') {
                            this.setState({
                                iframe_page_id: resultData.data.list[0].iframe_page_id,
                                iframe_page_name: resultData.data.list[0].iframe_page_name,
                                iframe_html_id: resultData.data.list[0].iframe_html_id,
                                iframe_html_name: resultData.data.list[0].iframe_html_name,
                                event_banner_pc_width: resultData.data.list[0].event_banner_pc_width,
                                event_banner_pc_height: resultData.data.list[0].event_banner_pc_height,
                                event_banner_mobile_width: resultData.data.list[0].event_banner_mobile_width,
                                event_banner_mobile_height: resultData.data.list[0].event_banner_mobile_height,
                                event_banner_pc_width_height : resultData.data.list[0].event_banner_pc_width_height,
                                event_banner_mobile_width_height : resultData.data.list[0].event_banner_mobile_width_height,
                                translated_yn : resultData.data.list[0].translated_yn,
                                display_yn : resultData.data.list[0].display_yn,
                            });

                            if (Number(resultData.data.list[0].event_banner_pc_width) / Number(resultData.data.list[0].event_banner_pc_height) > 1) {
                                this.setState({is_size_horizontal: true});
                                if (Number(resultData.data.list[0].event_banner_mobile_width) / Number(resultData.data.list[0].event_banner_mobile_height) <= 1) {
                                    this.setState({is_size_vertical: true});
                                } else {
                                    this.setState({is_size_vertical: false});
                                }
                            }
                            if (Number(resultData.data.list[0].event_banner_pc_width) / Number(resultData.data.list[0].event_banner_pc_height) <= 1)  {
                                this.setState({is_size_vertical: true});
                                if (Number(resultData.data.list[0].event_banner_mobile_width) / Number(resultData.data.list[0].event_banner_mobile_height) > 1) {
                                    this.setState({is_size_horizontal: true});
                                } else {
                                    this.setState({is_size_horizontal: false});
                                }
                            }

                            if (Number(resultData.data.list[0].event_banner_mobile_width) / Number(resultData.data.list[0].event_banner_mobile_height) > 1) {
                                this.setState({is_size_horizontal: true});
                                if (Number(resultData.data.list[0].event_banner_pc_width) / Number(resultData.data.list[0].event_banner_pc_height) <= 1) {
                                    this.setState({is_size_vertical: true});
                                } else {
                                    this.setState({is_size_vertical: false});
                                }
                            }
                            if (Number(resultData.data.list[0].event_banner_mobile_width) / Number(resultData.data.list[0].event_banner_mobile_height) <= 1) {
                                this.setState({is_size_vertical: true});
                                if (Number(resultData.data.list[0].event_banner_pc_width) / Number(resultData.data.list[0].event_banner_pc_height) > 1) {
                                    this.setState({is_size_horizontal: true});
                                } else {
                                    this.setState({is_size_horizontal: false});
                                }
                            }

                            this.getBannerDesignTemplateFilter();
                            this.getBannerDesignTemplateUserFavoritePaging("03000").then(r => {});
                            this.getBannerDesignTemplateUserFavoritePaging("07000").then(r => {});
                        }

                        if (resultData.data.list[0].event_time >= 12) {
                            this.setState({event_ampm : "pm"});
                        } else {
                            this.setState({event_ampm : "am"});
                        }
                        // if (resultData.data.list[0].event_time == 12) {    
                        //     this.setState({event_time : resultData.data.list[0].event_time});            
                        // } else if (resultData.data.list[0].event_time == 0) {
                        //     this.setState({event_time : parseInt(resultData.data.list[0].event_time) + 12});
                        // } else if (resultData.data.list[0].event_time > 12) {
                        //     this.setState({event_time : parseInt(resultData.data.list[0].event_time) - 12});
                        // } else {
                            this.setState({event_time : resultData.data.list[0].event_time});
                        // }
                        this.setState({event_type : resultData.data.list[0].event_type_cd});
                        this.setState({shop_intro_title : resultData.data.list[0].shop_intro_title});
                        this.setState({shop_intro_content : resultData.data.list[0].shop_intro_content});

                        $("#event_time").val(this.state.event_time).attr("selected", "selected");
                        // $("#event_cycle").val(this.state.event_cycle).attr("selected", "selected");
                        $("#event_type").val(this.state.event_type).attr("selected", "selected");
                        $("#event_period_"+resultData.data.list[0].event_period).addClass("active");
                        $("#event_cycle_"+resultData.data.list[0].event_cycle).addClass("active");
                        $("#"+this.state.event_ampm).attr("checked", true);

                        this.setState({iframe_html_name : resultData.data.list[0].iframe_html_name});

                        this.setState({start_date : new Date(resultData.data.list[0].start_date.replace(' 00:00:00', ''))});

                        this.setState({event_period_text : $("#event_period_"+resultData.data.list[0].event_period).text()});
                        this.setState({event_cycle_text : $("#event_cycle_"+resultData.data.list[0].event_cycle).text()});
                        // this.setState({event_cycle_text : $("#event_cycle option option:checked").text()});

                        // this.setState({event_item_min_price: resultData.data.list[0].event_item_min_price});
                        // this.setState({event_item_max_price: resultData.data.list[0].event_item_max_price});
                        // this.setState({event_item_created_period: resultData.data.list[0].event_item_created_period});
                        // this.setState({event_item_analysis_period: resultData.data.list[0].event_item_analysis_period});
                        var first_category_load = true;
                        if (resultData.data.list[0].iframe_html_id_category != null && resultData.data.list[0].iframe_html_id_category.length > 0) {
                            this.loadPageCategory("", 1, first_category_load); // 최상위 카테고리 조회
                            var categoryPageList = resultData.data.list[0].iframe_html_id_category.split(",");
                            this.setState({
                                categoryPageList : categoryPageList
                            }, () => {
                                for (var idx in categoryPageList) {
                                    if (idx == 0) {
                                        this.setState({
                                            category_page_1: categoryPageList != null && categoryPageList.length > 0 ? categoryPageList[0] : ""
                                        }, () => {
                                            first_category_load = false;
                                            this.loadPageCategory(categoryPageList[Number(idx)], Number(idx)+2, first_category_load);                       
                                        });
                                        break; // 0번째 완료 후 break :: 하위 카테고리 조회는 재귀 함수 이용.
                                    }
                                }
                            })
                        }

                        for (var settingIdx in resultData.data.list) {
                            // alert(resultData.data.list[settingIdx].event_item_user_type);
                            this.setState({event_item_user_type : resultData.data.list[settingIdx].event_item_user_type});
                            if (resultData.data.list[settingIdx].event_item_user_type == 15001 && resultData.data.list[settingIdx].item_user_type == "A") {
                                $("#all_user").attr("checked", true);
                                $("#member").attr("checked", false);
                                const { all_user_item } = this.state;
                                all_user_item["event_item_min_price"] = resultData.data.list[settingIdx].event_item_min_price;
                                all_user_item["event_item_max_price"] = resultData.data.list[settingIdx].event_item_max_price;
                                all_user_item["event_item_min_hit"] = resultData.data.list[settingIdx].event_item_min_hit;
                                all_user_item["event_item_max_hit"] = resultData.data.list[settingIdx].event_item_max_hit;
                                all_user_item["event_item_min_review"] = resultData.data.list[settingIdx].event_item_min_review;
                                all_user_item["event_item_max_review"] = resultData.data.list[settingIdx].event_item_max_review;
                                all_user_item["event_item_min_order"] = resultData.data.list[settingIdx].event_item_min_order;
                                all_user_item["event_item_max_order"] = resultData.data.list[settingIdx].event_item_max_order;
                                all_user_item["event_item_min_quantity"] = resultData.data.list[settingIdx].event_item_min_quantity;
                                all_user_item["event_item_max_quantity"] = resultData.data.list[settingIdx].event_item_max_quantity;
                                all_user_item["event_item_created_period"] = resultData.data.list[settingIdx].event_item_created_period;
                                all_user_item["event_item_analysis_period"] = resultData.data.list[settingIdx].event_item_analysis_period;
                                all_user_item["product_duplicate_check_type"] = resultData.data.list[settingIdx].product_duplicate_check_type;
                                
                                var select_category_no_list_for_all_user_array = []
                                if (resultData.data.list[settingIdx].category_no_list != null) {
                                    select_category_no_list_for_all_user_array = resultData.data.list[settingIdx].category_no_list.split(",");
                                }
                                var select_category_no_list_for_all_user = []
                                for (var idx in select_category_no_list_for_all_user_array) {
                                    select_category_no_list_for_all_user.push(select_category_no_list_for_all_user_array[idx]);
                                }
                                this.setState({
                                    all_user_item : all_user_item,
                                    select_category_no_list_for_all_user : select_category_no_list_for_all_user,
                                });
                                if (resultData.data.list[settingIdx].category_name_list != null && resultData.data.list[settingIdx].category_name_list.length > 0) {
                                    this.setState({
                                        select_category_name_list_for_all_user : JSON.parse(resultData.data.list[settingIdx].category_name_list)
                                    });
                                }
                                $("#event_item_created_period").val(this.state.all_user_item.event_item_created_period).attr("selected", "selected");
                                $("#event_item_analysis_period").val(this.state.all_user_item.event_item_analysis_period).attr("selected", "selected");
                                
                                // 가격무관
                                if (resultData.data.list[settingIdx].is_any_item_price == "Y") {
                                    const { all_user_item } = this.state;
                                    all_user_item["event_item_min_price"] = "";
                                    all_user_item["event_item_max_price"] = "";
                                    all_user_item["isAnyPrice"] = true;
                                    this.setState({
                                        all_user_item : all_user_item
                                    });

                                    $("#event_item_min_price").attr("disabled", "true");           
                                    $("#event_item_max_price").attr("disabled", "true");      
                                } else {
                                    const { all_user_item } = this.state;
                                    all_user_item["isAnyPrice"] = false;
                                    this.setState({
                                        all_user_item : all_user_item
                                    });

                                    $("#event_item_min_price").removeAttr("disabled");           
                                    $("#event_item_max_price").removeAttr("disabled");            
                                }
                                // 조회수 무관
                                if (resultData.data.list[settingIdx].is_any_item_hit == "Y") {
                                    const { all_user_item } = this.state;
                                    all_user_item["event_item_min_hit"] = "";
                                    all_user_item["event_item_max_hit"] = "";
                                    all_user_item["isAnyHit"] = true;
                                    this.setState({
                                        all_user_item : all_user_item
                                    });

                                    $("#event_item_min_hit").attr("disabled", "true");           
                                    $("#event_item_max_hit").attr("disabled", "true");      
                                } else {
                                    const { all_user_item } = this.state;
                                    all_user_item["isAnyHit"] = false;
                                    this.setState({
                                        all_user_item : all_user_item
                                    });

                                    $("#event_item_min_hit").removeAttr("disabled");           
                                    $("#event_item_max_hit").removeAttr("disabled");            
                                }
                                // 리뷰수 무관
                                if (resultData.data.list[settingIdx].is_any_item_review == "Y") {
                                    const { all_user_item } = this.state;
                                    all_user_item["event_item_min_review"] = "";
                                    all_user_item["event_item_max_review"] = "";
                                    all_user_item["isAnyReview"] = true;
                                    this.setState({
                                        all_user_item : all_user_item
                                    });

                                    $("#event_item_min_review").attr("disabled", "true");           
                                    $("#event_item_max_review").attr("disabled", "true");      
                                } else {
                                    const { all_user_item } = this.state;
                                    all_user_item["isAnyReview"] = false;
                                    this.setState({
                                        all_user_item : all_user_item
                                    });

                                    $("#event_item_min_review").removeAttr("disabled");           
                                    $("#event_item_max_review").removeAttr("disabled");            
                                }
                                // 주문수 무관
                                if (resultData.data.list[settingIdx].is_any_item_order == "Y") {
                                    const { all_user_item } = this.state;
                                    all_user_item["event_item_min_order"] = "";
                                    all_user_item["event_item_max_order"] = "";
                                    all_user_item["isAnyOrder"] = true;
                                    this.setState({
                                        all_user_item : all_user_item
                                    });

                                    $("#event_item_min_order").attr("disabled", "true");           
                                    $("#event_item_max_order").attr("disabled", "true");      
                                } else {
                                    const { all_user_item } = this.state;
                                    all_user_item["isAnyOrder"] = false;
                                    this.setState({
                                        all_user_item : all_user_item
                                    });

                                    $("#event_item_min_order").removeAttr("disabled");           
                                    $("#event_item_max_order").removeAttr("disabled");            
                                }
                                // 재고수 무관
                                if (resultData.data.list[settingIdx].is_any_item_quantity == "Y") {
                                    const { all_user_item } = this.state;
                                    all_user_item["event_item_min_quantity"] = "";
                                    all_user_item["event_item_max_quantity"] = "";
                                    all_user_item["isAnyQuantity"] = true;
                                    this.setState({
                                        all_user_item : all_user_item
                                    });

                                    $("#event_item_min_quantity").attr("disabled", "true");           
                                    $("#event_item_max_quantity").attr("disabled", "true");      
                                } else {
                                    const { all_user_item } = this.state;
                                    all_user_item["isAnyQuantity"] = false;
                                    this.setState({
                                        all_user_item : all_user_item
                                    });

                                    $("#event_item_min_quantity").removeAttr("disabled");           
                                    $("#event_item_max_quantity").removeAttr("disabled");            
                                }
                            }
                            if (resultData.data.list[settingIdx].event_item_user_type == 15002) {
                                $("#all_user").attr("checked", false);
                                $("#member").attr("checked", true);
                                if (resultData.data.list[settingIdx].item_user_type == "U") {
                                    const { member_user_item } = this.state;
                                    member_user_item["event_item_min_price"] = resultData.data.list[settingIdx].event_item_min_price;
                                    member_user_item["event_item_max_price"] = resultData.data.list[settingIdx].event_item_max_price;
                                    member_user_item["event_item_min_hit"] = resultData.data.list[settingIdx].event_item_min_hit;
                                    member_user_item["event_item_max_hit"] = resultData.data.list[settingIdx].event_item_max_hit;
                                    member_user_item["event_item_min_review"] = resultData.data.list[settingIdx].event_item_min_review;
                                    member_user_item["event_item_max_review"] = resultData.data.list[settingIdx].event_item_max_review;
                                    member_user_item["event_item_min_order"] = resultData.data.list[settingIdx].event_item_min_order;
                                    member_user_item["event_item_max_order"] = resultData.data.list[settingIdx].event_item_max_order;
                                    member_user_item["event_item_min_quantity"] = resultData.data.list[settingIdx].event_item_min_quantity;
                                    member_user_item["event_item_max_quantity"] = resultData.data.list[settingIdx].event_item_max_quantity;
                                    member_user_item["event_item_created_period"] = resultData.data.list[settingIdx].event_item_created_period;
                                    member_user_item["event_item_analysis_period"] = resultData.data.list[settingIdx].event_item_analysis_period;
                                    member_user_item["product_duplicate_check_type"] = resultData.data.list[settingIdx].product_duplicate_check_type;

                                    var select_category_no_list_for_only_user_array = []
                                    if (resultData.data.list[settingIdx].category_no_list != null) {
                                        resultData.data.list[settingIdx].category_no_list.split(",");
                                    }
                                    var select_category_no_list_for_only_user = []
                                    for (var idx in select_category_no_list_for_only_user_array) {
                                        select_category_no_list_for_only_user.push(select_category_no_list_for_only_user_array[idx]);
                                    }
                                    this.setState({
                                        member_user_item : member_user_item,
                                        select_category_no_list_for_only_user : select_category_no_list_for_only_user,
                                    })
                                    if (resultData.data.list[settingIdx].category_name_list != null && resultData.data.list[settingIdx].category_name_list.length > 0) {
                                        this.setState({
                                            select_category_name_list_for_only_user : JSON.parse(resultData.data.list[settingIdx].category_name_list)
                                        });
                                    }

                                    $("#event_item_created_period_member_user").val(this.state.member_user_item.event_item_created_period).attr("selected", "selected");
                                    $("#event_item_analysis_period_member_user").val(this.state.member_user_item.event_item_analysis_period).attr("selected", "selected");
                                
                                    // 가격수 무관
                                    if (resultData.data.list[settingIdx].is_any_item_price == "Y") {
                                        const { member_user_item } = this.state;
                                        member_user_item["event_item_min_price"] = "";
                                        member_user_item["event_item_max_price"] = "";
                                        member_user_item["isAnyPrice"] = true;
                                        this.setState({
                                            member_user_item : member_user_item
                                        });
                                        $("#event_item_min_price_member_user").attr("disabled", "true");           
                                        $("#event_item_max_price_member_user").attr("disabled", "true");      
                                    } else {
                                        const { member_user_item } = this.state;
                                        member_user_item["isAnyPrice"] = false;
                                        this.setState({
                                            member_user_item : member_user_item
                                        });
                                        $("#event_item_min_price_member_user").removeAttr("disabled");           
                                        $("#event_item_max_price_member_user").removeAttr("disabled");            
                                    }
                                    // 조회수 무관
                                    if (resultData.data.list[settingIdx].is_any_item_hit == "Y") {
                                        const { member_user_item } = this.state;
                                        member_user_item["event_item_min_hit"] = "";
                                        member_user_item["event_item_max_hit"] = "";
                                        member_user_item["isAnyHit"] = true;
                                        this.setState({
                                            member_user_item : member_user_item
                                        });
                                        $("#event_item_min_hit_member_user").attr("disabled", "true");           
                                        $("#event_item_max_hit_member_user").attr("disabled", "true");      
                                    } else {
                                        const { member_user_item } = this.state;
                                        member_user_item["isAnyHit"] = false;
                                        this.setState({
                                            member_user_item : member_user_item
                                        });
                                        $("#event_item_min_hit_member_user").removeAttr("disabled");           
                                        $("#event_item_max_hit_member_user").removeAttr("disabled");            
                                    }
                                    // 리뷰수 무관
                                    if (resultData.data.list[settingIdx].is_any_item_review == "Y") {
                                        const { member_user_item } = this.state;
                                        member_user_item["event_item_min_review"] = "";
                                        member_user_item["event_item_max_review"] = "";
                                        member_user_item["isAnyReview"] = true;
                                        this.setState({
                                            member_user_item : member_user_item
                                        });

                                        $("#event_item_min_review_member_user").attr("disabled", "true");           
                                        $("#event_item_max_review_member_user").attr("disabled", "true");      
                                    } else {
                                        const { member_user_item } = this.state;
                                        member_user_item["isAnyReview"] = false;
                                        this.setState({
                                            member_user_item : member_user_item
                                        });

                                        $("#event_item_min_review_member_user").removeAttr("disabled");           
                                        $("#event_item_max_review_member_user").removeAttr("disabled");            
                                    }
                                    // 주문수 무관
                                    if (resultData.data.list[settingIdx].is_any_item_order == "Y") {
                                        const { member_user_item } = this.state;
                                        member_user_item["event_item_min_order"] = "";
                                        member_user_item["event_item_max_order"] = "";
                                        member_user_item["isAnyOrder"] = true;
                                        this.setState({
                                            member_user_item : member_user_item
                                        });

                                        $("#event_item_min_order_member_user").attr("disabled", "true");           
                                        $("#event_item_max_order_member_user").attr("disabled", "true");      
                                    } else {
                                        const { member_user_item } = this.state;
                                        member_user_item["isAnyOrder"] = false;
                                        this.setState({
                                            member_user_item : member_user_item
                                        });

                                        $("#event_item_min_order_member_user").removeAttr("disabled");           
                                        $("#event_item_max_order_member_user").removeAttr("disabled");            
                                    }
                                    // 재고수 무관
                                    if (resultData.data.list[settingIdx].is_any_item_quantity == "Y") {
                                        const { member_user_item } = this.state;
                                        member_user_item["event_item_min_quantity"] = "";
                                        member_user_item["event_item_max_quantity"] = "";
                                        member_user_item["isAnyQuantity"] = true;
                                        this.setState({
                                            member_user_item : member_user_item
                                        });

                                        $("#event_item_min_quantity_member_user").attr("disabled", "true");           
                                        $("#event_item_max_quantity_member_user").attr("disabled", "true");      
                                    } else {
                                        const { member_user_item } = this.state;
                                        member_user_item["isAnyQuantity"] = false;
                                        this.setState({
                                            member_user_item : member_user_item
                                        });

                                        $("#event_item_min_quantity_member_user").removeAttr("disabled");           
                                        $("#event_item_max_quantity_member_user").removeAttr("disabled");            
                                    }
                                } else if (resultData.data.list[settingIdx].item_user_type == "N") {
                                    const { none_user_item } = this.state;
                                    none_user_item["event_item_min_price"] = resultData.data.list[settingIdx].event_item_min_price;
                                    none_user_item["event_item_max_price"] = resultData.data.list[settingIdx].event_item_max_price;
                                    none_user_item["event_item_min_hit"] = resultData.data.list[settingIdx].event_item_min_hit;
                                    none_user_item["event_item_max_hit"] = resultData.data.list[settingIdx].event_item_max_hit;
                                    none_user_item["event_item_min_review"] = resultData.data.list[settingIdx].event_item_min_review;
                                    none_user_item["event_item_max_review"] = resultData.data.list[settingIdx].event_item_max_review;
                                    none_user_item["event_item_min_order"] = resultData.data.list[settingIdx].event_item_min_order;
                                    none_user_item["event_item_max_order"] = resultData.data.list[settingIdx].event_item_max_order;
                                    none_user_item["event_item_min_quantity"] = resultData.data.list[settingIdx].event_item_min_quantity;
                                    none_user_item["event_item_max_quantity"] = resultData.data.list[settingIdx].event_item_max_quantity;
                                    none_user_item["event_item_created_period"] = resultData.data.list[settingIdx].event_item_created_period;
                                    none_user_item["event_item_analysis_period"] = resultData.data.list[settingIdx].event_item_analysis_period;
                                    none_user_item["product_duplicate_check_type"] = resultData.data.list[settingIdx].product_duplicate_check_type;

                                    var select_category_no_list_for_non_user_array = []
                                    if (resultData.data.list[settingIdx].category_no_list != null) {
                                        select_category_no_list_for_non_user_array = resultData.data.list[settingIdx].category_no_list.split(",");
                                    }
                                    var select_category_no_list_for_non_user = []
                                    for (var idx in select_category_no_list_for_non_user_array) {
                                        select_category_no_list_for_non_user.push(select_category_no_list_for_non_user_array[idx]);
                                    }
                                    this.setState({
                                        none_user_item : none_user_item,
                                        select_category_no_list_for_non_user : select_category_no_list_for_non_user,
                                    })
                                    if (resultData.data.list[settingIdx].category_name_list != null && resultData.data.list[settingIdx].category_name_list.length > 0) {
                                        this.setState({
                                            select_category_name_list_for_non_user : JSON.parse(resultData.data.list[settingIdx].category_name_list)
                                        });
                                    }

                                    $("#event_item_created_period_none_user").val(this.state.none_user_item.event_item_created_period).attr("selected", "selected");
                                    $("#event_item_analysis_period_none_user").val(this.state.none_user_item.event_item_analysis_period).attr("selected", "selected");
                                
                                    // 가격수 무관
                                    if (resultData.data.list[settingIdx].is_any_item_price == "Y") {
                                        const { none_user_item } = this.state;
                                        none_user_item["event_item_min_price"] = "";
                                        none_user_item["event_item_max_price"] = "";
                                        none_user_item["isAnyPrice"] = true;
                                        this.setState({
                                            none_user_item : none_user_item
                                        });
                                        $("#event_item_min_price_none_user_none_user").attr("disabled", "true");           
                                        $("#event_item_max_price_none_user_none_user").attr("disabled", "true");      
                                    } else {
                                        const { none_user_item } = this.state;
                                        none_user_item["isAnyPrice"] = false;
                                        this.setState({
                                            none_user_item : none_user_item
                                        });
                                        $("#event_item_min_price_none_user").removeAttr("disabled");           
                                        $("#event_item_max_price_none_user").removeAttr("disabled");            
                                    }
                                    // 조회수 무관
                                    if (resultData.data.list[settingIdx].is_any_item_hit == "Y") {
                                        const { none_user_item } = this.state;
                                        none_user_item["event_item_min_hit"] = "";
                                        none_user_item["event_item_max_hit"] = "";
                                        none_user_item["isAnyHit"] = true;
                                        this.setState({
                                            none_user_item : none_user_item
                                        });

                                        $("#event_item_min_hit_none_user").attr("disabled", "true");           
                                        $("#event_item_max_hit_none_user").attr("disabled", "true");      
                                    } else {
                                        const { none_user_item } = this.state;
                                        none_user_item["isAnyHit"] = false;
                                        this.setState({
                                            none_user_item : none_user_item
                                        });

                                        $("#event_item_min_hit_none_user").removeAttr("disabled");           
                                        $("#event_item_max_hit_none_user").removeAttr("disabled");            
                                    }
                                    // 리뷰수 무관
                                    if (resultData.data.list[settingIdx].is_any_item_review == "Y") {
                                        const { none_user_item } = this.state;
                                        none_user_item["event_item_min_review"] = "";
                                        none_user_item["event_item_max_review"] = "";
                                        none_user_item["isAnyReview"] = true;
                                        this.setState({
                                            none_user_item : none_user_item
                                        });

                                        $("#event_item_min_review_none_user").attr("disabled", "true");           
                                        $("#event_item_max_review_none_user").attr("disabled", "true");      
                                    } else {
                                        const { none_user_item } = this.state;
                                        none_user_item["isAnyReview"] = false;
                                        this.setState({
                                            none_user_item : none_user_item
                                        });

                                        $("#event_item_min_review_none_user").removeAttr("disabled");           
                                        $("#event_item_max_review_none_user").removeAttr("disabled");            
                                    }
                                    // 주문수 무관
                                    if (resultData.data.list[settingIdx].is_any_item_order == "Y") {
                                        const { none_user_item } = this.state;
                                        none_user_item["event_item_min_order"] = "";
                                        none_user_item["event_item_max_order"] = "";
                                        none_user_item["isAnyOrder"] = true;
                                        this.setState({
                                            none_user_item : none_user_item
                                        });

                                        $("#event_item_min_order_none_user").attr("disabled", "true");           
                                        $("#event_item_max_order_none_user").attr("disabled", "true");      
                                    } else {
                                        const { none_user_item } = this.state;
                                        none_user_item["isAnyOrder"] = false;
                                        this.setState({
                                            none_user_item : none_user_item
                                        });

                                        $("#event_item_min_order_none_user").removeAttr("disabled");           
                                        $("#event_item_max_order_none_user").removeAttr("disabled");            
                                    }
                                    // 재고수 무관
                                    if (resultData.data.list[settingIdx].is_any_item_quantity == "Y") {
                                        const { none_user_item } = this.state;
                                        none_user_item["event_item_min_quantity"] = "";
                                        none_user_item["event_item_max_quantity"] = "";
                                        none_user_item["isAnyQuantity"] = true;
                                        this.setState({
                                            none_user_item : none_user_item
                                        });

                                        $("#event_item_min_quantity_none_user").attr("disabled", "true");           
                                        $("#event_item_max_quantity_none_user").attr("disabled", "true");      
                                    } else {
                                        const { none_user_item } = this.state;
                                        none_user_item["isAnyQuantity"] = false;
                                        this.setState({
                                            none_user_item : none_user_item
                                        });

                                        $("#event_item_min_quantity_none_user").removeAttr("disabled");           
                                        $("#event_item_max_quantity_none_user").removeAttr("disabled");            
                                    }
                            }
                        }
                    }

                    if (resultData.data.list != null && resultData.data.list[0].domain_list != null) {
                        var domain_array = resultData.data.list[0].domain_list.split(",");
                        var domain_list = [];
                        if (domain_array != "") {
                            for (var idx in domain_array) {
                                domain_list.push(domain_array[idx]);
                            }
                            this.setState({domain_list: domain_list});
                        }
                    }

                    this.setState({ event_banner_pc_width: resultData.data.list[0].event_banner_pc_width
                                    , event_banner_pc_option_value : resultData.data.list[0].event_banner_pc_width
                                    , event_banner_pc_height: resultData.data.list[0].event_banner_pc_height});
                    this.setState({ event_banner_mobile_width: resultData.data.list[0].event_banner_mobile_width
                                    , event_banner_mobile_option_value: resultData.data.list[0].event_banner_mobile_width
                                    , event_banner_mobile_height: resultData.data.list[0].event_banner_mobile_height});

                    if (Number(resultData.data.list[0].event_banner_pc_width) / Number(resultData.data.list[0].event_banner_pc_height) > 1) {
                        this.setState({is_size_horizontal: true});
                        if (Number(resultData.data.list[0].event_banner_mobile_width) / Number(resultData.data.list[0].event_banner_mobile_height) <= 1) {
                            this.setState({is_size_vertical: true});
                        } else {
                            this.setState({is_size_vertical: false});
                        }
                    } 
                    if (Number(resultData.data.list[0].event_banner_pc_width) / Number(resultData.data.list[0].event_banner_pc_height) <= 1)  {
                        this.setState({is_size_vertical: true});
                        if (Number(resultData.data.list[0].event_banner_mobile_width) / Number(resultData.data.list[0].event_banner_mobile_height) > 1) {
                            this.setState({is_size_horizontal: true});
                        } else {
                            this.setState({is_size_horizontal: false});
                        }
                    }

                    if (Number(resultData.data.list[0].event_banner_mobile_width) / Number(resultData.data.list[0].event_banner_mobile_height) > 1) {
                        this.setState({is_size_horizontal: true});
                        if (Number(resultData.data.list[0].event_banner_pc_width) / Number(resultData.data.list[0].event_banner_pc_height) <= 1) {
                            this.setState({is_size_vertical: true});
                        } else {
                            this.setState({is_size_vertical: false});
                        }
                    } 
                    if (Number(resultData.data.list[0].event_banner_mobile_width) / Number(resultData.data.list[0].event_banner_mobile_height) <= 1) {
                        this.setState({is_size_vertical: true});
                        if (Number(resultData.data.list[0].event_banner_pc_width) / Number(resultData.data.list[0].event_banner_pc_height) > 1) {
                            this.setState({is_size_horizontal: true});
                        } else {
                            this.setState({is_size_horizontal: false});
                        }
                    }

                    // if (Number(resultData.data.list[0].event_banner_pc_width) / Number(resultData.data.list[0].event_banner_pc_height) <= 1) {
                    //     this.setState({is_size_horizontal: false});
                    //     this.setState({is_size_vertical: true});
                    // } 
                    
                    // if (Number(resultData.data.list[0].event_banner_mobile_width) / Number(resultData.data.list[0].event_banner_mobile_height) <= 1) {
                    //     this.setState({is_size_horizontal: false});
                    //     this.setState({is_size_vertical: true});
                    // }


                    // var idxPC = $("#event_banner_pc_width option").index( $("#event_banner_pc_width option option:checked"));
                    // var idxMobile = $("#event_banner_mobile_width option").index( $("#event_banner_mobile_width option option:checked"));
                    // this.setState({pc_banner_size_img: this.state.pcBannerSizeList[idxPC].val2})
                    // this.setState({mobile_banner_size_img: this.state.mobileBannerSizeList[idxMobile].val2})

                    // if (resultData.data.list[0].event_category_list != null) {
                    //     var categoryArray = resultData.data.list[0].event_category_list.split(",");
                    //     for (var idx in categoryArray) {
                    //         // console.log(categoryArray[idx]);
                    //         $("#"+categoryArray[idx]).prop("checked", true);
                    //     }
                    //     var i = 0;
                    //     $(".checkCategory").each( function() {
                    //         if ($(this).is(":checked")) {
                    //             i ++;
                    //         }
                    //     });
                    //     if (i == $(".checkCategory").length) {
                    //         $("#allCategory").prop( "checked", true );
                    //     } 
                    // }
                    // this.setState({ event_type_arr: JSON.parse("["+resultData.data.list[0].event_type_cds+"]")});
                    if (resultData.data.list[0].event_type_cds != null) {
                        this.setState({ event_type_arr: resultData.data.list[0].event_type_cds.split(",")});
                        var event_type_arr = resultData.data.list[0].event_type_cds.split(",");
                        // console.log(event_type_arr);
                        var element = $(".checkbox-type");
                        const {checked_pc_banner_list} = this.state;
                        for (var idx in event_type_arr) {
                            for(var i in this.state.bannerTypeList) {
                                if (this.state.bannerTypeList[i]["code_cd"] == event_type_arr[idx]) {
                                    checked_pc_banner_list.push(
                                        {
                                            id : Number(this.state.bannerTypeList[i]["code_cd"]),
                                            title : this.state.bannerTypeList[i]["code_name"],
                                            icon : this.state.bannerTypeList[i]["val2"],
                                            bannerType: this.state.bannerTypeList[i]["code_cd"]
                                        }
                                    )
                                }
                            }
                                    

                            // element.each(function( index ) {
                                // var thisElement = $(this);
                                // alert("event_type_arr: " + event_type_arr[idx]);
                                // console.log("############### event_type_arr ###############");
                                // console.log(event_type_arr[idx]);
                                // console.log(thisElement.attr('id'));
                                // console.log("##############################");
                                // if (event_type_arr[idx] == thisElement.attr('id')) {
                                    //         thisElement.text("");
                                    //         console.log(idx);
                                    //         thisElement.text(parseInt(idx)+1);
                                    //         thisElement.css("background-color", "#21a777");
                                    //     } 
                                    // });
                        }
                        this.setState({checked_pc_banner_list: checked_pc_banner_list});
                    }
                    if (resultData.data.list[0].event_mobile_type_cds != null) {
                        this.setState({ event_mobile_type_arr: resultData.data.list[0].event_mobile_type_cds.split(",")});
                        var event_mobile_type_arr = resultData.data.list[0].event_mobile_type_cds.split(",");
                        // console.log(event_mobile_type_arr);
                        var element = $(".checkbox-mobile-type");
                        const {checked_mobile_banner_list} = this.state;
                        for (var idx in event_mobile_type_arr) {
                            for(var i in this.state.mobileBannerTypeList) {
                                // alert(this.state.mobileBannerTypeList[i]["code_cd"] + " => " + (this.state.mobileBannerTypeList[i]["code_cd"] == event_mobile_type_arr[idx]));
                                // alert(this.state.mobileBannerTypeList[i]["code_cd"] == event_mobile_type_arr[idx] + " => " + event_mobile_type_arr[idx])
                                if (this.state.mobileBannerTypeList[i]["code_cd"] == event_mobile_type_arr[idx]) {
                                    checked_mobile_banner_list.push(
                                        {
                                            id : Number(this.state.mobileBannerTypeList[i]["code_cd"]),
                                            title : this.state.mobileBannerTypeList[i]["code_name"],
                                            icon : this.state.mobileBannerTypeList[i]["val2"],
                                            bannerType: this.state.mobileBannerTypeList[i]["code_cd"]
                                        }
                                    )
                                }

                            }

                            // element.each(function( index ) {
                                // var thisElement = $(this);
                                // console.log("############### event_mobile_type_arr ###############");
                                // console.log(event_mobile_type_arr[idx]);
                                // console.log(thisElement.attr('id'));
                                // console.log("##############################");
                                // if (event_mobile_type_arr[idx] == thisElement.attr('id')) {
                                    //         thisElement.text("");
                                    //         console.log(idx);
                                    //         thisElement.text(parseInt(idx)+1);
                                    //         thisElement.css("background-color", "#21a777");
                                    //     } 
                                    // });
                        }
                        this.setState({checked_mobile_banner_list: checked_mobile_banner_list});
                    }
                    
                    var is_iframe_page_id_loaded = false;
                    if (resultData.data.list[0].iframe_page_id != null && resultData.data.list[0].iframe_page_id != "") {
                        is_iframe_page_id_loaded = true;
                    }
                    
                    this.setState({
                        iframe_page_id : resultData.data.list[0].iframe_page_id,
                        iframe_html_id : resultData.data.list[0].iframe_html_id,
                        is_iframe_page_id_loaded : is_iframe_page_id_loaded,

                        banner_arrow_use_yn : resultData.data.list[0].banner_arrow_use_yn ? resultData.data.list[0].banner_arrow_use_yn : "N",
                        banner_arrow_position : resultData.data.list[0].banner_arrow_position ? resultData.data.list[0].banner_arrow_position : "A3001",
                        banner_arrow_box : resultData.data.list[0].banner_arrow_box ? resultData.data.list[0].banner_arrow_box : "A4001",
                        banner_arrow_color : resultData.data.list[0].banner_arrow_color ? resultData.data.list[0].banner_arrow_color : "A5001",
                        banner_arrow_size_border_width : resultData.data.list[0].banner_arrow_size_border_width ? resultData.data.list[0].banner_arrow_size_border_width : "A6001",
                        banner_arrow_hover_yn : resultData.data.list[0].banner_arrow_hover_yn ? resultData.data.list[0].banner_arrow_hover_yn : "N",
                        
                        page_control_type : resultData.data.list[0].page_control_type,
                        page_control_position_type : resultData.data.list[0].page_control_position_type,
                        transition_mode : resultData.data.list[0].transition_mode,
                        transition_speed : resultData.data.list[0].transition_speed,
                        transition_pause : resultData.data.list[0].transition_pause,
                        transition_speed_val : resultData.data.list[0].transition_speed_val,
                        transition_pause_val : resultData.data.list[0].transition_pause_val,
                        translated_yn : resultData.data.list[0].translated_yn,
                        language_code : resultData.data.list[0].language_code,
                        gif_divide_yn : resultData.data.list[0].gif_divide_yn,
                        link_open_type : resultData.data.list[0].link_open_type,
                    });

                    console.log(resultData.data.list[0].gif_divide_yn);
                    
                    let non_use_event_type_cd_list = [];
                    let non_use_event_mobile_type_cd_list = [];
                    for(var i=0;i<resultData.data.non_use_event_type_list.length;i++){
                        non_use_event_type_cd_list.push(resultData.data.non_use_event_type_list[i].code_cd);
                    }
                    for(var i=0;i<resultData.data.non_use_event_mobile_type_list.length;i++){
                        non_use_event_mobile_type_cd_list.push(resultData.data.non_use_event_mobile_type_list[i].code_cd);
                    }
                    
                    this.setState({
                        non_use_event_type_cd_list : non_use_event_type_cd_list,
                        non_use_event_mobile_type_cd_list : non_use_event_mobile_type_cd_list,
                    });

                    // 사이즈1, 사이즈2의 가로 세로 크기가 정확하게 동일하다면 단일 사이즈로 간주함
                    const single_size = (resultData.data.list[0].event_banner_pc_width == resultData.data.list[0].event_banner_mobile_width && resultData.data.list[0].event_banner_pc_height == resultData.data.list[0].event_banner_mobile_height);
                    this.setState({
                        single_size : single_size,
                    });

                    // 페이징된 배너 디자인 목록 조회
                    //this.getCafe24CodePaging("03000"); 
                    //this.getCafe24CodePaging("07000");
                    this.getBannerDesignTemplateFilter();
                    this.getBannerDesignTemplateUserFavoritePaging("03000").then(r => {});
                    this.getBannerDesignTemplateUserFavoritePaging("07000").then(r => {});

                    // 슬라이드 전환 효과 코드 조회
                    this.getCafe24Code("27000");
                    // 슬라이드 전환 효과 속도 코드 조회
                    this.getCafe24Code("28000");
                    // 슬라이드 전환 시간 코드 조회
                    this.getCafe24Code("29000");

                    // 상품 개수 조회
                    if (this.state.event_item_user_type == "15001") {
                        // this.getItemCntCheckValidate("all");
                    } else if (this.state.event_item_user_type == "15002") {
                        // this.getItemCntCheckValidate("member");
                        // this.getItemCntCheckValidate("non");
                    }
                }
            })
            .catch(
                error => { 
                    // console.log("저장에 실패하였습니다."); 
                }
            );
    };

    //Cafe24 공통코드 : 배너 템플릿 + 사용자 선호 템플릿 조회 (페이징)
    async getBannerDesignTemplateUserFavoritePaging(upper_code_cd, selected_tag_list) {
        var startidx = 0
        var rowcnt = 10
        if (upper_code_cd == "03000") {
            startidx = this.state.pc_banner_type_paging.startIdx;
            rowcnt = this.state.pc_banner_type_paging.rowcnt;
        } else if (upper_code_cd == "07000") {
            startidx = this.state.mobile_banner_type_paging.startIdx;
            rowcnt = this.state.mobile_banner_type_paging.rowcnt;
        }

        let tag_list = [];

        if(selected_tag_list != null && selected_tag_list != undefined && selected_tag_list.length > 0){
            tag_list = selected_tag_list;
        }

        const res = await http.get( "/rest/common/bannerDesignTemplateUserFavorite/paging"
                                    +"?upper_code_cd="+upper_code_cd
                                    +"&startidx="+startidx
                                    +"&rowcnt="+rowcnt 
                                    +"&is_auto_event_setting_use=Y" 
                                    +is_test_use
                                    +"&tag_list="+tag_list
                                    );
        if (upper_code_cd == "03000") {
            const{pc_banner_type_paging} = this.state;
            pc_banner_type_paging["totalCnt"] = res.data.totalCnt;

            this.setState({bannerTypeList : res.data.list
                            , pc_banner_type_paging : pc_banner_type_paging});
            if (res.data.list.length >= 4) {
                this.setState({bannerImgWidth : parseInt((100 / 4)-6) + "%"});
            } else {
                this.setState({bannerImgWidth : parseInt((100 / res.data.list.length)-6) + "%"});
            }

            // 가져온 배너들 중에 사용중인 배너 체크
            // var event_type_arr = res.data.listl;
            // console.log(event_type_arr);
            // for (var idx in event_type_arr) {
            //     for(var i in this.state.bannerTypeList) {
            //         if (this.state.bannerTypeList[i]["code_cd"] == event_type_arr[idx]) {
            //             const {checked_pc_banner_list} = this.state;
            //             checked_pc_banner_list.push(
            //                 {
            //                     id : Number(this.state.bannerTypeList[i]["code_cd"]),
            //                     title : this.state.bannerTypeList[i]["code_name"],
            //                     icon : this.state.bannerTypeList[i]["val2"],
            //                     bannerType: this.state.bannerTypeList[i]["code_cd"]
            //                 }
            //             )
            //             this.setState({checked_pc_banner_list: checked_pc_banner_list});
            //         }
            //     }
            // }

        } else if (upper_code_cd == "07000") {
            const{mobile_banner_type_paging} = this.state;
            mobile_banner_type_paging["totalCnt"] = res.data.totalCnt;

            this.setState({mobileBannerTypeList : res.data.list
                            , mobile_banner_type_paging : mobile_banner_type_paging});
            if (res.data.list.length >= 4) {
                this.setState({mobileBannerImgWidth : parseInt((100 / 4)-6) + "%"});
            } else {
                this.setState({mobileBannerImgWidth : parseInt((100 / res.data.list.length)-6) + "%"});
            }

            // 가져온 배너들 중에 사용중인 배너 체크
            // var event_mobile_type_arr = res.data.list;
            // console.log(event_mobile_type_arr);
            // for (var idx in event_mobile_type_arr) {
            //     for(var i in this.state.mobileBannerTypeList) {
            //         if (this.state.mobileBannerTypeList[i]["code_cd"] == event_mobile_type_arr[idx]) {
            //             const {checked_mobile_banner_list} = this.state;
            //             checked_mobile_banner_list.push(
            //                 {
            //                     id : Number(this.state.mobileBannerTypeList[i]["code_cd"]),
            //                     title : this.state.mobileBannerTypeList[i]["code_name"],
            //                     icon : this.state.mobileBannerTypeList[i]["val2"],
            //                     bannerType: this.state.mobileBannerTypeList[i]["code_cd"]
            //                 }
            //             )
            //             this.setState({checked_mobile_banner_list: checked_mobile_banner_list});
            //         }

            //     }
            // }

        } else if (upper_code_cd == "17000") {
            this.setState({simple_date_setting_list: res.data.list})
        }
    };

    //공통코드 조회 (페이징)
    async getCafe24CodePaging(upper_code_cd) {
        var startidx = 0
        var rowcnt = 10
        if (upper_code_cd == "03000") {
            startidx = this.state.pc_banner_type_paging.startIdx;
            rowcnt = this.state.pc_banner_type_paging.rowcnt;
        } else if (upper_code_cd == "07000") {
            startidx = this.state.mobile_banner_type_paging.startIdx;
            rowcnt = this.state.mobile_banner_type_paging.rowcnt;
        } 


        const res = await http.get( "/rest/common/cafe24AutoEventSettingCode/paging"
                                    +"?upper_code_cd="+upper_code_cd
                                    +"&startidx="+startidx
                                    +"&rowcnt="+rowcnt 
                                    +is_test_use
                                    );
        if (upper_code_cd == "03000") {
            const{pc_banner_type_paging} = this.state;
            pc_banner_type_paging["totalCnt"] = res.data.totalCnt;
            if(res.data.list.length > 0) {
                this.setState({bannerTypeList : res.data.list
                                , pc_banner_type_paging : pc_banner_type_paging});
                if (res.data.list.length >= 4) {
                    this.setState({bannerImgWidth : parseInt((100 / 4)-6) + "%"});
                } else {
                    this.setState({bannerImgWidth : parseInt((100 / res.data.list.length)-6) + "%"});
                }

                // 가져온 배너들 중에 사용중인 배너 체크
                // var event_type_arr = res.data.listl;
                // console.log(event_type_arr);
                // for (var idx in event_type_arr) {
                //     for(var i in this.state.bannerTypeList) {
                //         if (this.state.bannerTypeList[i]["code_cd"] == event_type_arr[idx]) {
                //             const {checked_pc_banner_list} = this.state;
                //             checked_pc_banner_list.push(
                //                 {
                //                     id : Number(this.state.bannerTypeList[i]["code_cd"]),
                //                     title : this.state.bannerTypeList[i]["code_name"],
                //                     icon : this.state.bannerTypeList[i]["val2"],
                //                     bannerType: this.state.bannerTypeList[i]["code_cd"]
                //                 }
                //             )
                //             this.setState({checked_pc_banner_list: checked_pc_banner_list});
                //         }
                //     }
                // }
            }

        } else if (upper_code_cd == "07000") {
            const{mobile_banner_type_paging} = this.state;
            mobile_banner_type_paging["totalCnt"] = res.data.totalCnt;
            if(res.data.list.length > 0) {
                this.setState({mobileBannerTypeList : res.data.list
                                , mobile_banner_type_paging : mobile_banner_type_paging});
                if (res.data.list.length >= 4) {
                    this.setState({mobileBannerImgWidth : parseInt((100 / 4)-6) + "%"});
                } else {
                    this.setState({mobileBannerImgWidth : parseInt((100 / res.data.list.length)-6) + "%"});
                }

                // 가져온 배너들 중에 사용중인 배너 체크
                // var event_mobile_type_arr = res.data.list;
                // console.log(event_mobile_type_arr);
                // for (var idx in event_mobile_type_arr) {
                //     for(var i in this.state.mobileBannerTypeList) {
                //         if (this.state.mobileBannerTypeList[i]["code_cd"] == event_mobile_type_arr[idx]) {
                //             const {checked_mobile_banner_list} = this.state;
                //             checked_mobile_banner_list.push(
                //                 {
                //                     id : Number(this.state.mobileBannerTypeList[i]["code_cd"]),
                //                     title : this.state.mobileBannerTypeList[i]["code_name"],
                //                     icon : this.state.mobileBannerTypeList[i]["val2"],
                //                     bannerType: this.state.mobileBannerTypeList[i]["code_cd"]
                //                 }
                //             )
                //             this.setState({checked_mobile_banner_list: checked_mobile_banner_list});
                //         }

                //     }
                // }
            }
        } else if (upper_code_cd == "17000") {
            this.setState({simple_date_setting_list: res.data.list})
        }
    };

    getItemCnt() {
        var event_item_user_type = this.state.event_item_user_type;

        const formData = new FormData();
        if (event_item_user_type == "15001" && is_item_cnt_vaidate_all) {
            formData.append('all_user_item',JSON.stringify(this.state.all_user_item));
            this.setState({is_load_item_cnt_err_all : false,
                    is_load_item_cnt_all : true});
        }
        if (event_item_user_type == "15002") {
            if (is_item_cnt_vaidate_member) {
                formData.append('member_user_item',JSON.stringify(this.state.member_user_item));
                this.setState({is_load_item_cnt_err_member : false,
                    is_load_item_cnt_member : true});
            }
            if (is_item_cnt_vaidate_non) {
                formData.append('none_user_item',JSON.stringify(this.state.none_user_item));
                this.setState({is_load_item_cnt_err_non : false, 
                    is_load_item_cnt_non : true});
            }
        }
        
        formData.append('select_category_no_list_for_all_user', this.state.select_category_no_list_for_all_user);
        formData.append('select_category_no_list_for_only_user', this.state.select_category_no_list_for_only_user);
        formData.append('select_category_no_list_for_non_user', this.state.select_category_no_list_for_non_user);
        
        const config = {
            headers: {
                'content-type': 'application/x-www-form-urlencoded; charset=utf-8'
            }
        }
        
        http.post("/rest/shop/event/setting/product/cnt", formData, config)
        .then(
            resultData => { 
                if (event_item_user_type == "15001") {
                    if (resultData["data"]["allrUserItemCntMap"] != null) {
                        this.setState({
                            allUserItemCnt: String(resultData["data"]["allrUserItemCntMap"]["total_product_cnt"])
                        })
                        is_item_cnt_vaidate_all = false;
                        this.setState({
                            is_load_item_cnt_all : false,
                        })
                    }
                } 
                if (event_item_user_type == "15002") {
                    // if (is_item_cnt_vaidate_member) {
                        if (resultData["data"]["memberUserItemCntMap"] != null) {
                            this.setState({
                                memberUserItemCnt: String(resultData["data"]["memberUserItemCntMap"]["total_product_cnt"]),
                            });
                            is_item_cnt_vaidate_member = false;
                            this.setState({
                                is_load_item_cnt_member : false,
                            })
                        }
                    // }
                    // if (is_item_cnt_vaidate_non) {
                        if (resultData["data"]["nonUserItemCntMap"] != null) {
                            this.setState({
                                nonUserItemCnt: String(resultData["data"]["nonUserItemCntMap"]["total_product_cnt"]),
                            })
                            is_item_cnt_vaidate_non = false;
                            this.setState({
                                is_load_item_cnt_non : false,
                            })
                        }
                    // }
                }
            }
        ).catch (
            error => { 
                alert("실패하였습니다."+"\n"+error); 

                this.setState({
                    is_load_item_cnt_all : false, 
                    is_load_item_cnt_member : false, 
                    is_load_item_cnt_non : false, 
                });
                is_item_cnt_vaidate_all = false;
                is_item_cnt_vaidate_member = false;
                is_item_cnt_vaidate_non = false;
            }
        );
    }

    // 공통 코드 조회
    async getCafe24Code(upper_code_cd) {
        const res = await http.get( "/rest/common/cafe24Code"
                                    +"?upper_code_cd="+upper_code_cd);
        if(res.data.length > 0) {
            if (upper_code_cd == "23000") {
                this.setState({
                    language_code_list: res.data
                });
            } else if (upper_code_cd == "27000") { 
                this.setState({
                    transition_mode_code_list: res.data
                });
                // 배너 전환 모드 미설정시 초기값 세팅
                if (this.state.transition_mode == "") {
                    res.data.filter(data => {
                        if (data.is_sample_use == "Y") {
                            this.setState({
                                transition_mode : data.code_cd,
                            })
                        }
                    })
                }
            } else if (upper_code_cd == "28000") {
                this.setState({
                    transition_speed_code_list: res.data
                });
                // 배너 전환 속도 미설정시 초기값 세팅
                if (this.state.transition_speed == "") {
                    res.data.filter(data => {
                        if (data.is_sample_use == "Y") {
                            this.setState({
                                transition_speed : data.code_cd,
                                transition_speed_val : data.val
                            })
                        }
                    })
                }
            } else if (upper_code_cd == "29000") {
                this.setState({
                    transition_pause_code_list: res.data
                });
                // 슬라이드 전환 시간 미설정시 초기값 세팅
                if (this.state.transition_pause == "") {
                    res.data.filter(data => {
                        if (data.is_sample_use == "Y") {
                            this.setState({
                                transition_pause : data.code_cd,
                                transition_pause_val : data.val
                            })
                        }
                    })
                }
            }

        }

    }

    getItemCntCheckValidate(type) {
        if (this.state.event_item_user_type == "15001" && !this.state.all_user_item.isAnyPrice && (this.state.all_user_item.event_item_min_price == null ||  this.state.all_user_item.event_item_min_price === "")) {
            this.setState({is_load_item_cnt_err_all : true,
                item_cnt_err_msg_all: "상품 최소 가격을 선택해 주세요."});
            // alert("상품 최소 가격을 선택해 주세요.");
        } else if (this.state.event_item_user_type == "15001" && !this.state.all_user_item.isAnyPrice && (this.state.all_user_item.event_item_max_price == null ||  this.state.all_user_item.event_item_max_price === "")) {
            this.setState({is_load_item_cnt_err_all : true,
                item_cnt_err_msg_all: "상품 최대 가격을 선택해 주세요."});
            // alert("상품 최대 가격을 선택해 주세요.");
        } else if (this.state.event_item_user_type == "15001" && !this.state.all_user_item.isAnyHit && (this.state.all_user_item.event_item_min_hit == null ||  this.state.all_user_item.event_item_min_hit === "")) {
            this.setState({is_load_item_cnt_err_all : true,
                item_cnt_err_msg_all: "상품 최소 조회수를 선택해 주세요."});
            // alert("상품 최소 조회수를 선택해 주세요.");
        } else if (this.state.event_item_user_type == "15001" && !this.state.all_user_item.isAnyHit && (this.state.all_user_item.event_item_max_hit == null ||  this.state.all_user_item.event_item_max_hit === "")) {
            this.setState({is_load_item_cnt_err_all : true,
                item_cnt_err_msg_all: "상품 최대 조회수를 선택해 주세요."});
            // alert("상품 최대 조회수를 선택해 주세요.");
        } 
        // else if (this.state.event_item_user_type == "15001" && !this.state.all_user_item.isAnyReview && (this.state.all_user_item.event_item_min_review == null ||  this.state.all_user_item.event_item_min_review === "")) {
        //     this.setState({is_load_item_cnt_err_all : true,
        //         item_cnt_err_msg_all: "상품 최소 리뷰수를 선택해 주세요."});
        //     // alert("상품 최소 리뷰수를 선택해 주세요.");
        // } else if (this.state.event_item_user_type == "15001" && !this.state.all_user_item.isAnyReview && (this.state.all_user_item.event_item_max_review == null ||  this.state.all_user_item.event_item_max_review === "")) {
        //     this.setState({is_load_item_cnt_err_all : true,
        //         item_cnt_err_msg_all: "상품 최대 리뷰수를 선택해 주세요."});
        //     // alert("상품 최대 리뷰수를 선택해 주세요.");
        // } 
        else if (this.state.event_item_user_type == "15001" && !this.state.all_user_item.isAnyOrder && (this.state.all_user_item.event_item_min_order == null ||  this.state.all_user_item.event_item_min_order === "")) {
            this.setState({is_load_item_cnt_err_all : true,
                item_cnt_err_msg_all: "상품 최소 구매수를 선택해 주세요."});
            // alert("상품 최소 구매수를 선택해 주세요.");
        } else if (this.state.event_item_user_type == "15001" && !this.state.all_user_item.isAnyOrder && (this.state.all_user_item.event_item_max_order == null ||  this.state.all_user_item.event_item_max_order === "")) {
            this.setState({is_load_item_cnt_err_all : true,
                item_cnt_err_msg_all: "상품 최대 구매수를 선택해 주세요."});
            // alert("상품 최대 구매수를 선택해 주세요.");
        } 
        else if (this.state.event_item_user_type == "15001" && (this.state.all_user_item.event_item_created_period == null ||  this.state.all_user_item.event_item_created_period === "")) {
            this.setState({is_load_item_cnt_err_all : true,
                item_cnt_err_msg_all: "상품 등록날짜를 선택해 주세요."});
            // alert("상품 등록날짜를 선택해 주세요.");
        } else if (this.state.event_item_user_type == "15001" && (this.state.all_user_item.event_item_analysis_period == null ||  this.state.all_user_item.event_item_analysis_period == "")) {
            this.setState({is_load_item_cnt_err_all : true,
                item_cnt_err_msg_all: "상품분석 기간을 선택해 주세요."});
            // alert("상품분석 기간을 선택해 주세요.");
        } else if (this.state.event_item_user_type == "15001" && (this.state.all_user_item.product_duplicate_check_type == null ||  this.state.all_user_item.product_duplicate_check_type == "")) {
            this.setState({is_load_item_cnt_err_all : true,
                item_cnt_err_msg_all: "상품 중복체크 유형을 선택해 주세요."});
            // alert("상품 중복체크 유형을 선택해 주세요.");
        } else {
            if (this.state.event_item_user_type == "15001" && type == "all") {
                is_item_cnt_vaidate_all = true;
                this.getItemCnt();
            }
            this.setState({is_load_item_cnt_err_all : false});
        }
        
        if (this.state.event_item_user_type == "15002" && !this.state.member_user_item.isAnyPrice && (this.state.member_user_item.event_item_min_price == null ||  this.state.member_user_item.event_item_min_price === "")) {
            this.setState({is_load_item_cnt_err_member : true,
                item_cnt_err_msg_member: "회원 상품 최소 가격을 선택해 주세요."});
            // alert("회원 상품 최소 가격을 선택해 주세요.");
        } else if (this.state.event_item_user_type == "15002" && !this.state.member_user_item.isAnyPrice && (this.state.member_user_item.event_item_max_price == null ||  this.state.member_user_item.event_item_max_price === "")) {
            this.setState({is_load_item_cnt_err_member : true,
                item_cnt_err_msg_member: "회원 상품 최대 가격을 선택해 주세요."});
            // alert("회원 상품 최대 가격을 선택해 주세요.");
        } else if (this.state.event_item_user_type == "15002" && !this.state.member_user_item.isAnyHit && (this.state.member_user_item.event_item_min_hit == null ||  this.state.member_user_item.event_item_min_hit === "")) {
            this.setState({is_load_item_cnt_err_member : true,
                item_cnt_err_msg_member: "회원 상품 최소 조회수를 선택해 주세요."});
            // alert("회원 상품 최소 조회수를 선택해 주세요.");
        } else if (this.state.event_item_user_type == "15002" && !this.state.member_user_item.isAnyHit && (this.state.member_user_item.event_item_max_hit == null ||  this.state.member_user_item.event_item_max_hit === "")) {
            this.setState({is_load_item_cnt_err_member : true,
                item_cnt_err_msg_member: "회원 상품 최대 조회수를 선택해 주세요."});
            // alert("회원 상품 최대 조회수를 선택해 주세요.");
        } 
        // else if (this.state.event_item_user_type == "15002" && !this.state.member_user_item.isAnyReview && (this.state.member_user_item.event_item_min_review == null ||  this.state.member_user_item.event_item_min_review === "")) {
        //     this.setState({is_load_item_cnt_err_member : true,
        //         item_cnt_err_msg_member: "회원 상품 최소 리뷰수를 선택해 주세요."});
        //     // alert("회원 상품 최소 리뷰수를 선택해 주세요.");
        // } else if (this.state.event_item_user_type == "15002" && !this.state.member_user_item.isAnyReview && (this.state.member_user_item.event_item_max_review == null ||  this.state.member_user_item.event_item_max_review === "")) {
        //     this.setState({is_load_item_cnt_err_member : true,
        //         item_cnt_err_msg_member: "회원 상품 최대 리뷰수를 선택해 주세요."});
        //     // alert("회원 상품 최대 리뷰수를 선택해 주세요.");
        // } 
        else if (this.state.event_item_user_type == "15002" && !this.state.member_user_item.isAnyOrder && (this.state.member_user_item.event_item_min_order == null ||  this.state.member_user_item.event_item_min_order === "")) {
            this.setState({is_load_item_cnt_err_member : true,
                item_cnt_err_msg_member: "회원 상품 최소 구매수를 선택해 주세요."});
            // alert("회원 상품 최소 구매수를 선택해 주세요.");
        } else if (this.state.event_item_user_type == "15002" && !this.state.member_user_item.isAnyOrder && (this.state.member_user_item.event_item_max_order == null ||  this.state.member_user_item.event_item_max_order === "")) {
            this.setState({is_load_item_cnt_err_member : true,
                item_cnt_err_msg_member: "회원 상품 최대 구매수를 선택해 주세요."});
            // alert("회원 상품 최대 구매수를 선택해 주세요.");
        } 
        else if (this.state.event_item_user_type == "15002" && (this.state.member_user_item.event_item_created_period == null ||  this.state.member_user_item.event_item_created_period === "")) {
            this.setState({is_load_item_cnt_err_member : true,
                item_cnt_err_msg_member: "회원 상품 등록날짜를 선택해 주세요."});
            // alert("회원 상품 등록날짜를 선택해 주세요.");
        } else if (this.state.event_item_user_type == "15002" && (this.state.member_user_item.event_item_analysis_period == null ||  this.state.member_user_item.event_item_analysis_period == "")) {
            this.setState({is_load_item_cnt_err_member : true,
                item_cnt_err_msg_member: "회원 상품분석 기간을 선택해 주세요."});
            // alert("회원 상품분석 기간을 선택해 주세요.");
        } else if (this.state.event_item_user_type == "15002" && (this.state.member_user_item.product_duplicate_check_type == null ||  this.state.member_user_item.product_duplicate_check_type == "")) {
            this.setState({is_load_item_cnt_err_all : true,
                item_cnt_err_msg_all: "회원 상품 중복체크 유형을 선택해 주세요."});
            // alert("상품 중복체크 유형을 선택해 주세요.");
        } else {
            if (this.state.event_item_user_type == "15002" && type == "member") {
                is_item_cnt_vaidate_member = true;
                this.getItemCnt();
            }
            this.setState({is_load_item_cnt_err_member : false});
        }
        
        if (this.state.event_item_user_type == "15002" && !this.state.none_user_item.isAnyPrice && (this.state.none_user_item.event_item_min_price == null ||  this.state.none_user_item.event_item_min_price === "")) {
            this.setState({is_load_item_cnt_err_non : true,
                item_cnt_err_msg_non: "비회원 상품 최소 가격을 선택해 주세요."});
            // alert("비회원 상품 최소 가격을 선택해 주세요.");
        } else if (this.state.event_item_user_type == "15002" && !this.state.none_user_item.isAnyPrice && (this.state.none_user_item.event_item_max_price == null ||  this.state.none_user_item.event_item_max_price === "")) {
            this.setState({is_load_item_cnt_err_non : true,
                item_cnt_err_msg_non: "비회원 상품 최대 가격을 선택해 주세요."});
            // alert("비회원 상품 최대 가격을 선택해 주세요.");
        } else if (this.state.event_item_user_type == "15002" && !this.state.none_user_item.isAnyHit && (this.state.none_user_item.event_item_min_hit == null ||  this.state.none_user_item.event_item_min_hit === "")) {
            this.setState({is_load_item_cnt_err_non : true,
                item_cnt_err_msg_non: "비회원 상품 최소 조회수를 선택해 주세요."});
            // alert("비회원 상품 최소 조회수를 선택해 주세요.");
        } else if (this.state.event_item_user_type == "15002" && !this.state.none_user_item.isAnyHit && (this.state.none_user_item.event_item_max_hit == null ||  this.state.none_user_item.event_item_max_hit === "")) {
            this.setState({is_load_item_cnt_err_non : true,
                item_cnt_err_msg_non: "비회원 상품 최대 조회수를 선택해 주세요."});
            // alert("비회원 상품 최대 조회수를 선택해 주세요.");
        } 
        // else if (this.state.event_item_user_type == "15002" && !this.state.none_user_item.isAnyReview && (this.state.none_user_item.event_item_min_review == null ||  this.state.none_user_item.event_item_min_review === "")) {
        //     this.setState({is_load_item_cnt_err_non : true,
        //         item_cnt_err_msg_non: "비회원 상품 최소 리뷰수를 선택해 주세요."});
        //     // alert("비회원 상품 최소 리뷰수를 선택해 주세요.");
        // } else if (this.state.event_item_user_type == "15002" && !this.state.none_user_item.isAnyReview && (this.state.none_user_item.event_item_max_review == null ||  this.state.none_user_item.event_item_max_review === "")) {
        //     this.setState({is_load_item_cnt_err_non : true,
        //         item_cnt_err_msg_non: "비회원 상품 최대 리뷰수를 선택해 주세요."});
        //     // alert("비회원 상품 최대 리뷰수를 선택해 주세요.");
        // } 
        else if (this.state.event_item_user_type == "15002" && !this.state.none_user_item.isAnyOrder && (this.state.none_user_item.event_item_min_order == null ||  this.state.none_user_item.event_item_min_order === "")) {
            this.setState({is_load_item_cnt_err_non : true,
                item_cnt_err_msg_non: "비회원 상품 최소 구매수를 선택해 주세요."});
            // alert("비회원 상품 최소 구매수를 선택해 주세요.");
        } else if (this.state.event_item_user_type == "15002" && !this.state.none_user_item.isAnyOrder && (this.state.none_user_item.event_item_max_order == null ||  this.state.none_user_item.event_item_max_order === "")) {
            this.setState({is_load_item_cnt_err_non : true,
                item_cnt_err_msg_non: "비회원 상품 최대 구매수를 선택해 주세요."});
            // alert("비회원 상품 최대 구매수를 선택해 주세요.");
        } 
        else if (this.state.event_item_user_type == "15002" && (this.state.none_user_item.event_item_created_period == null ||  this.state.none_user_item.event_item_created_period === "")) {
            this.setState({is_load_item_cnt_err_non : true,
                item_cnt_err_msg_non: "비회원 상품 등록날짜를 선택해 주세요."});
            // alert("비회원 상품 등록날짜를 선택해 주세요.");
        } else if (this.state.event_item_user_type == "15002" && (this.state.none_user_item.event_item_analysis_period == null ||  this.state.none_user_item.event_item_analysis_period == "")) {
            this.setState({is_load_item_cnt_err_non : true,
                item_cnt_err_msg_non: "비회원 상품분석 기간을 선택해 주세요."});
            // alert("비회원 상품분석 기간을 선택해 주세요.");
        } else if (this.state.event_item_user_type == "15002" && (this.state.none_user_item.product_duplicate_check_type == null ||  this.state.none_user_item.product_duplicate_check_type == "")) {
            this.setState({is_load_item_cnt_err_all : true,
                item_cnt_err_msg_all: "비회원 상품 중복체크 유형을 선택해 주세요."});
            // alert("상품 중복체크 유형을 선택해 주세요.");
        } else {
                // alert(this.state.event_item_user_type)
                // alert(type)
            if (this.state.event_item_user_type == "15002" && type == "non") {
                is_item_cnt_vaidate_non = true;
                this.getItemCnt();
            }
            this.setState({is_load_item_cnt_err_non : false});
        }
    }

    handlePeriodClick = (e, value) => { 
        var div = e.target.parentElement.getElementsByTagName("div");
        div = Array.prototype.slice.call(div);
        div.map(function(elem){
            elem.className = elem.className.replace(" active", "");
        });
        
        e.target.className += " active" 
        this.setState({event_period : value})
        this.setState({event_period_text : e.target.textContent})

        // 자동배너 설정 - 진열 기간
        ReactGA.event({
            category: "자동배너 설정",
            action: "진열 기간 : " + e.target.textContent,
            label: ga_label
        });
    };

    handleEventCycleClick = (e, value) => { 
        var div = e.target.parentElement.getElementsByTagName("div");
        div = Array.prototype.slice.call(div);
        div.map(function(elem){
            elem.className = elem.className.replace(" active", "");
        });
        
        e.target.className += " active" 
        this.setState({event_cycle : value})
        this.setState({event_cycle_text : e.target.textContent})

        // 자동배너 설정 - 진열 기간
        ReactGA.event({
            category: "자동배너 설정",
            action: "진열 주기 : " + e.target.textContent,
            label: ga_label
        });
    };

    handleCycleChange= (e) => { 
        this.setState({event_cycle : e.target.value})
        this.setState({event_cycle_text : e.target.options[e.target.selectedIndex].text})

        // 자동배너 설정 - 자동 생성주기
        ReactGA.event({
            category: "자동배너 설정",
            action: "자동 생성주기 : " + e.target.options[e.target.selectedIndex].text,
            label: ga_label
        });
    };

    handleItemCreatedPeriodChange= (e) => { 
        const { all_user_item } = this.state;
        all_user_item["event_item_created_period"] = e.target.value;
        this.setState({
            all_user_item : all_user_item
        });

        // 자동배너 설정 - 상품 등록날짜
        ReactGA.event({
            category: "자동배너 설정",
            action: "상품 등록날짜 : " + e.target.options[e.target.selectedIndex].text,
            label: ga_label
        });

        // this.getItemCntCheckValidate("all");
    };

    handleItemAnalysisPeriodChange= (e) => { 
        const { all_user_item } = this.state;
        all_user_item["event_item_analysis_period"] = e.target.value;
        this.setState({
            all_user_item : all_user_item
        });

        // 자동배너 설정 - 상품 분석기간
        ReactGA.event({
            category: "자동배너 설정",
            action: "상품 분석기간 : " + e.target.options[e.target.selectedIndex].text,
            label: ga_label
        });

        // this.getItemCntCheckValidate("all");
    };

    // 가격
    handleItemPriceMinChange= (e) => { 
        const { all_user_item } = this.state;
        all_user_item["event_item_min_price"] = e.target.value;
        this.setState({
            all_user_item : all_user_item
        });
    };

    handleItemPriceMaxChange= (e) => { 
        const { all_user_item } = this.state;
        all_user_item["event_item_max_price"] = e.target.value;
        this.setState({
            all_user_item : all_user_item
        });
    };

    // 조회수
    handleItemHitMinChange= (e) => { 
        const { all_user_item } = this.state;
        all_user_item["event_item_min_hit"] = e.target.value;
        this.setState({
            all_user_item : all_user_item
        });
    };

    handleItemHitMaxChange= (e) => { 
        const { all_user_item } = this.state;
        all_user_item["event_item_max_hit"] = e.target.value;
        this.setState({
            all_user_item : all_user_item
        });
    };

    // 리뷰수
    handleItemReviewMinChange= (e) => { 
        const { all_user_item } = this.state;
        all_user_item["event_item_min_review"] = e.target.value;
        this.setState({
            all_user_item : all_user_item
        });
    };

    handleItemReviewMaxChange= (e) => { 
        const { all_user_item } = this.state;
        all_user_item["event_item_max_review"] = e.target.value;
        this.setState({
            all_user_item : all_user_item
        });
    };

    // 구매수
    handleItemOrderMinChange= (e) => { 
        const { all_user_item } = this.state;
        all_user_item["event_item_min_order"] = e.target.value;
        this.setState({
            all_user_item : all_user_item
        });
    };

    handleItemOrderMaxChange= (e) => { 
        const { all_user_item } = this.state;
        all_user_item["event_item_max_order"] = e.target.value;
        this.setState({
            all_user_item : all_user_item
        });
    };

    // 재고수
    handleItemQuantityMinChange= (e) => { 
        const { all_user_item } = this.state;
        all_user_item["event_item_min_quantity"] = e.target.value;
        this.setState({
            all_user_item : all_user_item
        });
    };

    handleItemQuantityMaxChange= (e) => { 
        const { all_user_item } = this.state;
        all_user_item["event_item_max_quantity"] = e.target.value;
        this.setState({
            all_user_item : all_user_item
        });
    };

    handleItemCreatedPeriodChangeForMemberUser= (e) => { 
        const { member_user_item } = this.state;
        member_user_item["event_item_created_period"] = e.target.value;
        this.setState({
            member_user_item : member_user_item
        });

        // 자동배너 설정 - 상품 등록날짜
        ReactGA.event({
            category: "자동배너 설정",
            action: "상품 등록날짜 : " + e.target.options[e.target.selectedIndex].text,
            label: ga_label
        });
        // this.getItemCntCheckValidate("member");
    };

    handleItemAnalysisPeriodChangeForMemberUser= (e) => { 
        this.state.member_user_item.event_item_analysis_period = e.target.value;
        this.setState({event_item_analysis_period_text : e.target.options[e.target.selectedIndex].text})

        // 자동배너 설정 - 상품 분석기간
        ReactGA.event({
            category: "자동배너 설정",
            action: "상품 분석기간 : " + e.target.options[e.target.selectedIndex].text,
            label: ga_label
        });
        // this.getItemCntCheckValidate("member");
    };

    // 가격 (MEMBER USER)
    handleItemPriceMinChangeForMemberUser= (e) => { 
        const { member_user_item } = this.state;
        member_user_item["event_item_min_price"] = e.target.value;
        this.setState({
            member_user_item : member_user_item
        });
    };

    handleItemPriceMaxChangeForMemberUser= (e) => { 
        const { member_user_item } = this.state;
        member_user_item["event_item_max_price"] = e.target.value;
        this.setState({
            member_user_item : member_user_item
        });
    };

    // 조회수 (MEMBER USER)
    handleItemHitMinChangeForMemberUser= (e) => { 
        const { member_user_item } = this.state;
        member_user_item["event_item_min_hit"] = e.target.value;
        this.setState({
            member_user_item : member_user_item
        });
    };

    handleItemHitMaxChangeForMemberUser= (e) => { 
        const { member_user_item } = this.state;
        member_user_item["event_item_max_hit"] = e.target.value;
        this.setState({
            member_user_item : member_user_item
        });
    };

    // 리뷰수 (MEMBER USER)
    handleItemReviewMinChangeForMemberUser= (e) => { 
        const { member_user_item } = this.state;
        member_user_item["event_item_min_review"] = e.target.value;
        this.setState({
            member_user_item : member_user_item
        });
    };

    handleItemReviewMaxChangeForMemberUser= (e) => { 
        const { member_user_item } = this.state;
        member_user_item["event_item_max_review"] = e.target.value;
        this.setState({
            member_user_item : member_user_item
        });
    };

    // 구매수 (MEMBER USER)
    handleItemOrderMinChangeForMemberUser= (e) => { 
        const { member_user_item } = this.state;
        member_user_item["event_item_min_order"] = e.target.value;
        this.setState({
            member_user_item : member_user_item
        });
    };

    handleItemOrderMaxChangeForMemberUser= (e) => { 
        const { member_user_item } = this.state;
        member_user_item["event_item_max_order"] = e.target.value;
        this.setState({
            member_user_item : member_user_item
        });
    };

    // 재고수 (MEMBER USER)
    handleItemQuantityMinChangeForMemberUser= (e) => { 
        const { member_user_item } = this.state;
        member_user_item["event_item_min_quantity"] = e.target.value;
        this.setState({
            member_user_item : member_user_item
        });
    };

    handleItemQuantityMaxChangeForMemberUser= (e) => { 
        const { member_user_item } = this.state;
        member_user_item["event_item_max_quantity"] = e.target.value;
        this.setState({
            member_user_item : member_user_item
        });
    };

    handleItemCreatedPeriodChangeForNoneUser= (e) => { 
        this.state.none_user_item.event_item_created_period = e.target.value;
        this.setState({event_item_created_period_text : e.target.options[e.target.selectedIndex].text})

        // 자동배너 설정 - 상품 등록날짜
        ReactGA.event({
            category: "자동배너 설정",
            action: "상품 등록날짜 : " + e.target.options[e.target.selectedIndex].text,
            label: ga_label
        });

        // this.getItemCntCheckValidate("non");
    };

    handleItemAnalysisPeriodChangeForNoneUser= (e) => { 
        this.state.none_user_item.event_item_analysis_period = e.target.value;
        this.setState({event_item_analysis_period_text : e.target.options[e.target.selectedIndex].text})

        // 자동배너 설정 - 상품 분석기간
        ReactGA.event({
            category: "자동배너 설정",
            action: "상품 분석기간 : " + e.target.options[e.target.selectedIndex].text,
            label: ga_label
        });

        // this.getItemCntCheckValidate("non");
    };

    // 가격 (NONE USER)
    handleItemPriceMinChangeForNoneUser= (e) => { 
        const { none_user_item } = this.state;
        none_user_item["event_item_min_price"] = e.target.value;
        this.setState({
            none_user_item : none_user_item
        });
    };

    handleItemPriceMaxChangeForNoneUser= (e) => { 
        const { none_user_item } = this.state;
        none_user_item["event_item_max_price"] = e.target.value;
        this.setState({
            none_user_item : none_user_item
        });
    };

    // 조회수 (NONE USER)
    handleItemHitMinChangeForNoneUser= (e) => { 
        const { none_user_item } = this.state;
        none_user_item["event_item_min_hit"] = e.target.value;
        this.setState({
            none_user_item : none_user_item
        });
    };

    handleItemHitMaxChangeForNoneUser= (e) => { 
        const { none_user_item } = this.state;
        none_user_item["event_item_max_hit"] = e.target.value;
        this.setState({
            none_user_item : none_user_item
        });
    };

    // 리뷰수 (NONE USER)
    handleItemReviewMinChangeForNoneUser= (e) => { 
        const { none_user_item } = this.state;
        none_user_item["event_item_min_review"] = e.target.value;
        this.setState({
            none_user_item : none_user_item
        });
    };

    handleItemReviewMaxChangeForNoneUser= (e) => { 
        const { none_user_item } = this.state;
        none_user_item["event_item_max_review"] = e.target.value;
        this.setState({
            none_user_item : none_user_item
        });
    };

    // 구매수 (NONE USER)
    handleItemOrderMinChangeForNoneUser= (e) => { 
        const { none_user_item } = this.state;
        none_user_item["event_item_min_order"] = e.target.value;
        this.setState({
            none_user_item : none_user_item
        });
    };

    handleItemOrderMaxChangeForNoneUser= (e) => { 
        const { none_user_item } = this.state;
        none_user_item["event_item_max_order"] = e.target.value;
        this.setState({
            none_user_item : none_user_item
        });
    };

    // 재고수 (NONE USER)
    handleItemQuantityMinChangeForNoneUser= (e) => { 
        const { none_user_item } = this.state;
        none_user_item["event_item_min_quantity"] = e.target.value;
        this.setState({
            none_user_item : none_user_item
        });
    };

    handleItemQuantityMaxChangeForNoneUser= (e) => { 
        const { none_user_item } = this.state;
        none_user_item["event_item_max_quantity"] = e.target.value;
        this.setState({
            none_user_item : none_user_item
        });
    };

    onBlurItemPriceChange = (e, type) => {
        // 자동배너 설정 - 상품 분석기간
        // ReactGA.event({
        //     category: "자동배너 설정",
        //     action: "상품 가격 : " + this.state. + "~" + this.state.event_item_max_price,
        //     label: ga_label
        // });
        this.getItemCntCheckValidate(type);
    }
    
    onClickAmPm = e => {
        $(".radio_ampm:checked").prop("checked", false); 
        $("#"+e.target.value).prop("checked", true); 
        this.setState({event_ampm : e.target.value})
        this.setState({event_ampm_text : e.target.textContent})

        // 자동배너 설정 - 상품 분석기간
        ReactGA.event({
            category: "자동배너 설정",
            action: "자동생성 시간 : " + this.state.event_ampm + " " + this.state.event_time_text,
            label: ga_label
        });
    };
    
    handleTimeChange = e => {
        this.setState({event_time : e.target.value})
        this.setState({event_time_text : e.target.options[e.nativeEvent.target.selectedIndex].text})

        // 자동배너 설정 - 자동생성 시간
        ReactGA.event({
            category: "자동배너 설정",
            action: "자동생성 시간 : " + this.state.event_ampm + " " + e.target.options[e.nativeEvent.target.selectedIndex].text,
            label: ga_label
        });
    };
    
    handleTypeChange = e => {
        this.setState({event_type : e.target.value})
        this.setState({event_type_text : e.target.options[e.nativeEvent.target.selectedIndex].text})
    };
    handlePcSizeChange = e => {

        if (this.state.event_banner_mobile_height == null) {
            if (Number(e.target.value) > 1 || (Number(this.state.event_banner_mobile_width) > 1)) {
                this.setState({is_size_horizontal: true});
                // this.setState({is_size_vertical: false});
            } else if (Number(e.target.value) != 0) {
                this.setState({is_size_horizontal: false});
                this.setState({is_size_vertical: true});
            }
        } else {
            if (Number(e.target.value) > 1 || ((Number(this.state.event_banner_mobile_width) / Number(this.state.event_banner_mobile_height)) > 1)) {
                this.setState({is_size_horizontal: true});
                // this.setState({is_size_vertical: false});
            } else if (Number(e.target.value) != 0) {
                this.setState({is_size_horizontal: false});
                this.setState({is_size_vertical: true});
            }
        }

        var is_custom_pc_banner_size = false;
        if (Number(e.target.value) == 0) {
            is_custom_pc_banner_size = true;
        }

        this.setState({ event_banner_pc_option_value : e.target.value
                        , event_banner_pc_width : e.target.value
                        , event_banner_pc_height : "1"
                        , is_custom_pc_banner_size : is_custom_pc_banner_size
                        , pc_banner_size_img: this.state.pcBannerSizeList[e.nativeEvent.target.selectedIndex].val2})
        // this.setState({event_banner_pc_width_text : e.target.options[e.nativeEvent.target.selectedIndex].text})

        // 자동배너 설정 - 자동생성 시간
        ReactGA.event({
            category: "자동배너 설정",
            action: "배너 사이즈 1 : " + e.target.options[e.nativeEvent.target.selectedIndex].text,
            label: ga_label
        });
    };
    handleMobileSizeChange = e => {

        if (this.state.event_banner_pc_height == null) {
            if ((Number(e.target.value) <= 1 && Number(e.target.value) != 0) || Number(this.state.event_banner_pc_width) <= 1 && Number(this.state.event_banner_pc_width) != 0) {
                // this.setState({is_size_horizontal: false});
                this.setState({is_size_vertical: true});
            } else if (Number(e.target.value) != 0) {
                this.setState({is_size_horizontal: true});
                this.setState({is_size_vertical: false});
            }
        } else {
            if ((Number(e.target.value) <= 1 && Number(e.target.value) != 0) || (Number(this.state.event_banner_pc_width) / Number(this.state.event_banner_pc_height)) <= 1) {
                // this.setState({is_size_horizontal: false});
                this.setState({is_size_vertical: true});
            } else if (Number(e.target.value) != 0) {
                this.setState({is_size_horizontal: true});
                this.setState({is_size_vertical: false});
            }
        }
        

        var is_custom_mobile_banner_size = false;
        if (Number(e.target.value) == 0) {
            is_custom_mobile_banner_size = true;
        }

        this.setState({ event_banner_mobile_option_value : e.target.value
                        , event_banner_mobile_width : e.target.value
                        , event_banner_mobile_height : "1"
                        , is_custom_mobile_banner_size : is_custom_mobile_banner_size
                        , mobile_banner_size_img: this.state.mobileBannerSizeList[e.nativeEvent.target.selectedIndex].val2})
        // this.setState({event_banner_mobile_width_text : e.target.options[e.nativeEvent.target.selectedIndex].text})

        // 자동배너 설정 - 자동생성 시간
        ReactGA.event({
            category: "자동배너 설정",
            action: "배너 사이즈 2 : " + e.target.options[e.nativeEvent.target.selectedIndex].text,
            label: ga_label
        });
    };
    handleShopNoChange= (e) => { 
        this.setState({shop_no : e.target.value})
        
        // 자동배너 설정 - 쇼핑몰 선택
        ReactGA.event({
            category: "자동배너 설정",
            action: "쇼핑몰 선택 : " + e.target.options[e.nativeEvent.target.selectedIndex].text,
            label: ga_label
        });
    };

    handleTypeClick = e => {
        var event_type_arr = this.state.event_type_arr;
        var idx = event_type_arr.indexOf(e.target.id);
        if (idx > -1) {
            event_type_arr.splice(idx, 1);
            this.setState({event_type_arr: event_type_arr});
            e.target.textContent = "";
        } else {
            var event_type_arr = this.state.event_type_arr;
            event_type_arr.push(e.target.id);
            this.setState({event_type_arr: event_type_arr});
            // e.target.textContent = event_type_arr.indexOf(e.target.id)+1;
        }
        console.log(event_type_arr);

        var element = $(".checkbox-type");
        element.each(function( index ) {
            $(this).css("background-color", "white");
        });

        for (idx in event_type_arr) {
            element.each(function( index ) {
            var thisElement = $(this);
                console.log(thisElement.attr('id'));
                if (event_type_arr[idx] == thisElement.attr('id')) {
                    thisElement.text("");
                    console.log(idx);
                    thisElement.text(parseInt(idx)+1);
                    thisElement.css("background-color", "#21a777");
                } 
            });
        }

        // 자동배너 설정 - PC배너 유형
        ReactGA.event({
            category: "자동배너 설정",
            action: "PC배너 유형 : " + event_type_arr,
            label: ga_label
        });

    };
    handleMobileTypeClick = e => {
        var event_mobile_type_arr = this.state.event_mobile_type_arr;
        var idx = event_mobile_type_arr.indexOf(e.target.id);
        if (idx > -1) {
            event_mobile_type_arr.splice(idx, 1);
            this.setState({event_mobile_type_arr: event_mobile_type_arr});
            e.target.textContent = "";
        } else {
            var event_mobile_type_arr = this.state.event_mobile_type_arr;
            event_mobile_type_arr.push(e.target.id);
            this.setState({event_mobile_type_arr: event_mobile_type_arr});
            // e.target.textContent = event_type_arr.indexOf(e.target.id)+1;
        }
        console.log(event_mobile_type_arr);

        var element = $(".checkbox-mobile-type");
        element.each(function( index ) {
            $(this).css("background-color", "white");
        });

        for (idx in event_mobile_type_arr) {
            element.each(function( index ) {
            var thisElement = $(this);
                console.log(thisElement.attr('id'));
                if (event_mobile_type_arr[idx] == thisElement.attr('id')) {
                    thisElement.text("");
                    console.log(idx);
                    thisElement.text(parseInt(idx)+1);
                    thisElement.css("background-color", "#21a777");
                } 
            });
        }

        // 자동배너 설정 - Mobile배너 유형
        ReactGA.event({
            category: "자동배너 설정",
            action: "Mobile배너 유형 : " + event_mobile_type_arr,
            label: ga_label
        });
    };
    handleImgClick = e => {
        window.open(e.target.src);
    };
    handleEventTitleChange = e => {
        this.setState({shop_intro_title : e.target.value})
    };

    handleEventContentChange = e => {
        this.setState({shop_intro_content : e.target.value})
    };

    onClickCheckAllCategory = e => {
        var i = 0
        $(".checkCategory").each( function() {
            if ($(this).is(":checked")) {
                i ++;
            }
        });
        if (i == $(".checkCategory").length) {
            $(".checkCategory").prop( "checked", false );
        } else {
            $(".checkCategory").prop( "checked", true );
        }
    };

    onClickCheckCategory = e => {
        var i = 0
        if ($(this).is(":checked")) {
            $(this).prop( "checked", false );
        } else {
            $(this).prop( "checked", true );
        }
        $(".checkCategory").each( function() {
            if ($(this).is(":checked")) {
                i ++;
            }
        });
        if (i != $(".checkCategory").length) {
            $("#allCategory").prop( "checked", false );
        } else {
            $("#allCategory").prop( "checked", true );
        }
    };

    onClickSave =  e => {
        // cafe24 쇼핑몰/비연동형에만 체크
        if(this.state.solution_type_cd == "09001" || this.state.solution_type_cd == "09900"){
            if(!this.state.event_show_type){
                alert("디자인 노출 유형을 선택해 주세요.");
                return false;
            }
            // 디자인 노출 유형 : 팝업인 경우
            if(this.state.event_show_type == "70002"){
                if(!this.state.popup_position){
                    alert("팝업 위치를 선택해 주세요.");
                    return false;
                }
                if(!this.state.popup_block_cycle){
                    alert("팝업 차단 주기를 선택해 주세요.");
                    return false;
                }
                if(!this.state.popup_target_type){
                    alert("노출 대상을 선택해 주세요.");
                    return false;
                }
                if(this.state.popup_target_type == "73002"){
                    if(!(this.state.popup_target_view_list && this.state.popup_target_view_list.length > 0)){
                        alert("타겟을 선택해 주세요.");
                        return false;
                    }
                }

                if(this.state.popup_block_cycle == "72007") {
                    if (!this.state.popup_block_cycle_day) {
                        alert("팝업 차단 주기를 입력해 주세요.");
                        is_step_1_complete = false;
                        return false;
                    }
                    if (!this.state.popup_block_cycle_title) {
                        alert("팝업 차단 주기를 입력해 주세요.");
                        is_step_1_complete = false;
                        return false;
                    }
                }

                if(this.state.popup_close_btn_title_cd == "74008") {
                    if (!this.state.popup_close_btn_title) {
                        alert("팝업 닫기 문구를 입력해 주세요.");
                        is_step_1_complete = false;
                        return false;
                    }
                }
            }
        }

        if(this.state.solution_type_cd != '09900') {
            /* 0페이지 */
            if (this.state.domain_list == null || (this.state.domain_list != null && this.state.domain_list.length == 0)) {
                // alert("도매인을 추가해 주세요.");
                // return false;
            } else if(this.state.iframe_page_id == null ||  this.state.iframe_page_id == "") {
                alert("적용 페이지를 선택해 주세요.");
                return false;
            } else if (this.state.iframe_page_id == "robomd_category_page" && this.state.category_page_step == "-1") {
                alert("적용 카테고리 페이지를 선택해 주세요.");
                return false;
            } else if (this.state.iframe_page_id == "robomd_category_page" && this.state["category_page_"+this.state.category_page_step] == "-1") {
                alert("적용 카테고리 페이지가 중복 되었습니다.\n적용 카테고리 페이지를 변경해 주세요.");
                return false;
            }
        }

        if (this.state.iframe_html_name == null ||  this.state.iframe_html_name == "") {
            alert(this.state.solution_type_cd == "09900" ? "영역을 입력해 주세요." : "배너 영역을 입력해 주세요.");
            return false;
        }
        //  else if (this.state.event_type == null ||  this.state.event_type == "") {
        //     alert("배너 유형을 선택해 주세요.");
        //  }
        // 단일 사이즈인데 사이즈를 입력하지 않았다면
        else if(this.state.single_size && !(this.state.event_banner_pc_width && this.state.event_banner_pc_height && Number(this.state.event_banner_pc_width)>0 && Number(this.state.event_banner_pc_height)>0)){
            alert("배너 사이즈를 입력해 주세요.");
            return false;
        }
        // 사이즈1, 사이즈2 중에 모두 입력된 값이 없다면
        else if(!((this.state.event_banner_pc_width && this.state.event_banner_pc_height && Number(this.state.event_banner_pc_width)>0 && Number(this.state.event_banner_pc_height)>0) || (this.state.event_banner_mobile_width && this.state.event_banner_mobile_height && Number(this.state.event_banner_mobile_width)>0 && Number(this.state.event_banner_mobile_height)>0))){
            alert("배너 사이즈를 입력해 주세요.");
            return false;
        }

        if(this.state.solution_type_cd != '09900') {
            /* 1페이지 */
            if (this.state.start_date == null ||  this.state.start_date == "") {
                alert("시작 일자를 입력해 주세요.");
                return false;
            }
            else if (this.state.event_cycle == null ||  this.state.event_cycle == "") {
                alert("자동 생성주기를 선택해 주세요.");
                return false;
            }
                //  else if (this.state.event_ampm == null ||  this.state.event_ampm == "") {
                //     alert("자동 생성시간을 선택해 주세요.");
            //  }
            else if (this.state.event_time == null ||  this.state.event_time == "") {
                alert("자동 생성시간을 선택해 주세요.");
                return false;
            } else if (this.state.event_period == null ||  this.state.event_period == "") {
                alert("진열 기간을 선택해 주세요.");
                return false;
            }

            /* 2페이지 */
            else if (this.state.event_item_user_type == "15001" && !this.state.all_user_item.isAnyPrice && (this.state.all_user_item.event_item_min_price == null ||  this.state.all_user_item.event_item_min_price === "")) {
                alert("상품 최소 가격을 선택해 주세요.");
                return false;
            } else if (this.state.event_item_user_type == "15001" && !this.state.all_user_item.isAnyPrice && (this.state.all_user_item.event_item_max_price == null ||  this.state.all_user_item.event_item_max_price === "")) {
                alert("상품 최대 가격을 선택해 주세요.");
                return false;
            } else if (this.state.event_item_user_type == "15001" && !this.state.all_user_item.isAnyHit && (this.state.all_user_item.event_item_min_hit == null ||  this.state.all_user_item.event_item_min_hit === "")) {
                alert("상품 최소 조회수를 선택해 주세요.");
                return false;
            } else if (this.state.event_item_user_type == "15001" && !this.state.all_user_item.isAnyHit && (this.state.all_user_item.event_item_max_hit == null ||  this.state.all_user_item.event_item_max_hit === "")) {
                alert("상품 최대 조회수를 선택해 주세요.");
                return false;
            }
                // else if (this.state.event_item_user_type == "15001" && !this.state.all_user_item.isAnyReview && (this.state.all_user_item.event_item_min_review == null ||  this.state.all_user_item.event_item_min_review === "")) {
                //     alert("상품 최소 리뷰수를 선택해 주세요.");
                // } else if (this.state.event_item_user_type == "15001" && !this.state.all_user_item.isAnyReview && (this.state.all_user_item.event_item_max_review == null ||  this.state.all_user_item.event_item_max_review === "")) {
                //     alert("상품 최대 리뷰수를 선택해 주세요.");
            // }
            else if (this.state.event_item_user_type == "15001" && !this.state.all_user_item.isAnyOrder && (this.state.all_user_item.event_item_min_order == null ||  this.state.all_user_item.event_item_min_order === "")) {
                alert("상품 최소 구매수를 선택해 주세요.");
                return false;
            } else if (this.state.event_item_user_type == "15001" && !this.state.all_user_item.isAnyOrder && (this.state.all_user_item.event_item_max_order == null ||  this.state.all_user_item.event_item_max_order === "")) {
                alert("상품 최대 구매수를 선택해 주세요.");
                return false;
            }
                // else if (this.state.event_item_user_type == "15001" && !this.state.all_user_item.isAnyQuantity && (this.state.all_user_item.event_item_min_quantity == null ||  this.state.all_user_item.event_item_min_quantity === "")) {
                //     alert("상품 최소 재고수를 선택해 주세요.");
                // } else if (this.state.event_item_user_type == "15001" && !this.state.all_user_item.isAnyQuantity && (this.state.all_user_item.event_item_max_quantity == null ||  this.state.all_user_item.event_item_max_quantity === "")) {
                //     alert("상품 최대 재고수를 선택해 주세요.");
            // }
            else if (this.state.event_item_user_type == "15001" && (this.state.all_user_item.event_item_created_period == null ||  this.state.all_user_item.event_item_created_period === "")) {
                alert("상품 등록날짜를 선택해 주세요.");
                return false;
            } else if (this.state.event_item_user_type == "15001" && (this.state.all_user_item.event_item_analysis_period == null ||  this.state.all_user_item.event_item_analysis_period == "")) {
                alert("상품분석 기간을 선택해 주세요.");
                return false;
            }
            else if (this.state.event_item_user_type == "15001" && (this.state.all_user_item.product_duplicate_check_type == null ||  this.state.all_user_item.product_duplicate_check_type == "")) {
                alert("상품 중복체크 유형을 선택해 주세요.");
                return false;
            }

            else if (this.state.event_item_user_type == "15002" && !this.state.member_user_item.isAnyPrice && (this.state.member_user_item.event_item_min_price == null ||  this.state.member_user_item.event_item_min_price === "")) {
                alert("회원 상품 최소 가격을 선택해 주세요.");
                return false;
            } else if (this.state.event_item_user_type == "15002" && !this.state.member_user_item.isAnyPrice && (this.state.member_user_item.event_item_max_price == null ||  this.state.member_user_item.event_item_max_price === "")) {
                alert("회원 상품 최대 가격을 선택해 주세요.");
                return false;
            } else if (this.state.event_item_user_type == "15002" && !this.state.member_user_item.isAnyHit && (this.state.member_user_item.event_item_min_hit == null ||  this.state.member_user_item.event_item_min_hit === "")) {
                alert("회원 상품 최소 조회수를 선택해 주세요.");
                return false;
            } else if (this.state.event_item_user_type == "15002" && !this.state.member_user_item.isAnyHit && (this.state.member_user_item.event_item_max_hit == null ||  this.state.member_user_item.event_item_max_hit === "")) {
                alert("회원 상품 최대 조회수를 선택해 주세요.");
                return false;
            }
                // else if (this.state.event_item_user_type == "15002" && !this.state.member_user_item.isAnyReview && (this.state.member_user_item.event_item_min_review == null ||  this.state.member_user_item.event_item_min_review === "")) {
                //     alert("회원 상품 최소 리뷰수를 선택해 주세요.");
                // } else if (this.state.event_item_user_type == "15002" && !this.state.member_user_item.isAnyReview && (this.state.member_user_item.event_item_max_review == null ||  this.state.member_user_item.event_item_max_review === "")) {
                //     alert("회원 상품 최대 리뷰수를 선택해 주세요.");
            // }
            else if (this.state.event_item_user_type == "15002" && !this.state.member_user_item.isAnyOrder && (this.state.member_user_item.event_item_min_order == null ||  this.state.member_user_item.event_item_min_order === "")) {
                alert("회원 상품 최소 구매수를 선택해 주세요.");
                return false;
            } else if (this.state.event_item_user_type == "15002" && !this.state.member_user_item.isAnyOrder && (this.state.member_user_item.event_item_max_order == null ||  this.state.member_user_item.event_item_max_order === "")) {
                alert("회원 상품 최대 구매수를 선택해 주세요.");
                return false;
            }
                // else if (this.state.event_item_user_type == "15002" && !this.state.member_user_item.isAnyQuantity && (this.state.member_user_item.event_item_min_quantity == null ||  this.state.member_user_item.event_item_min_quantity === "")) {
                //     alert("회원 상품 최소 재고수를 선택해 주세요.");
                // } else if (this.state.event_item_user_type == "15002" && !this.state.member_user_item.isAnyQuantity && (this.state.member_user_item.event_item_max_quantity == null ||  this.state.member_user_item.event_item_max_quantity === "")) {
                //     alert("회원 상품 최대 재고수를 선택해 주세요.");
            // }
            else if (this.state.event_item_user_type == "15002" && (this.state.member_user_item.event_item_created_period == null ||  this.state.member_user_item.event_item_created_period === "")) {
                alert("회원 상품 등록날짜를 선택해 주세요.");
                return false;
            } else if (this.state.event_item_user_type == "15002" && (this.state.member_user_item.event_item_analysis_period == null ||  this.state.member_user_item.event_item_analysis_period == "")) {
                alert("회원 상품분석 기간을 선택해 주세요.");
                return false;
            }
            else if (this.state.event_item_user_type == "15002" && (this.state.member_user_item.product_duplicate_check_type == null ||  this.state.member_user_item.product_duplicate_check_type == "")) {
                alert("회원 상품 중복체크 유형을 선택해 주세요.");
                return false;
            }

            else if (this.state.event_item_user_type == "15002" && !this.state.none_user_item.isAnyPrice && (this.state.none_user_item.event_item_min_price == null ||  this.state.none_user_item.event_item_min_price === "")) {
                alert("비회원 상품 최소 가격을 선택해 주세요.");
                return false;
            } else if (this.state.event_item_user_type == "15002" && !this.state.none_user_item.isAnyPrice && (this.state.none_user_item.event_item_max_price == null ||  this.state.none_user_item.event_item_max_price === "")) {
                alert("비회원 상품 최대 가격을 선택해 주세요.");
                return false;
            } else if (this.state.event_item_user_type == "15002" && !this.state.none_user_item.isAnyHit && (this.state.none_user_item.event_item_min_hit == null ||  this.state.none_user_item.event_item_min_hit === "")) {
                alert("비회원 상품 최소 조회수를 선택해 주세요.");
                return false;
            } else if (this.state.event_item_user_type == "15002" && !this.state.none_user_item.isAnyHit && (this.state.none_user_item.event_item_max_hit == null ||  this.state.none_user_item.event_item_max_hit === "")) {
                alert("비회원 상품 최대 조회수를 선택해 주세요.");
                return false;
            }
                // else if (this.state.event_item_user_type == "15002" && !this.state.none_user_item.isAnyReview && (this.state.none_user_item.event_item_min_review == null ||  this.state.none_user_item.event_item_min_review === "")) {
                //     alert("비회원 상품 최소 리뷰수를 선택해 주세요.");
                // } else if (this.state.event_item_user_type == "15002" && !this.state.none_user_item.isAnyReview && (this.state.none_user_item.event_item_max_review == null ||  this.state.none_user_item.event_item_max_review === "")) {
                //     alert("비회원 상품 최대 리뷰수를 선택해 주세요.");
            // }
            else if (this.state.event_item_user_type == "15002" && !this.state.none_user_item.isAnyOrder && (this.state.none_user_item.event_item_min_order == null ||  this.state.none_user_item.event_item_min_order === "")) {
                alert("비회원 상품 최소 구매수를 선택해 주세요.");
                return false;
            } else if (this.state.event_item_user_type == "15002" && !this.state.none_user_item.isAnyOrder && (this.state.none_user_item.event_item_max_order == null ||  this.state.none_user_item.event_item_max_order === "")) {
                alert("비회원 상품 최대 구매수를 선택해 주세요.");
                return false;
            }
                // else if (this.state.event_item_user_type == "15002" && !this.state.none_user_item.isAnyQuantity && (this.state.none_user_item.event_item_min_quantity == null ||  this.state.none_user_item.event_item_min_quantity === "")) {
                //     alert("비회원 상품 최소 재고수를 선택해 주세요.");
                // } else if (this.state.event_item_user_type == "15002" && !this.state.none_user_item.isAnyQuantity && (this.state.none_user_item.event_item_max_quantity == null ||  this.state.none_user_item.event_item_max_quantity === "")) {
                //     alert("비회원 상품 최대 재고수를 선택해 주세요.");
            // }
            else if (this.state.event_item_user_type == "15002" && (this.state.none_user_item.event_item_created_period == null ||  this.state.none_user_item.event_item_created_period === "")) {
                alert("비회원 상품 등록날짜를 선택해 주세요.");
                return false;
            } else if (this.state.event_item_user_type == "15002" && (this.state.none_user_item.event_item_analysis_period == null ||  this.state.none_user_item.event_item_analysis_period == "")) {
                alert("비회원 상품분석 기간을 선택해 주세요.");
                return false;
            }
            else if (this.state.event_item_user_type == "15002" && (this.state.none_user_item.product_duplicate_check_type == null ||  this.state.none_user_item.product_duplicate_check_type == "")) {
                alert("비회원 상품 중복체크 유형을 선택해 주세요.");
                return false;
            }

        }
        
        /* 3패아지 */
        if (this.state.is_size_horizontal == true && (this.state.event_type_arr == null || this.state.event_type_arr == "" || (this.state.event_type_arr != null && this.state.event_type_arr.length <= 0))) {
           alert("가로 배너유형을 선택해 주세요.");
            return false;
        }
        else if (this.state.is_size_vertical == true && (this.state.event_mobile_type_arr == null || this.state.event_mobile_type_arr == "" || (this.state.event_mobile_type_arr != null && this.state.event_mobile_type_arr.length <= 0))) {
           alert("세로 배너유형을 선택해 주세요.");
            return false;
        }
        // else if (this.state.shop_no == null ||  this.state.shop_no == "") {
        //     alert("배너용 쇼핑몰을 선택해 주세요.");
        //  } 

        //  else if (this.state.shop_intro_title == null ||  this.state.shop_intro_title == "") {
        //     alert("미진열시 보여줄 배너 제목을 입력하여 주세요.");
        //  } else if (this.state.shop_intro_content == null ||  this.state.shop_intro_content == "") {
        //     alert("미진열시 보여줄 배너 내용을 입력하여 주세요.");
        //  }
        else {
            for(let i=0;i<this.state.event_type_arr.length;i++){
                if (this.state.is_size_horizontal && this.state.non_use_event_type_cd_list != null && this.state.non_use_event_type_cd_list.indexOf(this.state.event_type_arr[i]) != -1){
                    alert("사용 가능한 가로형 배너만을 선택해주세요.");
                    return false;
                }
            }
            for(let i=0;i<this.state.event_mobile_type_arr.length;i++){
                if (this.state.is_size_vertical && this.state.non_use_event_mobile_type_cd_list != null && this.state.non_use_event_mobile_type_cd_list.indexOf(this.state.event_mobile_type_arr[i]) != -1){
                    alert("사용 가능한 세로형 배너만을 선택해주세요.");
                    return false;
                }
            }

            if(this.state.solution_type_cd != '09900') {
                if (this.state.display_yn == "Y") {
                    if(is_free_finish == true) {
                        if(is_order != true) {
                            alert("자동 진열 기능은 멤버십 결제 후 이용하실 수 있습니다. 결제 후 진열하기로 변경해 주세요.");
                            return false;
                        }
                    } else {
                        if(is_order != true) {
                            alert("자동 진열 기능은 멤버십 결제 후 이용하실 수 있습니다. 결제 후 진열하기로 변경해 주세요.");
                            return false;
                        }
                    }
                }
            }

             var category_list = [];
             $(".checkCategory").each( function() {
                if ($(this).is(":checked")) {
                    category_list.push($(this).val());
                }
            });
            // if (category_list.length == 0) {
            //     alert("희망 카테고리를 선택해 주세요.");
            //     return false;
            // }
            // console.log(category_list);
            var event_category_list = category_list.join();

            if(this.state.solution_type_cd != '09900') {
                if (this.state.event_period < this.state.event_cycle) {
                    alert("자동생성 주기가 진열기간 보다 길 수 없습니다.");
                    return false;
                }
            }

            var event_time = this.state.event_time;
            var event_ampm = "";
            if (Number(event_time)>=13) {
                event_time = Number(event_time) - 12;
                event_ampm = "오후";
            } else {
                if (Number(event_time) == 0) {
                    event_time = Number(event_time)  + 12;
                }
                event_ampm = "오전"
            }

            if(!this.state.slide_yn){
                alert("슬라이드 여부를 선택해 주세요.");
                return false;
            }

            if(this.state.slide_yn == "Y") {
                // 슬라이드 전환 효과 체크
                if (this.state.transition_mode == null || this.state.transition_mode == "") {
                    alert("슬라이드 전환 효과를 선택해 주세요.");
                    return false;
                }
                // 슬라이드 전환 시간 체크
                if (this.state.transition_pause == null || this.state.transition_pause == "") {
                    alert("슬라이드 전환 시간을 선택해 주세요.");
                    return false;
                }
                if (this.state.transition_mode != "27003") {     //27003	효과 없음 (깜빡이는 것처럼 배너가 바로 바뀜)
                    // 슬라이드 전환 효과 속도 체크
                    if (this.state.transition_speed == null || this.state.transition_speed == "") {
                        alert("슬라이드 전환 효과 속도를 선택해 주세요.");
                        return false;
                    }
                    // 27001(롤링) 선택시 전환 속도는 텀보다 느리거나 같은 설정값은 저장 할 수 없음.
                    if (this.state.transition_mode == "27001" && Number(this.state.transition_speed_val) >= Number(this.state.transition_pause_val)) {
                        alert("전환 속도는 전환 텀보다 느리거나 같은 설정을 할 수 없습니다.");
                        return false;
                    }
                }
                
                // 페이지 컨트롤 모양 체크
                if (!(this.state.solution_type_cd == "09001" || this.state.solution_type_cd == "09900")) {
                    if (this.state.page_control_type == null || this.state.page_control_type == "") {
                        alert("페이지 컨트롤 모양을 선택해 주세요.");
                        return false;
                    } else if (this.state.page_control_type != "000") {
                        // 페이지 컨트롤 위치 체크
                        if (this.state.page_control_position_type == null || this.state.page_control_position_type == "") {
                            alert("페이지 컨트롤 위치를 선택해 주세요.");
                            return false;
                        }
                    }
                }
            }

            // 대제목 번역 언어 체크
            if (this.state.translated_yn == "Y") {
                if (this.state.language_code == null || this.state.language_code == "") {
                    alert("번역할 언어를 선택해 주세요.");
                    return false;
                }
            }

            if(this.state.solution_type_cd != '09900') {
                if (this.state.link_open_type == null || this.state.link_open_type == "") {
                    alert("링크 열기 타입을 선택해 주세요.");
                    return false;
                }
            }

            let confirm_message = "";

            if(this.state.solution_type_cd != '09900') {
                confirm_message = this.state.event_period_text  +"동안 진열되고 \n"
                    + this.state.event_cycle_text + " 간격으로 " + event_ampm + " " +  event_time + "시에 생성되는"
                    // +"\n"+ this.state.event_type_text + "유형의"
                    +" 배너입니다." + "\n\n"
                    + "저장하시겠습니까?";
            }else {
                confirm_message = "저장하시겠습니까?";
            }

            if (window.confirm(confirm_message)) {
                const formData = new FormData();

                // var event_time = 0;
                // if (this.state.event_ampm == "pm") {
                //     if (this.state.event_time == "12") { 
                //         event_time = this.state.event_time
                //     } else {
                //         event_time = parseInt(this.state.event_time)+12;
                //     }
                // } else {
                //     if (this.state.event_time == "12") {                
                //         event_time = parseInt(this.state.event_time)-12;
                //     } else {
                //         event_time = this.state.event_time
                //     }
                // }
                
                formData.append('user_seq',this.state.user_seq);
                formData.append('shop_no',1);
                
                formData.append('start_date', StringUtil.dateFormater(this.state.start_date));
                formData.append('event_period',this.state.event_period);
                formData.append('event_cycle',this.state.event_cycle);
                formData.append('event_time',this.state.event_time);
                // formData.append('event_type_cd',this.state.event_type);
                formData.append('shop_intro_title',this.state.shop_intro_title);
                formData.append('shop_intro_content',this.state.shop_intro_content);
                // formData.append('event_category_list',event_category_list);
                formData.append('event_type_arr', this.state.event_type_arr);
                formData.append('event_mobile_type_arr', this.state.event_mobile_type_arr);

                let event_banner_pc_width, event_banner_pc_height, event_banner_mobile_width, event_banner_mobile_height;
                if((this.state.event_banner_pc_width && this.state.event_banner_pc_height && Number(this.state.event_banner_pc_width) > 0 && Number(this.state.event_banner_pc_height) > 0) && !(this.state.event_banner_mobile_width && this.state.event_banner_mobile_height && Number(this.state.event_banner_mobile_width) > 0 && Number(this.state.event_banner_mobile_height) > 0)){
                    event_banner_pc_width = this.state.event_banner_pc_width;
                    event_banner_pc_height = this.state.event_banner_pc_height;
                    event_banner_mobile_width = this.state.event_banner_pc_width;
                    event_banner_mobile_height = this.state.event_banner_pc_height;
                } else if(!(this.state.event_banner_pc_width && this.state.event_banner_pc_height && Number(this.state.event_banner_pc_width) > 0 && Number(this.state.event_banner_pc_height) > 0) && (this.state.event_banner_mobile_width && this.state.event_banner_mobile_height && Number(this.state.event_banner_mobile_width) > 0 && Number(this.state.event_banner_mobile_height) > 0)){
                    event_banner_pc_width = this.state.event_banner_mobile_width;
                    event_banner_pc_height = this.state.event_banner_mobile_height;
                    event_banner_mobile_width = this.state.event_banner_mobile_width;
                    event_banner_mobile_height = this.state.event_banner_mobile_height;
                } else if(this.state.single_size) {
                    event_banner_pc_width = this.state.event_banner_pc_width;
                    event_banner_pc_height = this.state.event_banner_pc_height;
                    event_banner_mobile_width = this.state.event_banner_pc_width;
                    event_banner_mobile_height = this.state.event_banner_pc_height;
                } else {
                    event_banner_pc_width = this.state.event_banner_pc_width;
                    event_banner_pc_height = this.state.event_banner_pc_height;
                    event_banner_mobile_width = this.state.event_banner_mobile_width;
                    event_banner_mobile_height = this.state.event_banner_mobile_height;
                }

                formData.append('event_banner_pc_width', event_banner_pc_width);
                formData.append('event_banner_pc_height', event_banner_pc_height);
                formData.append('event_banner_mobile_width', event_banner_mobile_width);
                formData.append('event_banner_mobile_height', event_banner_mobile_height);

                // console.log("#### this.state.category_page_step: "+ this.state.category_page_step);
                if(this.state.iframe_page_id == "robomd_category_page") {
                    formData.append('iframe_html_id_category', 
                        this.state.category_page_step == 1 ? this.state.category_page_1
                        : this.state.category_page_step == 2 ? this.state.category_page_1+","+this.state.category_page_2
                        : this.state.category_page_step == 3 ? this.state.category_page_1+","+this.state.category_page_2+","+this.state.category_page_3
                        : this.state.category_page_step == 4 ? this.state.category_page_1+","+this.state.category_page_2+","+this.state.category_page_3+","+this.state.category_page_4
                        : ""
                    );
                }


                // formData.append('event_item_min_price',this.state.event_item_min_price);
                // formData.append('event_item_max_price',this.state.event_item_max_price);
                // formData.append('event_item_created_period',this.state.event_item_created_period);
                // formData.append('event_item_analysis_period',this.state.event_item_analysis_period);
                if (this.state.event_item_user_type == "15001") {
                    formData.append('all_user_item',JSON.stringify(this.state.all_user_item));
                }
                if (this.state.event_item_user_type == "15002") {
                    formData.append('member_user_item',JSON.stringify(this.state.member_user_item));
                    formData.append('none_user_item',JSON.stringify(this.state.none_user_item));
                }

                formData.append('select_category_no_list_for_all_user', this.state.select_category_no_list_for_all_user);
                formData.append('select_category_no_list_for_only_user', this.state.select_category_no_list_for_only_user);
                formData.append('select_category_no_list_for_non_user', this.state.select_category_no_list_for_non_user);

                formData.append('select_category_name_list_for_all_user', JSON.stringify(this.state.select_category_name_list_for_all_user));
                formData.append('select_category_name_list_for_only_user', JSON.stringify(this.state.select_category_name_list_for_only_user));
                formData.append('select_category_name_list_for_non_user', JSON.stringify(this.state.select_category_name_list_for_non_user));

                formData.append('domain_list',this.state.domain_list);
                
                formData.append('reg_date',this.state.reg_date);

                formData.append('iframe_page_id',this.state.iframe_page_id);
                formData.append('iframe_html_id',this.state.iframe_html_id) ;
                formData.append('iframe_html_name',this.state.iframe_html_name) ;

                formData.append('event_item_user_type',this.state.event_item_user_type) ;

                if (this.state.isAnyPrice)
                    formData.append('is_any_item_price',"Y");
                else
                    formData.append('is_any_item_price',"N");

                formData.append('page_control_type',this.state.page_control_type);
                formData.append('page_control_position_type',this.state.page_control_position_type);

                formData.append('transition_mode',this.state.transition_mode);
                formData.append('transition_speed',this.state.transition_speed);
                formData.append('transition_pause',this.state.transition_pause);

                formData.append('display_yn',this.state.display_yn);

                formData.append('translated_yn',this.state.translated_yn);
                formData.append('language_code',this.state.language_code);

                formData.append('gif_divide_yn',this.state.gif_divide_yn);

                formData.append('link_open_type',this.state.link_open_type);

                formData.append('slide_yn',this.state.slide_yn);
                formData.append('event_show_type',this.state.event_show_type);
                formData.append('popup_position',this.state.popup_position);
                formData.append('popup_block_cycle',this.state.popup_block_cycle);
                formData.append('popup_block_cycle_title',this.state.popup_block_cycle_title);
                
                formData.append('popup_close_btn_title_cd',this.state.popup_close_btn_title_cd);
                formData.append('popup_close_btn_title',this.state.popup_close_btn_title);

                formData.append('popup_delay_type_cd',this.state.popup_delay_type_cd);
                formData.append('popup_delay_time',this.state.popup_delay_time);
                
                formData.append('popup_block_cycle_day',this.state.popup_block_cycle_day);
                formData.append('popup_target_type',this.state.popup_target_type);
                if(this.state.popup_seq){
                    formData.append('popup_seq',this.state.popup_seq);
                }

                // 팝업 타겟뷰 seq 리스트 생성
                let popup_target_view_seq_list = [];
                for(var i=0;i<this.state.popup_target_view_list.length;i++){
                    popup_target_view_seq_list.push(this.state.popup_target_view_list[i].target_view_seq);
                }
                formData.append('popup_target_view_seq_list',JSON.stringify(popup_target_view_seq_list));

                if(this.state.solution_type_cd=="09900"){
                    formData.delete("event_period");
                    formData.append('event_period', 3);
                    formData.append('auto_create_yn',"N");
                }

                /* 화살표 관련 설정 */
                formData.append('banner_arrow_use_yn',this.state.banner_arrow_use_yn);
                formData.append('banner_arrow_position',this.state.banner_arrow_position);
                formData.append('banner_arrow_box',this.state.banner_arrow_box);
                formData.append('banner_arrow_color',this.state.banner_arrow_color);
                formData.append('banner_arrow_size_border_width',this.state.banner_arrow_size_border_width);
                formData.append('banner_arrow_hover_yn',this.state.banner_arrow_hover_yn);

                /* 팝업 위치이동 관련 설정 */
                const {popup_position_left, popup_position_right, popup_position_top, popup_position_bottom} = this.state;
                let popup_position_x = 0;
                let popup_position_y = 0;
                if (popup_position_left > 0) {
                    popup_position_x = -1 * popup_position_left;
                } else if (popup_position_right > 0) {
                    popup_position_x = popup_position_right;
                }
                if (popup_position_top > 0) {
                    popup_position_y = popup_position_top;
                } else if (popup_position_bottom > 0) {
                    popup_position_y = -1 * popup_position_bottom;
                }

                formData.append('popup_position_x',popup_position_x);
                formData.append('popup_position_y',popup_position_y);
                
                const config = {
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded; charset=utf-8'
                    }
                }

                // console.log(this.state.all_user_item);

                http.post("/rest/shop/event/setting", formData, config)
                .then(
                    resultData => { 
                        if(this.state.solution_type_cd=="09001" && this.state.event_show_type == "70002" && resultData.data.err_code == "9004"){
                            this.setState({
                                confirm_dialog_show_state : true,
                                confirm_dialog_content : "팝업으로 노출하기 위해서는<br/>배너앱 설치가 필요합니다.<br/><br/>지금 설치할까요?",
                                confirm_dialog_button_list : [
                                    {
                                        title: "확인",
                                        type: "1",
                                        event_method: () => {
                                            this.setState({
                                                confirm_dialog_show_state: false,
                                            });
                                            window.open("https://store.cafe24.com/kr/apps/3652", '_blank');
                                        }
                                    },
                                    {
                                        title: "아니요",
                                        type: "0",
                                        event_method: () => {
                                            this.setState({
                                                confirm_dialog_show_state: false,
                                            });
                                        }
                                    }
                                ]
                            });
                            return false;
                        }

                        if (resultData.data.err_msg == null) {
                            // console.log(resultData); 
                            alert("저장 되었습니다.");
                            // window.location.reload();
                            this.props.history.push("/shop/cafe24/event/setting/list")
                        } else {
                            alert(resultData.data.err_msg);
                            if (resultData.data.err_code == 401) {
                                window.location.href = "/logout";
                            }
                            window.location.reload();
                        }
                    })
                .catch(
                    error => { alert("저장에 실패하였습니다."); }
                );
            }
         }
    };

    domain_handleKeyDown =  e => {
        this.setState({input_domain_width : ((e.target.value.length + 3) * 8) + 'px'});
        if (e.key === 'Enter') {
            // console.log(e.target.value);
            if (e.target.value == null || e.target.value === "") {
                return false;
            }
            var domain_list = this.state.domain_list;
            // console.log(domain_list);
            domain_list.push(e.target.value);
            this.setState({domain_list: domain_list, input_domain_width :"35px"})
            e.target.value = "";

            // 자동배너 설정 - 쇼핑몰 사이트 주소 입력
            ReactGA.event({
                category: "자동배너 설정",
                action: "쇼핑몰 사이트 주소 입력 : " + domain_list,
                label: ga_label
            });
        }
    }

    number_keydown =  e => {
        // console.log(e.keyCode);
        if (e.keyCode === 69 || e.keyCode === 107 || e.keyCode === 109 || e.keyCode === 189) {
            /* e, -, + 막기 */
            e.preventDefault(); 
        } 
    }

    domain_focusout =  e => {
        // console.log(e.target.value);
        if (e.target.value == null || e.target.value === "") {
            return false;
        }
        var domain_list = this.state.domain_list;
        // console.log(domain_list);
        domain_list.push(e.target.value);
        this.setState({domain_list: domain_list, input_domain_width :"35px"})
        e.target.value = "";

        // 자동배너 설정 - 쇼핑몰 사이트 주소 입력
        ReactGA.event({
            category: "자동배너 설정",
            action: "쇼핑몰 사이트 주소 입력 : " + domain_list,
            label: ga_label
        });

    }
    domain_remove =  (e, domain) => {
        // console.log(domain);
        var domain_list = this.state.domain_list;
        // console.log(domain_list);
        var index = domain_list.indexOf(domain);
        domain_list.splice(index, 1);
        this.setState({domain_list: domain_list})

        // 자동배너 설정 - 쇼핑몰 사이트 주소 입력
        ReactGA.event({
            category: "자동배너 설정",
            action: "쇼핑몰 사이트 주소 입력 : " + domain_list,
            label: ga_label
        });
    }

    // 가격 무관
    onClickPriceAuto = (e) => {
        let target = e.target.value;
        let user_item = this.state[target+"_user_item"];
        if (e.target.checked) {
            user_item["event_item_min_price"] = "";
            user_item["event_item_max_price"] = "";
            user_item["isAnyPrice"] = true;
        } else {
            user_item["isAnyPrice"] = false;
        }
        this.setState({
            [target+"_user_item"] : user_item
        });

        // 자동배너 설정 - 가격무관 여부
        ReactGA.event({
            category: "자동배너 설정",
            action: "가격무관 여부 : " + e.target.checked,
            label: ga_label
        });

        // this.getItemCntCheckValidate("all");
    }

    // 조회수 무관
    onClickHitAuto = (e) => {
        let target = e.target.value;
        let user_item = this.state[target+"_user_item"];
        if (e.target.checked) {
            user_item["event_item_min_hit"] = "";
            user_item["event_item_max_hit"] = "";
            user_item["isAnyHit"] = true;
        } else {
            user_item["isAnyHit"] = false;
        }
        this.setState({
            [target+"_user_item"] : user_item
        });

        // 자동배너 설정 - 조회수 무관 여부
        ReactGA.event({
            category: "자동배너 설정",
            action: "조회수 무관 여부 : " + e.target.checked,
            label: ga_label
        });

        // this.getItemCntCheckValidate("all");
    }

    // 리뷰수 무관 (ALL USER)
    onClickReviewAuto = e => {
        if (e.target.checked) {
            // alert("checked");
            const { all_user_item } = this.state;
            all_user_item["event_item_min_review"] = "";
            all_user_item["event_item_max_review"] = "";
            all_user_item["isAnyReview"] = true;
            this.setState({
                all_user_item : all_user_item
            });            
            $("#event_item_min_review").attr("disabled", "true");           
            $("#event_item_max_review").attr("disabled", "true");           
        } else {
            // alert("unchecked");
            const { all_user_item } = this.state;
            all_user_item["isAnyReview"] = false;
            this.setState({
                all_user_item : all_user_item
            });  
            $("#event_item_min_review").removeAttr("disabled");           
            $("#event_item_max_review").removeAttr("disabled");   
        }

        // 자동배너 설정 - 리뷰수 무관 여부
        ReactGA.event({
            category: "자동배너 설정",
            action: "리뷰수 무관 여부 : " + e.target.checked,
            label: ga_label
        });

        // this.getItemCntCheckValidate("all");
    }

    // 구매수 무관
    onClickOrderAuto = (e) => {
        let target = e.target.value;
        let user_item = this.state[target+"_user_item"];
        if (e.target.checked) {
            user_item["event_item_min_order"] = "";
            user_item["event_item_max_order"] = "";
            user_item["isAnyOrder"] = true;
        } else {
            user_item["isAnyOrder"] = false;
        }
        this.setState({
            [target+"_user_item"] : user_item
        });

        // 자동배너 설정 - 구매수 무관 여부
        ReactGA.event({
            category: "자동배너 설정",
            action: "구매수 무관 여부 : " + e.target.checked,
            label: ga_label
        });

        // this.getItemCntCheckValidate("all");
    }
    
    // 재고수 무관 (ALL USER)
    onClickQuantityAuto = e => {
        if (e.target.checked) {
            // alert("checked");
            const { all_user_item } = this.state;
            all_user_item["event_item_min_quantity"] = "";
            all_user_item["event_item_max_quantity"] = "";
            all_user_item["isAnyQuantity"] = true;
            this.setState({
                all_user_item : all_user_item
            });            
            $("#event_item_min_quantity").attr("disabled", "true");           
            $("#event_item_max_quantity").attr("disabled", "true");           
        } else {
            // alert("unchecked");
            const { all_user_item } = this.state;
            all_user_item["isAnyQuantity"] = false;
            this.setState({
                all_user_item : all_user_item
            });  
            $("#event_item_min_quantity").removeAttr("disabled");           
            $("#event_item_max_quantity").removeAttr("disabled");   
        }

        // 자동배너 설정 - 재고수 무관 여부
        ReactGA.event({
            category: "자동배너 설정",
            action: "재고수 무관 여부 : " + e.target.checked,
            label: ga_label
        });

        // this.getItemCntCheckValidate("all");
    }

    // 리뷰수 무관 (MEMBER USER)
    onClickReviewAutoForMemberUser = (e, switchType) => {
        if (switchType == "on") {
            // alert("checked");
            const { member_user_item } = this.state;
            member_user_item["event_item_min_review"] = "";
            member_user_item["event_item_max_review"] = "";
            member_user_item["isAnyReview"] = true;
            this.setState({
                member_user_item : member_user_item
            });            
            $("#event_item_min_review_member_user").attr("disabled", "true");           
            $("#event_item_max_review_member_user").attr("disabled", "true");           
        } else {
            // alert("unchecked");
            const { member_user_item } = this.state;
            member_user_item["isAnyReview"] = false;
            this.setState({
                member_user_item : member_user_item
            });  
            $("#event_item_min_review_member_user").removeAttr("disabled");           
            $("#event_item_max_review_member_user").removeAttr("disabled");   
        }

        // 자동배너 설정 - 리뷰수 무관 여부
        ReactGA.event({
            category: "자동배너 설정",
            action: "리뷰수 무관 여부 : " + e.target.checked,
            label: ga_label
        });

        // this.getItemCntCheckValidate("member");
    }

    // 재고수 무관 (MEMBER USER)
    onClickQuantityAutoForMemberUser = (e, switchType) => {
        if (switchType == "on") {
            // alert("checked");
            const { member_user_item } = this.state;
            member_user_item["event_item_min_quantity"] = "";
            member_user_item["event_item_max_quantity"] = "";
            member_user_item["isAnyQuantity"] = true;
            this.setState({
                member_user_item : member_user_item
            });            
            $("#event_item_min_quantity_member_user").attr("disabled", "true");           
            $("#event_item_max_quantity_member_user").attr("disabled", "true");           
        } else {
            // alert("unchecked");
            const { member_user_item } = this.state;
            member_user_item["isAnyQuantity"] = false;
            this.setState({
                member_user_item : member_user_item
            });  
            $("#event_item_min_quantity_member_user").removeAttr("disabled");           
            $("#event_item_max_quantity_member_user").removeAttr("disabled");   
        }

        // 자동배너 설정 - 재고수 무관 여부
        ReactGA.event({
            category: "자동배너 설정",
            action: "재고수 무관 여부 : " + e.target.checked,
            label: ga_label
        });

        // this.getItemCntCheckValidate("member");
    }

    // 리뷰수 무관 (NONE USER)
    onClickReviewAutoForNoneUser = (e, switchType) => {
        if (switchType == "on") {
            // alert("checked");
            const { none_user_item } = this.state;
            none_user_item["event_item_min_review"] = "";
            none_user_item["event_item_max_review"] = "";
            none_user_item["isAnyReview"] = true;
            this.setState({
                none_user_item : none_user_item
            });            
            $("#event_item_min_review_none_user").attr("disabled", "true");           
            $("#event_item_max_review_none_user").attr("disabled", "true");           
        } else {
            // alert("unchecked");
            const { none_user_item } = this.state;
            none_user_item["isAnyReview"] = false;
            this.setState({
                none_user_item : none_user_item
            });  
            $("#event_item_min_review_none_user").removeAttr("disabled");           
            $("#event_item_max_review_none_user").removeAttr("disabled");   
        }

        // 자동배너 설정 - 리뷰수 무관 여부
        ReactGA.event({
            category: "자동배너 설정",
            action: "리뷰수 무관 여부 : " + e.target.checked,
            label: ga_label
        });

        // this.getItemCntCheckValidate("non");
    }

    // 재고수 무관 (NONE USER)
    onClickQuantityAutoForNoneUser = (e, switchType) => {
        if (switchType == "on") {
            // alert("checked");
            const { none_user_item } = this.state;
            none_user_item["event_item_min_quantity"] = "";
            none_user_item["event_item_max_quantity"] = "";
            none_user_item["isAnyQuantity"] = true;
            this.setState({
                none_user_item : none_user_item
            });            
            $("#event_item_min_quantity_none_user").attr("disabled", "true");           
            $("#event_item_max_quantity_none_user").attr("disabled", "true");           
        } else {
            // alert("unchecked");
            const { none_user_item } = this.state;
            none_user_item["isAnyQuantity"] = false;
            this.setState({
                none_user_item : none_user_item
            });  
            $("#event_item_min_quantity_none_user").removeAttr("disabled");           
            $("#event_item_max_quantity_none_user").removeAttr("disabled");   
        }

        // 자동배너 설정 - 재고수 무관 여부
        ReactGA.event({
            category: "자동배너 설정",
            action: "재고수 무관 여부 : " + e.target.checked,
            label: ga_label
        });

        // this.getItemCntCheckValidate("non");
    }

    onClickItemUserType = (e) => {
        let type = e.target.value;

        // $(".item_user_type:checked").prop("checked", false); 
        // $("#"+e.target.value).prop("checked", true); 
        if(type== "all_user") {
            this.setState({event_item_user_type : 15001});
        } else if(type == "member") {
            http.get("/rest/shop/solutionType")
            .then(
                resultData => { 
                    if(resultData.data.solution_type_cd != "09003") {
                        this.setState({event_item_user_type : 15002});
                    } else {
                        alert("아입웹 솔루션은 회원/비회원 기준을 등록 할 수 없습니다.")
                        return false;
                    }
                })
            .catch(
                error => { this.setState({event_item_user_type : 15002}); }
            );
        }
        // 자동배너 설정 - 상품 분석기간
        // ReactGA.event({
        //     category: "자동배너 설정",
        //     action: "자동생성 시간 : " + this.state.event_ampm + " " + this.state.event_time_text,
        //     label: ga_label
        // });
    };

    /* 화살표 사용 여부 */
    onClickBannerArrowUseYn = (e) => {
        this.setState({banner_arrow_use_yn : e.target.value});
    };
    /* 화살표 위치 */
    onClickBannerArrowPosition = (e) => {
        this.setState({banner_arrow_position : e.target.value});
    };
    /* 화살표 박스 형태 */
    onClickBannerArrowBox = (e) => {
        this.setState({banner_arrow_box : e.target.value});
    };
    /* 화살표 컬러 */
    onClickBannerArrowColor = (e) => {
        this.setState({banner_arrow_color : e.target.value});
    };
    /* 화살표 크기 및 굵기 */
    onClickBannerArrowSizeBorderWidth = (e) => {
        this.setState({banner_arrow_size_border_width : e.target.value});
    };
    /* 화살표 마우스 오버 */
    onClickBannerArrowHoverYn = (e) => {
        this.setState({banner_arrow_hover_yn : e.target.value});
    };


    /* 페이지 컨트롤 타입 */
    onClickPageControlType = (e) => {
        this.setState({page_control_type : e.target.value});
    };

    /* 페이지 컨트롤 위치 타입 */
    onClickPageControlPositionType = (e) => {
        this.setState({page_control_position_type : e.target.value});
    };

    /* 슬라이드 여부 */
    onClickSlideYN = (e) => {
        console.log(e);
        this.setState({slide_yn : e.target.value});
    };

    /* 슬라이드 전환 효과 */
    onClickTransitionMode = (e) => {
        this.setState({transition_mode : e.target.value});
    };

    /* 슬라이드 전환 시간 */
    onClickTransitionPause = (e) => {
        const {transition_pause_code_list} = this.state;
        const idx = e.target.value;
        this.setState({transition_pause : transition_pause_code_list[idx].code_cd});
        this.setState({transition_pause_val : transition_pause_code_list[idx].val1});
    };

    /* 슬라이드 전환 효과 속도 */
    onClickTransitionSpeed = (e) => {
        const {transition_speed_code_list} = this.state;
        const idx = e.target.value;
        this.setState({transition_speed : transition_speed_code_list[idx].code_cd});
        this.setState({transition_speed_val : transition_speed_code_list[idx].val1});
    };

    /* 번역 여부 */
    onClickTranslatedYn = (e) => {
        this.setState({translated_yn : e.target.value});
    };

    // 번역 선택
    handleLanguageChange = e => {
        this.setState({language_code : e.target.value});
    }

    /* gif 분리 여부 */
    onClickGifDivideYn = (e) => {
        this.setState({gif_divide_yn : e.target.value});
    };

    /** 링크 열기 타입 */
    onChangeLinkOpenType = (e) => {
        this.setState({link_open_type : e.target.value});
    };

    /** 팝업 차단 주기 */
    onChangePopupBlockCycle = (value) => {
        const title = this.state.popup_block_cycle_list.find(obj => obj.code_cd == value).val2;
        this.setState({
            popup_block_cycle : value,
            popup_block_cycle_title : value != "72007" ? title : this.state.popup_block_cycle_title,
        }
            // , () => {
            //     if (value != "72007") { // 72007: 직접 입력
            //         const popup_block_cycle_list = this.state.popup_block_cycle_list;
            //         const popup_block_cycle = this.state.popup_block_cycle;
        
            //         const result = popup_block_cycle_list
            //         .find(item => item.code_cd === popup_block_cycle)
            //         ?.val3;
        
            //         this.setState({
            //             popup_block_cycle_day: result,
            //         });
            //     }
            // }
        );
    };

    /** 팝업 닫기 문구 */
    onChangePopupCloseBtnTitleCd = (value) => {
        const title = this.state.popup_close_btn_title_list.find(obj => obj.code_cd == value).val1;
        this.setState({
            popup_close_btn_title_cd : value,
            popup_close_btn_title : value != "74008" ? title : this.state.popup_close_btn_title,
        }
            // , () => {
            //     if (value != "74008") { // 74008: 직접 입력
            //         const popup_close_btn_title_list = this.state.popup_close_btn_title_list;
            //         const popup_close_btn_title_cd = this.state.popup_close_btn_title_cd;
        
            //         const result = popup_close_btn_title_list
            //         .find(item => item.code_cd === popup_close_btn_title_cd)
            //         ?.val3;
        
            //         this.setState({
            //             popup_close_btn_title: result,
            //         });
            //     }
            // }
        );
    };

    /** 팝업 노출 대상 */
    onChangePopupTargetType = (value) => {
        // 타겟뷰 권한 체크
        this.fn_shopServiceOperated("01009", () => {
            if(this.state.is_use_target_view_service == "N" && value == "73002"){
                this.setState({
                    title_content_dialog_show_state : true,
                    title_content_dialog_title : "타겟뷰 서비스<br/>신청이 필요한 기능입니다.",
                    title_content_dialog_content : "타겟뷰로 맞춤 팝업을 원하는 방문자에게<br/>효과적으로 노출해 보세요.",
                    title_content_dialog_button_list: [
                        {
                            title: "확인",
                            type: "1",
                            event_method: () => {
                                // 결제 페이지 새창 열기
                                window.open("/shop/serviceShopAdd?service_type=01009&step=1", '_blank'); // 새 창으로 열기
    
                                this.setState({
                                    title_content_dialog_show_state: false,
                                });
                            }
                        },
                        {
                            title: "아니요",
                            type: "0",
                            event_method: () => {
                                this.setState({
                                    title_content_dialog_show_state: false,
                                });
                            }
                        }
                    ]
                });
                return false;
            }
    
            this.setState({
                popup_target_type : value,
            });
        });
    };

    /** 타겟 선택하기 */
    onChangeTargetViewSelect = (selectedOption) => {
        let originSelectedOption = this.state.popup_target_view_list;
        let selecteList = this.state.target_view_list;
        const noLimitCode = -1;
        const selectAll = -2;

        // 기존 모든 타겟 선택
        if(selectedOption.find((obj) => obj.target_view_seq == selectAll)){
            selectedOption = selecteList.filter(obj => obj.target_view_seq != noLimitCode && obj.target_view_seq != selectAll);
        } else if(selectedOption.find((obj) => obj.target_view_seq == noLimitCode)){ // 모든 타겟 선택
            // 변경 전에도 모든 타겟 값이 포함되어 있었다면, 모든 타겟이 아닌 새로운 값을 추가한 것
            if(originSelectedOption.find((obj) => obj.target_view_seq == noLimitCode)){
                selectedOption = selectedOption.filter(obj => obj.target_view_seq != noLimitCode);
            } else{ // 모든 타겟 값이 새로 추가된 경우
                selectedOption = selectedOption.filter((obj) => obj.target_view_seq == noLimitCode);
            }
        }
        this.setState({ popup_target_view_list: selectedOption });
    };

    /**
     * state 값 업데이트
     * @param {*} name 이름
     * @param {*} value 값
     */
    handleChange = (name, value) => {
        this.setState({[name] : value});
    }

    onChangeEventShowType  = (value) => {
        this.setState({event_show_type : value}, () => {
            if (this.state.event_show_type == "70002") {
                this.setState({
                    iframe_page_name_list: this.state.popup_iframe_page_name_list,
                }, () => {
                    if (this.state.popup_iframe_page_name_list.indexOf(this.state.iframe_page_id) < 0) {
                        this.setState({
                            iframe_page_id: this.state.popup_iframe_page_name_list[0]["code_name"],
                            iframe_page_name: this.state.popup_iframe_page_name_list[0]["val1"],
                        }) 
                    }
                });
            } else {
                this.setState({
                    iframe_page_name_list: this.state.banner_iframe_page_name_list,
                });
            }
        });
    }

    // 배너 페이징
    handleBannerPageChange(pageNumber) {
        const { pc_banner_type_paging, w_selected_tags } = this.state;
        pc_banner_type_paging["activePage"] = pageNumber;
        pc_banner_type_paging["startIdx"] = ((pageNumber * Number(pc_banner_type_paging["rowcnt"])) - pc_banner_type_paging["rowcnt"]);
        // isTmp = false;
        // startIdxChange = true;
        this.setState({pc_banner_type_paging : pc_banner_type_paging});
        // this.state.startIdx = (pageNumber * 10) - this.state.rowcnt;
        // this.loadCafe24Item(); // 상품 조회 componentDidUpdate 에서 실행
        //this.getCafe24CodePaging("03000");

        const selected_tag_list = [];
        for(const category in w_selected_tags){
            if(w_selected_tags.hasOwnProperty(category)){
                w_selected_tags[category].map((obj => {
                    selected_tag_list.push(obj)
                }));
            }
        }
        this.getBannerDesignTemplateUserFavoritePaging("03000", selected_tag_list).then(r => {});
    }   
    handleMobileBannerPageChange(pageNumber) {
        const { mobile_banner_type_paging, h_selected_tags } = this.state;
        mobile_banner_type_paging["activePage"] = pageNumber;
        mobile_banner_type_paging["startIdx"] = ((pageNumber * Number(mobile_banner_type_paging["rowcnt"])) - mobile_banner_type_paging["rowcnt"]);
        // isTmp = false;
        // startIdxChange = true;
        this.setState({mobile_banner_type_paging : mobile_banner_type_paging});
        // this.state.startIdx = (pageNumber * 10) - this.state.rowcnt;
        // this.loadCafe24Item(); // 상품 조회 componentDidUpdate 에서 실행
        //this.getCafe24CodePaging("07000");

        const selected_tag_list = [];
        for(const category in h_selected_tags){
            if(h_selected_tags.hasOwnProperty(category)){
                h_selected_tags[category].map((obj => {
                    selected_tag_list.push(obj)
                }));
            }
        }
        this.getBannerDesignTemplateUserFavoritePaging("07000", selected_tag_list).then(r => {});
    }   

    // 배너 라디오 버튼 클릭
    onClickBannerTypeRadioButton = (name, type, switchType, txt, img, banner_name, tag_name_list) => {
        // var name2 = name.replace("_cd", "") + "_name"
        // var name3 = name.replace("_cd", "") + "_img"
        // isTmp = true;
        if (name.indexOf("mobile") > 0) {
            const {checked_mobile_banner_list} = this.state;
            if (checked_mobile_banner_list != null) {
                if (switchType == "on") {
                    checked_mobile_banner_list.push({ 
                                                    id : Number(type),
                                                    title : txt,
                                                    icon : img,
                                                    bannerType : type,
                                                    banner_name : banner_name,
                                                    tag_name_list : tag_name_list
                                                })

                    var list = [];
                    for (var i in checked_mobile_banner_list) {
                        list.push(checked_mobile_banner_list[i]["bannerType"]);
                    }
                    this.setState({event_mobile_type_arr : list});                            

                    this.setState({
                        checked_mobile_banner_list : checked_mobile_banner_list,
                    });
                } else {
                    const idx = checked_mobile_banner_list.findIndex(function(item) {return item.bannerType === type})
                    if (idx > -1) {
                        checked_mobile_banner_list.splice(idx, 1)
                        
                        var list = [];
                        for (var i in checked_mobile_banner_list) {
                            list.push(checked_mobile_banner_list[i]["bannerType"]);
                        }
                        this.setState({event_mobile_type_arr : list});     

                        this.setState({
                            checked_mobile_banner_list : checked_mobile_banner_list,
                        });
                    }
                }
            }
        } else {
            const {checked_pc_banner_list} = this.state;
            if (checked_pc_banner_list != null) {
                if (switchType == "on") {
                    checked_pc_banner_list.push({ 
                                                    id : Number(type),
                                                    title : txt,
                                                    icon : img,
                                                    bannerType: type,
                                                    banner_name : banner_name,
                                                    tag_name_list : tag_name_list
                                                })

                    var list = [];
                    for (var i in checked_pc_banner_list) {
                        list.push(checked_pc_banner_list[i]["bannerType"]);
                    }
                    this.setState({event_type_arr : list});

                    this.setState({
                        checked_pc_banner_list : checked_pc_banner_list,
                    });
                } else {
                    const idx = checked_pc_banner_list.findIndex(function(item) {return item.bannerType === type})
                    if (idx > -1) {
                        checked_pc_banner_list.splice(idx, 1)
                        
                        var list = [];
                        for (var i in checked_pc_banner_list) {
                            list.push(checked_pc_banner_list[i]["bannerType"]);
                        }
                        this.setState({event_type_arr : list});

                        this.setState({
                            checked_pc_banner_list : checked_pc_banner_list,
                        });
                    }
                }
            }
        }
            

        // this.setState({
        //     // [name] : type,
        //     // [name2] : txt,
        //     // [name3] : img,
        //     checked_pc_banner_list : checked_pc_banner_list,
        // });

        // if (name.indexOf("mobile") > 0) {
        //     is_mobile_bnner_change = true;
        // } else { 
        //     is_banner_change = true;
        // }
    }

    itemRenderer(item, index) {
        return (
        <div>
            <b className={"num_banner_choose"}>{index+1}</b>
            <div className="flexBox" style={{marginTop:"10px"}}>
                <div style={{width:"100%", padding: 0}}>
                    <div className="checkbox_flexBox event_setting_banner_type" style={{marginTop:0, float: "left"}}>
                        <CheckBox
                            id={"selected_event_type_cd"+item.bannerType}
                            className={"checkbox_banner_template"}
                            checked={true}
                            onChangeCheck={() => this.onClickBannerTypeRadioButton("event_type_cd", item.bannerType, "off")}
                        />
                    </div>
                    <div className={"title_banner_template"} style={{fontWeight: "400", marginLeft: "35px", lineHeight: "13px"}}>{item.banner_name}</div>
                    <img src={item.icon} style={{width:"100%", height:"auto", alignSelf: "flex-start", pointerEvents: "none", border: "4px solid #00E2E6", borderRadius: "13px", margin: "5px 0 8px"}}/>
                    <div className={"btn_banner_template_tag"}>
                        {(item.tag_name_list || "").toString() != "" && (item.tag_name_list || "").toString().split(",").map((tag_name) => (
                            <button key={tag_name}>{tag_name.trim()}</button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
        );
      }
    
      handleRLDDChange(reorderedItems) {
        this.setState({ checked_pc_banner_list: reorderedItems });

        var list = [];
        for (var idx in reorderedItems) {
            list.push(reorderedItems[idx]["bannerType"]);
        }
        this.setState({event_type_arr : list});
      }

    itemRendererMobile(item, index) {
        return (
        <div>
            <b className={"num_banner_choose"}>{index+1}</b>
            <div className="flexBox" style={{marginTop:"10px"}}>
                <div style={{width:"100%", padding: 0}}>
                    <div className="checkbox_flexBox event_setting_banner_type" style={{marginTop:0, float: "left"}}>
                        <CheckBox
                            id={"selected_event_mobile_type_cd"+item.bannerType}
                            className={"checkbox_banner_template"}
                            checked={true}
                            onChangeCheck={() => this.onClickBannerTypeRadioButton("event_mobile_type_cd", item.bannerType, "off")}
                        />
                    </div>
                    <div className={"title_banner_template"} style={{fontWeight: "400", marginLeft: "35px", lineHeight: "13px"}}>{item.banner_name}</div>
                    <img src={item.icon} style={{width:"100%", height:"auto", alignSelf: "flex-start", pointerEvents: "none", border: "4px solid #00E2E6", borderRadius: "13px", margin: "5px 0 8px"}}></img>
                    <div className={"btn_banner_template_tag"}>
                        {(item.tag_name_list || "").toString() != "" && (item.tag_name_list || "").toString().split(",").map((tag_name) => (
                            <button key={tag_name}>{tag_name.trim()}</button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
        );
      }
    
      handleRLDDChangeMobile(reorderedItems) {
        this.setState({ checked_mobile_banner_list: reorderedItems });

        var list = [];
        for (var idx in reorderedItems) {
            list.push(reorderedItems[idx]["bannerType"]);
        }
        this.setState({event_mobile_type_arr : list});
      }

      stroeOrSettingCnt() {
        http.get("/rest/shop/stroeOrSettingCnt?iframe_page_id="+this.state.querystring.iframe_page_id+"&iframe_html_id="+this.state.querystring.iframe_html_id)
        .then(res => {
            if (res.data.freeDatePeriod != null) {
                if(res.data.freeDatePeriod.is_finish == "1") {
                    if (res.data.stroeOrSettingCnt.banner_operateed_yn == 'Y') {
                        is_order = true;
                    }
                    is_free_finish = true;
                } else {
                    if (res.data.stroeOrSettingCnt.banner_operateed_yn == 'Y') {
                        is_free_finish = true;
                        is_order = true;
                    } else {
                        is_free_finish = false;
                    }
                }

                if (is_order == false) {
                    this.setState({display_yn : "N"});
                }

                // 설치 여부 확인
                if (res.data.bannerInstallInfo != null) {
                    if (res.data.bannerInstallInfo.install_yn == "Y") {
                        is_install = true;
                    }
                }
            }
        })
        .catch(error => {
            alert(error); 
        });
    }


      onClickStepButton = (e, step) => {
        if(this.state.solution_type_cd == '09900' && step == 3) {
            if (this.state.iframe_html_name == null ||  this.state.iframe_html_name == "") {
                alert("영역을 입력해 주세요.");
                is_step_1_complete = false;
                return false;
            } 
            // 단일 사이즈인데 사이즈를 입력하지 않았다면
            else if(this.state.single_size && !(this.state.event_banner_pc_width && this.state.event_banner_pc_height && Number(this.state.event_banner_pc_width)>0 && Number(this.state.event_banner_pc_height)>0)){
                alert("사이즈를 입력해 주세요.");
                is_step_1_complete = false;
                return false;
            }
            // 사이즈1, 사이즈2 중에 모두 입력된 값이 없다면
            else if(!((this.state.event_banner_pc_width && this.state.event_banner_pc_height && Number(this.state.event_banner_pc_width)>0 && Number(this.state.event_banner_pc_height)>0) || (this.state.event_banner_mobile_width && this.state.event_banner_mobile_height && Number(this.state.event_banner_mobile_width)>0 && Number(this.state.event_banner_mobile_height)>0))){
                alert("사이즈를 입력해 주세요.");
                is_step_1_complete = false;
                return false;
            }

            is_step_1_complete = true;

        }else {

            /* 필수 값 입력 하지 않았으면 다음 스텝으로 이동 하지 못하도록 막음  */
            if (step >= 1) {
                /* 0페이지 */
                if (this.state.solution_type_cd != '09900') {
                    if (this.state.domain_list == null || (this.state.domain_list != null && this.state.domain_list.length == 0)) {
                        // alert("도메인을 추가해 주세요.");
                        // is_step_1_complete = false;
                        // return false;
                    } else if (this.state.iframe_page_id == null || this.state.iframe_page_id == "") {
                        alert("적용 페이지를 선택해 주세요.");
                        is_step_1_complete = false;
                        return false;
                    } else if (this.state.iframe_page_id == "robomd_category_page") {
                        if (this.state.category_page_step == "-1") {
                            alert("적용 카테고리 페이지를 선택해 주세요.");
                            is_step_1_complete = false;
                            return false;
                        } else if (this.state["category_page_" + this.state.category_page_step] == "-1") {
                            alert("적용 카테고리 페이지가 중복 되었습니다.\n적용 카테고리 페이지를 변경해 주세요.");
                            is_step_1_complete = false;
                            return false;
                        }
                    }
                }

                if (this.state.event_show_type == "70002") {
                    if (this.state.popup_block_cycle == "72007") {
                        if (!this.state.popup_block_cycle_day) {
                            alert("팝업 차단 주기를 입력해 주세요.");
                            is_step_1_complete = false;
                            return false;
                        }
                        if (!this.state.popup_block_cycle_title) {
                            alert("팝업 차단 주기를 입력해 주세요.");
                            is_step_1_complete = false;
                            return false;
                        }
                    }

                    if(this.state.popup_close_btn_title_cd == "74008") {
                        if (!this.state.popup_close_btn_title) {
                            alert("팝업 닫기 문구를 입력해 주세요.");
                            is_step_1_complete = false;
                            return false;
                        }
                    }
                }

                if (this.state.iframe_html_name == null || this.state.iframe_html_name == "") {
                    alert("배너 영역을 입력해 주세요.");
                    is_step_1_complete = false;
                    return false;
                }
                // 단일 사이즈인데 사이즈를 입력하지 않았다면
                else if(this.state.single_size && !(this.state.event_banner_pc_width && this.state.event_banner_pc_height && Number(this.state.event_banner_pc_width)>0 && Number(this.state.event_banner_pc_height)>0)){
                    alert("배너 사이즈를 입력해 주세요.");
                    is_step_1_complete = false;
                    return false;
                }
                // 사이즈1, 사이즈2 중에 모두 입력된 값이 없다면
                else if(!((this.state.event_banner_pc_width && this.state.event_banner_pc_height && Number(this.state.event_banner_pc_width)>0 && Number(this.state.event_banner_pc_height)>0) || (this.state.event_banner_mobile_width && this.state.event_banner_mobile_height && Number(this.state.event_banner_mobile_width)>0 && Number(this.state.event_banner_mobile_height)>0))){
                    alert("배너 사이즈를 입력해 주세요.");
                    is_step_1_complete = false;
                    return false;
                }
                is_step_1_complete = true;

            } else if (this.state.solution_type_cd != '09900' && step >= 2) {
                /* 1페이지 */
                if (this.state.start_date == null || this.state.start_date == "") {
                    alert("시작 일자를 입력해 주세요.");
                    is_step_2_complete = false;
                    return false;
                } else if (this.state.event_cycle == null || this.state.event_cycle == "") {
                    alert("자동 생성주기를 선택해 주세요.");
                    is_step_2_complete = false;
                    return false;
                } else if (this.state.event_time == null || this.state.event_time == "") {
                    alert("자동 생성시간을 선택해 주세요.");
                    is_step_2_complete = false;
                    return false;
                } else if (this.state.event_period == null || this.state.event_period == "") {
                    alert("진열 기간을 선택해 주세요.");
                    is_step_2_complete = false;
                    return false;
                }
                is_step_2_complete = true;

            } else if (this.state.solution_type_cd != '09900' && step >= 3) {
                /* 2페이지 */
                if (this.state.event_item_user_type == "15001" && !this.state.all_user_item.isAnyPrice && (this.state.all_user_item.event_item_min_price == null || this.state.all_user_item.event_item_min_price === "")) {
                    alert("상품 최소 가격을 선택해 주세요.");
                    is_step_3_complete = false;
                    return false;
                } else if (this.state.event_item_user_type == "15001" && !this.state.all_user_item.isAnyPrice && (this.state.all_user_item.event_item_max_price == null || this.state.all_user_item.event_item_max_price === "")) {
                    alert("상품 최대 가격을 선택해 주세요.");
                    is_step_3_complete = false;
                    return false;
                } else if (this.state.event_item_user_type == "15001" && !this.state.all_user_item.isAnyHit && (this.state.all_user_item.event_item_min_hit == null || this.state.all_user_item.event_item_min_hit === "")) {
                    alert("상품 최소 조회수를 선택해 주세요.");
                    is_step_3_complete = false;
                    return false;
                } else if (this.state.event_item_user_type == "15001" && !this.state.all_user_item.isAnyHit && (this.state.all_user_item.event_item_max_hit == null || this.state.all_user_item.event_item_max_hit === "")) {
                    alert("상품 최대 조회수를 선택해 주세요.");
                    is_step_3_complete = false;
                    return false;
                } else if (this.state.event_item_user_type == "15001" && !this.state.all_user_item.isAnyOrder && (this.state.all_user_item.event_item_min_order == null || this.state.all_user_item.event_item_min_order === "")) {
                    alert("상품 최소 구매수를 선택해 주세요.");
                    is_step_3_complete = false;
                    return false;
                } else if (this.state.event_item_user_type == "15001" && !this.state.all_user_item.isAnyOrder && (this.state.all_user_item.event_item_max_order == null || this.state.all_user_item.event_item_max_order === "")) {
                    alert("상품 최대 구매수를 선택해 주세요.");
                    is_step_3_complete = false;
                    return false;
                } else if (this.state.event_item_user_type == "15001" && (this.state.all_user_item.event_item_created_period == null || this.state.all_user_item.event_item_created_period === "")) {
                    alert("상품 등록날짜를 선택해 주세요.");
                    is_step_3_complete = false;
                    return false;
                } else if (this.state.event_item_user_type == "15001" && (this.state.all_user_item.event_item_analysis_period == null || this.state.all_user_item.event_item_analysis_period == "")) {
                    alert("상품분석 기간을 선택해 주세요.");
                    is_step_3_complete = false;
                    return false;
                } else if (this.state.event_item_user_type == "15001" && (this.state.all_user_item.product_duplicate_check_type == null || this.state.all_user_item.product_duplicate_check_type == "")) {
                    alert("상품 중복체크 유형을 선택해 주세요.");
                    is_step_3_complete = false;
                    return false;
                } else if (this.state.event_item_user_type == "15002" && !this.state.member_user_item.isAnyPrice && (this.state.member_user_item.event_item_min_price == null || this.state.member_user_item.event_item_min_price === "")) {
                    alert("회원 상품 최소 가격을 선택해 주세요.");
                    is_step_3_complete = false;
                    return false;
                } else if (this.state.event_item_user_type == "15002" && !this.state.member_user_item.isAnyPrice && (this.state.member_user_item.event_item_max_price == null || this.state.member_user_item.event_item_max_price === "")) {
                    alert("회원 상품 최대 가격을 선택해 주세요.");
                    is_step_3_complete = false;
                    return false;
                } else if (this.state.event_item_user_type == "15002" && !this.state.member_user_item.isAnyHit && (this.state.member_user_item.event_item_min_hit == null || this.state.member_user_item.event_item_min_hit === "")) {
                    alert("회원 상품 최소 조회수를 선택해 주세요.");
                    is_step_3_complete = false;
                    return false;
                } else if (this.state.event_item_user_type == "15002" && !this.state.member_user_item.isAnyHit && (this.state.member_user_item.event_item_max_hit == null || this.state.member_user_item.event_item_max_hit === "")) {
                    alert("회원 상품 최대 조회수를 선택해 주세요.");
                    is_step_3_complete = false;
                    return false;
                } else if (this.state.event_item_user_type == "15002" && !this.state.member_user_item.isAnyOrder && (this.state.member_user_item.event_item_min_order == null || this.state.member_user_item.event_item_min_order === "")) {
                    alert("회원 상품 최소 구매수를 선택해 주세요.");
                    is_step_3_complete = false;
                    return false;
                } else if (this.state.event_item_user_type == "15002" && !this.state.member_user_item.isAnyOrder && (this.state.member_user_item.event_item_max_order == null || this.state.member_user_item.event_item_max_order === "")) {
                    alert("회원 상품 최대 구매수를 선택해 주세요.");
                    is_step_3_complete = false;
                    return false;
                } else if (this.state.event_item_user_type == "15002" && (this.state.member_user_item.event_item_created_period == null || this.state.member_user_item.event_item_created_period === "")) {
                    alert("회원 상품 등록날짜를 선택해 주세요.");
                    is_step_3_complete = false;
                    return false;
                } else if (this.state.event_item_user_type == "15002" && (this.state.member_user_item.event_item_analysis_period == null || this.state.member_user_item.event_item_analysis_period == "")) {
                    alert("회원 상품분석 기간을 선택해 주세요.");
                    is_step_3_complete = false;
                    return false;
                } else if (this.state.event_item_user_type == "15002" && (this.state.member_user_item.product_duplicate_check_type == null || this.state.member_user_item.product_duplicate_check_type == "")) {
                    alert("회원 상품 중복체크 유형을 선택해 주세요.");
                    is_step_3_complete = false;
                    return false;
                } else if (this.state.event_item_user_type == "15002" && !this.state.none_user_item.isAnyPrice && (this.state.none_user_item.event_item_min_price == null || this.state.none_user_item.event_item_min_price === "")) {
                    alert("비회원 상품 최소 가격을 선택해 주세요.");
                    is_step_3_complete = false;
                    return false;
                } else if (this.state.event_item_user_type == "15002" && !this.state.none_user_item.isAnyPrice && (this.state.none_user_item.event_item_max_price == null || this.state.none_user_item.event_item_max_price === "")) {
                    alert("비회원 상품 최대 가격을 선택해 주세요.");
                    is_step_3_complete = false;
                    return false;
                } else if (this.state.event_item_user_type == "15002" && !this.state.none_user_item.isAnyHit && (this.state.none_user_item.event_item_min_hit == null || this.state.none_user_item.event_item_min_hit === "")) {
                    alert("비회원 상품 최소 조회수를 선택해 주세요.");
                    is_step_3_complete = false;
                    return false;
                } else if (this.state.event_item_user_type == "15002" && !this.state.none_user_item.isAnyHit && (this.state.none_user_item.event_item_max_hit == null || this.state.none_user_item.event_item_max_hit === "")) {
                    alert("비회원 상품 최대 조회수를 선택해 주세요.");
                    is_step_3_complete = false;
                    return false;
                } else if (this.state.event_item_user_type == "15002" && !this.state.none_user_item.isAnyOrder && (this.state.none_user_item.event_item_min_order == null || this.state.none_user_item.event_item_min_order === "")) {
                    alert("비회원 상품 최소 구매수를 선택해 주세요.");
                    is_step_3_complete = false;
                    return false;
                } else if (this.state.event_item_user_type == "15002" && !this.state.none_user_item.isAnyOrder && (this.state.none_user_item.event_item_max_order == null || this.state.none_user_item.event_item_max_order === "")) {
                    alert("비회원 상품 최대 구매수를 선택해 주세요.");
                    is_step_3_complete = false;
                    return false;
                } else if (this.state.event_item_user_type == "15002" && (this.state.none_user_item.event_item_created_period == null || this.state.none_user_item.event_item_created_period === "")) {
                    alert("비회원 상품 등록날짜를 선택해 주세요.");
                    is_step_3_complete = false;
                    return false;
                } else if (this.state.event_item_user_type == "15002" && (this.state.none_user_item.event_item_analysis_period == null || this.state.none_user_item.event_item_analysis_period == "")) {
                    alert("비회원 상품분석 기간을 선택해 주세요.");
                    is_step_3_complete = false;
                    return false;
                } else if (this.state.event_item_user_type == "15002" && (this.state.none_user_item.product_duplicate_check_type == null || this.state.none_user_item.product_duplicate_check_type == "")) {
                    alert("비회원 상품 중복체크 유형을 선택해 주세요.");
                    is_step_3_complete = false;
                    return false;
                }
                is_step_3_complete = true;
            }
        }

        this.setState({step : step});
        is_step_change=true;

      }

      handleChangeStartDate = date => {
        console.log("###### date", date);
        if (date != null) {
            this.setState({
                start_date: date
            });
        } 
    };

    onClickNextStep = e => {
        if(this.state.solution_type_cd == '09900') {
            this.onClickStepButton(e, Number(this.state.step)+3)
        }else{
            this.onClickStepButton(e, Number(this.state.step)+1)
        }
    }

    loadProductCategory(parentCategory, depth) {

        const sendForm = {
            user_seq: this.state.user_seq , 
            shop_no: "1", 
            parent_category_no: parentCategory
        }

        var name = "product_category_list_"+depth;
        http.get("/rest/common/cafe24/category", {params:sendForm})
        .then(res => {
            this.setState({[name]: res.data.list});
        })
        .catch(error => {
            console.log ("===== error =====");
            console.log (error);
            console.log ("===== error request =====");
            console.log(error.request);
         });
    }
    
    loadPageCategory(parentCategory, depth, first_category_load, isChangeCategory) {
        const sendForm = {
            user_seq: this.state.user_seq , 
            shop_no: "1", 
            parent_category_no: parentCategory,
            iframe_page_id: this.state.querystring.iframe_page_id,
            iframe_html_id: this.state.querystring.iframe_html_id,
            category_depth: Number(depth),
        }
        
        var name = "page_category_list_"+depth;
        var name2 = "category_page_"+depth;
        http.get("/rest/shop/event/page/category", {params:sendForm})
        .then(res => {
            category_page_depth = depth;
            var ctg_idx = 0;
            for (var idx in res.data.list) {
                if(res.data.list[idx].is_duplicate_category == "N") {
                    ctg_idx = idx;
                    break;
                }
            }

            var ctg_child_idx = 0;
            for (var idx in res.data.list) {
                if(res.data.list[idx].is_child_duplicate_category == "Y") {
                    ctg_child_idx = idx;
                    break;
                }
            }

            var ctg_child_idx2 = 0;
            for (var idx in res.data.list) {
                if(res.data.list[idx].is_child_duplicate_category == "N") {
                    ctg_child_idx2 = idx;
                    break;
                }
            }
            var categoryPageList = this.state.categoryPageList;
            var category_page = 
                                isChangeCategory // 카테고리 변경 할 때
                                    && res.data.list.length > 0
                                ?   categoryPageList != null && categoryPageList.length > (depth - 2) 
                                    ?   
                                        categoryPageList[Number(depth)-2] == parentCategory // 변경한 카테고리가 설정된 리스트의 상단 카테고리와 동일 한 경우
                                        ?   categoryPageList[Number(depth-1)]
                                        :   res.data.list[ctg_child_idx].is_child_duplicate_category == "Y" // 하위 카테고리에 중복인 카테고리가 있는 경우
                                                ? res.data.list[ctg_child_idx2].is_child_duplicate_category == "N" // 하위 카테고리에 중복이 아닌 카테고리가 있는 경우
                                                    ? res.data.list[ctg_idx].category_no 
                                                    : "-1" // 전체 중복인 경우
                                                : ""
                                    :   res.data.list[ctg_child_idx].is_child_duplicate_category == "Y" // 하위 카테고리에 중복인 카테고리가 있는 경우
                                        ? res.data.list[ctg_child_idx2].is_child_duplicate_category == "N" // 하위 카테고리에 중복이 아닌 카테고리가 있는 경우
                                            ? res.data.list[ctg_idx].category_no 
                                            : "-1" // 전체 중복인 경우
                                        : ""
                                :   depth == 1 
                                    ?   categoryPageList != null && categoryPageList.length > 0 ? categoryPageList[0] : "" // 설정된 카테고리 리스트가 있는 경우에 설정된 카테고리를 선택
                                    :   res.data.list != null && res.data.list[ctg_child_idx] != null && res.data.list[ctg_child_idx2] != null && res.data.list[ctg_idx] != null
                                        ?   res.data.list[ctg_child_idx].is_child_duplicate_category == "Y" // 하위 카테고리에 중복인 카테고리가 있는 경우
                                            ? res.data.list[ctg_child_idx2].is_child_duplicate_category == "N" // 하위 카테고리에 중복이 아닌 카테고리가 있는 경우
                                                ? res.data.list[ctg_idx].category_no 
                                                : "-1" // 전체 중복인 경우
                                            : categoryPageList != null && categoryPageList.length > Number(depth-1) ? categoryPageList[Number(depth-1)] : "" // 설정된 카테고리 리스트가 있는 경우에 설정된 카테고리를 선택     
                                        : categoryPageList != null && categoryPageList.length > Number(depth-1) ? categoryPageList[Number(depth-1)] : "" // 설정된 카테고리 리스트가 있는 경우에 설정된 카테고리를 선택  
            if (category_page == null) {
                category_page = ""; // 위 조건에 만족하지 않아서 null이 된 경우 빈 문자열로 초기화
            }
            // alert("category_page: "+category_page)
            this.setState({
                [name]: res.data.list,
                [name2]: category_page,
            }, () => {
                var name3 = "is_child_duplicate_category_"+Number(depth);
                this.setState({
                    [name3]:    ctg_child_idx != -1 
                                ?   this.state["page_category_list_"+Number(depth)][ctg_child_idx] != null
                                    ? this.state["page_category_list_"+Number(depth)][ctg_child_idx].is_child_duplicate_category 
                                    : null
                                : null
                })
                if (category_page_depth > depth) {
                    return false;
                } else {
                    if (parentCategory != null && parentCategory != "") {
                        if (res.data.list.length != 0) {
                            if (this.state[name2] == -1) {
                                this.setState({
                                    category_page_step: depth,
                                }, () => {
                                    $(".category_page_"+Number(depth)).val(null);
                                });
                            } else {
                                this.setState({
                                    category_page_step: Number(depth-1),
                                });
                            }
                        } else {
                            this.setState({
                                category_page_step: Number(depth-1),
                            });
                        }
                    } else {
                        this.setState({
                            category_page_step: depth == 1 && category_page  != null && category_page != "" ? 1 : Number(depth-2),
                        });
                    }
                    // alert(name2)
                    if (this.state[name2] != "" && depth < 4 && depth >= 1 && (!first_category_load || first_category_load == null)) {
                        // alert(name2 + ": " + this.state[name2]);
                        var next_depth = Number(depth)+1;
                        var parent_category_no = ""
                        if (category_page != -1) {
                            parent_category_no = category_page;
                            this.loadPageCategory(parent_category_no, next_depth, first_category_load); // 이미 선택 된 카테고리인 경우 하위 카테고리 까지 조회
                        } 
                    }
                }
            });

        })
        .catch(error => {
            console.log ("===== error =====");
            console.log (error);
            console.log ("===== error request =====");
            console.log(error.request);
         });
    }

    onChangeCategoryForPage = (e, depth) => {
        var ctg_idx = -1;
        for(var idx in this.state["page_category_list_"+Number(depth-1)]) {
            if (this.state["page_category_list_"+Number(depth-1)][idx].category_no == e.target.value) {
                ctg_idx = idx
                // alert(this.state["page_category_list_"+Number(depth-1)][idx].category_name)
                break;
            }
        }
        var cahnge_category_value = e.target.value
        if (depth > 1 && depth <= 5) {
            if (cahnge_category_value != "") {
                var name = "category_page_"+Number(depth-1);
                this.setState({
                    [name]: cahnge_category_value,
                    parent_category_idx: ctg_idx,
                    category_page_step: Number(depth-1),
                }, () => {
                    this.loadPageCategory(cahnge_category_value, depth, false, true);
                    // alert(this.state.category_page_step)
                });
            } else {
                var name = "category_page_"+Number(depth-1);
                this.setState({
                    [name]: cahnge_category_value,
                    category_page_step: Number(depth-2),
                }, () => {
                    // alert(this.state.category_page_step)
                });
            }
        }
        for(var idx = Number(depth); idx <=4; idx++) {
            var name = "page_category_list_"+idx;
            this.setState({
                [name]: [], // 카테고리 목록 초기화
            });
            var name2 = "category_page_"+idx;
            $("#"+name2).val("");
        }
    }

    onChangeCategoryForAllUser = (e, depth) => {
        if (depth > 1 && depth <= 5) {
            this.loadProductCategory(e.target.value, depth);
            var name = "select_catefory_for_all_user_"+Number(depth-1);
            this.setState({[name]: e.target.value});
        }

        for(var idx = depth; idx <=4; idx++) {
            var name = "product_category_list_"+idx;
            this.setState({[name]: []});
            var name2 = "category_for_all_user_"+idx;
            $("#"+name2).val("");
            var name3 = "category_for_all_user_"+idx;
            $("#"+name3).val("");
        }
    }

    onClickAddCategoryForAllUser = e => {
        var obj = {}

        var category_for_all_user_1
        var category_for_all_user_2
        var category_for_all_user_3
        var category_for_all_user_4
        var category_no = null;
        if ($("#category_for_all_user_1 option:checked").text() != null && $("#category_for_all_user_1 option:checked").text() != "") {
            if($("#category_for_all_user_1 option:checked").val() != null && $("#category_for_all_user_1 option:checked").val() != "") {
                category_for_all_user_1 = $("#category_for_all_user_1 option:checked").text()
                category_no = $("#category_for_all_user_1 option:checked").val();
            }
        }
        if ($("#category_for_all_user_2 option:checked").text() != null && $("#category_for_all_user_2 option:checked").text() != "") {
            if($("#category_for_all_user_2 option:checked").val() != null && $("#category_for_all_user_2 option:checked").val() != "") {
                category_for_all_user_2 = $("#category_for_all_user_2 option:checked").text()
                category_no = $("#category_for_all_user_2 option:checked").val();
            }
        }
        if ($("#category_for_all_user_3 option:checked").text() != null && $("#category_for_all_user_3 option:checked").text() != "") {
            if($("#category_for_all_user_3 option:checked").val() != null && $("#category_for_all_user_3 option:checked").val() != "") {
                category_for_all_user_3 = $("#category_for_all_user_3 option:checked").text()
                category_no = $("#category_for_all_user_3 option:checked").val();
            }
        }
        if ($("#category_for_all_user_4 option:checked").text() != null && $("#category_for_all_user_4 option:checked").text() != "") {
            if($("#category_for_all_user_4 option:checked").val() != null && $("#category_for_all_user_4 option:checked").val() != "") {
                category_for_all_user_4 = $("#category_for_all_user_4 option:checked").text()
                category_no = $("#category_for_all_user_4 option:checked").val();
            }
        }

        if(category_no == null || category_no == "") {
            alert("카테고리를 선택해 주세요.");
            return false;
        }

        obj = {
            category_for_all_user_1 : category_for_all_user_1,
            category_for_all_user_2 : category_for_all_user_2,
            category_for_all_user_3 : category_for_all_user_3,
            category_for_all_user_4 : category_for_all_user_4,
            category_no : category_no
        }

        // obj 에서 null 제거
        for (var propName in obj) {
            if (obj[propName] === null || obj[propName] === undefined) {
              delete obj[propName];
            }
          }


        const {select_category_name_list_for_all_user} = this.state;
        const {select_category_no_list_for_all_user} = this.state;

        if(select_category_no_list_for_all_user.indexOf(category_no) >= 0) {
            alert("이미 추가된 카테고리 입니다.");
            return false;
        }

        select_category_name_list_for_all_user.push(obj);  
        select_category_no_list_for_all_user.push(category_no);

        is_category_add_all = true;
        this.setState({select_category_no_list_for_all_user : select_category_no_list_for_all_user, 
            select_category_name_list_for_all_user : select_category_name_list_for_all_user});
    }

    onClickRemoveCategoryForAllUser = (e, category_no) => {
        const {select_category_name_list_for_all_user} = this.state;
        const {select_category_no_list_for_all_user: select_category_no_list_for_all_user} = this.state;


        // 인덱스 찾기
        for (var i = select_category_name_list_for_all_user.length - 1; i >= 0; --i) {
            if (select_category_name_list_for_all_user[i].category_no == category_no) {
                select_category_name_list_for_all_user.splice(i,1);
            }
        }
        for (var i = select_category_no_list_for_all_user.length - 1; i >= 0; --i) {
            if (select_category_no_list_for_all_user[i] == category_no) {
                select_category_no_list_for_all_user.splice(i,1);
            }
        }

        is_category_remove_all = true;
        this.setState({select_category_no_list_for_all_user : select_category_no_list_for_all_user, 
            select_category_name_list_for_all_user : select_category_name_list_for_all_user});
    }

    onChangeCategoryForOnlyUser = (e, depth) => {
        if (depth > 1 && depth <= 5) {
            this.loadProductCategory(e.target.value, depth);
            var name = "select_catefory_for_only_user_"+Number(depth-1);
            this.setState({[name]: e.target.value});
        }

        for(var idx = depth; idx <= 4; idx++) {
            var name = "product_category_list_"+idx;
            this.setState({[name]: []});
            var name2 = "category_for_only_user_"+idx;
            $("#"+name2).val("");
            var name3 = "category_for_only_user_"+idx;
            $("#"+name3).val("");
        }
    }

    onClickAddCategoryForOnlyUser = e => {
        var obj = {}

        var category_for_only_user_1
        var category_for_only_user_2
        var category_for_only_user_3
        var category_for_only_user_4
        var category_no = null;
        if ($("#category_for_only_user_1 option:checked").text() != null && $("#category_for_only_user_1 option:checked").text() != "") {
            if($("#category_for_only_user_1 option:checked").val() != null && $("#category_for_only_user_1 option:checked").val() != "") {
                category_for_only_user_1 = $("#category_for_only_user_1 option:checked").text()
                category_no = $("#category_for_only_user_1 option:checked").val();
            }
        }
        if ($("category_for_only_user_2 option:checked").text() != null && $("#category_for_only_user_2 option:checked").text() != "") {
            if($("#category_for_only_user_2 option:checked").val() != null && $("#category_for_only_user_2 option:checked").val() != "") {
                category_for_only_user_2 = $("#category_for_only_user_2 option:checked").text()
                category_no = $("#category_for_only_user_2 option:checked").val();
            }
        }
        if ($("#category_for_only_user_3 option:checked").text() != null && $("#category_for_only_user_3 option:checked").text() != "") {
            if($("#category_for_only_user_3 option:checked").val() != null && $("#category_for_only_user_3 option:checked").val() != "") {
                category_for_only_user_3 = $("#category_for_only_user_3 option:checked").text()
                category_no = $("#category_for_only_user_3 option:checked").val();
            }
        }
        if ($("#category_for_only_user_4 option:checked").text() != null && $("#category_for_only_user_4 option:checked").text() != "") {
            if($("#category_for_only_user_4 option:checked").val() != null && $("#category_for_only_user_4 option:checked").val() != "") {
                category_for_only_user_4 = $("#category_for_only_user_4 option:checked").text()
                category_no = $("#category_for_only_user_4 option:checked").val();
            }
        }

        if(category_no == null || category_no == "") {
            alert("카테고리를 선택해 주세요.");
            return false;
        }

        obj = {
            category_for_only_user_1 : category_for_only_user_1,
            category_for_only_user_2 : category_for_only_user_2,
            category_for_only_user_3 : category_for_only_user_3,
            category_for_only_user_4 : category_for_only_user_4,
            category_no : category_no
        }

        // obj 에서 null 제거
        for (var propName in obj) {
            if (obj[propName] === null || obj[propName] === undefined) {
              delete obj[propName];
            }
        }

        const {select_category_name_list_for_only_user} = this.state;
        const {select_category_no_list_for_only_user: select_category_no_list_for_only_user} = this.state;

        if(select_category_no_list_for_only_user.indexOf(category_no) >= 0) {
            alert("이미 추가된 카테고리 입니다.");
            return false;
        }

        select_category_name_list_for_only_user.push(obj);  
        select_category_no_list_for_only_user.push(category_no);

        is_category_add_member = true;
        this.setState({select_category_name_list_for_only_user : select_category_name_list_for_only_user, 
            select_category_no_list_for_only_user : select_category_no_list_for_only_user});
    }

    onClickRemoveCategoryForOnlyUser = (e, category_no) => {
        const {select_category_name_list_for_only_user} = this.state;
        const {select_category_no_list_for_only_user} = this.state;


        // 인덱스 찾기
        for (var i = select_category_name_list_for_only_user.length - 1; i >= 0; --i) {
            if (select_category_name_list_for_only_user[i].category_no == category_no) {
                select_category_name_list_for_only_user.splice(i,1);
            }
        }
        for (var i = select_category_no_list_for_only_user.length - 1; i >= 0; --i) {
            if (select_category_no_list_for_only_user[i] == category_no) {
                select_category_no_list_for_only_user.splice(i,1);
            }
        }

        is_category_remove_member = true;
        this.setState({select_category_name_list_for_only_user : select_category_name_list_for_only_user, 
            select_category_no_list_for_only_user : select_category_no_list_for_only_user});
    }

    onChangeCategoryForNonUser = (e, depth) => {
        if (depth > 1 && depth <= 5) {
            this.loadProductCategory(e.target.value, depth);
            var name = "select_catefory_for_non_user_"+Number(depth-1);
            this.setState({[name]: e.target.value});
        }

        for(var idx = depth; idx <= 4; idx++) {
            var name = "product_category_list_"+idx;
            this.setState({[name]: []});
            var name2 = "category_for_non_user_"+idx;
            $("#"+name2).val("");
            var name3 = "category_for_non_user_"+idx;
            $("#"+name3).val("");
        }
    }

    onClickAddCategoryForNonUser = e => {
        var obj = {}

        var category_for_non_user_1
        var category_for_non_user_2
        var category_for_non_user_3
        var category_for_non_user_4
        var category_no = null;
        if ($("#category_for_non_user_1 option:checked").text() != null && $("#category_for_non_user_1 option:checked").text() != "") {
            if($("#category_for_non_user_1 option:checked").val() != null && $("#category_for_non_user_1 option:checked").val() != "") {
                category_for_non_user_1 = $("#category_for_non_user_1 option:checked").text()
                category_no = $("#category_for_non_user_1 option:checked").val();
            }
        }
        if ($("category_for_non_user_2 option:checked").text() != null && $("#category_for_non_user_2 option:checked").text() != "") {
            if($("#category_for_non_user_2 option:checked").val() != null && $("#category_for_non_user_2 option:checked").val() != "") {
                category_for_non_user_2 = $("#category_for_non_user_2 option:checked").text()
                category_no = $("#category_for_non_user_2 option:checked").val();
            }
        }
        if ($("#category_for_non_user_3 option:checked").text() != null && $("#category_for_non_user_3 option:checked").text() != "") {
            if($("#category_for_non_user_3 option:checked").val() != null && $("#category_for_non_user_3 option:checked").val() != "") {
                category_for_non_user_3 = $("#category_for_non_user_3 option:checked").text()
                category_no = $("#category_for_non_user_3 option:checked").val();
            }
        }
        if ($("#category_for_non_user_4 option:checked").text() != null && $("#category_for_non_user_4 option:checked").text() != "") {
            if($("#category_for_non_user_4 option:checked").val() != null && $("#category_for_non_user_4 option:checked").val() != "") {
                category_for_non_user_4 = $("#category_for_non_user_4 option:checked").text()
                category_no = $("#category_for_non_user_4 option:checked").val();
            }
        }

        if(category_no == null || category_no == "") {
            alert("카테고리를 선택해 주세요.");
            return false;
        }

        obj = {
            category_for_non_user_1 : category_for_non_user_1,
            category_for_non_user_2 : category_for_non_user_2,
            category_for_non_user_3 : category_for_non_user_3,
            category_for_non_user_4 : category_for_non_user_4,
            category_no : category_no
        }

        // obj 에서 null 제거
        for (var propName in obj) {
            if (obj[propName] === null || obj[propName] === undefined) {
              delete obj[propName];
            }
        }

        const {select_category_name_list_for_non_user} = this.state;
        const {select_category_no_list_for_non_user} = this.state;

        if(select_category_no_list_for_non_user.indexOf(category_no) >= 0) {
            alert("이미 추가된 카테고리 입니다.");
            return false;
        }

        select_category_name_list_for_non_user.push(obj);  
        select_category_no_list_for_non_user.push(category_no);

       
       is_category_add_non = true;
        this.setState({select_category_name_list_for_non_user : select_category_name_list_for_non_user, 
            select_category_no_list_for_non_user : select_category_no_list_for_non_user});
    }

    onClickRemoveCategoryForNonUser = (e, category_no) => {
        const {select_category_name_list_for_non_user} = this.state;
        const {select_category_no_list_for_non_user: select_category_no_list_for_non_user} = this.state;


        // 인덱스 찾기
        for (var i = select_category_name_list_for_non_user.length - 1; i >= 0; --i) {
            if (select_category_name_list_for_non_user[i].category_no == category_no) {
                select_category_name_list_for_non_user.splice(i,1);
            }
        }
        for (var i = select_category_no_list_for_non_user.length - 1; i >= 0; --i) {
            if (select_category_no_list_for_non_user[i] == category_no) {
                select_category_no_list_for_non_user.splice(i,1);
            }
        }

        is_category_remove_non = true;
        this.setState({select_category_name_list_for_non_user : select_category_name_list_for_non_user, 
            select_category_no_list_for_non_user : select_category_no_list_for_non_user});
    }

    onBlurBannerSizeText = () => {
        const {event_banner_pc_width, event_banner_pc_height, event_banner_mobile_width, event_banner_mobile_height, single_size} = this.state;
        let is_size_horizontal = false;
        let is_size_vertical = false;
        if(event_banner_pc_width && event_banner_pc_height && Number(event_banner_pc_width) > 0 && Number(event_banner_pc_height) > 0){
            if(Number(event_banner_pc_width) > Number(event_banner_pc_height)){
                is_size_horizontal = true;
            } else {
                is_size_vertical = true;
            }
        }
        if(event_banner_mobile_width && event_banner_mobile_height && Number(event_banner_mobile_width) && Number(event_banner_mobile_height)){
            if(Number(event_banner_mobile_width) > Number(event_banner_mobile_height)){
                is_size_horizontal = true;
            } else {
                is_size_vertical = true;
            }
        }

        if(single_size){
            this.setState({
                event_banner_mobile_width : event_banner_pc_width,
                event_banner_mobile_height: event_banner_pc_height
            });
        }

        this.setState({
            is_size_horizontal : is_size_horizontal,
            is_size_vertical: is_size_vertical
        });
    }

    onClickAddDomain = e => {
        if ($("#input_domain").val() == null || $("#input_domain").val() === "") {
            return false;
        }

        const sendForm = {
            domain: $("#input_domain").val()
        }
        http.get("/rest/common/duplicate/domain", {params:sendForm})
        .then(res => {
            if (!(res.data.is_already_use == "true" || res.data.is_already_use)) {
                // console.log(e.target.value);
                var domain_list = this.state.domain_list;
                // console.log(domain_list);
                domain_list.push($("#input_domain").val());
                this.setState({domain_list: domain_list})
    
                // 자동배너 설정 - 쇼핑몰 사이트 주소 입력
                ReactGA.event({
                    category: "자동배너 설정",
                    action: "도메인 주소 입력 : " + domain_list,
                    label: ga_label
                });
            } else {
                alert("이미 사용중인 도메인 입니다.");
            }
        })
        .catch(error => {
            console.log ("===== error =====");
            console.log (error);
            console.log ("===== error request =====");
            console.log(error.request);
        });
    }

    onChangeIframePageId = e => {
        if (e.target.value != "robomd_category_page") {
            this.setState({
                iframe_page_id: e.target.value,
                /* 카테고리 페이지 선택 초기화 */
                category_page_1: "",
                category_page_2: "",
                category_page_3: "",
                category_page_4: "",
                page_category_list_1: [],
                page_category_list_2: [],
                page_category_list_3: [],
                page_category_list_4: [],
                category_page_step: 0, 
            });
        } else {
            this.setState({iframe_page_id: e.target.value}, () => {
                this.loadPageCategory("", 1, false, false); // 최상위 카테고리 조회
            });
        }
    }

    onChangeIframeHtmlName = e => {
        this.setState({iframe_html_name: e.target.value});
    }

    onClickDisplayYn = (e) => {
        if (e.target.value == "Y") {
            if(is_install != true) {
                alert("배너를 진열하려면 고객님 쇼핑몰에 스크립트를 설치해야 합니다. 화면 왼쪽 아래 채팅 아이콘을 눌러 로보MD팀에게 설치를 신청해 주세요.");
                return false;
            }
            if(is_free_finish == true) {
                if(is_order != true) {
                     alert("자동 진열 기능은 멤버십 결제 후 이용하실 수 있습니다. 결제 후 진열하기로 변경해 주세요.");
                    //alert("배너를 진열하려면 고객님 쇼핑몰에 스크립트를 설치해야 합니다. 화면 왼쪽 아래 채팅 아이콘을 눌러 로보MD팀에게 설치를 신청해 주세요.");
                    return false;
                }
            } 
            // else {
            //     if(is_order != true) {
            //         // alert("자동 진열 기능은 멤버십 결제 후 이용하실 수 있습니다. 결제 후 진열하기로 변경해 주세요.");
            //         alert("배너를 진열하려면 고객님 쇼핑몰에 스크립트를 설치해야 합니다. 화면 왼쪽 아래 채팅 아이콘을 눌러 로보MD팀에게 설치를 신청해 주세요.");
            //         return false;
            //     }
            // }
        }
        this.setState({display_yn : e.target.value});
    }
    
    onChangePopupBlockCycleDay = (e) => {
        const value = StringUtil.inputOnlyNumberFormat(e.target.value);
        this.setState({
            popup_block_cycle_day : value,
        })
    }
    onChangePopupBlockCycleTitle = (e) => {
        const value = e.target.value;
        this.setState({
            popup_block_cycle_title : value,
        })
    }
    
    onChangePopupCloseBtnTitle = (e) => {
        const value = e.target.value;
        this.setState({
            popup_close_btn_title : value,
        })
    }

    onChangePopupDelayTime = (e) => {
        const value = StringUtil.inputOnlyNumberFormat(e.target.value);
        this.setState({
            popup_delay_time : value,
        })
    }

    onChangeBannerSize = (e, type) => {
        const value = StringUtil.inputOnlyNumberFormat(e.target.value);
        if (type == "hrizontal") {
            this.setState({event_banner_pc_width : value}, () => {
                this.onBlurBannerSizeText();
            });
        }

        if (type == "vertical") {
            this.setState({event_banner_pc_height : value}, () => {
                this.onBlurBannerSizeText();
            });
        }
    }
    onChangeMobileBannerSize = (e, type) => {
        const value = StringUtil.inputOnlyNumberFormat(e.target.value);
        if (type == "hrizontal") {
            this.setState({event_banner_mobile_width : value}, () => {
                this.onBlurBannerSizeText();
            });
        }

        if (type == "vertical") {
            this.setState({event_banner_mobile_height : value}, () => {
                this.onBlurBannerSizeText();
            });
        }
    }

    onChangeProductDuplicateType = (e) => {
        let duplicateType = e.target.value;
        let userType = e.target.name.split('/')[0];
        if (userType == "all") {
            const { all_user_item } = this.state;
            all_user_item["product_duplicate_check_type"] = duplicateType;
            this.setState({all_user_item : all_user_item});
        } else if (userType == "member") {
            const { member_user_item } = this.state;
            member_user_item["product_duplicate_check_type"] = duplicateType;
            this.setState({member_user_item : member_user_item});
        } else if (userType == "none") {
            const { none_user_item } = this.state;
            none_user_item["product_duplicate_check_type"] = duplicateType;
            this.setState({none_user_item : none_user_item});
        }
    }

    /** 화살표 사용 여부 : 라디오박스의 디자인 코드 return */
    ArraowUseYnRenderer(type) {
        if(type=="N"){
            return (
                <font>사용 안함</font>
            );
        } else {
            return (
                <font>사용함</font>
            );
        }
    }
    
    /** 화살표 모양 : 라디오박스의 디자인 코드 return */
    ArraowTypeRenderer(type) {
        if(type=="001"){
            return (
                <div style={{display:"flex", height:"100%"}}>
                    <ul style={{display:"flex", width:"150px", margin:"auto 0"}}>
                        <li style={{width:"100%"}}>
                            <div style={{width:"100%", height:"8px", borderRadius:"8px", backgroundColor:"rgba(0, 0, 0)"}}></div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div style={{float:"right", width:"50%",height:"8px", borderRadius:"8px", backgroundColor:"rgba(123, 123, 123, 50%)"}}></div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div style={{float:"right", width:"50%",height:"8px", borderRadius:"8px", backgroundColor:"rgba(123, 123, 123, 50%)"}}></div>
                        </li>
                    </ul>
                </div>
            );
        } else if(type=="002"){
            return (
                <div style={{display:"flex", height:"100%"}}>
                    <ul style={{display:"flex", width:"150px", margin:"auto 0"}}>
                        <li style={{width:"100%"}}>
                            <div style={{height:"3px", backgroundColor:"rgba(0, 0, 0)"}}></div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div style={{height:"3px", backgroundColor:"rgba(123, 123, 123, 50%)"}}></div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div style={{height:"3px", backgroundColor:"rgba(123, 123, 123, 50%)"}}></div>
                        </li>
                    </ul>
                </div>
            );
        } else if(type=="003"){
            return (
                <div style={{display:"flex", height:"100%"}}>
                    <ul style={{display:"flex", width:"150px", margin:"auto 0"}}>
                        <li style={{width:"100%"}}>
                            <div>-</div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div>2</div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div>3</div>
                        </li>
                    </ul>
                </div>
            );
        } else if(type=="004"){
            return (
                <div style={{display:"flex", height:"100%"}}>
                    <ul style={{display:"flex", width:"150px", margin:"auto 0"}}>
                        <li style={{width:"100%"}}>
                            <div style={{width:"8px", height:"8px", borderRadius:"8px", backgroundColor:"rgba(0, 0, 0)"}}></div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div style={{width:"8px",height:"8px", borderRadius:"8px", backgroundColor:"rgba(123, 123, 123, 50%)"}}></div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div style={{width:"8px",height:"8px", borderRadius:"8px", backgroundColor:"rgba(123, 123, 123, 50%)"}}></div>
                        </li>
                    </ul>
                </div>
            );
        } else if(type=="005"){
            return (
                <div style={{display:"flex", height:"100%"}}>
                    <ul style={{display:"flex", width:"150px", margin:"auto 0"}}>
                        <li style={{width:"100%"}}>
                            <div style={{width:"8px", height:"8px", backgroundColor:"rgba(0, 0, 0)"}}></div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div style={{width:"8px",height:"8px", backgroundColor:"rgba(123, 123, 123, 50%)"}}></div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div style={{width:"8px",height:"8px", backgroundColor:"rgba(123, 123, 123, 50%)"}}></div>
                        </li>
                    </ul>
                </div>
            );
        } else if(type=="006"){
            return (
                <div style={{display:"flex", height:"100%"}}>
                    <ul style={{display:"flex", width:"150px", margin:"auto 0"}}>
                        <li style={{width:"100%"}}>
                            <div style={{width:"8px", height:"8px", backgroundColor:"rgba(0, 0, 0)", transform:"rotate(45deg)"}}></div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div style={{width:"8px",height:"8px", border:"1px solid rgba(123, 123, 123, 50%)", transform:"rotate(45deg)"}}></div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div style={{width:"8px",height:"8px", border:"1px solid rgba(123, 123, 123, 50%)", transform:"rotate(45deg)"}}></div>
                        </li>
                    </ul>
                </div>
            );
        } else if(type=="007"){
            return (
                <div style={{display:"flex", height:"100%"}}>
                    <ul style={{display:"flex", width:"150px", margin:"auto 0"}}>
                        <li style={{width:"100%"}}>
                            <div style={{width:"8px", height:"8px", backgroundColor:"rgba(0, 0, 0)", transform:"rotate(45deg)"}}></div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div style={{width:"8px",height:"8px", backgroundColor:"rgba(123, 123, 123, 50%)", transform:"rotate(45deg)"}}></div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div style={{width:"8px",height:"8px", backgroundColor:"rgba(123, 123, 123, 50%)", transform:"rotate(45deg)"}}></div>
                        </li>
                    </ul>
                </div>
            );
        } else if(type=="008"){
            return (
                <div style={{display:"flex", height:"100%"}}>
                    <div style={{width:"150px"}}>
                        <div style={{width:"58px", display:"flex", flexDirection:"row", justifyContent:"center", alignItems:"center", height:"30px", fontFamily:"Roboto", fontSize:"16px", fontWeight:"500", padding:"0 16px", borderRadius:"30px", color:"#FFFFFF", backgroundColor:"rgba(0,0,0,0.4)", transform:"translateY(-2px)"}}>
                            1/3
                        </div>
                    </div>
                </div>
            );
        } else if(type=="A3999"){
            return (
                <font>사용 안함</font>
            );
        }
    }

    /** 페이지 컨트롤 모양 : 라디오박스의 디자인 코드 return */
    pageControlRenderer(type) {
        if(type=="001"){
            return (
                <div style={{display:"flex", height:"100%"}}>
                    <ul style={{display:"flex", width:"150px", margin:"auto 0"}}>
                        <li style={{width:"100%"}}>
                            <div style={{width:"100%", height:"8px", borderRadius:"8px", backgroundColor:"rgba(0, 0, 0)"}}></div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div style={{float:"right", width:"50%",height:"8px", borderRadius:"8px", backgroundColor:"rgba(123, 123, 123, 50%)"}}></div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div style={{float:"right", width:"50%",height:"8px", borderRadius:"8px", backgroundColor:"rgba(123, 123, 123, 50%)"}}></div>
                        </li>
                    </ul>
                </div>
            );
        } else if(type=="002"){
            return (
                <div style={{display:"flex", height:"100%"}}>
                    <ul style={{display:"flex", width:"150px", margin:"auto 0"}}>
                        <li style={{width:"100%"}}>
                            <div style={{height:"3px", backgroundColor:"rgba(0, 0, 0)"}}></div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div style={{height:"3px", backgroundColor:"rgba(123, 123, 123, 50%)"}}></div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div style={{height:"3px", backgroundColor:"rgba(123, 123, 123, 50%)"}}></div>
                        </li>
                    </ul>
                </div>
            );
        } else if(type=="003"){
            return (
                <div style={{display:"flex", height:"100%"}}>
                    <ul style={{display:"flex", width:"150px", margin:"auto 0"}}>
                        <li style={{width:"100%"}}>
                            <div>-</div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div>2</div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div>3</div>
                        </li>
                    </ul>
                </div>
            );
        } else if(type=="004"){
            return (
                <div style={{display:"flex", height:"100%"}}>
                    <ul style={{display:"flex", width:"150px", margin:"auto 0"}}>
                        <li style={{width:"100%"}}>
                            <div style={{width:"8px", height:"8px", borderRadius:"8px", backgroundColor:"rgba(0, 0, 0)"}}></div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div style={{width:"8px",height:"8px", borderRadius:"8px", backgroundColor:"rgba(123, 123, 123, 50%)"}}></div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div style={{width:"8px",height:"8px", borderRadius:"8px", backgroundColor:"rgba(123, 123, 123, 50%)"}}></div>
                        </li>
                    </ul>
                </div>
            );
        } else if(type=="005"){
            return (
                <div style={{display:"flex", height:"100%"}}>
                    <ul style={{display:"flex", width:"150px", margin:"auto 0"}}>
                        <li style={{width:"100%"}}>
                            <div style={{width:"8px", height:"8px", backgroundColor:"rgba(0, 0, 0)"}}></div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div style={{width:"8px",height:"8px", backgroundColor:"rgba(123, 123, 123, 50%)"}}></div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div style={{width:"8px",height:"8px", backgroundColor:"rgba(123, 123, 123, 50%)"}}></div>
                        </li>
                    </ul>
                </div>
            );
        } else if(type=="006"){
            return (
                <div style={{display:"flex", height:"100%"}}>
                    <ul style={{display:"flex", width:"150px", margin:"auto 0"}}>
                        <li style={{width:"100%"}}>
                            <div style={{width:"8px", height:"8px", backgroundColor:"rgba(0, 0, 0)", transform:"rotate(45deg)"}}></div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div style={{width:"8px",height:"8px", border:"1px solid rgba(123, 123, 123, 50%)", transform:"rotate(45deg)"}}></div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div style={{width:"8px",height:"8px", border:"1px solid rgba(123, 123, 123, 50%)", transform:"rotate(45deg)"}}></div>
                        </li>
                    </ul>
                </div>
            );
        } else if(type=="007"){
            return (
                <div style={{display:"flex", height:"100%"}}>
                    <ul style={{display:"flex", width:"150px", margin:"auto 0"}}>
                        <li style={{width:"100%"}}>
                            <div style={{width:"8px", height:"8px", backgroundColor:"rgba(0, 0, 0)", transform:"rotate(45deg)"}}></div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div style={{width:"8px",height:"8px", backgroundColor:"rgba(123, 123, 123, 50%)", transform:"rotate(45deg)"}}></div>
                        </li>
                        <li style={{width:"100%"}}>
                            <div style={{width:"8px",height:"8px", backgroundColor:"rgba(123, 123, 123, 50%)", transform:"rotate(45deg)"}}></div>
                        </li>
                    </ul>
                </div>
            );
        } else if(type=="008"){
            return (
                <div style={{display:"flex", height:"100%"}}>
                    <div style={{width:"150px"}}>
                        <div style={{width:"58px", display:"flex", flexDirection:"row", justifyContent:"center", alignItems:"center", height:"30px", fontFamily:"Roboto", fontSize:"16px", fontWeight:"500", padding:"0 16px", borderRadius:"30px", color:"#FFFFFF", backgroundColor:"rgba(0,0,0,0.4)", transform:"translateY(-2px)"}}>
                            1/3
                        </div>
                    </div>
                </div>
            );
        } else if(type=="000"){
            return (
                <font>사용 안함</font>
            );
        }
    }

    handleFileNameSettingBtnClick = (e) => {
        if(this.state.iframe_page_id == null || this.state.iframe_page_id == "" || this.state.iframe_html_id == null || this.state.iframe_html_id == "") {
            this.setState({
                warning_dialog_show_state : true,
                warning_dialog_content : "자동 배너 설정을 저장한 이후에<br/> 설정할 수 있어요.",
                warning_dialog_button_list: [
                    {
                        title: "확인",
                        type: "1",
                        event_method: () => {
                            this.setState({ warning_dialog_show_state: false });
                        }
                    }
                ],
            });

        }else{
            $(document).ready(function () {
                if(sessionStorage.getItem('is_reduct_left_menu') == 'T'){
                    $(".wrap_file_name_setting").css("margin-left", "90px");
                } else{
                    $(".wrap_file_name_setting").css("margin-left", "260px");
                }
            });

            // 스크롤 최상단으로 이동
            window.scrollTo(0,0);

            // 다운로드 파일명 설정 여부 조회
            this.getFileNameSetting().then(r => {
                this.setState({file_name_setting_yn: r.file_name_setting_yn})
            });

            this.setState({
                is_file_name_setting_open: !this.state.is_file_name_setting_open,
            });
        }
    }

    // 다운로드 파일명 설정 여부 조회
    async getFileNameSetting() {
        try{
            const res = await http.get("/rest/shop/event/setting/file-name/setting-yn?iframe_page_id="+this.state.iframe_page_id+"&iframe_html_id="+this.state.iframe_html_id);

            if(res.data != null) {
                if (res.data.code == 401) {
                    alert(res.data.msg);
                    window.location.href = "/logout";
                }

                if (res.data.list != null && res.data.list.length > 0) {
                    this.setState({
                        file_name_setting_yn: res.data.list.file_name_setting_yn
                    });
                }

                return res.data.list;
            }

        }catch(error){
            console.log(error);
        }
    }

    // 사용자 멀티샵 서비스 무료체험, 결제여부 확인
    fn_shopServiceOperated = (service_type, callback=()=>{}) => {
        http.get("/rest/shop/serviceOperated/"+service_type)
        .then(res => {
            if(res.data.code == "0000"){
                if(service_type == "01009" 
                    && (
                            res.data.shopServiceOperated_map.is_finish == "0" 
                            || res.data.shopServiceOperated_map.is_finish == "1"        //타겟뷰 서비스 : 무료체험 구분 없음
                            || res.data.shopServiceOperated_map.is_payment == "1"
                        )
                ){
                    this.setState({is_use_target_view_service : "Y"});
                } else{
                    this.setState({
                        is_use_target_view_service : "N",       // is_finish : -1 미신청시 해당 팝업 출력
                        popup_target_type : "73001",
                    });
                }
            }
            return res;
        })
        .then((res) => {
            callback(res);
        })
        .catch(error => {
            console.log (error);
        });
    }

    getTargetViewList = () => {
        http.get("/rest/shop/selectbox/targetview/list")
        .then(res => {
            if(res.data.target_view_list){
                let target_view_list = res.data.target_view_list;
                if(target_view_list.length > 0){
                    target_view_list = [
                        {title : "모든 타겟 (새롭게 추가되는 모든 타겟 리스트를 포함)", target_view_seq: -1},
                        {title : "기존 타겟 전체 선택", target_view_seq: -2},
                        ...target_view_list
                    ];
                }
                this.setState({target_view_list : target_view_list})
            }
        })
        .catch(error => {
            console.log (error);
        });
    }

    goTargetViewSetting = () => {
        window.open("/shop/targetview/setting", '_blank'); // 새 창으로 열기
    }

    // 배너 템플릿 필터 조회
    getBannerDesignTemplateFilter() {
        http.get("/rest/common/bannerDesignTemplateFilter")
            .then(res => {
                let tagLists = {};
                let categoryList = [];

                res.data.ctg_list.map(obj => {
                    categoryList.push(obj.tag_cd.substr(0, 3).toLowerCase());
                });

                for (const category of categoryList) {
                    tagLists[category] = res.data[category + "_tag_list"].map((tag) => ({
                        ctg_cd: tag.ctg_cd,
                        ctg_sorting: tag.ctg_sorting,
                        ctg_sorting_inside: tag.ctg_sorting_inside,
                        display_yn: tag.display_yn,
                        tag_cd: tag.tag_cd,
                        tag_name: tag.tag_name,
                        tag_sorting: tag.tag_sorting,
                        isSelected: false,
                    }));
                }

                this.setState({
                    template_ctg_list: res.data.ctg_list,
                    template_tag_list: res.data.tag_list,
                    w_template_all_tag_list: tagLists,
                    h_template_all_tag_list: tagLists,
                });

            }).catch(e => {
            console.log("### [ERROR] getBannerDesignTemplateFilter ###", e);
        })
    }

    handleDrag = ({ scrollContainer }) => (ev) => {
        this.handleDragMove(ev, (posDiff) => {
            if (scrollContainer && scrollContainer.current) {
                scrollContainer.current.scrollLeft += posDiff;
            }
        });
    };

    handleMouseOnWheel = (apiObj, ev) => {
        const isTouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 15;

        if (isTouchpad) {
            ev.stopPropagation();
            return;
        }

        if (ev.deltaY < 0) {
            apiObj.scrollNext();
        } else if (ev.deltaY > 0) {
            apiObj.scrollPrev();
        }
    };

    handleDragStart = (ev) => {
        this.setState({
            position: ev.clientX,
            clicked: true,
        });
    };

    handleDragStop = () => {
        window.requestAnimationFrame(() => {
            this.setState({
                dragging: false,
                clicked: false,
            });
        });
    };

    handleDragMove = (ev, cb) => {
        const newDiff = this.state.position - ev.clientX;
        const movedEnough = Math.abs(newDiff) > 5;

        if (this.state.clicked && movedEnough) {
            this.setState({
                dragging: true,
            });
        }

        if (this.state.dragging && movedEnough) {
            this.setState(
                {
                    position: ev.clientX,
                },
                () => cb(newDiff)
            );
        }
    };

    // 템플릿 필터 버튼 클릭
    handleTemplateFilterBtnClick = (upper_code_cd) => {
        this.setState({
            show_template_filter_popup_type: upper_code_cd,
            show_template_filter_popup: true,
        })
    }

    // 템플릿 필터 팝업 닫기(x) 버튼 클릭
    closeTemplateFilterPopupBtnClick = () => {
        this.resetTemplateFilterBtnClick("03000", "w");     // 템플릿 필터 초기화
        this.resetTemplateFilterBtnClick("07000", "h");     // 템플릿 필터 초기화
        this.setState({
            show_template_filter_popup: false,
        });
    }

    // 태그 버튼 클릭
    tagBtnClick = (category, tagCd, isSelected, upper_code_cd, template_type) => {
        if (this.state.dragging) {
            return false;
        }

        const selected_tag_list = [];

        this.setState((prevState) => {
            const updatedList = prevState[`${template_type}_template_all_tag_list`][category].map((tag) => {
                if (tag.tag_cd === tagCd) {
                    return {
                        ...tag,
                        isSelected: isSelected,
                    };
                }
                return tag;
            });

            const allSelected = this.checkAllSelected(category, updatedList);

            const updatedSelectedTags = {
                ...prevState[`${template_type}_selected_tags`],
                [category]: updatedList.filter((tag) => tag.isSelected).map((tag) => tag.tag_cd),
            };

            for(const category in updatedSelectedTags){
                if(updatedSelectedTags.hasOwnProperty(category)){
                    updatedSelectedTags[category].map((obj => {
                        selected_tag_list.push(obj)
                    }));
                }
            }
            // console.log(selected_tag_list)

            if(updatedSelectedTags == null || updatedSelectedTags == undefined || updatedSelectedTags.length == 0){
                return {
                    [template_type + "_all_tag_selected"]: true,
                }
            }else{
                return {
                    selected: prevState.selected !== tagCd ? tagCd : "",
                    [template_type + "_template_all_tag_list"]: {
                        ...prevState[`${template_type}_template_all_tag_list`],
                        [category]: updatedList,
                    },
                    [template_type + "_selected_tags"]: updatedSelectedTags,
                    [template_type + "_all_selected"]: {
                        ...prevState[`${template_type}_all_selected`],
                        [category]: allSelected,
                    },
                    [template_type + "_all_tag_selected"]: false,
                }
            }
        }, () => {
            if(template_type == "w"){
                this.setState({
                    pc_banner_type_paging : {   // 페이징 초기화
                        activePage: 1,
                        totalCnt: 0,
                        startIdx: 0,
                        rowcnt:15,
                    }
                }, () => {
                    this.getBannerDesignTemplateUserFavoritePaging(upper_code_cd, selected_tag_list).then(r => {});
                });

            }else {
                this.setState({
                    mobile_banner_type_paging : {   // 페이징 초기화
                        activePage: 1,
                        totalCnt: 0,
                        startIdx: 0,
                        rowcnt:12,
                    },
                }, () => {
                    this.getBannerDesignTemplateUserFavoritePaging(upper_code_cd, selected_tag_list).then(r => {});
                });
            }
        });
    }

    // 필터 팝업 내부 태그 버튼 클릭
    handleTagBtnClick = (category, tagCd, isSelected, template_type) => {
        this.setState((prevState) => {
            const updatedList = prevState[`${template_type}_template_all_tag_list`][category].map((tag) => {
                if (tag.tag_cd === tagCd) {
                    return {
                        ...tag,
                        isSelected: isSelected,
                    };
                }
                return tag;
            });

            const allSelected = this.checkAllSelected(category, updatedList);

            const updatedSelectedTags = {
                ...prevState[`${template_type}_selected_tags`],
                [category]: updatedList.filter((tag) => tag.isSelected).map((tag) => tag.tag_cd),
            };

            if(updatedSelectedTags == null || updatedSelectedTags == undefined || updatedSelectedTags.length == 0) {
                return {
                    [template_type + "_all_tag_selected"]: true,
                }
            }else{
                return {
                    [template_type + "_template_all_tag_list"]: {
                        ...prevState[`${template_type}_template_all_tag_list`],
                        [category]: updatedList,
                    },
                    [template_type + "_selected_tags"]: updatedSelectedTags,
                    [template_type + "_all_selected"]: {
                        ...prevState[`${template_type}_all_selected`],
                        [category]: allSelected,
                    },
                    [template_type + "_all_tag_selected"]: false,
                };
            }
        });
    };

    // 필터 팝업 밖 전체 태그 버튼 클릭
    allTagBtnClick = (upper_code_cd, template_type) => {
        this.setState((prevState) => ({
            [template_type + "_all_tag_selected"]: !prevState[`${template_type}_all_tag_selected`],
        }), () => {
            if(this.state[template_type + "_all_tag_selected"]){
                this.resetTemplateFilterBtnClick(upper_code_cd, template_type);
            }
        });
    }

    // 필터 팝업 내부 전체 태그 버튼 클릭
    handleAllTagBtnClick = (category, template_type) => {
        this.setState((prevState) => {
            const allSelected = !prevState[`${template_type}_all_selected`][category];

            const updatedList = prevState[`${template_type}_template_all_tag_list`][category].map((tag) => ({
                ...tag,
                isSelected: allSelected,
            }));

            const updatedSelectedTags = {
                ...prevState[`${template_type}_selected_tags`],
                [category]: allSelected ? updatedList.map((tag) => tag.tag_cd) : [],
            };

            return {
                [template_type + "_template_all_tag_list"]: {
                    ...prevState[`${template_type}_template_all_tag_list`],
                    [category]: updatedList,
                },
                [template_type + "_selected_tags"]: updatedSelectedTags,
                [template_type + "_all_selected"]: {
                    ...prevState[`${template_type}_all_selected`],
                    [category]: allSelected,
                },
            };
        });
    };

    checkAllSelected = (category, updatedList) => {
        return updatedList.every((tag) => tag.isSelected) && updatedList.length > 0;
    };

    // 템플릿 필터 팝업 초기화 버튼 클릭
    resetTemplateFilterBtnClick = (upper_code_cd, template_type) => {
        this.setState((prevState) => {
            const updatedTagLists = {};
            const updatedAllSelected = {};

            Object.keys(prevState[`${template_type}_template_all_tag_list`]).forEach((category) => {
                updatedTagLists[category] = prevState[`${template_type}_template_all_tag_list`][category].map((tag) => ({
                    ...tag,
                    isSelected: false,
                }));
                updatedAllSelected[category] = false;
            });

            return {
                [template_type + "_template_all_tag_list"]: {
                    ...prevState[`${template_type}_template_all_tag_list`],
                    ...updatedTagLists,
                },
                [template_type + "_all_selected"]: {
                    ...prevState[`${template_type}_all_selected`],
                    ...updatedAllSelected,
                },
                [template_type + "_selected_tags"]: {
                    bsn: [],
                    usg: [],
                    lyt: [],
                    sty: [],
                },
                [template_type + "_all_tag_selected"]: true,
            };
        }, () => {
            if(template_type == "w"){
                this.setState({
                    pc_banner_type_paging : {   // 페이징 초기화
                        activePage: 1,
                        totalCnt: 0,
                        startIdx: 0,
                        rowcnt:15,
                    }
                }, () => {
                    this.getBannerDesignTemplateUserFavoritePaging(upper_code_cd).then(r => {});
                });

            }else {
                this.setState({
                    mobile_banner_type_paging : {   // 페이징 초기화
                        activePage: 1,
                        totalCnt: 0,
                        startIdx: 0,
                        rowcnt:12,
                    },
                }, () => {
                    this.getBannerDesignTemplateUserFavoritePaging(upper_code_cd).then(r => {});
                });
            }
        });
    }

    // 템플릿 필터 팝업 적용 버튼 클릭
    applyTemplateFilterBtnClick = (upper_code_cd, template_type) => {
        const selected_tag_list = [];

        for(const category in this.state[template_type + "_selected_tags"]){
            if(this.state[template_type + "_selected_tags"].hasOwnProperty(category)){
                this.state[template_type + "_selected_tags"][category].map((obj => {
                    selected_tag_list.push(obj)
                }));
            }
        }
        // console.log(selected_tag_list)

        if(template_type == "w"){
            this.setState({
                show_template_filter_popup: false,
                pc_banner_type_paging : {   // 페이징 초기화
                    activePage: 1,
                    totalCnt: 0,
                    startIdx: 0,
                    rowcnt:15,
                }
            }, () => {
                this.getBannerDesignTemplateUserFavoritePaging(upper_code_cd, selected_tag_list).then(r => {});
            });

        }else {
            this.setState({
                show_template_filter_popup: false,
                mobile_banner_type_paging : {   // 페이징 초기화
                    activePage: 1,
                    totalCnt: 0,
                    startIdx: 0,
                    rowcnt:12,
                },
            }, () => {
                this.getBannerDesignTemplateUserFavoritePaging(upper_code_cd, selected_tag_list).then(r => {});
            });
        }
    }

    /* 팝업 위치 이동 화살표 버튼 클릭 */
    movePositionOnClick = (e, position, opposite, value) => {
        let _position = this.state[position];
        let _opposite = this.state[opposite];

        if(_position == undefined || _position == null){
            _position = 0;
        }

        if(_opposite == undefined || _opposite == null){
            _opposite = 0;
        }

        if(Number(_opposite) == 0){
            this.setState({[position] : Number(_position) + Number(value)});
        }else{
            this.setState({[opposite] : Number(_opposite) - Number(value)});
        }
    }

    /* 팝업 위치 이동 초기화 버튼 클릭 */
    moveImgPositionResetOnClick = (e) => {
        this.setState({
            popup_position_left: 0,
            popup_position_right: 0,
            popup_position_top: 0,
            popup_position_bottom : 0,
        });
    }

    /* 팝업 위치 이동 입력 */
    movePositionOnBlur = (e, position, opposite) => {
        if(e.target.value == "" || e.target.value == -0 || isNaN(e.target.value)){
            this.setState({[position] : 0})
            return;
        }

        if(e.target.value != 0 && e.target.value != -0){
            this.setState({
                [position] : Math.abs(Number(e.target.value)),
                [opposite] : 0,
            });
        }
    }

    /* 팝업 위치 이동 입력 */
    movePositionOnKeyPress = (e) => {
        if (e.key === "Enter") {
            e.target.blur();
        }
    }

    render() {
        $(".pageName").text("배너 설정 등록");
        return (
            <div id='page-wrapper' className="container eventSetting" style={{backgroundColor: '#ffffff', minHeight:"100%"}}>
                <div id="setting_container">
                    {/* <h3>[Shop] 자동배너 설정</h3>
                    <br/> */}
                    <div style={{marginTop:"55px"}}></div>
                    <div className={this.state.is_file_name_setting_open ? "fixedStepArea fixedStepArea_m event_setting_menu_open" : "fixedStepArea fixedStepArea_m event_setting_menu"}>
                        <b className="flexBox" style={{fontSize:"18px", justifyContent: "stretch"}}>
                            <div className={"step_area"}>
                                {/* Step 1: 노출 */}
                                <div className="fixedStepAreaTitleArea flexBox cursor-pointer" onClick={e => this.onClickStepButton(e, 0)} style={{marginRight:"15px"}}>
                                    {
                                        Number(this.state.step) == 0 
                                        ?
                                            <div className="auto_setting_step active" onMouseLeave={() => {this.setState({is_hover_step_0: false})}}>
                                                <div className="icn_auto_setting_step">
                                                    <img src={btn_step_1_active} style={{width: "23.5px",height: "23.5px"}}></img>
                                                </div>
                                                <div className="txt_auto_setting_step">
                                                    <p style={{color: "#00E2E6"}}>
                                                        {
                                                            this.state.solution_type_cd == "09900"
                                                            ? "사이즈"
                                                            : "노출"
                                                        }
                                                    </p>
                                                </div>
                                            </div>
                                        :   
                                            <div className="auto_setting_step" onMouseOver={() => {this.setState({is_hover_step_0: true})}} onMouseLeave={() => {this.setState({is_hover_step_0: false})}}>
                                                <div className="icn_auto_setting_step">
                                                    <img src={this.state.is_hover_step_0 ? btn_step_1_hover : btn_step_1_default} style={{width: "19.5px",height: "19.5px"}}></img>
                                                </div>
                                                <div className="txt_auto_setting_step">
                                                    <p style={{color: "#3A3A3A"}}>
                                                        {
                                                            this.state.solution_type_cd == "09900"
                                                            ? "사이즈"
                                                            : "노출"
                                                        }
                                                    </p>
                                                </div>
                                            </div>    
                                    }
                                </div>
                                {this.state.solution_type_cd != '09900' &&
                                <>
                                    <div className="auto_setting_step_dash" style={{width: "40px", height: "3px", borderTop: "3px dashed #ACACAC", marginRight:"15px", marginTop:"15px"}}></div>
                                    {/* Step 2: 일정 */}
                                    <div className="fixedStepAreaTitleArea flexBox cursor-pointer" onClick={e => this.onClickStepButton(e, 1)} style={{marginRight:"15px"}}>
                                        {Number(this.state.step) == 1 
                                        ?
                                            <div className="auto_setting_step active" onMouseLeave={() => {this.setState({is_hover_step_1: false})}}>
                                                <div className="icn_auto_setting_step">
                                                    <img src={btn_step_2_active} style={{width: "23.5px",height: "23.5px"}}></img>
                                                </div>
                                                <div className="txt_auto_setting_step">
                                                    <p style={{color: "#00E2E6"}}>일정</p>
                                                </div>
                                            </div>
                                        :   
                                            <div className="auto_setting_step" onMouseOver={() => {this.setState({is_hover_step_1: true})}} onMouseLeave={() => {this.setState({is_hover_step_1: false})}}>
                                                <div className="icn_auto_setting_step">
                                                    <img src={this.state.is_hover_step_1 ? btn_step_2_hover : btn_step_2_default} style={{width: "19.5px",height: "19.5px"}}></img>
                                                </div>
                                                <div className="txt_auto_setting_step">
                                                    <p style={{color: "#3A3A3A"}}>일정</p>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    <div className="auto_setting_step_dash" style={{width: "40px", height: "3px", borderTop: "3px dashed #ACACAC", marginRight:"15px", marginTop:"15px"}}></div>
                                    {/* Step 3: 상품 */}
                                    <div className="fixedStepAreaTitleArea flexBox cursor-pointer" onClick={e => this.onClickStepButton(e, 2)} style={{marginRight:"15px"}}>
                                        {Number(this.state.step) == 2 
                                        ?
                                            <div className="auto_setting_step active" onMouseLeave={() => {this.setState({is_hover_step_2: false})}}>
                                                <div className="icn_auto_setting_step">
                                                    <img src={btn_step_3_active} style={{width: "23.5px",height: "23.5px"}}></img>
                                                </div>
                                                <div className="txt_auto_setting_step">
                                                    <p style={{color: "#00E2E6"}}>상품</p>
                                                </div>
                                            </div>
                                        :   
                                            <div className="auto_setting_step" onMouseOver={() => {this.setState({is_hover_step_2: true})}} onMouseLeave={() => {this.setState({is_hover_step_2: false})}}>
                                                <div className="icn_auto_setting_step">
                                                    <img src={this.state.is_hover_step_2 ? btn_step_3_hover : btn_step_3_default} style={{width: "19.5px",height: "19.5px"}}></img>
                                                </div>
                                                <div className="txt_auto_setting_step">
                                                    <p style={{color: "#3A3A3A"}}>상품</p>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </>
                                }
                                <div className="auto_setting_step_dash" style={{width: "40px", height: "3px", borderTop: "3px dashed #ACACAC", marginRight:"15px", marginTop:"15px"}}></div>
                                {/* Step 4: 디자인 */}
                                <div className="fixedStepAreaTitleArea flexBox cursor-pointer" onClick={e => this.onClickStepButton(e, 3)}>
                                    {Number(this.state.step) == 3
                                    ?
                                        <div className="auto_setting_step active" onMouseLeave={() => {this.setState({is_hover_step_3: false})}}>
                                            <div className="icn_auto_setting_step">
                                                <img src={this.state.solution_type_cd == "09900" ? btn_step_2_active : btn_step_4_active} style={{width: "23.5px",height: "23.5px"}}></img>
                                            </div>
                                            <div className="txt_auto_setting_step">
                                                <p style={{color: "#00E2E6"}}>디자인</p>
                                            </div>
                                        </div>
                                    :   
                                        <div className="auto_setting_step" onMouseOver={() => {this.setState({is_hover_step_3: true})}} onMouseLeave={() => {this.setState({is_hover_step_3: false})}}>
                                            <div className="icn_auto_setting_step">
                                                <img
                                                    src={
                                                        this.state.solution_type_cd == "09900"
                                                        ? (this.state.is_hover_step_3 ? btn_step_2_hover : btn_step_2_default)
                                                        : (this.state.is_hover_step_3 ? btn_step_4_hover : btn_step_4_default)
                                                    }
                                                    style={{width: "19.5px",height: "19.5px"}}
                                                ></img>
                                            </div>
                                            <div className="txt_auto_setting_step">
                                                <p style={{color: "#3A3A3A"}}>디자인</p>
                                            </div>
                                        </div>
                                            
                                    }
                                </div>
                            </div>
                            <button className="btn_file_name_setting" onClick={(e) => {this.handleFileNameSettingBtnClick(e)}}>
                                <div className="icn_file_name_setting">
                                    <svg width="18" height="18" viewBox="1 1 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14.843 6.51904C14.8275 6.44915 14.7971 6.38341 14.754 6.32626C14.7108 6.26911 14.6559 6.22189 14.593 6.18779L13.1055 5.36279C13.0257 5.2011 12.936 5.04455 12.8367 4.89404L12.868 3.19404C12.8686 3.12274 12.8544 3.05208 12.8265 2.98649C12.7985 2.92089 12.7573 2.86176 12.7055 2.81279C11.9648 2.14127 11.0889 1.63619 10.1367 1.33154C10.0684 1.31022 9.99623 1.30365 9.92512 1.31227C9.85401 1.32089 9.78554 1.3445 9.72424 1.38154L8.26798 2.25654C8.08673 2.25029 7.91173 2.25029 7.73048 2.25654L6.27423 1.38154C6.21293 1.3445 6.14446 1.32089 6.07335 1.31227C6.00224 1.30365 5.93012 1.31022 5.86173 1.33154C4.90827 1.63642 4.032 2.14385 3.29298 2.81904C3.2407 2.86633 3.19914 2.92426 3.17111 2.98894C3.14308 3.05362 3.12923 3.12356 3.13048 3.19404L3.16173 4.89404C3.06173 5.04404 2.97423 5.20029 2.88673 5.36279L1.39923 6.18779C1.33718 6.22225 1.28329 6.26967 1.24123 6.32683C1.19916 6.384 1.16992 6.44956 1.15548 6.51904C0.942964 7.49511 0.942964 8.50548 1.15548 9.48154C1.17101 9.55144 1.20136 9.61718 1.24449 9.67433C1.28762 9.73148 1.34253 9.7787 1.40548 9.81279L2.89298 10.6378C2.97272 10.7995 3.06248 10.956 3.16173 11.1065L3.13048 12.8065C3.12991 12.8778 3.14405 12.9485 3.17201 13.0141C3.19997 13.0797 3.24115 13.1388 3.29298 13.1878C4.03363 13.8593 4.90953 14.3644 5.86173 14.669C5.93012 14.6904 6.00224 14.6969 6.07335 14.6883C6.14446 14.6797 6.21293 14.6561 6.27423 14.619L7.73048 13.744H8.26798L9.73048 14.619C9.80651 14.669 9.89575 14.6952 9.98674 14.694C10.0376 14.6918 10.0879 14.6835 10.1367 14.669C11.0902 14.3642 11.9665 13.8567 12.7055 13.1815C12.7578 13.1343 12.7993 13.0763 12.8274 13.0116C12.8554 12.947 12.8692 12.877 12.868 12.8065L12.8367 11.1065C12.9367 10.9565 13.0242 10.8003 13.1117 10.6378L14.5992 9.81279C14.6613 9.77834 14.7152 9.73092 14.7572 9.67376C14.7993 9.61659 14.8286 9.55103 14.843 9.48154C15.0555 8.50548 15.0555 7.49511 14.843 6.51904ZM13.9055 9.05029L12.4867 9.83779C12.3967 9.89011 12.3248 9.96859 12.2805 10.0628C12.1777 10.2758 12.0586 10.4806 11.9242 10.6753C11.8672 10.7626 11.8368 10.8647 11.8367 10.969L11.8617 12.5878C11.3236 13.046 10.7076 13.4037 10.043 13.644L8.64923 12.8065C8.57145 12.7613 8.48299 12.7375 8.39298 12.7378H8.35548C8.11835 12.7565 7.88011 12.7565 7.64298 12.7378C7.54051 12.7322 7.43858 12.7561 7.34923 12.8065L5.95548 13.644C5.29166 13.4049 4.67578 13.0493 4.13673 12.594L4.16173 10.969C4.1617 10.8647 4.13129 10.7626 4.07423 10.6753C3.9422 10.4791 3.8232 10.2745 3.71798 10.0628C3.67184 9.96984 3.60033 9.89183 3.51173 9.83779L2.09298 9.05029C1.96794 8.35588 1.96794 7.64471 2.09298 6.95029L3.51173 6.16279C3.60174 6.11048 3.67368 6.032 3.71798 5.93779C3.82081 5.72477 3.93991 5.52 4.07423 5.32529C4.13129 5.23794 4.1617 5.13588 4.16173 5.03154L4.13673 3.41279C4.67483 2.95462 5.29087 2.59686 5.95548 2.35654L7.34923 3.19404C7.43832 3.24521 7.54045 3.26911 7.64298 3.26279C7.88011 3.24404 8.11835 3.24404 8.35548 3.26279C8.45796 3.26839 8.55989 3.24453 8.64923 3.19404L10.043 2.35654C10.7068 2.5957 11.3227 2.95126 11.8617 3.40654L11.8367 5.03154C11.8368 5.13588 11.8672 5.23794 11.9242 5.32529C12.0563 5.52144 12.1753 5.72605 12.2805 5.93779C12.3266 6.03075 12.3981 6.10876 12.4867 6.16279L13.9055 6.95029C14.0305 7.64471 14.0305 8.35588 13.9055 9.05029ZM7.99923 4.50029C7.307 4.50029 6.63031 4.70557 6.05474 5.09015C5.47917 5.47474 5.03056 6.02136 4.76566 6.6609C4.50075 7.30044 4.43144 8.00418 4.56649 8.68311C4.70153 9.36204 5.03488 9.98568 5.52436 10.4752C6.01384 10.9647 6.63749 11.298 7.31642 11.433C7.99535 11.5681 8.69909 11.4988 9.33863 11.2339C9.97817 10.969 10.5248 10.5204 10.9094 9.94479C11.294 9.36922 11.4992 8.69253 11.4992 8.00029C11.4992 7.07204 11.1305 6.1818 10.4741 5.52542C9.81773 4.86904 8.92749 4.50029 7.99923 4.50029ZM7.99923 10.5003C7.50478 10.5003 7.02143 10.3537 6.61031 10.079C6.19919 9.80427 5.87875 9.41382 5.68954 8.957C5.50032 8.50019 5.45081 7.99752 5.54727 7.51257C5.64373 7.02762 5.88184 6.58216 6.23147 6.23253C6.5811 5.8829 7.02656 5.64479 7.51151 5.54833C7.99646 5.45187 8.49913 5.50138 8.95594 5.6906C9.41276 5.87981 9.80321 6.20025 10.0779 6.61137C10.3526 7.02249 10.4992 7.50584 10.4992 8.00029C10.4992 8.66334 10.2358 9.29922 9.767 9.76806C9.29816 10.2369 8.66228 10.5003 7.99923 10.5003Z" fill="#333333"/>
                                    </svg>
                                </div>
                                &nbsp;다운로드 파일명 설정
                            </button>
                        </b>
                    </div>
                    {this.state.is_file_name_setting_open && <EventSettingFileName singleSize={this.state.single_size} iframePageId={this.state.querystring.iframe_page_id} iframeHtmlId={this.state.querystring.iframe_html_id} isFileNameSettingOpen={this.state.is_file_name_setting_open} fileNameSettingYn={this.state.file_name_setting_yn} handleFileNameSettingBtnClick={(e) => this.handleFileNameSettingBtnClick(e)}/>}
                    {/* <div style={{width:"100%", borderTop:"1px solid #676867", margin: "0 0 0 0"}}>
                    <div style={{backgroundColor:"white", width:"120px", margin:"-10px auto 10px auto", padding:"0 10px 0 10px", color:"#676867", textAlign: "center"}}>
                         배너 기본 설정
                    </div>
                    </div> */}
                    {/* <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                        <div className="margin-vertical-auto eventSettingTitle" style={{width: "100%",}}>
                            <label style={{marginTop: "auto", marginBottom: "15px"}}><b>시작일</b></label>
                        </div>
                        <div style={{width:"150px"}}>
                            <DatePicker name="start_date" id="start_date" className="border_form_radius_b_h_42"
                                selected={this.state.start_date}
                                onSelect={this.handleSelect} //when day is clicked
                                onChange={this.handleChangeStartDate} //only when value has changed
                                placeholderText="시작일자"
                                // showTimeSelect
                                dateFormat="yyyy-MM-dd"
                                autoComplete='off'
                            />
                            
                        </div>
                    </div> */}
                    <div className="fixedStepAreaTitleArea_marginBottom_for_maxWidth_500"></div>
                    {
                        Number(this.state.step) == 0
                        ?   <div>
                                <div className="flexBox" style={{marginBottom:"43px"}}>
                                    <div className="form_primary_title" style={{marginRight: "20px"}}>
                                        {
                                            this.state.solution_type_cd == "09900"
                                            ? "사이즈"
                                            : "노출"
                                        }
                                    </div>
                                    <div className="userGuideButton" 
                                         onClick={(e) => Menu.call_userGuide('https://www.notion.so/iclave/4-8e2c8f9db1804792bdf78e70fff0d2aa#61d03ee0067f42d39674320ffef43408')}
                                         style={{height: "25px", margin:"auto 0 auto 0"}}
                                    >
                                        <span>사용자 가이드</span>
                                    </div>
                                    <div className="userGuideButtonMobile" 
                                         onClick={(e) => Menu.call_userGuide('https://www.notion.so/iclave/4-8e2c8f9db1804792bdf78e70fff0d2aa#61d03ee0067f42d39674320ffef43408')} 
                                         style={{height: "25px", margin:"auto 0 auto 0", float:'right'}}
                                    >
                                        <span>?</span>
                                    </div>
                                </div>
                                {
                                    // this.state.solution_type_cd != '09900' &&
                                    // <div className="flexBox eventSettingItemArea" id="domain_parent_area" style={{height:"auto", marginBottom:"30px"}}>
                                    //         <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%", position: "relative"}}>
                                    //             <label style={{marginTop: "auto", marginBottom: "15px"}}><b>도메인</b></label>
                                    //             <div className="fa fa-question-circle margin-l-10">
                                    //                 <div className="question-hover-area" style={{minWidth:"310px", position:"absolute", left:"6%"}}>
                                    //                     <font style={{fontSize:"14px",  lineHeight:"15px", wordBreak:"keep-all"}}>
                                    //                     <ul style={{marginBottom:"0px",fontSize:"14px", lineHeight:"15px", wordBreak:"keep-all"}}>
                                    //                         <li>배너를 삽입 할 쇼핑몰 사이트 주소를 입력 합니다.</li>
                                    //                         <li>입력한 쇼핑몰 사이트 주소 외에는 배너 호출이 불가능 합니다.</li>
                                    //                         <li>https://www.를 제외한 도매인 주소만 입력해 주세요.<br/>(예: https://www.domain.com 이면 domain.com 만 입력합니다.) </li>
                                    //                     </ul>
                                    //                     </font></div>
                                    //             </div>
                                    //         </div> 
                                    //         <div className="margin-vertical-auto flexBox" style={{width:"auto"}}>
                                    //             <input className="border_form_radius_b_h_42 border_form_radius_b_h_42_mobile" type="text" id="input_domain" name="input_domain" style={{width:"345px", height:"48px", minWidth:"110px", border:"0"}}></input>
                                    //             <div className="flexBox" style={{marginLeft:"10px", height:"48px"}}>
                                    //                 <button className="btn-auto-d" style={{height:"100%", lineHeight:"100%"}} onClick={e => this.onClickAddDomain(e)}>
                                    //                     입력한 도메인 추가   +
                                    //                 </button>
                                    //             </div>
                                    //         </div>
                                    //         <div style={{width: "100%"}}>
                                    //             {this.state.domain_list.map((domain, idx) => (
                                    //                 <div className="round_grey_flex_box" style={{marginRight:"10px"}}>
                                    //                     <div>{domain}</div>
                                    //                     <div className="m-l-15"></div>
                                    //                     <div className="btn_exit_grey cursor-pointer" onClick={(e) => this.domain_remove(e, domain)}></div>
                                    //                 </div>
                                    //             ))}
                                    //         </div>
                                    //         {/* <div className="margin-vertical-auto flexBox input_domain" style={{width:"78%"}}>
                                    //             <div className="flexBox" style={{width:"100%", height:"auto", border:"1px solid gray"}}>
                                    //                 {this.state.domain_list.map((domain,idx) => (
                                    //                     <div key={idx} className="domain_area" style={{width:"max-content", height: "36px", border:"1px solid #21a777", backgroundColor:"#21a777", color:"white", borderRadius:"10px", margin:"3px", padding:"3px 10px 3px 10px", lineHeight: "27px"}}>
                                    //                         {domain}
                                    //                         <span className="fa fa-close cursor-pointer" style={{marginLeft:"3px", color:"lightgrey"}} onClick={(e) => this.domain_remove(e, domain)}></span>
                                    //                     </div>
                                    //                 ))}
                                    //                 <input type="text" placeholder="domain.com" name="input_domain" onKeyDown={this.domain_handleKeyDown} onBlur={this.domain_focusout} style={{width:this.state.input_domain_width, minWidth:"110px", border:"0", margin:"3px"}}></input>
                                    //             </div>
                                    //         </div> */}
                                    //     </div>
                                }
                                    <div>
                                        {/* 디자인 노출 유형 설정 : cafe24 계정인 경우에만 설정 가능 */}
                                        {(
                                            /*
                                             * 기존 조건:
                                             * (this.state.solution_type_cd == '09001' || this.state.solution_type_cd == '09900')
                                             * && !(this.state.solution_type_cd == "09900" && this.state.roleType == "2221")
                                             */
                                            this.state.solution_type_cd == '09001'
                                        )
                                        &&
                                        <>
                                            <div className="flexBox eventSettingItemArea" style={{height: "auto"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width: "100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}><b>노출 유형</b></label>
                                                </div>
                                                <div style={{margin: "auto 0", marginBottom: "30px", fontSize: "13px"}}>
                                                    <b>원하는 노출 유형을 선택해 주세요.</b>
                                                </div>
                                                <div class="banner_radio_flexbox event_setting_content_radio event_setting_radio_auto_width">
                                                    {this.state.install_yn == "Y"
                                                    ?<>
                                                        {this.state.event_show_type_list.map((obj, idx) => (
                                                            <RadioButton
                                                                id={"event_show_type" + obj.code_cd}
                                                                name={"event_show_type"}
                                                                value={obj.code_cd}
                                                                checked={this.state.event_show_type == obj.code_cd}
                                                                disabled={true}
                                                            >
                                                                <div className="banner_radio_text">{obj.code_name}</div>
                                                            </RadioButton>
                                                        ))}
                                                        <span style={{width:"100%"}}>
                                                            <Alert type={"info"} text={"자동 배너 생성 설정이 설치된 경우, 노출 유형을 변경할 수 없어요. 변경을 원하시는 경우, 문의를 통해 요청해 주세요."}/>
                                                        </span>
                                                    </>
                                                    :<>
                                                        {this.state.event_show_type_list.map((obj, idx) => (
                                                            <RadioButton
                                                                id={"event_show_type" + obj.code_cd}
                                                                name={"event_show_type"}
                                                                value={obj.code_cd}
                                                                checked={this.state.event_show_type == obj.code_cd}
                                                                onChangeCheck={e => this.onChangeEventShowType(e.target.value)}
                                                            >
                                                                <div className="banner_radio_text">{obj.code_name}</div>
                                                            </RadioButton>
                                                        ))}
                                                    </>}
                                                </div>
                                            </div>
                                            {this.state.event_show_type == "70002" &&
                                            <>
                                                {/* 팝업 위치 설정 */}
                                                <div className="flexBox eventSettingItemArea" style={{height: "auto"}}>
                                                    <div className="margin-vertical-auto eventSettingTitle" style={{width: "100%"}}>
                                                        <label style={{marginTop: "auto", marginBottom: "15px"}}><b>팝업 위치</b></label>
                                                    </div>
                                                    <div style={{margin: "auto 0", marginBottom: "30px", fontSize: "13px"}}>
                                                        <b>화면에서 팝업이 나타나는 기준 위치를 선택해 주세요.</b>
                                                    </div>
                                                    <div
                                                        class="banner_radio_flexbox event_setting_content_radio event_setting_radio_auto_width popup_position_radio_area">
                                                        {this.state.popup_position_list.map((obj, idx) => (
                                                            <RadioButton
                                                                id={"popup_position" + obj.code_cd}
                                                                name={"popup_position"}
                                                                value={obj.code_cd}
                                                                checked={this.state.popup_position == obj.code_cd}
                                                                onChangeCheck={e => this.handleChange("popup_position", e.target.value)}
                                                            >
                                                                <div className="banner_radio_text" style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", lineHeight: 1}}>
                                                                    <div style={{marginBottom: "5px"}}>{obj.code_name}</div>
                                                                    <img src={obj.val2} style={{width: "100px", height: "100px", border: "1.5px solid rgb(219, 221, 228)", borderRadius: "5px"}}></img>
                                                                </div>
                                                            </RadioButton>
                                                        ))}
                                                    </div>
                                                </div>

                                                {/* 팝업 위치 이동 */}
                                                <div className="eventSettingItemArea" style={{display: "inline-block", height: "auto", marginBottom: "50px"}}>
                                                    <div className="margin-vertical-auto eventSettingTitle" style={{width: "100%"}}>
                                                        <label style={{marginTop: "auto", marginBottom: "15px"}}><b>팝업 위치 이동</b></label>
                                                    </div>
                                                    <div style={{margin: "auto 0", marginBottom: "30px", fontSize: "13px"}}>
                                                        <b>기준 위치에서 원하는 만큼 팝업을 이동해 주세요. (단위: px)</b>
                                                    </div>
                                                    <div className="flexBox" style={{border: "1.5px solid #DBDDE4", width:"auto", padding: "0 8px", justifyContent: "center"}}>
                                                        <div className="flexBox"
                                                        style={{
                                                            // position: "relative",
                                                            width: "120px",
                                                            height: "120px",
                                                            justifyContent: "center",
                                                            marginTop: "8px",
                                                            marginBottom: "8px",
                                                        }}>
                                                            <div
                                                                className="flexBox ie_position_relative"
                                                                style={{
                                                                    zIndex: 1,
                                                                    position: "absolute",
                                                                    alignSelf: "center"
                                                                }}>
                                                                <div
                                                                    className="btn_keypad_arrow_area"
                                                                    onClick={(e) => this.movePositionOnClick(e, "popup_position_left", "popup_position_right", 1)}/>
                                                                <div
                                                                    className="btn_keypad_center_area"
                                                                    onClick={(e) => this.moveImgPositionResetOnClick(e)}>
                                                                    <div
                                                                        className="btn_keypad_center_area_reset">
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className="btn_keypad_arrow_area"
                                                                    style={{transform: "rotate(180deg)"}}
                                                                    onClick={(e) => this.movePositionOnClick(e, "popup_position_right", "popup_position_left", 1)}/>
                                                            </div>
                                                            <div
                                                                className="flexBox ie_left_40px"
                                                                style={{
                                                                    zIndex: 0,
                                                                    flexDirection: "column",
                                                                    position: "absolute",
                                                                    alignSelf: "center"
                                                                }}>
                                                                <div
                                                                    className="btn_keypad_arrow_area"
                                                                    style={{transform: "rotate(90deg)"}}
                                                                    onClick={(e) => this.movePositionOnClick(e, "popup_position_top", "popup_position_bottom", 1)}/>
                                                                <div
                                                                    className="btn_keypad_center_area">
                                                                </div>
                                                                <div
                                                                    className="btn_keypad_arrow_area"
                                                                    style={{transform: "rotate(-90deg)"}}
                                                                    onClick={(e) => this.movePositionOnClick(e, "popup_position_bottom", "popup_position_top", 1)}/>
                                                            </div>
                                                        </div>
                                                        <div className="flexBox"
                                                        style={{
                                                            // position: "relative",
                                                            width: "120px",
                                                            height: "120px",
                                                            justifyContent: "center",
                                                            marginLeft: "20px",
                                                            marginTop: "8px",
                                                            marginBottom: "8px",
                                                        }}>
                                                            <div
                                                                className="flexBox ie_position_relative"
                                                                style={{
                                                                    zIndex: 1,
                                                                    position: "absolute",
                                                                    alignSelf: "center"
                                                                }}>
                                                                <div
                                                                    className="btn_keypad_number_area">
                                                                    <input
                                                                        className="numbersOnly input_banner_img_position"
                                                                        type="text"
                                                                        value={this.state["popup_position_left"]}
                                                                        onChange={e => this.setState({["popup_position_left"]: e.target.value})}
                                                                        onKeyPress={e => this.movePositionOnKeyPress(e)}
                                                                        onBlur={e => this.movePositionOnBlur(e, "popup_position_left", "popup_position_right")}
                                                                        />
                                                                </div>
                                                                <div
                                                                    className="btn_keypad_center_area"
                                                                    style={{cursor: "default"}}>

                                                                </div>
                                                                <div
                                                                    className="btn_keypad_number_area">
                                                                    <input
                                                                        className="numbersOnly input_banner_img_position"
                                                                        type="text"
                                                                        value={this.state["popup_position_right"]}
                                                                        onChange={e => this.setState({["popup_position_right"]: e.target.value})}
                                                                        onKeyPress={e => this.movePositionOnKeyPress(e)}
                                                                        onBlur={e => this.movePositionOnBlur(e, "popup_position_right", "popup_position_left")}
                                                                        />
                                                                </div>
                                                            </div>
                                                            <div
                                                                className="flexBox ie_left_40px"
                                                                style={{
                                                                    zIndex: 0,
                                                                    flexDirection: "column",
                                                                    position: "absolute",
                                                                    alignSelf: "center"
                                                                }}>
                                                                <div
                                                                    className="btn_keypad_number_area">
                                                                    <input
                                                                        className="numbersOnly input_banner_img_position"
                                                                        type="text"
                                                                        value={this.state["popup_position_top"]}
                                                                        onChange={e => this.setState({["popup_position_top"]: e.target.value})}
                                                                        onKeyPress={e => this.movePositionOnKeyPress(e)}
                                                                        onBlur={e => this.movePositionOnBlur(e, "popup_position_top", "popup_position_bottom")}
                                                                        />
                                                                </div>
                                                                <div
                                                                    className="btn_keypad_center_area"
                                                                    style={{cursor: "default"}}>

                                                                </div>
                                                                <div
                                                                    className="btn_keypad_number_area">
                                                                    <input
                                                                        className="numbersOnly input_banner_img_position"
                                                                        type="text"
                                                                        value={this.state["popup_position_bottom"]}
                                                                        onChange={e => this.setState({["popup_position_bottom"]: e.target.value})}
                                                                        onKeyPress={e => this.movePositionOnKeyPress(e)}
                                                                        onBlur={e => this.movePositionOnBlur(e, "popup_position_bottom", "popup_position_top")}
                                                                        />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* 팝업 차단 주기 설정 */}
                                                <div className="eventSettingItemArea popup_block_cycle_area" style={{height: "auto", zIndex: 4}}>
                                                    <div className="margin-vertical-auto eventSettingTitle" style={{width: "100%"}}>
                                                        <label style={{marginTop: "auto", marginBottom: "15px"}}><b>팝업 차단 주기</b></label>
                                                    </div>
                                                    <div style={{margin: "auto 0", marginBottom: "30px", fontSize: "13px"}}>
                                                        <b>일정 주기 동안 다시 노출되지 않도록 옵션을 선택해 주세요.</b>
                                                    </div>
                                                    <div style={{marginBottom: "50px"}}>
                                                    <div style={{maxWidth: "250px", width: "100%"}}>
                                                        <Select
                                                            className={"react-select"}
                                                            defaultValue={this.state.popup_block_cycle_list.find(obj => obj.code_cd == this.state.popup_block_cycle)}
                                                            value={this.state.popup_block_cycle_list.find(obj => obj.code_cd == this.state.popup_block_cycle)}
                                                            components={animatedComponents}
                                                            placeholder={"옵션을 선택해 주세요"}
                                                            getOptionValue={(option) => option.code_cd}
                                                            getOptionLabel={(option) => option.val1}
                                                            noOptionsMessage={() => "없음"}
                                                            options={this.state.popup_block_cycle_list}
                                                            onChange={option => this.onChangePopupBlockCycle(option.code_cd)}
                                                            styles={reactSelectStyles()}
                                                        />
                                                    </div>
                                                        {
                                                            this.state.popup_block_cycle == "72007"
                                                            && <>
                                                                <div lassName="flexBox" style={{marginTop: "10px", fontSize:"14px", alignItems:"center"}}>
                                                                    <span style={{marginRight:"5px"}}>팝업 차단 일 입력 :</span> 
                                                                    <input style={{width:"60px", textAlign: "center"}} className="border_form_radius_b_h_42 popup_input" type="text" value={this.state.popup_block_cycle_day} placeholder="1" onChange={e => this.onChangePopupBlockCycleDay(e)} maxLength="3"></input> 일
                                                                </div>
                                                                <div lassName="flexBox" style={{marginTop: "10px", fontSize:"14px", alignItems:"center"}}>
                                                                    <span style={{marginRight:"5px"}}>팝업 차단 문구 입력 :</span> 
                                                                    <input style={{flex:1}} className="border_form_radius_b_h_42 popup_input" type="text" value={this.state.popup_block_cycle_title} placeholder="오늘 하루 보지 않기" onChange={e => this.onChangePopupBlockCycleTitle(e)}></input>
                                                                </div>
                                                            </>
                                                        }
                                                    </div>
                                                </div>

                                                {/* 팝업 닫기 문구 설정 */}
                                                {
                                                    this.state.popup_position != "71003"
                                                    &&  <div className="eventSettingItemArea popup_block_cycle_area" style={{height: "auto"}}>
                                                            <div className="margin-vertical-auto eventSettingTitle" style={{width: "100%"}}>
                                                                <label style={{marginTop: "auto", marginBottom: "15px"}}><b>팝업 닫기 버튼</b></label>
                                                            </div>
                                                            <div style={{margin: "auto 0", marginBottom: "30px", fontSize: "13px"}}>
                                                                <b>닫기 버튼의 문구를 무엇으로 할지 선택해 주세요.</b>
                                                            </div>
                                                            <div style={{marginBottom: "50px"}}>
                                                            <div style={{maxWidth: "250px", width: "100%"}}>
                                                                <Select
                                                                    className={"react-select"}
                                                                    defaultValue={this.state.popup_close_btn_title_list.find(obj => this.state.popup_close_btn_title_cd ? (obj.code_cd == this.state.popup_close_btn_title_cd) : "74001")}
                                                                    value={this.state.popup_close_btn_title_list.find(obj => this.state.popup_close_btn_title_cd ? (obj.code_cd == this.state.popup_close_btn_title_cd) : "74001")}
                                                                    components={animatedComponents}
                                                                    placeholder={"옵션을 선택해 주세요"}
                                                                    getOptionValue={(option) => option.code_cd}
                                                                    getOptionLabel={(option) => option.val1}
                                                                    noOptionsMessage={() => "없음"}
                                                                    options={this.state.popup_close_btn_title_list}
                                                                    onChange={option => this.onChangePopupCloseBtnTitleCd(option.code_cd)}
                                                                    styles={reactSelectStyles()}
                                                                />
                                                            </div>
                                                                {
                                                                    this.state.popup_close_btn_title_cd == "74008"
                                                                    && <div className="flexBox" style={{maxWidth: "340px", width: "100%", marginTop: "15px", alignItems:"center", fontSize:"14px"}}>
                                                                        <span style={{marginRight:"5px"}}>닫기 문구 입력 :</span> 
                                                                        <input style={{flex:1}} className="border_form_radius_b_h_42 popup_input" type="text" value={this.state.popup_close_btn_title} placeholder="닫기 버튼에 사용할 문구를 입력하세요." onChange={e => this.onChangePopupCloseBtnTitle(e)}></input>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                }

                                                {/* 노출 대기 시간 */}
                                                <div className="flexBox eventSettingItemArea" style={{height: "auto"}}>
                                                    <div className="margin-vertical-auto eventSettingTitle" style={{width: "100%"}}>
                                                        <label style={{marginTop: "auto", marginBottom: "15px"}}><b>노출 대기 시간</b></label>
                                                    </div>
                                                    <div style={{margin: "auto 0", marginBottom: "30px", fontSize: "13px"}}>
                                                        <b>팝업을 바로 보여줄지, 일정 시간 후에 보여줄지 선택해 주세요.</b>
                                                    </div>
                                                    <div
                                                        class="banner_radio_flexbox event_setting_content_radio event_setting_radio_auto_width popup_delay_time_area" style={{display:"block"}}>
                                                        {this.state.popup_delay_type_list.map((obj, idx) => (
                                                            <RadioButton
                                                                id={"popup_delay_type_cd_" + obj.code_cd}
                                                                name={"popup_delay_type_cd"}
                                                                value={obj.code_cd}
                                                                checked={this.state.popup_delay_type_cd == obj.code_cd}
                                                                onChangeCheck={e => this.handleChange("popup_delay_type_cd", e.target.value)}
                                                            >
                                                                <div className='flexBox' style={{height: "30px", alignContent:"center"}}>
                                                                    <div className="banner_radio_text" style={{width: "45px", marginLeft: "8px", marginRight: "0px", fontSize: "15px"}}>{obj.code_name}</div>
                                                                    {
                                                                        obj.code_cd > "75001" && this.state.popup_delay_type_cd > "75001" && obj.code_cd == this.state.popup_delay_type_cd
                                                                        && <div className="banner_radio_text flexBox" style={{fontSize: "15px", alignContent:"center"}}>  
                                                                        <input style={{width:"58px", height:"30px"}} className="border_form_radius_b_h_42 popup_input" type="text" value={this.state.popup_delay_time} maxLength="3" placeholder="" onChange={e => this.onChangePopupDelayTime(e)}></input>
                                                                        <div style={{marginLeft: "8px", display: "flex", alignItems: "center"}}>{obj.val1+" "}동안 기다립니다.</div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </RadioButton>
                                                        ))}
                                                    </div>
                                                </div>
                                                
                                                {/* 노출 대상 설정 */}
                                                {
                                                    this.state.solution_type_cd == "09001" &&
                                                    <div className="flexBox eventSettingItemArea" style={{height: "auto"}}>
                                                        <div className="margin-vertical-auto eventSettingTitle" style={{width: "100%"}}>
                                                            <label style={{marginTop: "auto", marginBottom: "15px"}}><b>노출 대상</b></label>
                                                        </div>
                                                        <div style={{margin: "auto 0", marginBottom: "30px", fontSize: "15px"}}>
                                                            <b>팝업을 노출하고 싶은 대상을 선택해 주세요.</b>
                                                        </div>
                                                        <div
                                                            class="banner_radio_flexbox event_setting_content_radio event_setting_radio_auto_width" style={{display:"block"}}>
                                                            {this.state.popup_target_type_list.map((obj, idx) => (
                                                                <>
                                                                    <RadioButton
                                                                        className={"useToolTip"}
                                                                        id={"popup_target_type" + obj.code_cd}
                                                                        name={"popup_target_type"}
                                                                        value={obj.code_cd}
                                                                        checked={this.state.popup_target_type == obj.code_cd}
                                                                        onChangeCheck={e => this.onChangePopupTargetType(e.target.value)}
                                                                    >
                                                                        {obj.code_cd == "73002" &&
                                                                            <div className="eventSettingTargetViewLabel">타겟뷰</div>
                                                                        }
                                                                        <div className="banner_radio_text" style={{marginRight: "8px", whiteSpace: "nowrap"}}>
                                                                            {obj.code_name}
                                                                            {obj.code_cd == "73001" && <font style={{color:"#00E2E6"}}>{this.state.event_item_user_type == "15002" ? "(회원/비회원 기준)" : "(전체고객 기준)"}</font>}
                                                                        </div>
                                                                        {obj.code_cd == "73002" &&
                                                                        <>
                                                                            <img src={crown_icon} style={{width:"18px", height:"18px", marginRight:"6px"}}/>
                                                                            <Tooltip
                                                                                zIndex={2}
                                                                                iconWidth={22.2}
                                                                                iconHeight={22.2}
                                                                                squareMoveLeft={this.state.innerWidth < 400 ? 20 : 0}
                                                                                content={"세분화된 고객 분류 기준 설정 기능을 통해 로보MD에서 생성한 콘텐츠를 원하는 고객별로 맞춤 노출하는 타겟 마케팅이 가능한 서비스에요."}
                                                                            />
                                                                            <div style={{color: "#ACACAC", fontSize: "12px", marginLeft:"2px", whiteSpace: "nowrap"}}>타겟뷰란?</div>
                                                                        </>}
                                                                    </RadioButton>
                                                                </>
                                                            ))}
                                                            {this.state.popup_target_type == "73002" && this.state.is_use_target_view_service == "Y" &&
                                                                (this.state.target_view_list.length > 0
                                                                ?<>
                                                                    <div style={{maxWidth: "500px", width: "100%", marginBottom: "10px"}}>
                                                                        <Select
                                                                            className={"react-select"}
                                                                            value={this.state.popup_target_view_list}
                                                                            closeMenuOnSelect={false}
                                                                            isMulti
                                                                            components={animatedComponents}
                                                                            placeholder={"타겟을 선택해 주세요"}
                                                                            getOptionValue={(option) => option.target_view_seq}
                                                                            getOptionLabel={(option) => option.title}
                                                                            noOptionsMessage={() => "없음"}
                                                                            options={this.state.target_view_list}
                                                                            onChange={selectedOption => this.onChangeTargetViewSelect(selectedOption)}
                                                                            styles={reactSelectStyles()}
                                                                        />
                                                                    </div>
                                                                    <span style={{width:"100%"}}>
                                                                        <Alert type={"info"} text={"설정한 조건에 포함되는 고객이 없는 경우, 팝업이 노출되지 않으니 주의해 주세요."}/>
                                                                    </span>
                                                                </>
                                                                :<>
                                                                    <div style={{display:"flex", width:"100%", fontSize:"15px", alignItems: "center"}}>
                                                                        <div style={{marginRight:"10px"}}>아직 등록된 타겟이 없어요.<br/>타겟을 설정하고 나의 콘텐츠를 노출해 보세요.</div>
                                                                        <Button fontSize={"14px"} width={"120px"} height={"36px"} onClick={this.goTargetViewSetting}>
                                                                            타겟 설정하기
                                                                        </Button>
                                                                    </div>
                                                                    <div style={{display:"flex", width:"100%", fontSize:"15px", marginTop:"20px", alignItems: "center"}}>
                                                                        <div style={{marginRight:"10px"}}>타겟 설정 이후 버튼을 눌러 주세요.</div>
                                                                        <Button type={"hover_white"} fontSize={"12px"} width={"80px"} height={"24px"} onClick={this.getTargetViewList}>
                                                                            <div style={{display: "flex", justifyContent: "center", alignItems: "center", color:"#3a3a3a", paddingTop:"1px"}}>
                                                                                <img src={curved_arrow_right} style={{width:"14px", height:"14px", marginRight: "4px", marginBottom:"1px"}}/>
                                                                                새로고침
                                                                            </div>
                                                                        </Button>
                                                                    </div>
                                                                </>
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                }

                                                

                                            </>}
                                            <div className="lightGreyLine" 
                                            style={{borderTop: "1px solid rgba(0, 0, 0, 0.12)",
                                                    width: "100%",
                                                    marginBottom: "35px",
                                                    marginTop: "-16px"}}></div>
                                        </>
                                        }

                                        {
                                            /* 기존 조건: !(this.state.solution_type_cd == "09900" && this.state.roleType == "2221") */
                                            this.state.solution_type_cd != "09900" &&
                                            <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"30px"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%", lineHeight:"2rem"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}><b>적용 페이지 선택</b></label>
                                                    <div className="fa fa-question-circle margin-l-10">
                                                        <div className="question-hover-area">
                                                            <font style={{fontSize:"14px",  lineHeight:"15px", wordBreak:"keep-all"}}>
                                                                어느 페이지에 배너를 적용 할 것인지 선택합니다.<br/>
                                                                ※ 한 번 저장 후 변경이 불가능합니다.
                                                            </font>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        {this.state.is_iframe_page_id_loaded != null && this.state.is_iframe_page_id_loaded == true
                                                            ?   <select id="iframe_page_id" className="border_form_radius_b_h_42 border_form_radius_b_h_42_mobile" style={{width:"345px", padding:"5px", backgroundPositionX: "94%", backgroundColor:'#efefefef'}}  value={this.state.iframe_page_id} onChange={e => this.onChangeIframePageId(e)} disabled>
                                                                <option value="" disabled>
                                                                    로보 배너를 적용할 페이지를 선택해 주세요.
                                                                </option>
                                                                {this.state.iframe_page_name_list.map((obj, idx) => (
                                                                    <option key={idx} value={obj.code_name}>
                                                                        {obj.val1}
                                                                    </option>
                                                                ))}
                                                                {/* <option value={"robomd_category_page"}>
                                                                    {"카테고리 페이지"}
                                                            </option> */}
                                                            </select>
                                                            :   <select id="iframe_page_id" className="border_form_radius_b_h_42 border_form_radius_b_h_42_mobile" style={{width:"345px", padding:"5px", backgroundPositionX: "94%"}}  value={this.state.iframe_page_id} onChange={e => this.onChangeIframePageId(e)}>
                                                                <option value="" disabled>
                                                                    로보 배너를 적용할 페이지를 선택해 주세요.
                                                                </option>
                                                                {this.state.iframe_page_name_list.map((obj, idx) => (
                                                                    <option key={idx} value={obj.code_name}>
                                                                        {obj.val1}
                                                                    </option>
                                                                ))}
                                                                {/* <option value={"robomd_category_page"}>
                                                                    {"카테고리 페이지"}
                                                            </option> */}
                                                            </select>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    {this.state.solution_type_cd != '09900' &&
                                        this.state.iframe_page_id == "robomd_category_page"
                                        ?   <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"30px"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%", lineHeight:"2rem"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}><b>적용 카테고리 페이지 선택</b></label>
                                                    <div className="fa fa-question-circle margin-l-10">
                                                        <div className="question-hover-area">
                                                            <font style={{fontSize:"14px",  lineHeight:"15px", wordBreak:"keep-all"}}>
                                                                어느 카테고리 페이지에 배너를 적용 할 것인지 선택합니다.<br/>
                                                                '하위 카테고리 전체' 항목이 비활성화 된 경우 하위 카테고리중에 이미 선택된 카테고리가 있는 경우 입니다.
                                                            </font>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <select id="category_page_1" className="border_form_radius_b_h_42" style={{width:"260px", padding:"5px"}} onChange={e => this.onChangeCategoryForPage(e,2)}
                                                            value={this.state.category_page_1}
                                                        >
                                                        <option value="" disabled>
                                                            카테고리 페이지를 선택해 주세요.
                                                        </option> 
                                                        {this.state.page_category_list_1 != null && this.state.page_category_list_1.map((obj, idx) => (
                                                                obj.is_duplicate_category == "Y"
                                                                ?   <option key={idx} value={obj.category_no} disabled>
                                                                        {obj.category_name_no_format}
                                                                    </option>
                                                                :   <option key={idx} value={obj.category_no}>
                                                                        {obj.category_name_no_format}
                                                                    </option>
                                                        ))}
                                                        </select>
                                                        {
                                                            this.state.page_category_list_2 != null && this.state.page_category_list_2.length > 0
                                                            ?   <select id="category_page_2" className="border_form_radius_b_h_42" style={{width:"260px", padding:"5px", marginLeft:"10px"}} onChange={e => this.onChangeCategoryForPage(e,3)}
                                                                        value={this.state.category_page_2}
                                                                >
                                                                {
                                                                    this.state.parent_category_idx != null && this.state.is_child_duplicate_category_2 == "Y"
                                                                    ?   <option value="" disabled>
                                                                            하위 카테고리 전체
                                                                        </option> 
                                                                    :   <option value="">
                                                                            하위 카테고리 전체
                                                                        </option> 
                                                                }
                                                                
                                                                {this.state.page_category_list_2 != null && this.state.page_category_list_2.map((obj, idx) => (
                                                                    obj.is_duplicate_category == "Y"
                                                                    ?   <option key={idx} value={obj.category_no} disabled>
                                                                            {obj.category_name_no_format} 
                                                                        </option>
                                                                    :   <option key={idx} value={obj.category_no}>
                                                                            {obj.category_name_no_format}
                                                                        </option>                            
                                                                ))}
                                                                </select>
                                                            : ""
                                                        }
                                                        {
                                                            this.state.page_category_list_3 != null && this.state.page_category_list_3.length > 0
                                                            ?   <select id="category_page_3" className="border_form_radius_b_h_42" style={{width:"260px", padding:"5px", marginLeft:"10px"}} onChange={e => this.onChangeCategoryForPage(e,4)}
                                                                        value={this.state.category_page_3}
                                                                >
                                                                {
                                                                    this.state.parent_category_idx != null && this.state.is_child_duplicate_category_3 == "Y"
                                                                    ?   <option value="" disabled>
                                                                            하위 카테고리 전체
                                                                        </option> 
                                                                    :   <option value="">
                                                                            하위 카테고리 전체
                                                                        </option> 
                                                                }
                                                                {this.state.page_category_list_3 != null && this.state.page_category_list_3.map((obj, idx) => (
                                                                    obj.is_duplicate_category == "Y"
                                                                    ?   <option key={idx} value={obj.category_no} disabled>
                                                                            {obj.category_name_no_format}
                                                                        </option>
                                                                    :   <option key={idx} value={obj.category_no}>
                                                                            {obj.category_name_no_format}
                                                                        </option>                            
                                                                ))}
                                                                </select>
                                                            : ""    
                                                        }
                                                        {   
                                                            this.state.page_category_list_4 != null && this.state.page_category_list_4.length > 0
                                                            ?   <select id="category_page_4" className="border_form_radius_b_h_42" style={{width:"260px", padding:"5px", marginLeft:"10px"}} onChange={e => this.onChangeCategoryForPage(e,5)}
                                                                        value={this.state.category_page_4}
                                                                >
                                                                {
                                                                    this.state.parent_category_idx != null && this.state.is_child_duplicate_category_4 == "Y"
                                                                    ?   <option value="" disabled>
                                                                            하위 카테고리 전체
                                                                        </option> 
                                                                    :   <option value="">
                                                                            하위 카테고리 전체
                                                                        </option> 
                                                                }
                                                                {this.state.page_category_list_4 != null &&  this.state.page_category_list_4.map((obj, idx) => (
                                                                    obj.is_duplicate_category == "Y"
                                                                    ?   <option key={idx} value={obj.category_no} disabled>
                                                                            {obj.category_name_no_format}
                                                                        </option>
                                                                    :   <option key={idx} value={obj.category_no}>
                                                                            {obj.category_name_no_format}
                                                                        </option>                            
                                                                ))}
                                                                </select>
                                                            : ""
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        :   ""
                                    }
                                </div>
                                <div>
                                    <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"30px"}}>
                                        <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%", lineHeight:"2rem"}}>
                                            <label style={{marginTop: "auto", marginBottom: "15px"}}><b>
                                                {
                                                    /* 기존 조건: this.state.solution_type_cd == "09900" && this.state.roleType == "2221" */
                                                    this.state.solution_type_cd == "09900"
                                                    ? "제목"
                                                    : "배너영역명"
                                                }
                                            </b></label>
                                            <div className="fa fa-question-circle margin-l-10">
                                                <div className="question-hover-area">
                                                    <font style={{fontSize:"14px",  lineHeight:"15px", wordBreak:"keep-all"}}>
                                                        로보배너 명칭을 설정합니다.<br/>
                                                        여러 영역의 배너를 사용할 경우 로보배너 명칭을 이용해 쉽게 찾을 수 있습니다.
                                                    </font>
                                                </div>
                                            </div>
                                            <div>
                                                <input className="border_form_radius_b_h_42 border_form_radius_b_h_42_mobile" type="text" style={{width:"345px", height:"48px", minWidth:"110px", border:"0"}} value={this.state.iframe_html_name} onChange={e => this.onChangeIframeHtmlName(e)}></input>
                                            </div> 
                                        </div>
                                    </div>
                                </div>

                                <div className="flexBox" style={{marginTop:"1%"}}>
                                    <div className="bannerTypeImg eventSettingItemArea bannerSizeArea" style={{height:"auto", borderLeft: "0px", marginRight:"20px"}}>
                                        <div className="eventSettingTitle" style={{width: "100%",height:"36px"}}>
                                            <label style={{marginTop: "0px", marginBottom: "15px"}}>
                                            <b>
                                                {
                                                    this.state.solution_type_cd == "09900"
                                                    ? (this.state.single_size ? "사이즈" : "사이즈 1")
                                                    : (this.state.single_size ? "배너 사이즈" : "배너 사이즈 1 (예 PC 가로형)")
                                                }
                                            </b>
                                            </label>
                                            <div className="fa fa-question-circle margin-l-10">
                                                <div className="question-hover-area"><font style={{fontSize:"14px",  lineHeight:"15px", wordBreak:"keep-all"}}>원하시는 {
                                                    this.state.solution_type_cd == "09900" ? "사이즈" : "배너 사이즈"}를 입력해 주세요.</font></div>
                                            </div>
                                        </div>
                                        {/* <div className="flexBox" style={{width:"100%", flex:"1.5%"}}>
                                            <div className="flexBox" style={{width:"auto"}}>
                                                <select id="event_banner_pc_width" className="border_form_radius_b_h_42" style={{width:"150px", padding:"5px"}} onChange={this.handlePcSizeChange}>
                                                {this.state.pcBannerSizeList != null ?
                                                    this.state.pcBannerSizeList.map((pcSize,idx) => (
                                                        <option key={idx} value={pcSize.code_name}>
                                                            {pcSize.val1}
                                                        </option>
                                                    )) : null
                                                }
                                                </select>
                                            </div>
                                        </div> */}
                                        {
                                            this.state.is_custom_pc_banner_size
                                            ? <div>
                                                <div className="flexBox m-t-15" style={{maxWidth:"fit-content"}}>
                                                    <div style={{flex:"1", marginRight:"10px"}}>
                                                        <input id="pcHorizontalInputText" style={{width:"100%"}} className="border_form_radius_b_h_42" type="text" value={this.state.event_banner_pc_width} placeholder="가로" onChange={e => this.onChangeBannerSize(e, "hrizontal")} onBlur={() => this.onBlurBannerSizeText()}>

                                                        </input>
                                                    </div>   
                                                    <div style={{height: "100%",margin: "auto"}}>
                                                        <font style={{fontSize:"18px"}}>×</font>
                                                    </div>   
                                                    <div style={{flex:"1", marginLeft:"10px"}}>
                                                        <input id="pcVerticalInputText" style={{width:"100%"}} className="border_form_radius_b_h_42" type="text"  value={this.state.event_banner_pc_height} placeholder="세로" onChange={e => this.onChangeBannerSize(e, "vertical")} onBlur={() => this.onBlurBannerSizeText()}>

                                                        </input>
                                                    </div>   
                                                </div>
                                                {Boolean(this.state.event_banner_pc_width && this.state.event_banner_pc_height && Number(this.state.event_banner_pc_width) > 0 && Number(this.state.event_banner_pc_height) > 0)
                                                && <div className="flexBox m-t-15" style={{flexWrap:"nowrap"}}>
                                                        <div className="icn_warning_round_blue" style={{margin: "0"}}>
                                                        </div>
                                                        &nbsp;&nbsp;
                                                        <div style={{flex:1, fontSize:"14px",  lineHeight:"15px", wordBreak:"keep-all"}}>
                                                            <b>{`${Number(this.state.event_banner_pc_width) > Number(this.state.event_banner_pc_height) ? "가로" : "세로"}형 ${this.state.solution_type_cd == "09900" ? "사이즈" : "배너 사이즈"}입니다.`}</b>
                                                        </div>
                                                    </div>
                                                    }
                                            </div>
                                            : ""
                                        }
                                    </div>
                                    
                                    {!this.state.single_size &&
                                        <div className="bannerTypeImg eventSettingItemArea bannerSizeArea" style={{height:"auto", borderLeft: "0px"}}>
                                            <div className="eventSettingTitle" style={{width: "100%",height:"36px"}}>
                                                <label style={{marginTop: "0px", marginBottom: "15px"}}>
                                                    <b>{this.state.solution_type_cd == "09900" ? "사이즈 2" : "배너 사이즈 2 (예 mobile 세로형)"}</b>
                                                </label>
                                                <div className="fa fa-question-circle margin-l-10">
                                                    <div className="question-hover-area"><font style={{fontSize:"14px",  lineHeight:"15px", wordBreak:"keep-all"}}>원하시는 {this.state.solution_type_cd == "09900" ? "사이즈" : "배너 사이즈"}를 입력해 주세요.</font></div>
                                                </div>
                                            </div>
                                            {/* <div className="flexBox" style={{width:"100%", flex:"1.5%"}}>
                                                <div className="flexBox" style={{width:"auto"}}>
                                                    <select id="event_banner_mobile_width" className="border_form_radius_b_h_42" style={{width:"150px", padding:"5px"}} onChange={this.handleMobileSizeChange}>
                                                    { this.state.mobileBannerSizeList != null ?
                                                        this.state.mobileBannerSizeList.map((mobileSize,idx) => (
                                                            <option key={idx} value={mobileSize.code_name}>
                                                                {mobileSize.val1}
                                                            </option>
                                                        )) : null
                                                    }
                                                    </select>
                                                </div>
                                            </div> */}
                                            {
                                                this.state.is_custom_mobile_banner_size
                                                ? <div>
                                                    <div className="flexBox m-t-15" style={{maxWidth:"fit-content"}}>
                                                        <div style={{flex:"1", marginRight:"10px"}}>
                                                            <input id="mobileHorizontalInputText" style={{width:"100%"}} className="border_form_radius_b_h_42" type="text" value={this.state.event_banner_mobile_width} placeholder="가로" onChange={e => this.onChangeMobileBannerSize(e, "hrizontal")} onBlur={() => this.onBlurBannerSizeText()}>

                                                            </input>
                                                        </div>   
                                                        <div style={{height: "100%",margin: "auto"}}>
                                                            <font style={{fontSize:"18px"}}>×</font>
                                                        </div>   
                                                        <div style={{flex:"1", marginLeft:"10px"}}>
                                                            <input id="mobileVerticalInputText" style={{width:"100%"}} className="border_form_radius_b_h_42" type="text"  value={this.state.event_banner_mobile_height} placeholder="세로" onChange={e => this.onChangeMobileBannerSize(e, "vertical")} onBlur={() => this.onBlurBannerSizeText()}>

                                                            </input>
                                                        </div>   
                                                    </div>
                                                    {Boolean(this.state.event_banner_mobile_width && this.state.event_banner_mobile_height && Number(this.state.event_banner_mobile_width) > 0 && Number(this.state.event_banner_mobile_height) > 0)
                                                    && <div className="flexBox m-t-15" style={{flexWrap:"nowrap"}}>
                                                            <div className="icn_warning_round_blue" style={{margin: "0"}}>
                                                            </div>
                                                            &nbsp;&nbsp;
                                                            <div style={{flex:1, fontSize:"14px",  lineHeight:"15px", wordBreak:"keep-all"}}>
                                                            <b>{`${Number(this.state.event_banner_mobile_width) > Number(this.state.event_banner_mobile_height) ? "가로" : "세로"}형 배너 사이즈 입니다.`}</b>
                                                            </div>
                                                        </div>}
                                                </div>
                                                : ""
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                        :   ""
                    }
                    {this.state.solution_type_cd != '09900' &&
                        Number(this.state.step) == 1
                        ?   <div>
                                <div className="flexBox">
                                    <div className="form_primary_title" style={{marginRight: "20px"}}>
                                        일정
                                    </div>
                                    <div className="userGuideButton" 
                                         onClick={(e) => Menu.call_userGuide('https://www.notion.so/iclave/4-8e2c8f9db1804792bdf78e70fff0d2aa#31d8b16244984adcb05aff704e64cc86')}
                                         style={{height: "25px", margin:"auto 0 auto 0"}}
                                    >
                                        <span>사용자 가이드</span>
                                    </div>
                                    <div className="userGuideButtonMobile" 
                                         onClick={(e) => Menu.call_userGuide('https://www.notion.so/iclave/4-8e2c8f9db1804792bdf78e70fff0d2aa#31d8b16244984adcb05aff704e64cc86')} 
                                         style={{height: "25px", margin:"auto 0 auto 0", float:'right'}}
                                    >
                                        <span>?</span>
                                    </div>
                                </div>
                                <div className="flexBox eventSettingItemArea m-t-43" style={{height:"auto", marginBottom:"20px"}}>
                                    <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%", lineHeight:"2rem"}}>
                                        <label style={{marginTop: "auto", marginBottom: "15px"}}><b>배너 생성 주기</b></label>
                                        <div className="fa fa-question-circle margin-l-10">
                                            <div className="question-hover-area">
                                                <font style={{fontSize:"14px",  lineHeight:"15px", wordBreak:"keep-all"}}>
                                                    {/* <ul style={{paddingLeft:"20px",fontSize:"14px", lineHeight:"15px", wordBreak:"keep-all"}}> */}
                                                        {/* <li> */}
                                                            몇일에 한 번 씩 배너를 생성 할 것인지 선택합니다.
                                                        {/* </li> */}
                                                    {/* </ul> */}
                                                </font>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="margin-vertical-auto flexBox" style={{width:"auto"}}>
                                        <div style={{width:"150px"}}>
                                            <DatePicker name="start_date" id="start_date" className="border_form_radius_b_h_42"
                                                selected={this.state.start_date}
                                                onSelect={this.handleSelect} //when day is clicked
                                                onChange={this.handleChangeStartDate} //only when value has changed
                                                placeholderText="시작일자"
                                                // showTimeSelect
                                                minDate={moment().add(1,'days').toDate()}
                                                maxDate={new Date("9999-12-31")}
                                                dateFormat="yyyy-MM-dd"
                                                autoComplete='off'
                                            />
                                            
                                        </div>
                                        <div style={{margin:"auto 15px"}}>
                                            부터
                                        </div>
                                        <div className="flexBox flexButton" id="event_cycle">
                                            <div className="greyBackgroundBox_r_8" id="event_cycle_1" onClick={(e) => this.handleEventCycleClick(e, 1)}>1일</div>
                                            <div className="greyBackgroundBox_r_8 m-l-10" id="event_cycle_3" onClick={(e) => this.handleEventCycleClick(e, 3)}>3일</div>
                                            <div className="greyBackgroundBox_r_8 m-l-10" id="event_cycle_5" onClick={(e) => this.handleEventCycleClick(e, 5)}>5일</div>
                                            <div className="greyBackgroundBox_r_8 m-l-10" id="event_cycle_7" onClick={(e) => this.handleEventCycleClick(e, 7)}>7일</div>
                                            <div className="greyBackgroundBox_r_8 m-l-10" id="event_cycle_14" onClick={(e) => this.handleEventCycleClick(e, 14)}>14일</div>
                                            <div className="greyBackgroundBox_r_8 m-l-10" id="event_cycle_30" onClick={(e) => this.handleEventCycleClick(e, 30)}>1개월</div>
                                        </div>
                                        <div style={{margin:"auto 15px"}}>
                                            간격으로 배너 생성
                                        </div>
                                    </div>
                                </div>
                                <div className="flexBox" style={{marginBottom:"50px"}}>
                                    <div className="icn_warning_round_blue" style={{margin:"auto 0"}}></div>
                                    &nbsp;&nbsp;
                                    <div style={{margin:"auto 0", fontSize: "13px"}}><b>생성 주기는 진열 기간보다 짧아야 합니다.</b></div>
                                </div>      

                                <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                    <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%", lineHeight:"2rem"}}>
                                        <label style={{marginTop: "auto", marginBottom: "15px"}}><b>배너 생성 시간</b></label>
                                        <div className="fa fa-question-circle margin-l-10">
                                            <div className="question-hover-area">
                                                <font style={{fontSize:"14px",  lineHeight:"15px", wordBreak:"keep-all"}}>
                                                    {/* <ul style={{paddingLeft:"20px",fontSize:"14px", lineHeight:"15px", wordBreak:"keep-all"}}> */}
                                                        {/* <li> */}
                                                            배너 생성 주기의 몇시에 배너를 생성 할 것인지 선택합니다.
                                                        {/* </li> */}
                                                    {/* </ul> */}
                                                </font>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flexBox margin-vertical-auto" style={{width:"auto"}}>
                                        {/* <div style={{marginTop: "auto", marginBottom: "auto"}}>
                                            <input type="radio" className="radio_ampm" name="am" id="am" value="am" onClick={this.onClickAmPm}/> 오전
                                            <input type="radio" className="radio_ampm" name="pm" id="pm" value="pm" onClick={this.onClickAmPm}/> 오후
                                        </div> */}
                                        <div style={{marginTop: "auto", marginBottom: "auto"}}>
                                            <select id="event_time" className="border_form_radius_b_h_42" style={{width:"150px", padding:"5px"}} onChange={this.handleTimeChange} value={this.state.event_time}>
                                                {/* <option value="12">
                                                    12:00
                                                </option>
                                                <option value="1">
                                                    01:00
                                                </option>
                                                <option value="2">
                                                    02:00
                                                </option>
                                                <option value="3">
                                                    03:00
                                                </option>
                                                <option value="4">
                                                    04:00   
                                                </option>
                                                <option value="5">
                                                    05:00
                                                </option>
                                                <option value="6">
                                                    06:00
                                                </option>
                                                <option value="7">
                                                    07:00
                                                </option>
                                                <option value="8">
                                                    08:00
                                                </option>
                                                <option value="9">
                                                    09:00
                                                </option>
                                                <option value="10">
                                                    10:00
                                                </option>
                                                <option value="11">
                                                    11:00   
                                                </option> */}
                                                {
                                                    this.state.hour_list.map((obj, idx) => (
                                                        <option key={idx} value={obj.key}>
                                                            {obj.hour}
                                                        </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                    <div className="margin-vertical-auto eventSettingTitle" style={{width: "100%",}}>
                                        <label style={{marginTop: "auto", marginBottom: "15px"}}><b>생성주기</b></label>
                                    </div>
                                    <div className="margin-vertical-auto" style={{width:"auto"}}>
                                        <select id="event_cycle" className="border_form_radius_b_h_42" style={{width:"150px", padding:"5px"}} onChange={this.handleCycleChange}>
                                            <option value="0">
                                                반복안함
                                            </option>
                                            <option value="1">
                                                하루에 한번
                                            </option>
                                            <option value="2">
                                                2일에 한번
                                            </option>
                                            <option value="3">
                                                3일에 한번
                                            </option>
                                            <option value="7">
                                                1주일에 한번
                                            </option>
                                            <option value="14">
                                                2주일에 한번
                                            </option>
                                        </select>
                                    </div>
                                </div> */}
                                <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                    <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%", lineHeight:"2rem"}}>
                                        <label style={{marginTop: "auto", marginBottom: "15px"}}><b>배너 진열 기간</b></label>
                                        <div className="fa fa-question-circle margin-l-10">
                                            <div className="question-hover-area">
                                                <font style={{fontSize:"14px",  lineHeight:"15px", wordBreak:"keep-all"}}>
                                                    {/* <ul style={{paddingLeft:"20px",fontSize:"14px", lineHeight:"15px", wordBreak:"keep-all"}}>
                                                        <li> */}
                                                            한 번 생성된 배너를 며칠간 진열 할 것인지 선택합니다.
                                                        {/* </li>
                                                        <li> */}
                                                            <br/>
                                                            (진열 기간이 종료된 이후에는 쇼핑몰에 진열되지 않습니다.)
                                                        {/* </li>
                                                    </ul> */}
                                                </font>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="margin-vertical-auto" style={{width:"auto"}}>
                                        <div className="flexBox flexButton" id="displayPeriod">
                                            <div className="greyBackgroundBox_r_8" id="event_period_1" onClick={(e) => this.handlePeriodClick(e, 1)}>1일</div>
                                            <div className="greyBackgroundBox_r_8 m-l-10" id="event_period_3" onClick={(e) => this.handlePeriodClick(e, 3)}>3일</div>
                                            <div className="greyBackgroundBox_r_8 m-l-10" id="event_period_5" onClick={(e) => this.handlePeriodClick(e, 5)}>5일</div>
                                            <div className="greyBackgroundBox_r_8 m-l-10" id="event_period_7" onClick={(e) => this.handlePeriodClick(e, 7)}>7일</div>
                                            <div className="greyBackgroundBox_r_8 m-l-10" id="event_period_14" onClick={(e) => this.handlePeriodClick(e, 14)}>14일</div>
                                            <div className="greyBackgroundBox_r_8 m-l-10" id="event_period_30" onClick={(e) => this.handlePeriodClick(e, 30)}>1개월</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        :   ""
                    }
                    
                    {
                        Number(this.state.step) == 3
                        ?   <div>
                                <div className="flexBox">
                                    <div className="form_primary_title" style={{marginRight: "20px"}}>
                                        {this.state.solution_type_cd == "09900" ? "디자인" : "맞춤 배너 디자인"}
                                    </div>
                                    <div className="userGuideButton" 
                                         onClick={(e) => Menu.call_userGuide('https://www.notion.so/iclave/4-8e2c8f9db1804792bdf78e70fff0d2aa#cea8419a8be44aa69205f7d88118dee2')}
                                         style={{height: "25px", margin:"auto 0 auto 0"}}
                                    >
                                        <span>사용자 가이드</span>
                                    </div>
                                    <div className="userGuideButtonMobile" 
                                         onClick={(e) => Menu.call_userGuide('https://www.notion.so/iclave/4-8e2c8f9db1804792bdf78e70fff0d2aa#cea8419a8be44aa69205f7d88118dee2')} 
                                         style={{height: "25px", margin:"auto 0 auto 0", float:'right'}}
                                    >
                                        <span>?</span>
                                    </div>
                                </div>
                            { this.state.is_size_horizontal
                            ?    <div className="m-t-43" style={{marginBottom:"30px"}}>
                                    <div className="flexBox-no-wrap">
                                        <div className="icn_warning_round_blue" style={{margin:"auto 0"}}></div>
                                        &nbsp;&nbsp;
                                        <div style={{margin:"auto 0", fontSize: "13px", flex: 1}}>
                                            {this.state.is_size_vertical
                                            ? this.state.event_banner_pc_width && this.state.event_banner_pc_height && Number(this.state.event_banner_pc_width) > Number(this.state.event_banner_pc_height)
                                                ? <b>{`입력하신 ${this.state.solution_type_cd == "09900" ? "사이즈 1" : "배너 사이즈 1"}에 맞는 템플릿을 추천해 드립니다. 가로 유형의 템플릿이 골라졌습니다.`}</b>
                                                : <b>{`입력하신 ${this.state.solution_type_cd == "09900" ? "사이즈 2" : "배너 사이즈 2"}에 맞는 템플릿을 추천해 드립니다. 가로 유형의 템플릿이 골라졌습니다.`}</b>
                                            : <b>{`입력하신 모든 ${this.state.solution_type_cd == "09900" ? "사이즈" : "배너 사이즈"}에 맞는 템플릿을 추천해 드립니다. 가로 유형의 템플릿이 골라졌습니다.`}</b>}
                                        </div>
                                    </div>
                                    {/* 템플릿 필터 start */}
                                    <div className={"template_tag_filter"}>
                                        <button className={"btn_template_filter"} onClick={() => this.handleTemplateFilterBtnClick("03000")}>
                                            <img src={icn_filter} alt={"템플릿 태그 필터 아이콘"}/>
                                        </button>
                                        <div className={"template_tag_list"}>
                                            <div onMouseLeave={this.handleDragStop}>
                                                <ScrollMenu
                                                    handleMouseOnWheel={(apiObj, ev) => this.handleMouseOnWheel(apiObj, ev)}
                                                    onMouseDown={() => this.handleDragStart}
                                                    onMouseUp={() => this.handleDragStop}
                                                    onMouseMove={this.handleDrag}
                                                >
                                                    <button style={this.state.w_all_tag_selected ? {backgroundColor:'#00E2E6', border: '1px solid #00E2E6'} : {backgroundColor: '#FFF', border: '1px solid #ACACAC'}}
                                                            onClick={() => this.allTagBtnClick("03000", "w")}>{this.state.template_tag_list && this.state.template_tag_list.length > 0 && this.state.template_tag_list[0].tag_name}</button>
                                                    {
                                                        Object.keys(this.state.w_template_all_tag_list).map((category, tag_idx) => (
                                                            this.state.w_template_all_tag_list[category].map((tag)=>(
                                                                <TagButton key={tag.tag_cd} tagCd={tag.tag_cd} tagName={tag.tag_name}
                                                                           isSelected={tag.isSelected}
                                                                           onClick={(tagCd, isSelected) => this.tagBtnClick(category, tag.tag_cd, isSelected, "03000", "w")}/>
                                                            ))
                                                        ))
                                                    }
                                                </ScrollMenu>
                                            </div>
                                        </div>
                                    </div>
                                    {/* 템플릿 필터 end */}
                                    <div className="container_banner_template m-t-21 m-b-20 settingBannerType"> {/* content_box_radius */}
                                        <div className="flexBox bannerTypeImg" style={{flex:"1", borderLeft:"0px"}}>
                                            <div className="flexBox" style={{width:"100%"}}>
                                                {this.state.bannerTypeList == null || this.state.bannerTypeList.length == 0
                                                    ?
                                                    <div className={"no_banner_template"}>
                                                        <div>
                                                            <p>해당 템플릿 디자인이 없어요.<br/>다른 디자인으로 선택해 볼까요?</p>
                                                            <button onClick={() => this.resetTemplateFilterBtnClick("03000", "w")}>
                                                                <img src={icn_refresh_2} alt={"전체 다시보기"}/>
                                                                &nbsp;&nbsp;전체 다시보기
                                                            </button>
                                                        </div>
                                                    </div>
                                                    :
                                                    this.state.bannerTypeList.map((bannerType,idx) => (
                                                    <div key={idx} className="banner-inner-v2 mobile-width-100" style={{margin: "0px 0.82vw 30px 0", width: "calc((100% - 4.28vw)/5)", cursor: "pointer"}}
                                                         onClick={() => {this.onClickBannerTypeRadioButton(
                                                            "event_type_cd",
                                                            bannerType.code_cd,
                                                            this.state.checked_pc_banner_list.find(banner => banner.bannerType == bannerType.code_cd) != null ? "off" : "on",
                                                            bannerType.val1,
                                                            bannerType.val2,
                                                             bannerType.banner_name,
                                                             bannerType.tag_name_list
                                                        )}}>
                                                        {/*<div className="checkbox_flexBox event_setting_banner_type">*/}
                                                            {/*<CheckBox*/}
                                                            {/*    id={"bannerType"+bannerType.code_cd}*/}
                                                            {/*    checked={this.state.checked_pc_banner_list.find(banner => banner.bannerType == bannerType.code_cd) != null}*/}
                                                            {/*    onChangeCheck={() => */}
                                                            {/*        this.onClickBannerTypeRadioButton(*/}
                                                            {/*            "event_type_cd",*/}
                                                            {/*            bannerType.code_cd,*/}
                                                            {/*            this.state.checked_pc_banner_list.find(banner => banner.bannerType == bannerType.code_cd) != null ? "off" : "on",*/}
                                                            {/*            bannerType.val1,*/}
                                                            {/*            bannerType.val2,*/}
                                                            {/*        )*/}
                                                            {/*    }*/}
                                                            {/*/>*/}
                                                        {/*</div>*/}
                                                        <img src={bannerType.val2} width="100%" height="auto"
                                                             style={{margin:"auto", border: this.state.checked_pc_banner_list.find(banner => banner.bannerType == bannerType.code_cd) != null ? "4px solid #00E2E6" : "1px solid #D9D9D9", borderRadius: "13px"}}/>
                                                        <div className={"title_banner_template"} style={{fontWeight: this.state.checked_pc_banner_list.find(banner => banner.bannerType == bannerType.code_cd) != null ? "500" : "400"}}>{bannerType.banner_name}</div>
                                                        <div className={"btn_banner_template_tag"}>
                                                            {(bannerType.tag_name_list || "").toString() != "" && (bannerType.tag_name_list || "").toString().split(",").map((tag_name) => (
                                                                <button key={tag_name}>{tag_name.trim()}</button>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        {this.state.bannerTypeList == null || this.state.bannerTypeList.length == 0 ? <></>
                                            :
                                            <div className={"container_banner_template_paging"}> {/* className="content_box_radius_paging" */}
                                                <div style={{lineHeight:"60px"}}>
                                                    <Pagination
                                                        activePage={this.state.pc_banner_type_paging.activePage}
                                                        itemsCountPerPage={this.state.pc_banner_type_paging.rowcnt}
                                                        totalItemsCount={this.state.pc_banner_type_paging.totalCnt}
                                                        pageRangeDisplayed={10}
                                                        onChange={this.handleBannerPageChange.bind(this)}
                                                    />
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    <div className="flexBox settingBannerTypeResultPc">
                                        { this.state.checked_pc_banner_list != null && this.state.checked_pc_banner_list.length > 0
                                        ?   <div style={{width:"100%"}}>
                                                <div style={{marginBottom:"30px"}}>
                                                    <b>아래 순서대로 {this.state.solution_type_cd == "09900" ? "디자인이" : "배너가"} 생성됩니다. 클릭하고 드래그 하면 순서를 바꿀 수 있습니다.</b>
                                                </div>
                                                    <RLDD
                                                    cssClasses="example-list-container"
                                                    layout="horizontal"
                                                    items={this.state.checked_pc_banner_list}
                                                    itemRenderer={this.itemRenderer.bind(this)}
                                                    onChange={this.handleRLDDChange.bind(this)}
                                                    />
                                                {/* </div> */}
                                            </div>
                                        :   ""
                                        }    
                                    </div>
                                </div>   
                                :   <>
                                    {
                                        this.state.is_size_horizontal == null 
                                        ?   <div className="m-t-43">
                                                <div className="flexBox-no-wrap" style={{marginBottom:"50px"}}><div className="icn_warning_round_blue" style={{margin:"auto 0"}}></div>&nbsp;&nbsp;<div style={{margin:"auto 0", fontSize: "13px"}}><b>원하는 만큼 배너 스타일을 선택해 주세요. (가로형)</b></div></div>
                                                <div className="flexBox m-b-60 m-l-34 width-100-34px">
                                                        <div style={{color:"#FF7B7B", margin:"auto 0", fontSize:"15px"}}><b>* 배너 사이즈를 먼저 선택해 주세요.</b></div>
                                                        {/* <div className="btn-175-b cursor-pointer" style={{width: "80px", height:"40px", lineHeight:"41px", marginLeft:"20px"}} onClick={e => this.onClickShortcutFocusing(e, "iframe_page_id_cd")}>바로가기</div> */}
                                                </div>    
                                            </div>
                                        :   ""    
                                    }
                                    </>
                                } 



                                { this.state.is_size_vertical == true 
                                ? <div className="m-t-43" style={{marginBottom:"75px"}}>
                                    <div className="flexBox-no-wrap">
                                        <div className="icn_warning_round_blue" style={{margin:"auto 0"}}></div>
                                        &nbsp;&nbsp;
                                        <div style={{margin:"auto 0", fontSize: "13px", flex: 1}}>
                                            {this.state.is_size_horizontal
                                            ? this.state.event_banner_pc_width && this.state.event_banner_pc_height && Number(this.state.event_banner_pc_width) <= Number(this.state.event_banner_pc_height)
                                                ? <b>{`입력하신 ${this.state.solution_type_cd == "09900" ? "사이즈 1" : "배너 사이즈 1"}에 맞는 템플릿을 추천해 드립니다. 세로 유형의 템플릿이 골라졌습니다.`}</b>
                                                : <b>{`입력하신 ${this.state.solution_type_cd == "09900" ? "사이즈 2" : "배너 사이즈 2"}에 맞는 템플릿을 추천해 드립니다. 세로 유형의 템플릿이 골라졌습니다.`}</b>
                                            : <b>{`입력하신 모든 ${this.state.solution_type_cd == "09900" ? "사이즈" : "배너 사이즈"}에 맞는 템플릿을 추천해 드립니다. 세로 유형의 템플릿이 골라졌습니다.`}</b>}
                                        </div>
                                    </div>
                                        {/* 템플릿 필터 start */}
                                        <div className={"template_tag_filter"}>
                                            <button className={"btn_template_filter"} onClick={() => this.handleTemplateFilterBtnClick("07000")}>
                                                <img src={icn_filter} alt={"템플릿 태그 필터 아이콘"}/>
                                            </button>
                                            <div className={"template_tag_list"}>
                                                <div onMouseLeave={this.handleDragStop}>
                                                    <ScrollMenu
                                                        handleMouseOnWheel={(apiObj, ev) => this.handleMouseOnWheel(apiObj, ev)}
                                                        onMouseDown={() => this.handleDragStart}
                                                        onMouseUp={() => this.handleDragStop}
                                                        onMouseMove={this.handleDrag}
                                                    >
                                                        <button style={this.state.h_all_tag_selected ? {backgroundColor:'#00E2E6', border: '1px solid #00E2E6'} : {backgroundColor: '#FFF', border: '1px solid #ACACAC'}}
                                                                onClick={() => this.allTagBtnClick("07000", "h")}>{this.state.template_tag_list && this.state.template_tag_list.length > 0 && this.state.template_tag_list[0].tag_name}</button>
                                                        {
                                                            Object.keys(this.state.h_template_all_tag_list).map((category, tag_idx) => (
                                                                this.state.h_template_all_tag_list[category].map((tag)=>(
                                                                    <TagButton key={tag.tag_cd} tagCd={tag.tag_cd} tagName={tag.tag_name}
                                                                               isSelected={tag.isSelected}
                                                                               onClick={(tagCd, isSelected) => this.tagBtnClick(category, tag.tag_cd, isSelected, "07000", "h")}/>
                                                                ))
                                                            ))
                                                        }
                                                    </ScrollMenu>
                                                </div>
                                            </div>
                                        </div>
                                        {/* 템플릿 필터 end */}
                                        <div className="container_banner_template m-t-21 m-b-20 settingBannerType"> {/* content_box_radius */}
                                        <div className="flexBox bannerTypeImg" style={{flex:"1", borderLeft:"0px"}}>
                                            <div className="flexBox" style={{width:"100%"}}>
                                                {this.state.mobileBannerTypeList == null || this.state.mobileBannerTypeList.length == 0
                                                    ?
                                                    <div className={"no_banner_template"}>
                                                        <div>
                                                            <p>해당 템플릿 디자인이 없어요.<br/>다른 디자인으로 선택해 볼까요?</p>
                                                            <button onClick={() => this.resetTemplateFilterBtnClick("07000", "h")}>
                                                                <img src={icn_refresh_2} alt={"전체 다시보기"}/>
                                                                &nbsp;&nbsp;전체 다시보기
                                                            </button>
                                                        </div>
                                                    </div>
                                                    :
                                                    this.state.mobileBannerTypeList.map((bannerType,idx) => (
                                                    <div key={idx} className="banner-inner-v2 mobile-width-100" style={{margin: "0px 0.82vw 30px 0", width: "calc((99% - 4.6vw) / 6)", cursor: "pointer"}}
                                                         onClick={() => {this.onClickBannerTypeRadioButton(
                                                             "event_mobile_type_cd",
                                                             bannerType.code_cd,
                                                             this.state.checked_mobile_banner_list.find(banner => banner.bannerType == bannerType.code_cd) != null ? "off" : "on",
                                                             bannerType.val1,
                                                             bannerType.val2,
                                                             bannerType.banner_name,
                                                             bannerType.tag_name_list
                                                         )}}>
                                                        {/*<div className="checkbox_flexBox event_setting_banner_type">*/}
                                                        {/*    <CheckBox*/}
                                                        {/*        id={"mobileBannerType"+bannerType.code_cd}*/}
                                                        {/*        checked={this.state.checked_mobile_banner_list.find(banner => banner.bannerType == bannerType.code_cd) != null}*/}
                                                        {/*        onChangeCheck={() => */}
                                                        {/*            this.onClickBannerTypeRadioButton(*/}
                                                        {/*                "event_mobile_type_cd",*/}
                                                        {/*                bannerType.code_cd,*/}
                                                        {/*                this.state.checked_mobile_banner_list.find(banner => banner.bannerType == bannerType.code_cd) != null ? "off" : "on",*/}
                                                        {/*                bannerType.val1,*/}
                                                        {/*                bannerType.val2,*/}
                                                        {/*            )*/}
                                                        {/*        }*/}
                                                        {/*    />*/}
                                                        {/*</div>*/}
                                                        <img src={bannerType.val2} width="100%" height="auto"
                                                             style={{margin:"auto", border: this.state.checked_mobile_banner_list.find(banner => banner.bannerType == bannerType.code_cd) != null ? "4px solid #00E2E6" : "1px solid #D9D9D9", borderRadius: "13px"}}/>
                                                        <div className={"title_banner_template"} style={{fontWeight: this.state.checked_mobile_banner_list.find(banner => banner.bannerType == bannerType.code_cd) != null ? "500" : "400"}}>{bannerType.banner_name}</div>
                                                        <div className={"btn_banner_template_tag"}>
                                                            {(bannerType.tag_name_list || "").toString() != "" && (bannerType.tag_name_list || "").toString().split(",").map((tag_name) => (
                                                                <button key={tag_name}>{tag_name.trim()}</button>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                            {this.state.mobileBannerTypeList == null || this.state.mobileBannerTypeList.length == 0 ? <></>
                                                :
                                                <div className={"container_banner_template_paging"}> {/* className="content_box_radius_paging" */}
                                                    <div style={{lineHeight:"60px"}}>
                                                        <Pagination
                                                            activePage={this.state.mobile_banner_type_paging.activePage}
                                                            itemsCountPerPage={this.state.mobile_banner_type_paging.rowcnt}
                                                            totalItemsCount={this.state.mobile_banner_type_paging.totalCnt}
                                                            pageRangeDisplayed={10}
                                                            onChange={this.handleMobileBannerPageChange.bind(this)}
                                                        />
                                                    </div>
                                                </div>
                                            }
                                    </div>
                                    <div className="flexBox settingBannerTypeResultMobile">
                                        { this.state.checked_mobile_banner_list != null && this.state.checked_mobile_banner_list.length > 0
                                        ?   <div style={{width:"100%"}}>
                                                <div style={{marginBottom:"30px"}}>
                                                    <b>아래 순서대로 {this.state.solution_type_cd == "09900" ? "디자인이" : "배너가"} 생성됩니다. 클릭하고 드래그 하면 순서를 바꿀 수 있습니다.</b>
                                                </div>
                                                    <RLDD
                                                    cssClasses="example-list-container"
                                                    layout="horizontal"
                                                    items={this.state.checked_mobile_banner_list}
                                                    itemRenderer={this.itemRendererMobile.bind(this)}
                                                    onChange={this.handleRLDDChangeMobile.bind(this)}
                                                    />
                                                {/* </div> */}
                                            </div>
                                        :   ""
                                        }    
                                    </div>
                                </div>   
                                :   
                                    <>
                                        {
                                            this.state.is_size_vertical == null 
                                            ?   <div className="m-t-43">
                                                    <div className="flexBox-no-wrap" style={{marginBottom:"50px"}}><div className="icn_warning_round_blue" style={{margin:"auto 0"}}></div>&nbsp;&nbsp;<div style={{margin:"auto 0", fontSize: "13px"}}><b>원하는 만큼 배너 스타일을 선택해 주세요. (가로형)</b></div></div>
                                                    <div className="flexBox m-b-60 m-l-34 width-100-34px">
                                                    <div style={{color:"#FF7B7B", margin:"auto 0", fontSize:"15px"}}><b>* 배너 사이즈를 먼저 선택해 주세요.</b></div>
                                                    {/* <div className="btn-175-b cursor-pointer" style={{width: "80px", height:"40px", lineHeight:"41px", marginLeft:"20px"}} onClick={e => this.onClickShortcutFocusing(e, "iframe_page_id_cd")}>바로가기</div> */}
                                                    </div>    
                                                </div>    
                                            :   ""
                                        }
                                    </>
                                }

                                {
                                /* 기존 조건: !(this.state.solution_type_cd == "09900" && this.state.roleType == "2221") */
                                this.state.solution_type_cd != "09900"
                                &&
                                <>
                                    {/* 슬라이드 여부 */}
                                    <div className="flexBox eventSettingItemArea" style={{height: "auto"}}>
                                        <div className="margin-vertical-auto eventSettingTitle" style={{width: "100%"}}>
                                            <label style={{marginTop: "auto", marginBottom: "15px"}}><b>슬라이드 여부</b></label>
                                        </div>
                                        <div style={{margin: "auto 0", marginBottom: "30px", fontSize: "13px"}}>
                                            <b>단일 이미지로 노출할지, 여러 이미지를 슬라이드로 노출할지 선택해 주세요.</b>
                                        </div>
                                        <div className="banner_radio_flexbox event_setting_content_radio">
                                        {
                                            [{type:'Y', text:'여러 이미지'},{type:'N', text:'단일 이미지'}].map((obj, idx) => (
                                                <RadioButton
                                                    id={"slide_"+obj.type}
                                                    name={"slide_yn"}
                                                    value={obj.type}
                                                    checked={this.state.slide_yn == obj.type}
                                                    onChangeCheck={e => this.onClickSlideYN(e)}
                                                >
                                                    <div className="banner_radio_text">{obj.text}</div>
                                                </RadioButton>
                                            ))
                                        }
                                        </div>
                                    </div>
                                    
                                    {this.state.slide_yn == "Y" &&
                                    <>
                                        {/* 슬라이드 전환 시간 */}
                                        <div className="flexBox eventSettingItemArea" style={{height: "auto"}}>
                                            <div className="margin-vertical-auto eventSettingTitle" style={{width: "100%"}}>
                                                <label style={{marginTop: "auto", marginBottom: "15px"}}><b>슬라이드 전환 시간</b></label>
                                            </div>
                                            <div style={{margin: "auto 0", marginBottom: "30px", fontSize: "13px"}}>
                                                <b>여러 개의 배너가 진열되는 경우, 배너 하나당 보여지는 시간을 선택해 주세요.</b>
                                            </div>
                                            {
                                                this.state.transition_pause_code_list.length > 0
                                                    ?
                                                    <div className="banner_radio_flexbox event_setting_content_radio">
                                                        {
                                                            this.state.transition_pause_code_list.map((pause, idx) => (
                                                                <RadioButton
                                                                    id={"transition_pause" + pause.code_cd}
                                                                    name={"transition_pause"}
                                                                    value={idx}
                                                                    checked={this.state.transition_pause == pause.code_cd}
                                                                    onChangeCheck={this.onClickTransitionPause.bind(this)}
                                                                >
                                                                    <div
                                                                        className="banner_radio_text">{pause.code_name}</div>
                                                                </RadioButton>
                                                            ))
                                                        }
                                                    </div>
                                                    : ''
                                            }
                                        </div>

                                        {/* 슬라이드 전환 효과 */}
                                        <div className="flexBox eventSettingItemArea" style={{height: "auto"}}>
                                            <div className="margin-vertical-auto eventSettingTitle" style={{width: "100%"}}>
                                                <label style={{marginTop: "auto", marginBottom: "15px"}}><b>슬라이드 전환 효과</b></label>
                                            </div>
                                            <div style={{margin: "auto 0", marginBottom: "30px", fontSize: "13px"}}>
                                                <b>여러 개의 배너가 진열되는 경우, 다음 배너로 넘어갈 때의 효과를 선택해 주세요.</b>
                                            </div>
                                            {
                                                this.state.transition_mode_code_list.length > 0
                                                    ?
                                                    <div className="banner_radio_flexbox event_setting_content_radio">
                                                        {
                                                            this.state.transition_mode_code_list.map((mode, idx) => (
                                                                <RadioButton
                                                                    id={"transition_mode" + mode.code_cd}
                                                                    name={"transition_mode"}
                                                                    value={mode.code_cd}
                                                                    checked={this.state.transition_mode == mode.code_cd}
                                                                    onChangeCheck={this.onClickTransitionMode.bind(this)}
                                                                >
                                                                    <div
                                                                        className="banner_radio_text">{mode.code_name}</div>
                                                                </RadioButton>
                                                            ))
                                                        }
                                                    </div>
                                                    : ''
                                            }
                                        </div>

                                        {/* 슬라이드 전환 효과 속도 */}
                                        {this.state.transition_mode != "27003" &&
                                            <div className="flexBox eventSettingItemArea" style={{height:"auto"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}><b>슬라이드 전환 효과 속도</b></label>
                                                </div>
                                                <div style={{margin:"auto 0", marginBottom:"30px", fontSize: "13px"}}>
                                                    <b>여러 개의 배너가 진열되는 경우, 다음 배너로 넘어갈 때의 효과가 적용되는 속도를 선택해 주세요.</b>
                                                </div>
                                                    {
                                                        this.state.transition_speed_code_list.length > 0
                                                        ?
                                                            <div class="banner_radio_flexbox event_setting_content_radio">
                                                                {
                                                                    this.state.transition_speed_code_list.map((speed, idx) => (
                                                                        <RadioButton
                                                                            id={"transition_speed"+speed.code_cd}
                                                                            name={"transition_speed"}
                                                                            value={idx}
                                                                            checked={this.state.transition_speed == speed.code_cd}
                                                                            onChangeCheck={this.onClickTransitionSpeed.bind(this)}
                                                                        >
                                                                            <div className="banner_radio_text">{speed.code_name}</div>
                                                                        </RadioButton>
                                                                    ))
                                                                }
                                                            </div>
                                                        : ''
                                                    }
                                            </div>
                                        }

                                        {/* 네비게이션 화살표 사용 여부 */}
                                        <div className="flexBox eventSettingItemArea" style={{height: "auto"}}>
                                            <div className="margin-vertical-auto eventSettingTitle" style={{width: "100%"}}>
                                                <label style={{marginTop: "auto", marginBottom: "15px"}}><b>네비게이션 화살표</b></label>
                                            </div>
                                            <div style={{margin: "auto 0", marginBottom: "30px", fontSize: "13px"}}>
                                                <b>이전과 이후로 넘어가는 기능인 네이게이션 화살표의 사용여부를 선택해주세요.</b>
                                            </div>
                                            <div className="banner_radio_flexbox event_setting_content_radio event_setting_radio_auto_width">
                                                {
                                                    ['N', 'Y'].map((type, idx) => (
                                                        <RadioButton
                                                            id={"banner_arrow_use_yn_" + type}
                                                            name={"banner_arrow_use_yn"}
                                                            value={type}
                                                            checked={this.state.banner_arrow_use_yn == type}
                                                            onChangeCheck={this.onClickBannerArrowUseYn.bind(this)}
                                                        >
                                                            <div
                                                                className="banner_radio_text">{this.ArraowUseYnRenderer(type)}</div>
                                                        </RadioButton>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                        {   this.state.banner_arrow_use_yn == "Y"
                                            ? <div style={{
                                                border: "#333 solid 1px",
                                                padding: "20px",
                                                marginBottom: "50px",
                                                marginTop: "-50px",
                                            }}>
                                                {/* 네비게이션 화살표 디자인 */}
                                                <div className="flexBox eventSettingItemArea" style={{height: "auto"}}>
                                                    <div className="margin-vertical-auto eventSettingTitle" style={{width: "100%"}}>
                                                        <label style={{marginTop: "auto", marginBottom: "15px"}}><b>네비게이션 화살표 디자인</b></label>
                                                    </div>
                                                    <div style={{margin: "auto 0", marginBottom: "30px", fontSize: "13px"}}>
                                                        <b>이전과 이후로 넘어가는 기능인 네이게이션 화살표의 디자인을 선택해주세요.</b>
                                                    </div>
                                                </div>
                                                {/* 네비게이션 화살표 위치 */}
                                                <div className="flexBox eventSettingItemArea" style={{height: "auto"}}>
                                                    <div className="margin-vertical-auto eventSettingTitle" style={{width: "100%"}}>
                                                        <label style={{marginTop: "auto", marginBottom: "15px"}}><b>네비게이션 화살표 위치</b></label>
                                                    </div>
                                                    <div className="banner_radio_flexbox event_setting_content_radio" 
                                                    style={{width: window.innerWidth <= 800 ? "auto" : null,
                                                            flexDirection: window.innerWidth <= 800 ? "column" : null,
                                                            marginRight: window.innerWidth <= 800 ? "auto" : null}}>
                                                        {
                                                            this.state.banner_arrow_position_list.map((obj, idx) => (
                                                                <div style={{
                                                                    marginRight:"10px"
                                                                }}>
                                                                    <RadioButton
                                                                        id={"banner_arrow_type_" + obj.value}
                                                                        name={"banner_arrow_type"}
                                                                        value={obj.value}
                                                                        checked={this.state.banner_arrow_position == obj.value}
                                                                        onChangeCheck={this.onClickBannerArrowPosition.bind(this)}
                                                                        text={obj.text}
                                                                        img_url={obj.img_url}
                                                                        img_width={obj.img_width}
                                                                    >
                                                                    </RadioButton>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                                {/* 네비게이션 박스 형태 */}
                                                <div className="flexBox eventSettingItemArea" style={{height: "auto"}}>
                                                    <div className="margin-vertical-auto eventSettingTitle" style={{width: "100%"}}>
                                                        <label style={{marginTop: "auto", marginBottom: "15px"}}><b>네비게이션 박스 형태</b></label>
                                                    </div>
                                                    <div className="banner_radio_flexbox event_setting_content_radio"
                                                    style={{width: window.innerWidth <= 800 ? "auto" : null,
                                                            flexDirection: window.innerWidth <= 800 ? "column" : null,
                                                            marginRight: window.innerWidth <= 800 ? "auto" : null}}>
                                                        {
                                                            this.state.banner_arrow_box_list.map((obj, idx) => (
                                                                <div style={{
                                                                    marginRight:"10px"
                                                                }}>
                                                                    <RadioButton
                                                                        id={"banner_arrow_box_type_" + obj.value}
                                                                        name={"banner_arrow_box_type"}
                                                                        value={obj.value}
                                                                        checked={this.state.banner_arrow_box == obj.value}
                                                                        onChangeCheck={this.onClickBannerArrowBox.bind(this)}
                                                                        text={obj.text}
                                                                        img_url={obj.img_url}
                                                                        img_height={obj.img_height}
                                                                    >
                                                                    </RadioButton>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                                {/* 네비게이션 화살표 컬러 */}
                                                <div className="flexBox eventSettingItemArea" style={{height: "auto"}}>
                                                    <div className="margin-vertical-auto eventSettingTitle" style={{width: "100%"}}>
                                                        <label style={{marginTop: "auto", marginBottom: "15px"}}><b>네비게이션 화살표 컬러</b></label>
                                                    </div>
                                                    <div className="banner_radio_flexbox event_setting_content_radio event_setting_radio_auto_width">
                                                        {
                                                            this.state.banner_arrow_color_list.map((obj, idx) => (
                                                                <div style={{
                                                                    marginRight:"10px"
                                                                }}>
                                                                    <RadioButton
                                                                        id={"banner_arrow_color_type_" + obj.value}
                                                                        name={"banner_arrow_color_type"}
                                                                        value={obj.value}
                                                                        checked={this.state.banner_arrow_color == obj.value}
                                                                        onChangeCheck={this.onClickBannerArrowColor.bind(this)}
                                                                        text={obj.text}
                                                                    >
                                                                    </RadioButton>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                                {/* 네비게이션 화살표 크기 및 굵기 */}
                                                <div className="flexBox eventSettingItemArea" style={{height: "auto"}}>
                                                    <div className="margin-vertical-auto eventSettingTitle" style={{width: "100%"}}>
                                                        <label style={{marginTop: "auto", marginBottom: "15px"}}><b>네비게이션 화살표 크기 및 굵기</b></label>
                                                    </div>
                                                    <div className="banner_radio_flexbox event_setting_content_radio"
                                                    style={{width: window.innerWidth <= 800 ? "auto" : null,
                                                            flexDirection: window.innerWidth <= 800 ? "column" : null,
                                                            marginRight: window.innerWidth <= 800 ? "auto" : null}}>
                                                        {
                                                            this.state.banner_arrow_size_border_width_list.map((obj, idx) => (
                                                                <div style={{
                                                                    marginRight:"10px"
                                                                }}>
                                                                    <RadioButton
                                                                        id={"banner_arrow_size_border_width_type_" + obj.value}
                                                                        name={"banner_arrow_size_border_width_type"}
                                                                        value={obj.value}
                                                                        checked={this.state.banner_arrow_size_border_width == obj.value}
                                                                        onChangeCheck={this.onClickBannerArrowSizeBorderWidth.bind(this)}
                                                                        text={obj.text}
                                                                        img_url={obj.img_url}
                                                                        img_height={obj.img_height}
                                                                    >
                                                                    </RadioButton>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                                {/* 네비게이션 화살표 마우스오버 */}
                                                <div className="flexBox eventSettingItemArea" style={{height: "auto"}}>
                                                    <div className="margin-vertical-auto eventSettingTitle" style={{width: "100%"}}>
                                                        <label style={{marginTop: "auto", marginBottom: "15px"}}><b>네비게이션 화살표 마우스 효과</b></label>
                                                    </div>
                                                    <div style={{margin: "auto 0", marginBottom: "30px", fontSize: "13px"}}>
                                                        <b>마우스를 사용하는 기기에서는 배너 위에 마우스를 올렸을 때만 화살표가 보이도록 설정하시겠습니까?</b>
                                                    </div>
                                                    <div className="banner_radio_flexbox event_setting_content_radio event_setting_radio_auto_width">
                                                        {
                                                            this.state.banner_arrow_hover_yn_list.map((obj, idx) => (
                                                                <div style={{
                                                                    marginRight:"10px"
                                                                }}>
                                                                    <RadioButton
                                                                        id={"banner_arrow_hover_yn_" + obj.value}
                                                                        name={"banner_arrow_hover_yn_"}
                                                                        value={obj.value}
                                                                        checked={this.state.banner_arrow_hover_yn == obj.value}
                                                                        onChangeCheck={this.onClickBannerArrowHoverYn.bind(this)}
                                                                        text={obj.text}
                                                                    >
                                                                    </RadioButton>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            : null
                                        }
                                        
                                        {/* 페이지 컨트롤 모양 선택 */}
                                        <div className="flexBox eventSettingItemArea" style={{height: "auto"}}>
                                            <div className="margin-vertical-auto eventSettingTitle" style={{width: "100%"}}>
                                                <label style={{marginTop: "auto", marginBottom: "15px"}}><b>페이지 컨트롤 모양</b></label>
                                            </div>
                                            <div style={{margin: "auto 0", marginBottom: "30px", fontSize: "13px"}}>
                                                <b>여러 개의 배너가 진열되는 경우, 배너 영역의 페이지 컨트롤 모양을 선택해 주세요.</b>
                                            </div>
                                            <div className="banner_radio_flexbox event_setting_content_radio">
                                                {
                                                    ['001', '002', '003', '004', '005', '006', '007', '008', '000'].map((type, idx) => (
                                                        <RadioButton
                                                            id={"page_control_type" + type}
                                                            name={"page_control_type"}
                                                            value={type}
                                                            checked={this.state.page_control_type == type}
                                                            onChangeCheck={this.onClickPageControlType.bind(this)}
                                                        >
                                                            <div
                                                                className="banner_radio_text">{this.pageControlRenderer(type)}</div>
                                                        </RadioButton>
                                                    ))
                                                }
                                            </div>
                                        </div>

                                        {/* 페이지 컨트롤 위치 선택 */}
                                        {this.state.page_control_type != "000" &&
                                            <div className="flexBox eventSettingItemArea" style={{height:"auto"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}><b>페이지 컨트롤 위치</b></label>
                                                </div>
                                                <div style={{margin:"auto 0", marginBottom:"30px", fontSize: "13px"}}>
                                                    <b>여러 개의 배너가 진열되는 경우, 배너 영역에 페이지 컨트롤이 나타나는 위치를 선택해 주세요.</b>
                                                </div>
                                                <div class="banner_radio_flexbox event_setting_content_radio event_setting_radio_auto_width">
                                                    {
                                                        [{type:'001', text:'왼쪽 아래'},{type:'002', text:'가운데 아래'},{type:'003', text:'오른쪽 아래'}].map((obj, idx) => (
                                                            <RadioButton
                                                                id={"page_control_position_type"+obj.type}
                                                                name={"page_control_position_type"}
                                                                value={obj.type}
                                                                checked={this.state.page_control_position_type == obj.type}
                                                                onChangeCheck={this.onClickPageControlPositionType.bind(this)}
                                                            >
                                                                <div className="banner_radio_text">{obj.text}</div>
                                                            </RadioButton>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </>}
                                </>
                                }

                                {/* 대제목 언어 선택 */}
                                <div className="flexBox eventSettingItemArea" style={{height:"auto"}}>
                                    <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                        <label style={{marginTop: "auto", marginBottom: "15px"}}><b>제목 언어 선택</b></label>
                                    </div>
                                    <div style={{margin:"auto 0", marginBottom:"30px", fontSize: "13px"}}><b>{this.state.solution_type_cd != "09900" ? "로보MD는 상품명의 언어로 배너의 큰 글자 제목을 생성합니다. 제목의 번역 여부와 번역 시 기본 언어를 설정해 주세요." : "제목의 번역 여부와 번역 시 기본 언어를 설정해 주세요."}</b></div>
                                    <div class="banner_radio_flexbox event_setting_content_radio event_setting_radio_auto_width event_setting_translated_yn">
                                        {
                                            [{state:'N', text:'번역 안함'},{state:'Y', text:'번역함'}].map((obj, idx) => (
                                                <RadioButton
                                                    id={"translated_yn_"+obj.state}
                                                    name={"translated_yn"}
                                                    value={obj.state}
                                                    checked={this.state.translated_yn == obj.state}
                                                    onChangeCheck={this.onClickTranslatedYn.bind(this)}
                                                >
                                                    <div className="banner_radio_text">{obj.text}</div>
                                                </RadioButton>
                                            ))
                                        }
                                        {
                                            this.state.translated_yn == "Y" ?
                                                <select className="border_form_radius_b_h_42" style={{width:"160px", padding:"5px"}} onChange={this.handleLanguageChange}
                                                        value={this.state.language_code}>
                                                    <option value="">
                                                        선택해 주세요.
                                                    </option>
                                                    {
                                                        this.state.language_code_list.length > 0
                                                        ?
                                                            <>
                                                                {
                                                                    this.state.language_code_list.map((language, idx) => (
                                                                        <option value={language.code_cd}>
                                                                            {language.code_name}
                                                                        </option>
                                                                    ))
                                                                }
                                                            </>
                                                        : ''
                                                    }
                                                </select>
                                            : ''
                                        }
                                    </div>
                                </div>

                                {/* GIF 이미지 설정 */}
                                {this.state.solution_type_cd != '09900' &&
                                    <div className="flexBox eventSettingItemArea" style={{height: "auto"}}>
                                        <div className="margin-vertical-auto eventSettingTitle" style={{width: "100%"}}>
                                            <label style={{marginTop: "auto", marginBottom: "15px"}}><b>GIF 이미지
                                                설정</b></label>
                                        </div>
                                        <div style={{margin: "auto 0", marginBottom: "30px", fontSize: "13px"}}><b>상품
                                            이미지가 gif 파일인 경우, 사진 그대로 또는 사진을 분리하여 배너를 만드실 수 있습니다. 원하시는 값을 설정해 주세요.</b>
                                        </div>
                                        <div
                                            className="banner_radio_flexbox event_setting_content_radio event_setting_radio_auto_width">
                                            {
                                                [{state: 'N', text: 'GIF 파일 그대로 배너 생성'}, {
                                                    state: 'Y',
                                                    text: 'GIF 파일을 분리하여 배너 생성'
                                                }].map((obj, idx) => (
                                                    <RadioButton
                                                        id={"gif_divide_yn" + obj.state}
                                                        name={"gif_divide_yn"}
                                                        value={obj.state}
                                                        checked={this.state.gif_divide_yn == obj.state}
                                                        onChangeCheck={this.onClickGifDivideYn.bind(this)}
                                                    >
                                                        <div className="banner_radio_text">{obj.text}</div>
                                                    </RadioButton>
                                                ))
                                            }
                                        </div>
                                    </div>
                                }

                                {
                                /* 기존 조건: !(this.state.solution_type_cd == "09900" && this.state.roleType == "2221") */
                                this.state.solution_type_cd != "09900"
                                &&
                                <>
                                    {/* 링크 열기 타입 설정 */}
                                    <div className="flexBox eventSettingItemArea" style={{height: "auto"}}>
                                        <div className="margin-vertical-auto eventSettingTitle" style={{width: "100%"}}>
                                            <label style={{marginTop: "auto", marginBottom: "15px"}}><b>링크 열기 타입</b></label>
                                        </div>
                                        <div style={{margin: "auto 0", marginBottom: "30px", fontSize: "13px"}}><b>배너를
                                            클릭하였을때 새탭으로 열지 현재탭으로 열지 골라주세요.</b></div>
                                        <div
                                            class="banner_radio_flexbox event_setting_content_radio event_setting_radio_auto_width">
                                            {this.state.link_open_type_list.map((obj, idx) => (
                                                <RadioButton
                                                    id={"link_open_type" + obj.code_cd}
                                                    name={"link_open_type"}
                                                    value={obj.code_cd}
                                                    checked={this.state.link_open_type == obj.code_cd}
                                                    onChangeCheck={this.onChangeLinkOpenType.bind(this)}
                                                >
                                                    <div className="banner_radio_text">{obj.code_name}</div>
                                                </RadioButton>
                                            ))}
                                        </div>
                                    </div>
                                </>
                                }

                                {/* <div className="flexBox eventSettingItemArea" id="bannerTypeArea" style={{marginTop: "auto", marginBottom: "auto", height:"auto", paddingTop:"36px"}}>
                                    <div className="margin-vertical-auto eventSettingTitle" style={{width: "100%",}}>
                                        <label style={{marginTop: "auto", marginBottom: "15px"}}>가로형 배너유형</label>
                                        <div className="fa fa-question-circle margin-l-10">
                                            <div className="question-hover-area"><font style={{fontSize:"14px",  lineHeight:"15px", wordBreak:"keep-all"}}>원하시는 가로형 배너 유형을 선택해 주세요.<br/>선택하신 순서에 따라 배너가 자동 생성됩니다.<br/>(인공지능AI가 상품 이미지에 어울리는 최적의 색상을 찾아서 배너에 자동 적용합니다.)</font></div>
                                        </div>
                                    </div>
                                    <div className="flexBox bannerTypeImg eventSettingItemArea" style={{flex:"1", borderLeft: "0px"}}>
                                        <div className="flexBox" style={{width:"100%", flex:"1.5%"}}>
                                            {this.state.bannerTypeList.map((bannerType,idx) => (
                                                <div key={idx} className="banner-inner" style={{margin: "auto auto auto 1%"}}>
                                                    <div className="flexBox">
                                                        <div id={bannerType.code_cd} className="checkbox-type" onClick={this.handleTypeClick} style={{backgroundColor: "white", border:"1px solid black" ,width: "24px", height: "24px", textAlign:"center", marginBottom:"5px", color:"white", cursor:"pointer"}}></div>
                                                        &nbsp;{bannerType.val1}
                                                    </div>
                                                    <img src={bannerType.val2} width="100%" height="auto" style={{margin:"auto auto 10px auto" , border:"0.5px solid dimgray"}} onClick={this.handleImgClick}></img>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className="flexBox eventSettingItemArea" id="bannerTypeArea" style={{marginTop: "2%", marginBottom: "auto", height:"auto"}}>
                                    <div className="margin-vertical-auto eventSettingTitle" style={{width: "100%",}}>
                                        <label style={{marginTop: "auto", marginBottom: "15px"}}>세로형 배너유형</label>
                                        <div className="fa fa-question-circle margin-l-10">
                                            <div className="question-hover-area"><font style={{fontSize:"14px",  lineHeight:"15px", wordBreak:"keep-all"}}>원하시는 세로형 배너 유형을 선택해 주세요.<br/>선택하신 순서에 따라 배너가 자동 생성됩니다.<br/>(인공지능AI가 상품 이미지에 어울리는 최적의 색상을 찾아서 배너에 자동 적용합니다.)</font></div>
                                        </div>
                                    </div>
                                    <div className="flexBox bannerTypeImg eventSettingItemArea" style={{flex:"1", borderLeft: "0px"}}>
                                        <div className="flexBox" style={{width:"100%", flex:"1.5%"}}>
                                            {this.state.mobileBannerTypeList.map((bannerType,idx) => (
                                                <div key={idx} className="mobile-banner-inner" style={{margin: "0 auto auto 1%"}}>
                                                    <div className="flexBox">
                                                        <div id={bannerType.code_cd} className="checkbox-mobile-type" onClick={this.handleMobileTypeClick} style={{backgroundColor: "white", border:"1px solid black" ,width: "24px", height: "24px", textAlign:"center", marginBottom:"5px", color:"white", cursor:"pointer"}}></div>
                                                        &nbsp;{bannerType.val1}
                                                    </div>
                                                    <img src={bannerType.val2} width="100%" height="auto" style={{margin:"auto auto 10px auto", border:"0.5px solid dimgray"}} onClick={this.handleImgClick}></img>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div> */}

                                {/* <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                    <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                        <label style={{marginTop: "auto", marginBottom: "15px"}}><b>배너용 쇼핑몰 선택</b></label>
                                        <div className="fa fa-question-circle margin-l-10">
                                            <div className="question-hover-area"><font style={{fontSize:"14px",  lineHeight:"15px", wordBreak:"keep-all"}}>배너용 쇼핑몰을 선택해 주세요.<br/>선택한 쇼핑몰의 상품으로 배너를 생성합니다.<br/>(1개의 쇼핑몰만 선택 가능합니다.)</font></div>
                                        </div>
                                    </div>
                                    <div className="margin-vertical-auto flexBox" style={{width:"auto"}}>
                                        <select id="cafe24Shops" style={{maxWidth:"87vw", width:"400px", padding:"5px"}} onChange={this.handleShopNoChange}>
                                        {this.state.cafe24ShopsList.map((cafe24Shops,idx) => (
                                            <option key={idx} value={cafe24Shops.shop_no}>{cafe24Shops.shop_text}</option>
                                        ))}
                                        </select>
                                    </div>
                                </div>    */}
                            </div>
                        :   ""
                    }
                    {this.state.solution_type_cd != '09900' &&
                        Number(this.state.step) == 2
                        ?   <div>
                                <div className="flexBox">
                                    <div className="form_primary_title" style={{marginRight: "20px"}}>
                                        상품
                                    </div>
                                    <div className="userGuideButton" 
                                         onClick={(e) => Menu.call_userGuide('https://www.notion.so/iclave/4-8e2c8f9db1804792bdf78e70fff0d2aa#139a9f6504e64459a2f25e765091a82f')}
                                         style={{height: "25px", margin:"auto 0 auto 0"}}
                                    >
                                        <span>사용자 가이드</span>
                                    </div>
                                    <div className="userGuideButtonMobile" 
                                         onClick={(e) => Menu.call_userGuide('https://www.notion.so/iclave/4-8e2c8f9db1804792bdf78e70fff0d2aa#139a9f6504e64459a2f25e765091a82f')} 
                                         style={{height: "25px", margin:"auto 0 auto 0", float:'right'}}
                                    >
                                        <span>?</span>
                                    </div>
                                </div>
                                {/* <div style={{width:"100%", borderTop:"1px solid #676867", margin: "70px 0 0 0 "}}>
                                    <div style={{backgroundColor:"white", width:"160px", margin:"-10px auto 10px auto", padding:"0 10px 0 10px", color:"#676867", textAlign: "center"}}>
                                        배너용 상품 분석 기준
                                    </div>
                                    <div style={{marginTop: "auto", marginBottom: "auto"}}>
                                            <input type="radio" className="item_user_type" name="all_user" id="all_user" value="all_user" onClick={this.onClickItemUserType}/> 전체사용자 기준
                                            &nbsp;
                                            <input type="radio" className="item_user_type" name="member" id="member" value="member" onClick={this.onClickItemUserType}/> 회원/비회원 기준
                                            &nbsp;
                                            <div className="fa fa-question-circle margin-l-10">
                                                <div className="question-hover-area">
                                                    <font style={{fontSize:"14px",  lineHeight:"15px", wordBreak:"keep-all"}}>
                                                        - 전체사용자 기준 : 모든 사용자에게 같은 상품을 보여줍니다.<br/>
                                                        - 회원/비회원 기준 : 로그인 유무에 따라 다른 상품을 보여줍니다.       
                                                    </font>
                                                </div>
                                            </div>
                                    </div>
                                </div> */}
                                <div className="m-t-43">
                                    <div class="banner_radio_flexbox event_item_user_type_radio">
                                        <RadioButton
                                            id={"event_item_user_type_all_user"}
                                            name={"event_item_user_type"}
                                            value={"all_user"}
                                            checked={this.state.event_item_user_type == 15001}
                                            onChangeCheck={this.onClickItemUserType.bind(this)}
                                        >
                                            <div className="banner_radio_text">전체고객 기준
                                                <div className="fa fa-question-circle margin-l-10">
                                                    <div className="question-hover-area">
                                                        <font style={{fontSize:"14px",  lineHeight:"15px", wordBreak:"keep-all"}}>
                                                            회원과 비회원 모두에게 같은 상품을 보여줍니다.      
                                                        </font>
                                                    </div>
                                                </div>
                                            </div>
                                        </RadioButton>
                                        <RadioButton
                                            id={"event_item_user_type_all_member"}
                                            name={"event_item_user_type"}
                                            value={"member"}
                                            checked={this.state.event_item_user_type == 15002}
                                            onChangeCheck={this.onClickItemUserType.bind(this)}
                                        >
                                            <div className="banner_radio_text">회원/비회원 기준
                                                <div className="fa fa-question-circle margin-l-10">
                                                    <div className="question-hover-area">
                                                        <font style={{fontSize:"14px",  lineHeight:"15px", wordBreak:"keep-all"}}>
                                                            로그인 유무에 따라 다른 상품을 보여줍니다.       
                                                        </font>
                                                    </div>
                                                </div>
                                            </div>
                                        </RadioButton>
                                    </div>
                                
                                {   this.state.event_item_user_type == "15001" || !this.state.event_item_user_type
                                    ?   <div className="allUserItemSetting">
                                            <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}><b>카테고리 선택</b></label>
                                                    {/* <div className="fa fa-question-circle margin-l-10">
                                                        <div className="question-hover-area"><font style={{fontSize:"14px",  lineHeight:"15px", wordBreak:"keep-all"}}>  </font></div>
                                                    </div> */}
                                                </div>
                                                <div className="margin-vertical-auto flexBox" style={{width:"auto"}}>
                                                    <select id="category_for_all_user_1" className="border_form_radius_b_h_42" style={{width:"150px", padding:"5px"}} onChange={e => this.onChangeCategoryForAllUser(e,2)}
                                                            value={this.state.select_catefory_for_all_user_1}
                                                    >
                                                    <option value="" disabled>
                                                        카테고리를 선택해 주세요.
                                                    </option> 
                                                    {this.state.product_category_list_1 != null && this.state.product_category_list_1.map((obj, idx) => (
                                                        <option key={idx} value={obj.category_no}>
                                                            {obj.category_name_no_format}
                                                        </option>                            
                                                    ))}
                                                    </select>
                                                    {
                                                        this.state.product_category_list_2 != null && this.state.product_category_list_2.length > 0
                                                        ?   <select id="category_for_all_user_2" className="border_form_radius_b_h_42" style={{width:"150px", padding:"5px", marginLeft:"10px"}} onChange={e => this.onChangeCategoryForAllUser(e,3)}
                                                                    value={this.state.select_catefory_for_all_user_2}
                                                            >
                                                            <option value="" disabled>
                                                                하위 카테고리를 선택해 주세요.
                                                            </option> 
                                                            {this.state.product_category_list_2 != null && this.state.product_category_list_2.map((obj, idx) => (
                                                                <option key={idx} value={obj.category_no}>
                                                                    {obj.category_name_no_format}
                                                                </option>                            
                                                            ))}
                                                            </select>
                                                        : ""
                                                    }
                                                    {
                                                        this.state.product_category_list_3 != null && this.state.product_category_list_3.length > 0
                                                        ?   <select id="category_for_all_user_3" className="border_form_radius_b_h_42" style={{width:"150px", padding:"5px", marginLeft:"10px"}} onChange={e => this.onChangeCategoryForAllUser(e,4)}
                                                                    value={this.state.select_catefory_for_all_user_3}
                                                            >
                                                            <option value="" disabled>
                                                                하위 카테고리를 선택해 주세요.
                                                            </option> 
                                                            {this.state.product_category_list_3 != null && this.state.product_category_list_3.map((obj, idx) => (
                                                                <option key={idx} value={obj.category_no}>
                                                                    {obj.category_name_no_format}
                                                                </option>                            
                                                            ))}
                                                            </select>
                                                        : ""    
                                                    }
                                                    {   
                                                        this.state.product_category_list_4 != null && this.state.product_category_list_4.length > 0
                                                        ?   <select id="category_for_all_user_4" className="border_form_radius_b_h_42" style={{width:"150px", padding:"5px", marginLeft:"10px"}} onChange={e => this.onChangeCategoryForAllUser(e,5)}
                                                                    value={this.state.select_catefory_for_all_user_4}
                                                            >
                                                            <option value="" disabled>
                                                                하위 카테고리를 선택해 주세요.
                                                            </option> 
                                                            {this.state.product_category_list_4 != null &&  this.state.product_category_list_4.map((obj, idx) => (
                                                                <option key={idx} value={obj.category_no}>
                                                                    {obj.category_name_no_format}
                                                                </option>                            
                                                            ))}
                                                            </select>
                                                        : ""
                                                    }
                                                    <div className="flexBox" style={{marginLeft:"10px", height:"48px"}}>
                                                        <button className="btn-auto-d" style={{height:"100%", lineHeight:"100%"}} onClick={e => this.onClickAddCategoryForAllUser(e)}>   
                                                            선택된 카테고리 추가   +
                                                        </button>
                                                    </div>
                                                </div>
                                                <div style={{width: "100%"}}>
                                                    {this.state.select_category_name_list_for_all_user.map((obj, idx) => (
                                                        
                                                        <div className="round_grey_flex_box" style={{marginRight:"10px"}}>
                                                            {
                                                                obj.category_for_all_user_1 != null && obj.category_for_all_user_1 != ""
                                                                ? <div>{obj.category_for_all_user_1}</div>
                                                                : ""
                                                            }
                                                            {
                                                                obj.category_for_all_user_2 != null && obj.category_for_all_user_2 != ""
                                                                ? <div>&nbsp;&nbsp;&nbsp;&nbsp;<b style={{color:"#C9C9CC"}}>〉</b>&nbsp;&nbsp;&nbsp;&nbsp;{obj.category_for_all_user_2}</div>
                                                                : ""
                                                            }
                                                            {
                                                                obj.category_for_all_user_3 != null && obj.category_for_all_user_3 != ""
                                                                ? <div>&nbsp;&nbsp;&nbsp;&nbsp;<b style={{color:"#C9C9CC"}}>〉</b>&nbsp;&nbsp;&nbsp;&nbsp;{obj.category_for_all_user_3}</div>
                                                                : ""
                                                            }
                                                            {
                                                                obj.category_for_all_user_4 != null && obj.category_for_all_user_4 != ""
                                                                ? <div>&nbsp;&nbsp;&nbsp;&nbsp;<b style={{color:"#C9C9CC"}}>〉</b>&nbsp;&nbsp;&nbsp;&nbsp;{obj.category_for_all_user_4}</div>
                                                                : ""
                                                            }
                                                            <div className="m-l-15"></div>
                                                            <div className="btn_exit_grey cursor-pointer" onClick={e => this.onClickRemoveCategoryForAllUser(e, obj.category_no)}></div>
                                                        </div>
                                                    ))} 
                                                </div>
                                            </div>    


                                            <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}><b>상품 등록날짜</b></label>
                                                    <div className="fa fa-question-circle margin-l-10">
                                                        <div className="question-hover-area"><font style={{fontSize:"14px",  lineHeight:"15px", wordBreak:"keep-all"}}>최근 몇주간의 신상을 사용할지 선택해 주세요.</font></div>
                                                    </div>
                                                </div>
                                                <div className="margin-vertical-auto flexBox" style={{width:"auto"}}>
                                                    <select className="border_form_radius_b_h_42" id="event_item_created_period" style={{width:"150px", padding:"5px"}} onChange={this.handleItemCreatedPeriodChange}
                                                            value={this.state.all_user_item.event_item_created_period}>
                                                        <option value="0">
                                                            날짜 무관
                                                        </option>
                                                        <option value="1">
                                                            최근 1주
                                                        </option>
                                                        <option value="2">
                                                            최근 2주
                                                        </option>
                                                        <option value="3">
                                                            최근 3주
                                                        </option>
                                                        <option value="4">
                                                            최근 4주
                                                        </option>
                                                        <option value="8">
                                                            최근 8주
                                                        </option>
                                                        <option value="12">
                                                            최근 12주
                                                        </option>
                                                        <option value="24">
                                                            최근 24주
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>    
                                            <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}><b>상품분석 기간</b></label>
                                                    <div className="fa fa-question-circle margin-l-10">
                                                        <div className="question-hover-area"><font style={{fontSize:"14px",  lineHeight:"15px", wordBreak:"keep-all"}}>조회수, 리뷰수, 구매수를 분석할 기간을 선택해 주세요.</font></div>
                                                    </div>
                                                </div>
                                                <div className="margin-vertical-auto flexBox" style={{width:"auto"}}>
                                                    <select className="border_form_radius_b_h_42" id="event_item_analysis_period" style={{width:"150px", padding:"5px"}} onChange={this.handleItemAnalysisPeriodChange}
                                                            value={this.state.all_user_item.event_item_analysis_period}>
                                                        <option value="1">
                                                            최근 1주
                                                        </option>
                                                        <option value="2">
                                                            최근 2주
                                                        </option>
                                                        <option value="3">
                                                            최근 3주
                                                        </option>
                                                        <option value="4">
                                                            최근 4주
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}><b>상품 가격</b></label>
                                                </div>
                                                <div className="margin-vertical-auto flexBox" style={{width:"auto"}}>
                                                    <input className="border_form_radius_b_h_42"  type="number" name="event_item_min_price" id="event_item_min_price" onChange={this.handleItemPriceMinChange} value={this.state.all_user_item.event_item_min_price} onKeyDown={this.number_keydown} onBlur={e => this.onBlurItemPriceChange (e, "all")} disabled={this.state.all_user_item.isAnyPrice}></input> &nbsp;<div className="margin-vertical-auto">원</div>
                                                   <div className="margin-vertical-auto" style={{width:"50px", height:"100%", textAlign:"center", lineHeight:"25px"}}> ~ </div>
                                                    <input className="border_form_radius_b_h_42"  type="number" name="event_item_max_price" id="event_item_max_price" onChange={this.handleItemPriceMaxChange} value={this.state.all_user_item.event_item_max_price} onKeyDown={this.number_keydown} onBlur={e => this.onBlurItemPriceChange (e, "all")} disabled={this.state.all_user_item.isAnyPrice}></input> &nbsp;<div className="margin-vertical-auto">원</div>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;        
                                                    <div class="banner_check_flexbox event_setting_isAny_filter">
                                                        <CheckBox
                                                            id={"all_user_isAnyPrice"}
                                                            checked={this.state.all_user_item.isAnyPrice}
                                                            value={"all"}
                                                            onChangeCheck={this.onClickPriceAuto.bind(this)}
                                                        />
                                                        &nbsp;가격 무관
                                                    </div>
                                                </div>
                                            </div>     
                                            <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}><b>조회수</b></label>
                                                </div>
                                                <div className="margin-vertical-auto flexBox" style={{width:"auto"}}>
                                                    <input className="border_form_radius_b_h_42"  type="number" name="event_item_min_hit" id="event_item_min_hit" onChange={this.handleItemHitMinChange} value={this.state.all_user_item.event_item_min_hit} onKeyDown={this.number_keydown} onBlur={e => this.onBlurItemPriceChange (e, "all")} disabled={this.state.all_user_item.isAnyHit}></input> &nbsp;<div className="margin-vertical-auto">개</div>
                                                    <div className="margin-vertical-auto" style={{width:"50px", height:"100%", textAlign:"center", lineHeight:"25px"}}> ~ </div>
                                                    <input className="border_form_radius_b_h_42"  type="number" name="event_item_max_hit" id="event_item_max_hit" onChange={this.handleItemHitMaxChange} value={this.state.all_user_item.event_item_max_hit} onKeyDown={this.number_keydown} onBlur={e => this.onBlurItemPriceChange (e, "all")} disabled={this.state.all_user_item.isAnyHit}></input> &nbsp;<div className="margin-vertical-auto">개</div>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;        
                                                    <div class="banner_check_flexbox event_setting_isAny_filter">
                                                        <CheckBox
                                                            id={"all_user_isAnyHit"}
                                                            checked={this.state.all_user_item.isAnyHit}
                                                            value={"all"}
                                                            onChangeCheck={this.onClickHitAuto.bind(this)}
                                                        />
                                                        &nbsp;조회수 무관
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}>리뷰수</label>
                                                </div>
                                                <div className="margin-vertical-auto flexBox" style={{width:"auto"}}>
                                                    <input className="border_form_radius_b_h_42"  type="number" name="event_item_min_review" id="event_item_min_review" onChange={this.handleItemReviewMinChange} value={this.state.all_user_item.event_item_min_review} onKeyDown={this.number_keydown} onBlur={e => this.onBlurItemPriceChange (e)}></input> &nbsp;<div className="margin-vertical-auto">개</div>
                                                    <div className="margin-vertical-auto" style={{width:"50px", height:"100%", textAlign:"center", lineHeight:"25px"}}> ~ </div>
                                                    <input className="border_form_radius_b_h_42"  type="number" name="event_item_max_review" id="event_item_max_review" onChange={this.handleItemReviewMaxChange} value={this.state.all_user_item.event_item_max_review} onKeyDown={this.number_keydown} onBlur={e => this.onBlurItemPriceChange (e)}></input> &nbsp;<div className="margin-vertical-auto">개</div>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;        
                                                    {
                                                        this.state.all_user_item.isAnyReview
                                                        ? <div className="margin-vertical-auto checkbox_v2">
                                                            <div className="checkbox_flexBox">
                                                                <input className="border_form_radius_b_h_42" type="checkbox" onChange={this.onClickReviewAuto} checked={true}/> 
                                                                <div className="checkbox on" onClick={this.onClickReviewAuto}></div> 
                                                                &nbsp;리뷰수 무관
                                                            </div>
                                                        </div>
                                                        : <div className="margin-vertical-auto checkbox_v2">
                                                            <div className="checkbox_flexBox">
                                                                <input className="border_form_radius_b_h_42" type="checkbox" onChange={this.onClickReviewAuto}/> 
                                                                <div className="checkbox" onClick={this.onClickReviewAuto}></div> 
                                                                &nbsp;리뷰수 무관
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>      */}
                                            <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}><b>구매수</b></label>
                                                </div>
                                                <div className="margin-vertical-auto flexBox" style={{width:"auto"}}>
                                                    <input className="border_form_radius_b_h_42"  type="number" name="event_item_min_order" id="event_item_min_order" onChange={this.handleItemOrderMinChange} value={this.state.all_user_item.event_item_min_order} onKeyDown={this.number_keydown} onBlur={e => this.onBlurItemPriceChange (e, "all")} disabled={this.state.all_user_item.isAnyOrder}></input> &nbsp;<div className="margin-vertical-auto">개</div>
                                                   <div className="margin-vertical-auto" style={{width:"50px", height:"100%", textAlign:"center", lineHeight:"25px"}}> ~ </div>
                                                    <input className="border_form_radius_b_h_42"  type="number" name="event_item_max_order" id="event_item_max_order" onChange={this.handleItemOrderMaxChange} value={this.state.all_user_item.event_item_max_order} onKeyDown={this.number_keydown} onBlur={e => this.onBlurItemPriceChange (e, "all")} disabled={this.state.all_user_item.isAnyOrder}></input> &nbsp;<div className="margin-vertical-auto">개</div>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;        
                                                    <div class="banner_check_flexbox event_setting_isAny_filter">
                                                        <CheckBox
                                                            id={"all_user_isAnyOrder"}
                                                            checked={this.state.all_user_item.isAnyOrder}
                                                            value={"all"}
                                                            onChangeCheck={this.onClickOrderAuto.bind(this)}
                                                        />
                                                        &nbsp;구매수 무관
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}><b>상품을 중복체크하여 배너를 생성하겠습니까?</b></label>
                                                </div>
                                                <div className="margin-vertical-auto flexBox redio_v2" style={{width:"auto"}}>
                                                    <div style={{display:"flex", flexDirection:"column"}}>
                                                        {this.state.product_duplicate_check_type_list.map((obj, idx) => (
                                                            <div class="banner_check_flexbox" style={{marginBottom:"10px" ,flexWrap: "nowrap"}}>
                                                                <RadioButton
                                                                    id={"all/product_duplicate_check_type"+obj.code_cd}
                                                                    name={"all/product_duplicate_check_type"}
                                                                    value={obj.code_cd}
                                                                    checked={this.state.all_user_item.product_duplicate_check_type == obj.code_cd}
                                                                    onChangeCheck={this.onChangeProductDuplicateType.bind(this)}
                                                                />
                                                                <div style={{marginLeft:"10px"}}>{obj.val1}</div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>    
                                            </div>     

                                            {/* <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}>재고수</label>
                                                </div>
                                                <div className="margin-vertical-auto flexBox" style={{width:"auto"}}>
                                                    <input type="number" name="event_item_min_quantity" id="event_item_min_quantity" onChange={this.handleItemQuantityMinChange} value={this.state.all_user_item.event_item_min_quantity} onKeyDown={this.number_keydown} onBlur={this.onBlurItemQuantityChange}></input> &nbsp;개
                                                   <div className="margin-vertical-auto" style={{width:"50px", height:"100%", textAlign:"center", lineHeight:"25px"}}> ~ </div>
                                                    <input type="number" name="event_item_max_quantity" id="event_item_max_quantity" onChange={this.handleItemQuantityMaxChange} value={this.state.all_user_item.event_item_max_quantity} onKeyDown={this.number_keydown} onBlur={this.onBlurItemQuantityChange}></input> &nbsp;개
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;        
                                                    {
                                                        this.state.all_user_item.isAnyQuantity
                                                        ? <div className="margin-vertical-auto">
                                                            <input type="checkbox" onChange={this.onClickQuantityAuto} checked={true}/> 재고수 무관
                                                        </div>
                                                        : <div className="margin-vertical-auto">
                                                            <input type="checkbox" onChange={this.onClickQuantityAuto}/> 재고수 무관
                                                        </div>
                                                    }
                                                </div>
                                            </div>      */}
                                            {/* {
                                                this.state.allUserItemCnt != null && this.state.allUserItemCnt == "0"
                                                ?   <div style={{marginTop:"80px"}}>
                                                        <b style={{display:"flex"}}>
                                                        {
                                                            this.state.is_load_item_cnt_err_all
                                                            ?    <>
                                                                    <div className="icn_warning_round_red"></div>
                                                                    &nbsp;&nbsp;
                                                                    {this.state.item_cnt_err_msg_all}
                                                                </>  
                                                            :   
                                                                <>
                                                                    { this.state.is_load_item_cnt_all
                                                                    ?  
                                                                        <>
                                                                            <div><img src={icn_loading} style={{width:"20px", height:"20px"}}></img></div>
                                                                            &nbsp;&nbsp;
                                                                            상품 개수를 로딩중 입니다.
                                                                        </> 
                                                                    :   <>
                                                                        { this.state.is_load_item_cnt_err_all
                                                                        ?   <>
                                                                                <div className="icn_warning_round_red"></div>
                                                                                &nbsp;&nbsp;
                                                                                {this.state.item_cnt_err_msg_all}
                                                                            </>
                                                                        :   <>
                                                                                <div className="icn_warning_round_red"></div>
                                                                                &nbsp;&nbsp;
                                                                                상품 개수가 0개 입니다. 상품 설정을 다시해 주세요.
                                                                            </>    
                                                                        }
                                                                    </>
                                                                    }    
                                                                </>    
                                                        }
                                                        </b>
                                                    </div>
                                                :   ""
                                            }
                                            {
                                                this.state.allUserItemCnt != null && this.state.allUserItemCnt != "0"
                                                ?   <div style={{marginTop:"80px"}}>
                                                        <b style={{display:"flex"}}>
                                                        {
                                                            this.state.is_load_item_cnt_err_all
                                                            ?   <>
                                                                    <div className="icn_warning_round_red"></div>
                                                                    &nbsp;&nbsp;
                                                                    {this.state.item_cnt_err_msg_all}
                                                                </>
                                                            :   <>
                                                                { this.state.is_load_item_cnt_all
                                                                ?   <>
                                                                        <div><img src={icn_loading} style={{width:"20px", height:"20px"}}></img></div>
                                                                        &nbsp;&nbsp;
                                                                        상품 개수를 로딩중 입니다.
                                                                    </>
                                                                :   <>
                                                                    <div className="icn_warning_round_blue"></div>
                                                                    &nbsp;&nbsp;
                                                                    총&nbsp; 
                                                                    <div>
                                                                    {this.state.allUserItemCnt}
                                                                    개 
                                                                    </div>
                                                                    &nbsp;상품을 이용하여 배너를 생성합니다.
                                                                </>
                                                                }
                                                                </>
                                                        }
                                                        </b>
                                                    </div>
                                                :   ""
                                            } */}
                                        </div>
                                    :   <div className="allUserItemSetting">
                                            <div style={{marginTop: "10px", marginBottom:"30px", fontSize:"15px"}}><b>[회원 상품 설정]</b></div>


                                            <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}><b>카테고리 선택</b></label>
                                                    {/* <div className="fa fa-question-circle margin-l-10">
                                                        <div className="question-hover-area"><font style={{fontSize:"14px",  lineHeight:"15px", wordBreak:"keep-all"}}>  </font></div>
                                                    </div> */}
                                                </div>
                                                <div className="margin-vertical-auto flexBox" style={{width:"auto"}}>
                                                    <select id="category_for_only_user_1" className="border_form_radius_b_h_42" style={{width:"150px", padding:"5px"}} onChange={e => this.onChangeCategoryForOnlyUser(e,2)}
                                                            value={this.state.select_catefory_for_only_user_1}
                                                    >
                                                    <option value="" disabled>
                                                        카테고리를 선택해 주세요.
                                                    </option> 
                                                    {this.state.product_category_list_1 != null && this.state.product_category_list_1.map((obj, idx) => (
                                                        <option key={idx} value={obj.category_no}>
                                                            {obj.category_name_no_format}
                                                        </option>                            
                                                    ))}
                                                    </select>
                                                    {
                                                        this.state.product_category_list_2 != null && this.state.product_category_list_2.length > 0
                                                        ?   <select id="category_for_only_user_2" className="border_form_radius_b_h_42" style={{width:"150px", padding:"5px", marginLeft:"10px"}} onChange={e => this.onChangeCategoryForOnlyUser(e,3)}
                                                                    value={this.state.select_catefory_for_only_user_2}
                                                            >
                                                            <option value="" disabled>
                                                                하위 카테고리를 선택해 주세요.
                                                            </option> 
                                                            {this.state.product_category_list_2 != null && this.state.product_category_list_2.map((obj, idx) => (
                                                                <option key={idx} value={obj.category_no}>
                                                                    {obj.category_name_no_format}
                                                                </option>                            
                                                            ))}
                                                            </select>
                                                        : ""
                                                    }
                                                    {
                                                        this.state.product_category_list_3 != null && this.state.product_category_list_3.length > 0
                                                        ?   <select id="category_for_only_user_3" className="border_form_radius_b_h_42" style={{width:"150px", padding:"5px", marginLeft:"10px"}} onChange={e => this.onChangeCategoryForOnlyUser(e,4)}
                                                                    value={this.state.select_catefory_for_only_user_3}
                                                            >
                                                            <option value="" disabled>
                                                                하위 카테고리를 선택해 주세요.
                                                            </option> 
                                                            {this.state.product_category_list_3 != null && this.state.product_category_list_3.map((obj, idx) => (
                                                                <option key={idx} value={obj.category_no}>
                                                                    {obj.category_name_no_format}
                                                                </option>                            
                                                            ))}
                                                            </select>
                                                        : ""    
                                                    }
                                                    {   
                                                        this.state.product_category_list_4 != null && this.state.product_category_list_4.length > 0
                                                        ?   <select id="category_for_only_user_4" className="border_form_radius_b_h_42" style={{width:"150px", padding:"5px", marginLeft:"10px"}} onChange={e => this.onChangeCategoryForOnlyUser(e,5)}
                                                                    value={this.state.select_catefory_for_only_user_4}
                                                            >
                                                            <option value="" disabled>
                                                                하위 카테고리를 선택해 주세요.
                                                            </option> 
                                                            {this.state.product_category_list_4 != null &&  this.state.product_category_list_4.map((obj, idx) => (
                                                                <option key={idx} value={obj.category_no}>
                                                                    {obj.category_name_no_format}
                                                                </option>                            
                                                            ))}
                                                            </select>
                                                        : ""
                                                    }
                                                    <div className="flexBox" style={{marginLeft:"10px", height:"48px"}}>
                                                        <button className="btn-auto-d" style={{height:"100%", lineHeight:"100%"}} onClick={e => this.onClickAddCategoryForOnlyUser(e)}>   
                                                            선택된 카테고리 추가   +
                                                        </button>
                                                    </div>
                                                </div>
                                                <div style={{width: "100%"}}>
                                                    {this.state.select_category_name_list_for_only_user.map((obj, idx) => (
                                                        
                                                        <div className="round_grey_flex_box" style={{marginLeft:"10px"}}>
                                                            {
                                                                obj.category_for_only_user_1 != null && obj.category_for_only_user_1 != ""
                                                                ? <div>{obj.category_for_only_user_1}</div>
                                                                : ""
                                                            }
                                                            {
                                                                obj.category_for_only_user_2 != null && obj.category_for_only_user_2 != ""
                                                                ? <div>&nbsp;&nbsp;&nbsp;&nbsp;<b style={{color:"#C9C9CC"}}>〉</b>&nbsp;&nbsp;&nbsp;&nbsp;{obj.category_for_only_user_2}</div>
                                                                : ""
                                                            }
                                                            {
                                                                obj.category_for_only_user_3 != null && obj.category_for_only_user_3 != ""
                                                                ? <div>&nbsp;&nbsp;&nbsp;&nbsp;<b style={{color:"#C9C9CC"}}>〉</b>&nbsp;&nbsp;&nbsp;&nbsp;{obj.category_for_only_user_3}</div>
                                                                : ""
                                                            }
                                                            {
                                                                obj.category_for_only_user_4 != null && obj.category_for_only_user_4 != ""
                                                                ? <div>&nbsp;&nbsp;&nbsp;&nbsp;<b style={{color:"#C9C9CC"}}>〉</b>&nbsp;&nbsp;&nbsp;&nbsp;{obj.category_for_only_user_4}</div>
                                                                : ""
                                                            }
                                                            <div className="m-l-15"></div>
                                                            <div className="btn_exit_grey cursor-pointer" onClick={e => this.onClickRemoveCategoryForOnlyUser(e, obj.category_no)}></div>
                                                        </div>
                                                    ))} 
                                                </div>
                                            </div>    

                                            <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}> 
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}><b>상품 등록날짜</b></label>
                                                    <div className="fa fa-question-circle margin-l-10">
                                                        <div className="question-hover-area"><font style={{fontSize:"14px",  lineHeight:"15px", wordBreak:"keep-all"}}>최근 몇주간의 신상을 사용할지 선택해 주세요.</font></div>
                                                    </div>
                                                </div>
                                                <div className="margin-vertical-auto flexBox" style={{width:"auto"}}>
                                                    <select className="border_form_radius_b_h_42" id="event_item_created_period_member_user" style={{width:"150px", padding:"5px"}} onChange={this.handleItemCreatedPeriodChangeForMemberUser}
                                                            value={this.state.member_user_item.event_item_created_period}>
                                                        <option value="0">
                                                            날짜 무관
                                                        </option>
                                                        <option value="1">
                                                            최근 1주
                                                        </option>
                                                        <option value="2">
                                                            최근 2주
                                                        </option>
                                                        <option value="3">
                                                            최근 3주
                                                        </option>
                                                        <option value="4">
                                                            최근 4주
                                                        </option>
                                                        <option value="8">
                                                            최근 8주
                                                        </option>
                                                        <option value="12">
                                                            최근 12주
                                                        </option>
                                                        <option value="24">
                                                            최근 24주
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>    
                                            <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}> 
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}><b>상품분석 기간</b></label>
                                                    <div className="fa fa-question-circle margin-l-10">
                                                        <div className="question-hover-area"><font style={{fontSize:"14px",  lineHeight:"15px", wordBreak:"keep-all"}}>조회수, 리뷰수, 구매수를 분석할 기간을 선택해 주세요.</font></div>
                                                    </div>
                                                </div>
                                                <div className="margin-vertical-auto flexBox" style={{width:"auto"}}>
                                                    <select className="border_form_radius_b_h_42" id="event_item_analysis_period_member_user" style={{width:"150px", padding:"5px"}} onChange={this.handleItemAnalysisPeriodChangeForMemberUser}
                                                            value={this.state.member_user_item.event_item_analysis_period}>
                                                        <option value="1">
                                                            최근 1주
                                                        </option>
                                                        <option value="2">
                                                            최근 2주
                                                        </option>
                                                        <option value="3">
                                                            최근 3주
                                                        </option>
                                                        <option value="4">
                                                            최근 4주
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}><b>상품 가격</b></label>
                                                </div>
                                                <div className="margin-vertical-auto flexBox" style={{width:"auto"}}>
                                                    <input className="border_form_radius_b_h_42" type="number" name="event_item_min_price_member_user" id="event_item_min_price_member_user" onChange={this.handleItemPriceMinChangeForMemberUser} value={this.state.member_user_item.event_item_min_price} onKeyDown={this.number_keydown} onBlur={e => this.onBlurItemPriceChange (e, "member")} disabled={this.state.member_user_item.isAnyPrice}></input> &nbsp;<div className="margin-vertical-auto">원</div>
                                                   <div className="margin-vertical-auto" style={{width:"50px", height:"100%", textAlign:"center", lineHeight:"25px"}}> ~ </div>
                                                    <input className="border_form_radius_b_h_42"  type="number" name="event_item_max_price_member_user" id="event_item_max_price_member_user" onChange={this.handleItemPriceMaxChangeForMemberUser} value={this.state.member_user_item.event_item_max_price} onKeyDown={this.number_keydown} onBlur={e => this.onBlurItemPriceChange (e, "member")} disabled={this.state.member_user_item.isAnyPrice}></input> &nbsp;<div className="margin-vertical-auto">원</div>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;        
                                                    <div class="banner_check_flexbox event_setting_isAny_filter">
                                                        <CheckBox
                                                            id={"member_user_isAnyPrice"}
                                                            checked={this.state.member_user_item.isAnyPrice}
                                                            value={"member"}
                                                            onChangeCheck={this.onClickPriceAuto.bind(this)}
                                                        />
                                                        &nbsp;가격 무관
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}><b>조회수</b></label>
                                                </div>
                                                <div className="margin-vertical-auto flexBox" style={{width:"auto"}}>
                                                    <input className="border_form_radius_b_h_42"  type="number" name="event_item_min_hit_member_user" id="event_item_min_hit_member_user" onChange={this.handleItemHitMinChangeForMemberUser} value={this.state.member_user_item.event_item_min_hit} onKeyDown={this.number_keydown} onBlur={e => this.onBlurItemPriceChange (e, "member")} disabled={this.state.member_user_item.isAnyHit}></input> &nbsp;<div className="margin-vertical-auto">개</div>
                                                   <div className="margin-vertical-auto" style={{width:"50px", height:"100%", textAlign:"center", lineHeight:"25px"}}> ~ </div>
                                                    <input className="border_form_radius_b_h_42"  type="number" name="event_item_max_hit_member_user" id="event_item_max_hit_member_user" onChange={this.handleItemHitMaxChangeForMemberUser} value={this.state.member_user_item.event_item_max_hit} onKeyDown={this.number_keydown} onBlur={e => this.onBlurItemPriceChange (e, "member")} disabled={this.state.member_user_item.isAnyHit}></input> &nbsp;<div className="margin-vertical-auto">개</div>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;        
                                                    {/* {
                                                        this.state.member_user_item.isAnyHit
                                                        ? <div className="margin-vertical-auto checkbox_v2">
                                                            <div className="checkbox_flexBox">
                                                                <input className="border_form_radius_b_h_42" type="checkbox" onChange={this.onClickHitAutoForMemberUser} checked={true}/> 
                                                                <div className="checkbox on" onClick={e => this.onClickHitAutoForMemberUser(e, "off")}></div> 
                                                                &nbsp;조회수 무관
                                                            </div>
                                                        </div>
                                                        : <div className="margin-vertical-auto checkbox_v2">
                                                            <div className="checkbox_flexBox">
                                                                <input className="border_form_radius_b_h_42" type="checkbox" onChange={this.onClickHitAutoForMemberUser}/> 
                                                                <div className="checkbox" onClick={e => this.onClickHitAutoForMemberUser(e, "on")}></div> 
                                                                &nbsp;조회수 무관
                                                            </div>
                                                        </div>
                                                    } */}
                                                    <div class="banner_check_flexbox event_setting_isAny_filter">
                                                        <CheckBox
                                                            id={"member_user_isAnyHit"}
                                                            checked={this.state.member_user_item.isAnyHit}
                                                            value={"member"}
                                                            onChangeCheck={this.onClickHitAuto.bind(this)}
                                                        />
                                                        &nbsp;조회수 무관
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}>리뷰수</label>
                                                </div>
                                                <div className="margin-vertical-auto flexBox" style={{width:"auto"}}>
                                                    <input className="border_form_radius_b_h_42"  type="number" name="event_item_min_review_member_user" id="event_item_min_review_member_user" disabled={false} onChange={this.handleItemReviewMinChangeForMemberUser} value={this.state.member_user_item.event_item_min_review} onKeyDown={this.number_keydown} onBlur={e => this.onBlurItemPriceChange (e)}></input> &nbsp;<div className="margin-vertical-auto">개</div>
                                                   <div className="margin-vertical-auto" style={{width:"50px", height:"100%", textAlign:"center", lineHeight:"25px"}}> ~ </div>
                                                    <input className="border_form_radius_b_h_42"  type="number" name="event_item_max_review_member_user" id="event_item_max_review_member_user" disabled={false} onChange={this.handleItemReviewMaxChangeForMemberUser} value={this.state.member_user_item.event_item_max_review} onKeyDown={this.number_keydown} onBlur={e => this.onBlurItemPriceChange (e)}></input> &nbsp;<div className="margin-vertical-auto">개</div>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;        
                                                    {
                                                        this.state.member_user_item.isAnyReview
                                                        ? <div className="margin-vertical-auto checkbox_v2">
                                                            <div className="checkbox_flexBox">
                                                                <input className="border_form_radius_b_h_42" type="checkbox" onChange={this.onClickReviewAutoForMemberUser} checked={true}/> 
                                                                <div className="checkbox on" onClick={this.onClickReviewAutoForMemberUser}></div> 
                                                                &nbsp;리뷰수 무관
                                                            </div>
                                                        </div>
                                                        : <div className="margin-vertical-auto checkbox_v2">
                                                            <div className="checkbox_flexBox">
                                                                <input className="border_form_radius_b_h_42" type="checkbox" onChange={this.onClickReviewAutoForMemberUser}/> 
                                                                <div className="checkbox" onClick={this.onClickReviewAutoForMemberUser}></div> 
                                                                &nbsp;리뷰수 무관
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>      */}
                                            <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}><b>구매수</b></label>
                                                </div>
                                                <div className="margin-vertical-auto flexBox" style={{width:"auto"}}>
                                                    <input className="border_form_radius_b_h_42"  type="number" name="event_item_min_order_member_user" id="event_item_min_order_member_user" onChange={this.handleItemOrderMinChangeForMemberUser} value={this.state.member_user_item.event_item_min_order} onKeyDown={this.number_keydown} onBlur={e => this.onBlurItemPriceChange (e, "member")} disabled={this.state.member_user_item.isAnyOrder}></input> &nbsp;<div className="margin-vertical-auto">개</div>
                                                   <div className="margin-vertical-auto" style={{width:"50px", height:"100%", textAlign:"center", lineHeight:"25px"}}> ~ </div>
                                                    <input className="border_form_radius_b_h_42"  type="number" name="event_item_max_order_member_user" id="event_item_max_order_member_user" onChange={this.handleItemOrderMaxChangeForMemberUser} value={this.state.member_user_item.event_item_max_order} onKeyDown={this.number_keydown} onBlur={e => this.onBlurItemPriceChange (e, "member")} disabled={this.state.member_user_item.isAnyOrder}></input> &nbsp;<div className="margin-vertical-auto">개</div>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;        
                                                    {/* {
                                                        this.state.member_user_item.isAnyOrder
                                                        ? <div className="margin-vertical-auto checkbox_v2">
                                                            <div className="checkbox_flexBox">
                                                                <input className="border_form_radius_b_h_42" type="checkbox" onChange={this.onClickOrderAutoForMemberUser} checked={true}/> 
                                                                <div className="checkbox on" onClick={e => this.onClickOrderAutoForMemberUser(e, "off")}></div> 
                                                                &nbsp;구매수 무관
                                                            </div>
                                                        </div>
                                                        : <div className="margin-vertical-auto checkbox_v2">
                                                            <div className="checkbox_flexBox">
                                                                <input className="border_form_radius_b_h_42" type="checkbox" onChange={this.onClickOrderAutoForMemberUser}/> 
                                                                <div className="checkbox" onClick={e => this.onClickOrderAutoForMemberUser(e, "on")}></div> 
                                                                &nbsp;구매수 무관
                                                            </div>
                                                        </div>
                                                    } */}
                                                    <div class="banner_check_flexbox event_setting_isAny_filter">
                                                        <CheckBox
                                                            id={"member_user_isAnyOrder"}
                                                            checked={this.state.member_user_item.isAnyOrder}
                                                            value={"member"}
                                                            onChangeCheck={this.onClickOrderAuto.bind(this)}
                                                        />
                                                        &nbsp;구매수 무관
                                                    </div>
                                                </div>
                                            </div>  

                                            <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}><b>상품을 중복체크하여 배너를 생성하겠습니까?</b></label>
                                                </div>
                                                <div className="margin-vertical-auto flexBox redio_v2" style={{width:"auto"}}>
                                                    <div style={{display:"flex", flexDirection:"column"}}>
                                                        {this.state.product_duplicate_check_type_list.map((obj, idx) => (
                                                            <div class="banner_check_flexbox" style={{marginBottom:"10px" ,flexWrap: "nowrap"}}>
                                                                <RadioButton
                                                                    id={"member/product_duplicate_check_type"+obj.code_cd}
                                                                    name={"member/product_duplicate_check_type"}
                                                                    value={obj.code_cd}
                                                                    checked={this.state.member_user_item.product_duplicate_check_type == obj.code_cd}
                                                                    onChangeCheck={this.onChangeProductDuplicateType.bind(this)}
                                                                />
                                                                <div style={{marginLeft:"10px"}}>{obj.val1}</div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>    
                                            </div>

                                            {/*  <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}>재고수</label>
                                                </div>
                                               <div className="margin-vertical-auto flexBox" style={{width:"auto"}}>
                                                    <input type="number" name="event_item_min_quantity_member_user" id="event_item_min_quantity_member_user" disabled={false} onChange={this.handleItemQuantityMinChangeForMemberUser} value={this.state.member_user_item.event_item_min_quantity} onKeyDown={this.number_keydown} onBlur={this.onBlurItemQuantityChange}></input> &nbsp;개
                                                   <div className="margin-vertical-auto" style={{width:"50px", height:"100%", textAlign:"center", lineHeight:"25px"}}> ~ </div>
                                                    <input type="number" name="event_item_max_quantity_member_user" id="event_item_max_quantity_member_user" disabled={false} onChange={this.handleItemQuantityMaxChangeForMemberUser} value={this.state.member_user_item.event_item_max_quantity} onKeyDown={this.number_keydown} onBlur={this.onBlurItemQuantityChange}></input> &nbsp;개
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;        
                                                    {
                                                        this.state.member_user_item.isAnyQuantity
                                                        ? <div className="margin-vertical-auto">
                                                            <input type="checkbox" onChange={this.onClickQuantityAutoForMemberUser} checked={true}/> 재고수 무관
                                                        </div>
                                                        : <div className="margin-vertical-auto">
                                                            <input type="checkbox" onChange={this.onClickQuantityAutoForMemberUser}/> 재고수 무관
                                                        </div>
                                                    }
                                                </div> 
                                            </div> */}
                                            {/* {
                                                this.state.memberUserItemCnt != null && this.state.memberUserItemCnt == "0"
                                                ?   <div style={{marginTop:"50px"}}>
                                                        <b style={{display:"flex"}}>
                                                        {
                                                            this.state.is_load_item_cnt_err_member
                                                            ?   <>
                                                                    <div className="icn_warning_round_red"></div>
                                                                    &nbsp;&nbsp;
                                                                    {this.state.item_cnt_err_msg_member}
                                                                </>
                                                            :   <>
                                                                { this.state.is_load_item_cnt_member
                                                                ?    <>
                                                                        <div><img src={icn_loading} style={{width:"20px", height:"20px"}}></img></div>
                                                                        &nbsp;&nbsp;
                                                                        상품 개수를 로딩중입니다.
                                                                    </> 
                                                                :   <>
                                                                    <div className="icn_warning_round_red"></div>
                                                                    &nbsp;&nbsp;
                                                                    상품 개수가 0개 입니다. 상품 설정을 다시해 주세요.
                                                                </>   
                                                                } 
                                                                </>    
                                                        }
                                                        </b>
                                                    </div>
                                                :   ""
                                            }
                                            {
                                                this.state.memberUserItemCnt != null && this.state.memberUserItemCnt != "0"
                                                ?   <div style={{marginTop:"50px"}}>
                                                        <b style={{display:"flex"}}>
                                                        {
                                                            this.state.is_load_item_cnt_err_member
                                                            ?   <>
                                                                    <div className="icn_warning_round_red"></div>
                                                                    &nbsp;&nbsp;
                                                                    {this.state.item_cnt_err_msg_member}
                                                                </>
                                                            :   <>
                                                                { this.state.is_load_item_cnt_member
                                                                ?   <>
                                                                        <div><img src={icn_loading} style={{width:"20px", height:"20px"}}></img></div>
                                                                        &nbsp;&nbsp;
                                                                        상품 개수를 로딩중 입니다.
                                                                    </>
                                                                :   <>
                                                                    <div className="icn_warning_round_blue"></div>
                                                                    &nbsp;&nbsp;
                                                                    총&nbsp; 
                                                                    <div>
                                                                    {this.state.memberUserItemCnt}
                                                                    개 
                                                                    </div>
                                                                    &nbsp;상품을 이용하여 배너를 생성합니다.
                                                                </>
                                                                }
                                                                </>
                                                        }
                                                        </b>
                                                    </div>
                                                :   ""
                                            } */}
                                            
                                               
                                            <div style={{marginTop: "80px", marginBottom:"30px", fontSize:"15px"}}><b>[비회원 상품 설정]</b></div>


                                            <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}><b>카테고리 선택</b></label>
                                                    {/* <div className="fa fa-question-circle margin-l-10">
                                                        <div className="question-hover-area"><font style={{fontSize:"14px",  lineHeight:"15px", wordBreak:"keep-all"}}>  </font></div>
                                                    </div> */}
                                                </div>
                                                <div className="margin-vertical-auto flexBox" style={{width:"auto"}}>
                                                    <select id="category_for_non_user_1" className="border_form_radius_b_h_42" style={{width:"150px", padding:"5px"}} onChange={e => this.onChangeCategoryForNonUser(e,2)}
                                                            value={this.state.select_catefory_for_non_user_1}
                                                    >
                                                    <option value="" disabled>
                                                        카테고리를 선택해 주세요.
                                                    </option> 
                                                    {this.state.product_category_list_1 != null && this.state.product_category_list_1.map((obj, idx) => (
                                                        <option key={idx} value={obj.category_no}>
                                                            {obj.category_name_no_format}
                                                        </option>                            
                                                    ))}
                                                    </select>
                                                    {
                                                        this.state.product_category_list_2 != null && this.state.product_category_list_2.length > 0
                                                        ?   <select id="category_for_non_user_2" className="border_form_radius_b_h_42" style={{width:"150px", padding:"5px", marginLeft:"10px"}} onChange={e => this.onChangeCategoryForNonUser(e,3)}
                                                                    value={this.state.select_catefory_for_non_user_2}
                                                            >
                                                            <option value="" disabled>
                                                                하위 카테고리를 선택해 주세요.
                                                            </option> 
                                                            {this.state.product_category_list_2 != null && this.state.product_category_list_2.map((obj, idx) => (
                                                                <option key={idx} value={obj.category_no}>
                                                                    {obj.category_name_no_format}
                                                                </option>                            
                                                            ))}
                                                            </select>
                                                        : ""
                                                    }
                                                    {
                                                        this.state.product_category_list_3 != null && this.state.product_category_list_3.length > 0
                                                        ?   <select id="category_for_non_user_3" className="border_form_radius_b_h_42" style={{width:"150px", padding:"5px", marginLeft:"10px"}} onChange={e => this.onChangeCategoryForNonUser(e,4)}
                                                                    value={this.state.select_catefory_for_non_user_3}
                                                            >
                                                            <option value="" disabled>
                                                                하위 카테고리를 선택해 주세요.
                                                            </option> 
                                                            {this.state.product_category_list_3 != null && this.state.product_category_list_3.map((obj, idx) => (
                                                                <option key={idx} value={obj.category_no}>
                                                                    {obj.category_name_no_format}
                                                                </option>                            
                                                            ))}
                                                            </select>
                                                        : ""    
                                                    }
                                                    {   
                                                        this.state.product_category_list_4 != null && this.state.product_category_list_4.length > 0
                                                        ?   <select id="category_for_non_user_4" className="border_form_radius_b_h_42" style={{width:"150px", padding:"5px", marginLeft:"10px"}} onChange={e => this.onChangeCategoryForNonUser(e,5)}
                                                                    value={this.state.select_catefory_for_non_user_4}
                                                            >
                                                            <option value="" disabled>
                                                                하위 카테고리를 선택해 주세요.
                                                            </option> 
                                                            {this.state.product_category_list_4 != null &&  this.state.product_category_list_4.map((obj, idx) => (
                                                                <option key={idx} value={obj.category_no}>
                                                                    {obj.category_name_no_format}
                                                                </option>                            
                                                            ))}
                                                            </select>
                                                        : ""
                                                    }
                                                    <div className="flexBox" style={{marginLeft:"10px", height:"48px"}}>
                                                        <button className="btn-auto-d" style={{height:"100%", lineHeight:"100%"}} onClick={e => this.onClickAddCategoryForNonUser(e)}>   
                                                            선택된 카테고리 추가   +
                                                        </button>
                                                    </div>
                                                </div>
                                                <div style={{width: "100%"}}>
                                                    {this.state.select_category_name_list_for_non_user.map((obj, idx) => (
                                                        
                                                        <div className="round_grey_flex_box" style={{marginRight:"10px"}}>
                                                            {
                                                                obj.category_for_non_user_1 != null && obj.category_for_non_user_1 != ""
                                                                ? <div>{obj.category_for_non_user_1}</div>
                                                                : ""
                                                            }
                                                            {
                                                                obj.category_for_non_user_2 != null && obj.category_for_non_user_2 != ""
                                                                ? <div>&nbsp;&nbsp;&nbsp;&nbsp;<b style={{color:"#C9C9CC"}}>〉</b>&nbsp;&nbsp;&nbsp;&nbsp;{obj.category_for_non_user_2}</div>
                                                                : ""
                                                            }
                                                            {
                                                                obj.category_for_non_user_3 != null && obj.category_for_non_user_3 != ""
                                                                ? <div>&nbsp;&nbsp;&nbsp;&nbsp;<b style={{color:"#C9C9CC"}}>〉</b>&nbsp;&nbsp;&nbsp;&nbsp;{obj.category_for_non_user_3}</div>
                                                                : ""
                                                            }
                                                            {
                                                                obj.category_for_non_user_4 != null && obj.category_for_non_user_4 != ""
                                                                ? <div>&nbsp;&nbsp;&nbsp;&nbsp;<b style={{color:"#C9C9CC"}}>〉</b>&nbsp;&nbsp;&nbsp;&nbsp;{obj.category_for_non_user_4}</div>
                                                                : ""
                                                            }
                                                            <div className="m-l-15"></div>
                                                            <div className="btn_exit_grey cursor-pointer" onClick={e => this.onClickRemoveCategoryForNonUser(e, obj.category_no)}></div>
                                                        </div>
                                                    ))} 
                                                </div>
                                            </div>


                                            
                                            <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}><b>상품 등록날짜</b></label>
                                                    <div className="fa fa-question-circle margin-l-10">
                                                        <div className="question-hover-area"><font style={{fontSize:"14px",  lineHeight:"15px", wordBreak:"keep-all"}}>최근 몇주간의 신상을 사용할지 선택해 주세요.</font></div>
                                                    </div>
                                                </div>
                                                <div className="margin-vertical-auto flexBox" style={{width:"auto"}}>
                                                    <select className="border_form_radius_b_h_42" id="event_item_created_period_none_user" style={{width:"150px", padding:"5px"}} onChange={this.handleItemCreatedPeriodChangeForNoneUser}
                                                            value={this.state.none_user_item.event_item_created_period}>
                                                        <option value="0">
                                                            날짜 무관
                                                        </option>
                                                        <option value="1">
                                                            최근 1주
                                                        </option>
                                                        <option value="2">
                                                            최근 2주
                                                        </option>
                                                        <option value="3">
                                                            최근 3주
                                                        </option>
                                                        <option value="4">
                                                            최근 4주
                                                        </option>
                                                        <option value="8">
                                                            최근 8주
                                                        </option>
                                                        <option value="12">
                                                            최근 12주
                                                        </option>
                                                        <option value="24">
                                                            최근 24주
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>    
                                            <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}><b>상품분석 기간</b></label>
                                                    <div className="fa fa-question-circle margin-l-10">
                                                        <div className="question-hover-area"><font style={{fontSize:"14px",  lineHeight:"15px", wordBreak:"keep-all"}}>조회수, 리뷰수, 구매수를 분석할 기간을 선택해 주세요.</font></div>
                                                    </div>
                                                </div>
                                                <div className="margin-vertical-auto flexBox" style={{width:"auto"}}>
                                                    <select className="border_form_radius_b_h_42" id="event_item_analysis_period_none_user" style={{width:"150px", padding:"5px"}} onChange={this.handleItemAnalysisPeriodChangeForNoneUser}
                                                            value={this.state.none_user_item.event_item_analysis_period}>
                                                        <option value="1">
                                                            최근 1주
                                                        </option>
                                                        <option value="2">
                                                            최근 2주
                                                        </option>
                                                        <option value="3">
                                                            최근 3주
                                                        </option>
                                                        <option value="4">
                                                            최근 4주
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}><b>상품 가격</b></label>
                                                </div>
                                                <div className="margin-vertical-auto flexBox" style={{width:"auto"}}>
                                                    <input className="border_form_radius_b_h_42"  type="number" name="event_item_min_price_none_user" id="event_item_min_price_none_user" onChange={this.handleItemPriceMinChangeForNoneUser} value={this.state.none_user_item.event_item_min_price} onKeyDown={this.number_keydown} onBlur={e => this.onBlurItemPriceChange (e, "non")} disabled={this.state.none_user_item.isAnyPrice}></input> &nbsp;<div className="margin-vertical-auto">원</div>
                                                   <div className="margin-vertical-auto" style={{width:"50px", height:"100%", textAlign:"center", lineHeight:"25px"}}> ~ </div>
                                                    <input className="border_form_radius_b_h_42"  type="number" name="event_item_max_price_none_user" id="event_item_max_price_none_user" onChange={this.handleItemPriceMaxChangeForNoneUser} value={this.state.none_user_item.event_item_max_price} onKeyDown={this.number_keydown} onBlur={e => this.onBlurItemPriceChange (e, "non")} disabled={this.state.none_user_item.isAnyPrice}></input> &nbsp;<div className="margin-vertical-auto">원</div>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;        
                                                    <div class="banner_check_flexbox event_setting_isAny_filter">
                                                        <CheckBox
                                                            id={"none_user_isAnyPrice"}
                                                            checked={this.state.none_user_item.isAnyPrice}
                                                            value={"none"}
                                                            onChangeCheck={this.onClickPriceAuto.bind(this)}
                                                        />
                                                        &nbsp;가격 무관
                                                    </div>
                                                </div>
                                            </div>   
                                            <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}><b>조회수</b></label>
                                                </div>
                                                <div className="margin-vertical-auto flexBox" style={{width:"auto"}}>
                                                    <input className="border_form_radius_b_h_42"  type="number" name="event_item_min_hit_none_user" id="event_item_min_hit_none_user" onChange={this.handleItemHitMinChangeForNoneUser} value={this.state.none_user_item.event_item_min_hit} onKeyDown={this.number_keydown} onBlur={e => this.onBlurItemPriceChange (e, "non")} disabled={this.state.none_user_item.isAnyHit}></input> &nbsp;<div className="margin-vertical-auto">개</div>
                                                   <div className="margin-vertical-auto" style={{width:"50px", height:"100%", textAlign:"center", lineHeight:"25px"}}> ~ </div>
                                                    <input className="border_form_radius_b_h_42"  type="number" name="event_item_max_hit_none_user" id="event_item_max_hit_none_user" onChange={this.handleItemHitMaxChangeForNoneUser} value={this.state.none_user_item.event_item_max_hit} onKeyDown={this.number_keydown} onBlur={e => this.onBlurItemPriceChange (e, "non")} disabled={this.state.none_user_item.isAnyHit}></input> &nbsp;<div className="margin-vertical-auto">개</div>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;        
                                                    <div class="banner_check_flexbox event_setting_isAny_filter">
                                                        <CheckBox
                                                            id={"none_user_isAnyHit"}
                                                            checked={this.state.none_user_item.isAnyHit}
                                                            value={"none"}
                                                            onChangeCheck={this.onClickHitAuto.bind(this)}
                                                        />
                                                        &nbsp;조회수 무관
                                                    </div>
                                                </div>
                                            </div>

                                            {/* <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}>리뷰수</label>
                                                </div>
                                                <div className="margin-vertical-auto flexBox" style={{width:"auto"}}>
                                                    <input className="border_form_radius_b_h_42"  type="number" name="event_item_min_review_none_user" id="event_item_min_review_none_user" onChange={this.handleItemReviewMinChangeForNoneUser} value={this.state.none_user_item.event_item_min_review} onKeyDown={this.number_keydown} onBlur={e => this.onBlurItemPriceChange (e)}></input> &nbsp;<div className="margin-vertical-auto">개</div>
                                                   <div className="margin-vertical-auto" style={{width:"50px", height:"100%", textAlign:"center", lineHeight:"25px"}}> ~ </div>
                                                    <input className="border_form_radius_b_h_42"  type="number" name="event_item_max_review_none_user" id="event_item_max_review_none_user" onChange={this.handleItemReviewMaxChangeForNoneUser} value={this.state.none_user_item.event_item_max_review} onKeyDown={this.number_keydown} onBlur={e => this.onBlurItemPriceChange (e)}></input> &nbsp;<div className="margin-vertical-auto">개</div>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;        
                                                    {
                                                        this.state.none_user_item.isAnyReview
                                                        ? <div className="margin-vertical-auto checkbox_v2">
                                                            <div className="checkbox_flexBox">
                                                                <input className="border_form_radius_b_h_42" type="checkbox" onChange={this.onClickReviewAutoForNoneUser} checked={true}/> 
                                                                <div className="checkbox on" onClick={this.onClickReviewAutoForNoneUser}></div> 
                                                                &nbsp;리뷰수 무관
                                                            </div>
                                                        </div>
                                                        : <div className="margin-vertical-auto checkbox_v2">
                                                            <div className="checkbox_flexBox">
                                                                <input className="border_form_radius_b_h_42" type="checkbox" onChange={this.onClickReviewAutoForNoneUser}/> 
                                                                <div className="checkbox" onClick={this.onClickReviewAutoForNoneUser}></div> 
                                                                &nbsp;리뷰수 무관
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>      */}
                                            <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}><b>구매수</b></label>
                                                </div>
                                                <div className="margin-vertical-auto flexBox" style={{width:"auto"}}>
                                                    <input className="border_form_radius_b_h_42"  type="number" name="event_item_min_order_none_user" id="event_item_min_order_none_user" onChange={this.handleItemOrderMinChangeForNoneUser} value={this.state.none_user_item.event_item_min_order} onKeyDown={this.number_keydown} onBlur={e => this.onBlurItemPriceChange (e, "non")} disabled={this.state.none_user_item.isAnyOrder}></input> &nbsp;<div className="margin-vertical-auto">개</div>
                                                   <div className="margin-vertical-auto" style={{width:"50px", height:"100%", textAlign:"center", lineHeight:"25px"}}> ~ </div>
                                                    <input className="border_form_radius_b_h_42"  type="number" name="event_item_max_order_none_user" id="event_item_max_order_none_user" onChange={this.handleItemOrderMaxChangeForNoneUser} value={this.state.none_user_item.event_item_max_order} onKeyDown={this.number_keydown} onBlur={e => this.onBlurItemPriceChange (e, "non")} disabled={this.state.none_user_item.isAnyOrder}></input> &nbsp;<div className="margin-vertical-auto">개</div>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;        
                                                    <div class="banner_check_flexbox event_setting_isAny_filter">
                                                        <CheckBox
                                                            id={"none_user_isAnyOrder"}
                                                            checked={this.state.none_user_item.isAnyOrder}
                                                            value={"none"}
                                                            onChangeCheck={this.onClickOrderAuto.bind(this)}
                                                        />
                                                        &nbsp;구매수 무관
                                                    </div>
                                                </div>
                                            </div>   

                                            <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}><b>상품을 중복체크하여 배너를 생성하겠습니까?</b></label>
                                                </div>
                                                <div className="margin-vertical-auto flexBox redio_v2" style={{width:"auto"}}>
                                                    <div style={{display:"flex", flexDirection:"column"}}>
                                                        {this.state.product_duplicate_check_type_list.map((obj, idx) => (
                                                            <div class="banner_check_flexbox" style={{marginBottom:"10px" ,flexWrap: "nowrap"}}>
                                                                <RadioButton
                                                                    id={"none/product_duplicate_check_type"+obj.code_cd}
                                                                    name={"none/product_duplicate_check_type"}
                                                                    value={obj.code_cd}
                                                                    checked={this.state.none_user_item.product_duplicate_check_type == obj.code_cd}
                                                                    onChangeCheck={this.onChangeProductDuplicateType.bind(this)}
                                                                />
                                                                <div style={{marginLeft:"10px"}}>{obj.val1}</div>
                                                            </div>  
                                                        ))}
                                                    </div>
                                                </div>    
                                            </div>

                                            {/* <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                                                <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                                    <label style={{marginTop: "auto", marginBottom: "15px"}}>재고수</label>
                                                </div>
                                                <div className="margin-vertical-auto flexBox" style={{width:"auto"}}>
                                                    <input type="number" name="event_item_min_quantity_none_user" id="event_item_min_quantity_none_user" onChange={this.handleItemQuantityMinChangeForNoneUser} value={this.state.none_user_item.event_item_min_quantity} onKeyDown={this.number_keydown} onBlur={this.onBlurItemQuantityChange}></input> &nbsp;개
                                                   <div className="margin-vertical-auto" style={{width:"50px", height:"100%", textAlign:"center", lineHeight:"25px"}}> ~ </div>
                                                    <input type="number" name="event_item_max_quantity_none_user" id="event_item_max_quantity_none_user" onChange={this.handleItemQuantityMaxChangeForNoneUser} value={this.state.none_user_item.event_item_max_quantity} onKeyDown={this.number_keydown} onBlur={this.onBlurItemQuantityChange}></input> &nbsp;개
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;        
                                                    {
                                                        this.state.none_user_item.isAnyQuantity
                                                        ? <div className="margin-vertical-auto">
                                                            <input type="checkbox" onChange={this.onClickQuantityAutoForNoneUser} checked={true}/> 재고수 무관
                                                        </div>
                                                        : <div className="margin-vertical-auto">
                                                            <input type="checkbox" onChange={this.onClickQuantityAutoForNoneUser}/> 재고수 무관
                                                        </div>
                                                    }
                                                </div>
                                            </div> */}
                                            {/* {
                                                this.state.nonUserItemCnt != null && this.state.nonUserItemCnt == "0"
                                                ?   <div style={{marginTop:"60px"}}>
                                                        <b style={{display:"flex"}}>
                                                        {
                                                            this.state.is_load_item_cnt_err_non
                                                            ?   <>
                                                                    <div className="icn_warning_round_red"></div>
                                                                    &nbsp;&nbsp;
                                                                    {this.state.item_cnt_err_msg_non}
                                                                </>
                                                            :   <>
                                                                { this.state.is_load_item_cnt_non
                                                                ?   <>
                                                                        <div><img src={icn_loading} style={{width:"20px", height:"20px"}}></img></div>
                                                                        &nbsp;&nbsp;
                                                                        상품 개수를 로딩중 입니다.
                                                                    </> 
                                                                :   <>
                                                                        <div className="icn_warning_round_red"></div>
                                                                        &nbsp;&nbsp;
                                                                        상품 개수가 0개 입니다. 상품 설정을 다시해 주세요.
                                                                    </>
                                                                }    
                                                                </>    
                                                        }
                                                        </b>
                                                    </div>
                                                :   ""
                                            }
                                            {
                                                this.state.nonUserItemCnt != null && this.state.nonUserItemCnt != "0"
                                                ?   <div style={{marginTop:"60px"}}>
                                                        <b style={{display:"flex"}}>
                                                        {   this.state.is_load_item_cnt_err_non
                                                                ?   <>
                                                                        <div className="icn_warning_round_red"></div>
                                                                        &nbsp;&nbsp;
                                                                        {this.state.item_cnt_err_msg_non}
                                                                    </>
                                                            :   <>
                                                                { this.state.is_load_item_cnt_non
                                                                ?   <>
                                                                        <div><img src={icn_loading} style={{width:"20px", height:"20px"}}></img></div>
                                                                        &nbsp;&nbsp;
                                                                        상품 개수를 로딩중 입니다.
                                                                    </>
                                                                :   <>
                                                                    <div className="icn_warning_round_blue"></div>
                                                                        &nbsp;&nbsp;
                                                                        총&nbsp; 
                                                                        <div>
                                                                        {this.state.nonUserItemCnt}
                                                                        개 
                                                                        </div>
                                                                        &nbsp;상품을 이용하여 배너를 생성합니다.
                                                                    </>
                                                                }
                                                            </>
                                                        }
                                                        </b>
                                                    </div>
                                                :   ""
                                            } */}
                                        </div>
                                } 
                                </div>                                
                            </div>
                        :   ""
                    }
                        {/* <div className="flexBox eventSettingItemArea" style={{height:"auto", marginBottom:"50px"}}>
                            <div className="margin-vertical-auto eventSettingTitle" style={{width:"100%"}}>
                                <label style={{marginTop: "auto", marginBottom: "15px"}}>희망 카테고리</label>
                            </div>
                            <div className="margin-vertical-auto flexBox" style={{width:"auto",lineHeight: "11px"}}>
                                <div style={{marginRight:"10px"}}>
                                    <input type="checkbox" id="allCategory" value="0" onClick={this.onClickCheckAllCategory}/>전체
                                </div>
                                {this.state.categoryList.map((category,idx) => (
                                    <div style={{marginRight:"10px"}}>
                                        <input type="checkbox" className="checkCategory" value={category.cd_code} id={category.cd_code} onClick={this.onClickCheckCategory}/>{category.cd_desc}
                                    </div>
                                ))}
                            </div>
                        </div> */}
                    </div>
                {/* <div style={{width:"100%", borderTop:"1px solid #676867", margin: "70px 0 0 0 "}}>
                    <div style={{backgroundColor:"white", width:"220px", margin:"-10px auto 10px auto", padding:"0 10px 0 10px", color:"#676867", textAlign: "center"}}>
                        진열중인 배너가 없을때 문구 설정
                    </div>
                </div>
                <div className="flexBox eventSettingItemArea" style={{marginTop: "auto", height:"70px"}}>
                        <div className="margin-vertical-auto eventSettingTitle" style={{width: "100%",}}>
                            <label style={{marginTop: "auto", marginBottom: "15px"}}>배너 제목</label>
                        </div>
                        <div className="margin-vertical-auto" style={{flex:"1"}}>
                            <input type="text" placeholder="진열중인 배너가 없을때 보여줄 제목을 입력하세요." className="width-100" onChange={this.handleEventTitleChange} value={this.state.shop_intro_title}></input>
                        </div>
                </div>
                <div className="flexBox eventSettingItemArea" style={{marginTop: "auto", height:"70px"}}>
                        <div className="margin-vertical-auto eventSettingTitle" style={{width: "100%",}}>
                            <label style={{marginTop: "auto", marginBottom: "15px"}}>배너 내용</label>
                        </div>
                        <div className="margin-vertical-auto" style={{flex:"1"}}>
                            <input type="text" placeholder="진열중인 배너가 없을때 보여줄 내용을 입력하세요." className="width-100" onChange={this.handleEventContentChange} value={this.state.shop_intro_content}></input>
                        </div>
                </div> */}

                {
                    Number(this.state.step) == 3
                    ?   <div className="width-100">
                            <div class="banner_radio_flexbox event_setting_content_radio event_setting_display_yn">
                                {this.state.solution_type_cd != '09900' &&
                                    [{state:'Y',text:'자동 생성이 완료되면 진열하기'},{state:'N',text:'미진열 상태로 저장하기'}].map((obj, idx) => (
                                        <RadioButton
                                            id={"display_yn_"+obj.state}
                                            name={"display_yn"}
                                            value={obj.state}
                                            checked={this.state.display_yn == obj.state}
                                            onChangeCheck={this.onClickDisplayYn.bind(this)}
                                        >
                                            {this.state.display_yn == obj.state
                                            ?<div className="banner_radio_text" style={{fontWeight:"bold"}}>{obj.text}</div>
                                            :<div className="banner_radio_text" style={{color:"#818283"}}>{obj.text}</div>}
                                        </RadioButton>
                                    ))
                                }
                            </div>

                            <button className="btn-175-b" onClick={(e) => this.onClickSave(e)} style={{marginBottom:"30px"}}>
                                등록하기
                            </button>
                        </div>
                    :   <div className="width-100 flexBox" style={{marginTop:"166px"}}>
                            <button className="btn-175-b" onClick={(e) => this.onClickNextStep(e)} style={{marginBottom:"30px"}}>
                                다음 단계
                            </button>
                        </div>
                }

                {/* 팔레트 배경 */}
                <div id="palleteBack" style={{top: "0", left:"0", width:"100%", height:"100%", position:"fixed", display:"none", background:"#ffffff00"}}></div>

                {/* <Prompt
                when={isFormIncomplete}
                message="이 페이지를 벗어나면 저장하지 않은 내용은 모두 초기화 됩니다." /> */}

                {/* 경고 다이얼로그 */
                    this.state.warning_dialog_show_state === true &&
                    <WarningDialog
                        content={this.state.warning_dialog_content}
                        button_list={this.state.warning_dialog_button_list}
                    />
                }
                {/* confirm 다이얼로그 */
                    this.state.title_content_dialog_show_state &&
                     <TitleContentDialogV2
                        title={this.state.title_content_dialog_title}
                        content={this.state.title_content_dialog_content}
                        button_list={this.state.title_content_dialog_button_list}
                        popup_close={() => {
                            this.setState({
                                title_content_dialog_show_state: false,
                            });
                        }}
                    />
                }
                {/* 기본 confirm 다이얼로그 */
                    this.state.confirm_dialog_show_state &&
                     <ConfirmDialogV2
                        content={this.state.confirm_dialog_content}
                        button_list={this.state.confirm_dialog_button_list}
                        popup_close={() => {
                            this.setState({
                                confirm_dialog_show_state: false,
                            });
                        }}
                    />
                }
                {/* 템플릿 태그 필터 팝업 */
                    this.state.show_template_filter_popup &&
                    <PopupFrameV2
                        className={"template_filter_popup"}
                        maxWidth={"950px"}
                        onClose={this.closeTemplateFilterPopupBtnClick.bind(this)}
                    >
                        <div className={"template_filter_popup_container"}>
                            <h4>템플릿 필터</h4>
                            {this.state.show_template_filter_popup_type == "03000"
                                ?
                                Object.keys(this.state.w_template_all_tag_list).map((category, tag_idx) => (
                                    <section key={category}>
                                        <h5>{this.state.template_ctg_list.at(tag_idx).tag_name}</h5>
                                        <div>
                                            <button style={this.state.w_all_selected[category] ? {backgroundColor:'#00E2E6', border: '1px solid #00E2E6'} : {backgroundColor: '#FFF', border: '1px solid #ACACAC'}}
                                                    onClick={() => this.handleAllTagBtnClick(category, "w")}>{this.state.template_tag_list ? this.state.template_tag_list[0].tag_name : ""}</button>
                                            {this.state.w_template_all_tag_list[category].map((tag)=>(
                                                <TagButton key={tag.tag_cd} tagCd={tag.tag_cd} tagName={tag.tag_name}
                                                           isSelected={tag.isSelected}
                                                           onClick={(tagCd, isSelected) => this.handleTagBtnClick(category, tag.tag_cd, isSelected, "w")}/>
                                            ))}
                                        </div>
                                    </section>
                                ))
                                :
                                Object.keys(this.state.h_template_all_tag_list).map((category, tag_idx) => (
                                    <section key={category}>
                                        <h5>{this.state.template_ctg_list.at(tag_idx).tag_name}</h5>
                                        <div>
                                            <button style={this.state.h_all_selected[category] ? {backgroundColor:'#00E2E6', border: '1px solid #00E2E6'} : {backgroundColor: '#FFF', border: '1px solid #ACACAC'}}
                                                    onClick={() => this.handleAllTagBtnClick(category, "h")}>{this.state.template_tag_list ? this.state.template_tag_list[0].tag_name : ""}</button>
                                            {this.state.h_template_all_tag_list[category].map((tag)=>(
                                                <TagButton key={tag.tag_cd} tagCd={tag.tag_cd} tagName={tag.tag_name}
                                                           isSelected={tag.isSelected}
                                                           onClick={(tagCd, isSelected) => this.handleTagBtnClick(category, tag.tag_cd, isSelected, "h")}/>
                                            ))}
                                        </div>
                                    </section>
                                ))
                            }
                        </div>
                        <div className={"template_filter_popup_footer"}>
                            {this.state.show_template_filter_popup_type == "03000"
                                ? <button onClick={() => this.resetTemplateFilterBtnClick("03000", "w")}>초기화</button>
                                : <button onClick={() => this.resetTemplateFilterBtnClick("07000", "h")}>초기화</button>
                            }
                            {this.state.show_template_filter_popup_type == "03000"
                                ? <button onClick={() => this.applyTemplateFilterBtnClick("03000", "w")}>필터적용</button>
                                : <button onClick={() => this.applyTemplateFilterBtnClick("07000", "h")}>필터적용</button>
                            }
                        </div>
                    </PopupFrameV2>
                }
            </div>
        )
    }
}